var Va = Object.defineProperty, Wa = Object.defineProperties;
var Ya = Object.getOwnPropertyDescriptors;
var Ut = Object.getOwnPropertySymbols;
var Qs = Object.prototype.hasOwnProperty, Js = Object.prototype.propertyIsEnumerable;
var ki = Math.pow, Xs = (s, e, t) => e in s ? Va(s, e, { enumerable: !0, configurable: !0, writable: !0, value: t }) : s[e] = t, tt = (s, e) => {
  for (var t in e || (e = {}))
    Qs.call(e, t) && Xs(s, t, e[t]);
  if (Ut)
    for (var t of Ut(e))
      Js.call(e, t) && Xs(s, t, e[t]);
  return s;
}, Bt = (s, e) => Wa(s, Ya(e));
var Zs = (s, e) => {
  var t = {};
  for (var i in s)
    Qs.call(s, i) && e.indexOf(i) < 0 && (t[i] = s[i]);
  if (s != null && Ut)
    for (var i of Ut(s))
      e.indexOf(i) < 0 && Js.call(s, i) && (t[i] = s[i]);
  return t;
};
function F(s, e, t) {
  return (e = qa(e)) in s ? Object.defineProperty(s, e, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : s[e] = t, s;
}
function ja(s, e) {
  if (typeof s != "object" || s === null) return s;
  var t = s[Symbol.toPrimitive];
  if (t !== void 0) {
    var i = t.call(s, e);
    if (typeof i != "object") return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (e === "string" ? String : Number)(s);
}
function qa(s) {
  var e = ja(s, "string");
  return typeof e == "symbol" ? e : String(e);
}
function za(s, e) {
  if (!(s instanceof e)) throw new TypeError("Cannot call a class as a function");
}
function en(s, e) {
  for (var t = 0; t < e.length; t++) {
    var i = e[t];
    i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(s, i.key, i);
  }
}
function Xa(s, e, t) {
  return e && en(s.prototype, e), t && en(s, t), s;
}
function Qa(s, e, t) {
  return e in s ? Object.defineProperty(s, e, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : s[e] = t, s;
}
function tn(s, e) {
  var t = Object.keys(s);
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(s);
    e && (i = i.filter(function(n) {
      return Object.getOwnPropertyDescriptor(s, n).enumerable;
    })), t.push.apply(t, i);
  }
  return t;
}
function sn(s) {
  for (var e = 1; e < arguments.length; e++) {
    var t = arguments[e] != null ? arguments[e] : {};
    e % 2 ? tn(Object(t), !0).forEach(function(i) {
      Qa(s, i, t[i]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(s, Object.getOwnPropertyDescriptors(t)) : tn(Object(t)).forEach(function(i) {
      Object.defineProperty(s, i, Object.getOwnPropertyDescriptor(t, i));
    });
  }
  return s;
}
var nn = { addCSS: !0, thumbWidth: 15, watch: !0 };
function Ja(s, e) {
  return function() {
    return Array.from(document.querySelectorAll(e)).includes(this);
  }.call(s, e);
}
function Za(s, e) {
  if (s && e) {
    var t = new Event(e, { bubbles: !0 });
    s.dispatchEvent(t);
  }
}
var Ft = function(s) {
  return s != null ? s.constructor : null;
}, Is = function(s, e) {
  return !!(s && e && s instanceof e);
}, hr = function(s) {
  return s == null;
}, ur = function(s) {
  return Ft(s) === Object;
}, eo = function(s) {
  return Ft(s) === Number && !Number.isNaN(s);
}, dr = function(s) {
  return Ft(s) === String;
}, to = function(s) {
  return Ft(s) === Boolean;
}, io = function(s) {
  return Ft(s) === Function;
}, fr = function(s) {
  return Array.isArray(s);
}, gr = function(s) {
  return Is(s, NodeList);
}, so = function(s) {
  return Is(s, Element);
}, no = function(s) {
  return Is(s, Event);
}, ro = function(s) {
  return hr(s) || (dr(s) || fr(s) || gr(s)) && !s.length || ur(s) && !Object.keys(s).length;
}, Ae = { nullOrUndefined: hr, object: ur, number: eo, string: dr, boolean: to, function: io, array: fr, nodeList: gr, element: so, event: no, empty: ro };
function ao(s) {
  var e = "".concat(s).match(/(?:\.(\d+))?(?:[eE]([+-]?\d+))?$/);
  return e ? Math.max(0, (e[1] ? e[1].length : 0) - (e[2] ? +e[2] : 0)) : 0;
}
function oo(s, e) {
  if (1 > e) {
    var t = ao(e);
    return parseFloat(s.toFixed(t));
  }
  return Math.round(s / e) * e;
}
var lo = function() {
  function s(e, t) {
    za(this, s), Ae.element(e) ? this.element = e : Ae.string(e) && (this.element = document.querySelector(e)), Ae.element(this.element) && Ae.empty(this.element.rangeTouch) && (this.config = sn({}, nn, {}, t), this.init());
  }
  return Xa(s, [{ key: "init", value: function() {
    s.enabled && (this.config.addCSS && (this.element.style.userSelect = "none", this.element.style.webKitUserSelect = "none", this.element.style.touchAction = "manipulation"), this.listeners(!0), this.element.rangeTouch = this);
  } }, { key: "destroy", value: function() {
    s.enabled && (this.config.addCSS && (this.element.style.userSelect = "", this.element.style.webKitUserSelect = "", this.element.style.touchAction = ""), this.listeners(!1), this.element.rangeTouch = null);
  } }, { key: "listeners", value: function(e) {
    var t = this, i = e ? "addEventListener" : "removeEventListener";
    ["touchstart", "touchmove", "touchend"].forEach(function(n) {
      t.element[i](n, function(r) {
        return t.set(r);
      }, !1);
    });
  } }, { key: "get", value: function(e) {
    if (!s.enabled || !Ae.event(e)) return null;
    var t, i = e.target, n = e.changedTouches[0], r = parseFloat(i.getAttribute("min")) || 0, a = parseFloat(i.getAttribute("max")) || 100, o = parseFloat(i.getAttribute("step")) || 1, l = i.getBoundingClientRect(), c = 100 / l.width * (this.config.thumbWidth / 2) / 100;
    return 0 > (t = 100 / l.width * (n.clientX - l.left)) ? t = 0 : 100 < t && (t = 100), 50 > t ? t -= (100 - 2 * t) * c : 50 < t && (t += 2 * (t - 50) * c), r + oo(t / 100 * (a - r), o);
  } }, { key: "set", value: function(e) {
    s.enabled && Ae.event(e) && !e.target.disabled && (e.preventDefault(), e.target.value = this.get(e), Za(e.target, e.type === "touchend" ? "change" : "input"));
  } }], [{ key: "setup", value: function(e) {
    var t = 1 < arguments.length && arguments[1] !== void 0 ? arguments[1] : {}, i = null;
    if (Ae.empty(e) || Ae.string(e) ? i = Array.from(document.querySelectorAll(Ae.string(e) ? e : 'input[type="range"]')) : Ae.element(e) ? i = [e] : Ae.nodeList(e) ? i = Array.from(e) : Ae.array(e) && (i = e.filter(Ae.element)), Ae.empty(i)) return null;
    var n = sn({}, nn, {}, t);
    if (Ae.string(e) && n.watch) {
      var r = new MutationObserver(function(a) {
        Array.from(a).forEach(function(o) {
          Array.from(o.addedNodes).forEach(function(l) {
            Ae.element(l) && Ja(l, e) && new s(l, n);
          });
        });
      });
      r.observe(document.body, { childList: !0, subtree: !0 });
    }
    return i.map(function(a) {
      return new s(a, t);
    });
  } }, { key: "enabled", get: function() {
    return "ontouchstart" in document.documentElement;
  } }]), s;
}();
const Mt = (s) => s != null ? s.constructor : null, Xe = (s, e) => !!(s && e && s instanceof e), ws = (s) => s == null, mr = (s) => Mt(s) === Object, co = (s) => Mt(s) === Number && !Number.isNaN(s), Li = (s) => Mt(s) === String, ho = (s) => Mt(s) === Boolean, pr = (s) => typeof s == "function", yr = (s) => Array.isArray(s), uo = (s) => Xe(s, WeakMap), Tr = (s) => Xe(s, NodeList), fo = (s) => Mt(s) === Text, go = (s) => Xe(s, Event), mo = (s) => Xe(s, KeyboardEvent), po = (s) => Xe(s, window.TextTrackCue) || Xe(s, window.VTTCue), yo = (s) => Xe(s, TextTrack) || !ws(s) && Li(s.kind), To = (s) => Xe(s, Promise) && pr(s.then), Eo = (s) => s !== null && typeof s == "object" && s.nodeType === 1 && typeof s.style == "object" && typeof s.ownerDocument == "object", Er = (s) => ws(s) || (Li(s) || yr(s) || Tr(s)) && !s.length || mr(s) && !Object.keys(s).length, vo = (s) => {
  if (Xe(s, window.URL)) return !0;
  if (!Li(s)) return !1;
  let e = s;
  s.startsWith("http://") && s.startsWith("https://") || (e = `http://${s}`);
  try {
    return !Er(new URL(e).hostname);
  } catch (t) {
    return !1;
  }
};
var E = { nullOrUndefined: ws, object: mr, number: co, string: Li, boolean: ho, function: pr, array: yr, weakMap: uo, nodeList: Tr, element: Eo, textNode: fo, event: go, keyboardEvent: mo, cue: po, track: yo, promise: To, url: vo, empty: Er };
const rs = (() => {
  const s = document.createElement("span"), e = { WebkitTransition: "webkitTransitionEnd", MozTransition: "transitionend", OTransition: "oTransitionEnd otransitionend", transition: "transitionend" }, t = Object.keys(e).find((i) => s.style[i] !== void 0);
  return !!E.string(t) && e[t];
})();
function vr(s, e) {
  setTimeout(() => {
    try {
      s.hidden = !0, s.offsetHeight, s.hidden = !1;
    } catch (t) {
    }
  }, e);
}
const bo = !!window.document.documentMode, xo = /Edge/g.test(navigator.userAgent), So = "WebkitAppearance" in document.documentElement.style && !/Edge/g.test(navigator.userAgent), Ao = /iPhone|iPod/gi.test(navigator.userAgent) && navigator.maxTouchPoints > 1, Lo = navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1, Ro = /iPad|iPhone|iPod/gi.test(navigator.userAgent) && navigator.maxTouchPoints > 1;
var Ee = { isIE: bo, isEdge: xo, isWebKit: So, isIPhone: Ao, isIPadOS: Lo, isIos: Ro };
function Io(s) {
  return JSON.parse(JSON.stringify(s));
}
function br(s, e) {
  return e.split(".").reduce((t, i) => t && t[i], s);
}
function he(s = {}, ...e) {
  if (!e.length) return s;
  const t = e.shift();
  return E.object(t) ? (Object.keys(t).forEach((i) => {
    E.object(t[i]) ? (Object.keys(s).includes(i) || Object.assign(s, { [i]: {} }), he(s[i], t[i])) : Object.assign(s, { [i]: t[i] });
  }), he(s, ...e)) : s;
}
function xr(s, e) {
  const t = s.length ? s : [s];
  Array.from(t).reverse().forEach((i, n) => {
    const r = n > 0 ? e.cloneNode(!0) : e, a = i.parentNode, o = i.nextSibling;
    r.appendChild(i), o ? a.insertBefore(r, o) : a.appendChild(r);
  });
}
function as(s, e) {
  E.element(s) && !E.empty(e) && Object.entries(e).filter(([, t]) => !E.nullOrUndefined(t)).forEach(([t, i]) => s.setAttribute(t, i));
}
function K(s, e, t) {
  const i = document.createElement(s);
  return E.object(e) && as(i, e), E.string(t) && (i.innerText = t), i;
}
function wo(s, e) {
  E.element(s) && E.element(e) && e.parentNode.insertBefore(s, e.nextSibling);
}
function rn(s, e, t, i) {
  E.element(e) && e.appendChild(K(s, t, i));
}
function ze(s) {
  E.nodeList(s) || E.array(s) ? Array.from(s).forEach(ze) : E.element(s) && E.element(s.parentNode) && s.parentNode.removeChild(s);
}
function Zt(s) {
  if (!E.element(s)) return;
  let { length: e } = s.childNodes;
  for (; e > 0; ) s.removeChild(s.lastChild), e -= 1;
}
function hi(s, e) {
  return E.element(e) && E.element(e.parentNode) && E.element(s) ? (e.parentNode.replaceChild(s, e), s) : null;
}
function Ne(s, e) {
  if (!E.string(s) || E.empty(s)) return {};
  const t = {}, i = he({}, e);
  return s.split(",").forEach((n) => {
    const r = n.trim(), a = r.replace(".", ""), o = r.replace(/[[\]]/g, "").split("="), [l] = o, c = o.length > 1 ? o[1].replace(/["']/g, "") : "";
    switch (r.charAt(0)) {
      case ".":
        E.string(i.class) ? t.class = `${i.class} ${a}` : t.class = a;
        break;
      case "#":
        t.id = r.replace("#", "");
        break;
      case "[":
        t[l] = c;
    }
  }), he(i, t);
}
function it(s, e) {
  if (!E.element(s)) return;
  let t = e;
  E.boolean(t) || (t = !s.hidden), s.hidden = t;
}
function ie(s, e, t) {
  if (E.nodeList(s)) return Array.from(s).map((i) => ie(i, e, t));
  if (E.element(s)) {
    let i = "toggle";
    return t !== void 0 && (i = t ? "add" : "remove"), s.classList[i](e), s.classList.contains(e);
  }
  return !1;
}
function ui(s, e) {
  return E.element(s) && s.classList.contains(e);
}
function at(s, e) {
  const { prototype: t } = Element;
  return (t.matches || t.webkitMatchesSelector || t.mozMatchesSelector || t.msMatchesSelector || function() {
    return Array.from(document.querySelectorAll(e)).includes(this);
  }).call(s, e);
}
function Co(s, e) {
  const { prototype: t } = Element;
  return (t.closest || function() {
    let i = this;
    do {
      if (at.matches(i, e)) return i;
      i = i.parentElement || i.parentNode;
    } while (i !== null && i.nodeType === 1);
    return null;
  }).call(s, e);
}
function wt(s) {
  return this.elements.container.querySelectorAll(s);
}
function ge(s) {
  return this.elements.container.querySelector(s);
}
function Pi(s = null, e = !1) {
  E.element(s) && s.focus({ preventScroll: !0, focusVisible: e });
}
const an = { "audio/ogg": "vorbis", "audio/wav": "1", "video/webm": "vp8, vorbis", "video/mp4": "avc1.42E01E, mp4a.40.2", "video/ogg": "theora" }, ue = { audio: "canPlayType" in document.createElement("audio"), video: "canPlayType" in document.createElement("video"), check(s, e) {
  const t = ue[s] || e !== "html5";
  return { api: t, ui: t && ue.rangeInput };
}, pip: !(Ee.isIPhone || !E.function(K("video").webkitSetPresentationMode) && (!document.pictureInPictureEnabled || K("video").disablePictureInPicture)), airplay: E.function(window.WebKitPlaybackTargetAvailabilityEvent), playsinline: "playsInline" in document.createElement("video"), mime(s) {
  if (E.empty(s)) return !1;
  const [e] = s.split("/");
  let t = s;
  if (!this.isHTML5 || e !== this.type) return !1;
  Object.keys(an).includes(t) && (t += `; codecs="${an[s]}"`);
  try {
    return !!(t && this.media.canPlayType(t).replace(/no/, ""));
  } catch (i) {
    return !1;
  }
}, textTracks: "textTracks" in document.createElement("video"), rangeInput: (() => {
  const s = document.createElement("input");
  return s.type = "range", s.type === "range";
})(), touch: "ontouchstart" in document.documentElement, transitions: rs !== !1, reducedMotion: "matchMedia" in window && window.matchMedia("(prefers-reduced-motion)").matches }, Do = (() => {
  let s = !1;
  try {
    const e = Object.defineProperty({}, "passive", { get: () => (s = !0, null) });
    window.addEventListener("test", null, e), window.removeEventListener("test", null, e);
  } catch (e) {
  }
  return s;
})();
function Ct(s, e, t, i = !1, n = !0, r = !1) {
  if (!s || !("addEventListener" in s) || E.empty(e) || !E.function(t)) return;
  const a = e.split(" ");
  let o = r;
  Do && (o = { passive: n, capture: r }), a.forEach((l) => {
    this && this.eventListeners && i && this.eventListeners.push({ element: s, type: l, callback: t, options: o }), s[i ? "addEventListener" : "removeEventListener"](l, t, o);
  });
}
function J(s, e = "", t, i = !0, n = !1) {
  Ct.call(this, s, e, t, !0, i, n);
}
function Ri(s, e = "", t, i = !0, n = !1) {
  Ct.call(this, s, e, t, !1, i, n);
}
function Cs(s, e = "", t, i = !0, n = !1) {
  const r = (...a) => {
    Ri(s, e, r, i, n), t.apply(this, a);
  };
  Ct.call(this, s, e, r, !0, i, n);
}
function W(s, e = "", t = !1, i = {}) {
  if (!E.element(s) || E.empty(e)) return;
  const n = new CustomEvent(e, { bubbles: t, detail: Bt(tt({}, i), { plyr: this }) });
  s.dispatchEvent(n);
}
function ko() {
  this && this.eventListeners && (this.eventListeners.forEach((s) => {
    const { element: e, type: t, callback: i, options: n } = s;
    e.removeEventListener(t, i, n);
  }), this.eventListeners = []);
}
function Po() {
  return new Promise((s) => this.ready ? setTimeout(s, 0) : J.call(this, this.elements.container, "ready", s)).then(() => {
  });
}
function $e(s) {
  E.promise(s) && s.then(null, () => {
  });
}
function os(s) {
  return E.array(s) ? s.filter((e, t) => s.indexOf(e) === t) : s;
}
function Sr(s, e) {
  return E.array(s) && s.length ? s.reduce((t, i) => Math.abs(i - e) < Math.abs(t - e) ? i : t) : null;
}
function Ar(s) {
  return !(!window || !window.CSS) && window.CSS.supports(s);
}
const on = [[1, 1], [4, 3], [3, 4], [5, 4], [4, 5], [3, 2], [2, 3], [16, 10], [10, 16], [16, 9], [9, 16], [21, 9], [9, 21], [32, 9], [9, 32]].reduce((s, [e, t]) => Bt(tt({}, s), { [e / t]: [e, t] }), {});
function Lr(s) {
  return E.array(s) || E.string(s) && s.includes(":") ? (E.array(s) ? s : s.split(":")).map(Number).every(E.number) : !1;
}
function di(s) {
  if (!E.array(s) || !s.every(E.number)) return null;
  const [e, t] = s, i = (r, a) => a === 0 ? r : i(a, r % a), n = i(e, t);
  return [e / n, t / n];
}
function Ds(s) {
  const e = (i) => Lr(i) ? i.split(":").map(Number) : null;
  let t = e(s);
  if (t === null && (t = e(this.config.ratio)), t === null && !E.empty(this.embed) && E.array(this.embed.ratio) && ({ ratio: t } = this.embed), t === null && this.isHTML5) {
    const { videoWidth: i, videoHeight: n } = this.media;
    t = [i, n];
  }
  return di(t);
}
function Tt(s) {
  if (!this.isVideo) return {};
  const { wrapper: e } = this.elements, t = Ds.call(this, s);
  if (!E.array(t)) return {};
  const [i, n] = di(t), r = 100 / i * n;
  if (Ar(`aspect-ratio: ${i}/${n}`) ? e.style.aspectRatio = `${i}/${n}` : e.style.paddingBottom = `${r}%`, this.isVimeo && !this.config.vimeo.premium && this.supported.ui) {
    const a = 100 / this.media.offsetWidth * parseInt(window.getComputedStyle(this.media).paddingBottom, 10), o = (a - r) / (a / 50);
    this.fullscreen.active ? e.style.paddingBottom = null : this.media.style.transform = `translateY(-${o}%)`;
  } else this.isHTML5 && e.classList.add(this.config.classNames.videoFixedRatio);
  return { padding: r, ratio: t };
}
function Rr(s, e, t = 0.05) {
  const i = s / e, n = Sr(Object.keys(on), i);
  return Math.abs(n - i) <= t ? on[n] : [s, e];
}
function _o() {
  return [Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0), Math.max(document.documentElement.clientHeight || 0, window.innerHeight || 0)];
}
const et = { getSources() {
  return this.isHTML5 ? Array.from(this.media.querySelectorAll("source")).filter((s) => {
    const e = s.getAttribute("type");
    return !!E.empty(e) || ue.mime.call(this, e);
  }) : [];
}, getQualityOptions() {
  return this.config.quality.forced ? this.config.quality.options : et.getSources.call(this).map((s) => Number(s.getAttribute("size"))).filter(Boolean);
}, setup() {
  if (!this.isHTML5) return;
  const s = this;
  s.options.speed = s.config.speed.options, E.empty(this.config.ratio) || Tt.call(s), Object.defineProperty(s.media, "quality", { get() {
    const e = et.getSources.call(s).find((t) => t.getAttribute("src") === s.source);
    return e && Number(e.getAttribute("size"));
  }, set(e) {
    if (s.quality !== e) {
      if (s.config.quality.forced && E.function(s.config.quality.onChange)) s.config.quality.onChange(e);
      else {
        const t = et.getSources.call(s).find((l) => Number(l.getAttribute("size")) === e);
        if (!t) return;
        const { currentTime: i, paused: n, preload: r, readyState: a, playbackRate: o } = s.media;
        s.media.src = t.getAttribute("src"), (r !== "none" || a) && (s.once("loadedmetadata", () => {
          s.speed = o, s.currentTime = i, n || $e(s.play());
        }), s.media.load());
      }
      W.call(s, s.media, "qualitychange", !1, { quality: e });
    }
  } });
}, cancelRequests() {
  this.isHTML5 && (ze(et.getSources.call(this)), this.media.setAttribute("src", this.config.blankVideo), this.media.load(), this.debug.log("Cancelled network requests"));
} };
function Oo(s) {
  return `${s}-${Math.floor(1e4 * Math.random())}`;
}
function ls(s, ...e) {
  return E.empty(s) ? s : s.toString().replace(/{(\d+)}/g, (t, i) => e[i].toString());
}
function Fo(s, e) {
  return s === 0 || e === 0 || Number.isNaN(s) || Number.isNaN(e) ? 0 : (s / e * 100).toFixed(2);
}
const Rt = (s = "", e = "", t = "") => s.replace(new RegExp(e.toString().replace(/([.*+?^=!:${}()|[\]/\\])/g, "\\$1"), "g"), t.toString()), Ir = (s = "") => s.toString().replace(/\w\S*/g, (e) => e.charAt(0).toUpperCase() + e.slice(1).toLowerCase());
function Mo(s = "") {
  let e = s.toString();
  return e = Rt(e, "-", " "), e = Rt(e, "_", " "), e = Ir(e), Rt(e, " ", "");
}
function No(s = "") {
  let e = s.toString();
  return e = Mo(e), e.charAt(0).toLowerCase() + e.slice(1);
}
function Uo(s) {
  const e = document.createDocumentFragment(), t = document.createElement("div");
  return e.appendChild(t), t.innerHTML = s, e.firstChild.innerText;
}
function Bo(s) {
  const e = document.createElement("div");
  return e.appendChild(s), e.innerHTML;
}
const ln = { pip: "PIP", airplay: "AirPlay", html5: "HTML5", vimeo: "Vimeo", youtube: "YouTube" }, Te = { get(s = "", e = {}) {
  if (E.empty(s) || E.empty(e)) return "";
  let t = br(e.i18n, s);
  if (E.empty(t)) return Object.keys(ln).includes(s) ? ln[s] : "";
  const i = { "{seektime}": e.seekTime, "{title}": e.title };
  return Object.entries(i).forEach(([n, r]) => {
    t = Rt(t, n, r);
  }), t;
} };
class Dt {
  constructor(e) {
    F(this, "get", (t) => {
      if (!Dt.supported || !this.enabled) return null;
      const i = window.localStorage.getItem(this.key);
      if (E.empty(i)) return null;
      const n = JSON.parse(i);
      return E.string(t) && t.length ? n[t] : n;
    }), F(this, "set", (t) => {
      if (!Dt.supported || !this.enabled || !E.object(t)) return;
      let i = this.get();
      E.empty(i) && (i = {}), he(i, t);
      try {
        window.localStorage.setItem(this.key, JSON.stringify(i));
      } catch (n) {
      }
    }), this.enabled = e.config.storage.enabled, this.key = e.config.storage.key;
  }
  static get supported() {
    try {
      if (!("localStorage" in window)) return !1;
      const e = "___test";
      return window.localStorage.setItem(e, e), window.localStorage.removeItem(e), !0;
    } catch (e) {
      return !1;
    }
  }
}
function Nt(s, e = "text") {
  return new Promise((t, i) => {
    try {
      const n = new XMLHttpRequest();
      if (!("withCredentials" in n)) return;
      n.addEventListener("load", () => {
        if (e === "text") try {
          t(JSON.parse(n.responseText));
        } catch (r) {
          t(n.responseText);
        }
        else t(n.response);
      }), n.addEventListener("error", () => {
        throw new Error(n.status);
      }), n.open("GET", s, !0), n.responseType = e, n.send();
    } catch (n) {
      i(n);
    }
  });
}
function wr(s, e) {
  if (!E.string(s)) return;
  const t = "cache", i = E.string(e);
  let n = !1;
  const r = () => document.getElementById(e) !== null, a = (o, l) => {
    o.innerHTML = l, i && r() || document.body.insertAdjacentElement("afterbegin", o);
  };
  if (!i || !r()) {
    const o = Dt.supported, l = document.createElement("div");
    if (l.setAttribute("hidden", ""), i && l.setAttribute("id", e), o) {
      const c = window.localStorage.getItem(`${t}-${e}`);
      if (n = c !== null, n) {
        const h = JSON.parse(c);
        a(l, h.content);
      }
    }
    Nt(s).then((c) => {
      if (!E.empty(c)) {
        if (o) try {
          window.localStorage.setItem(`${t}-${e}`, JSON.stringify({ content: c }));
        } catch (h) {
        }
        a(l, c);
      }
    }).catch(() => {
    });
  }
}
const Cr = (s) => Math.trunc(s / 60 / 60 % 60, 10), $o = (s) => Math.trunc(s / 60 % 60, 10), Go = (s) => Math.trunc(s % 60, 10);
function Ii(s = 0, e = !1, t = !1) {
  if (!E.number(s)) return Ii(void 0, e, t);
  const i = (o) => `0${o}`.slice(-2);
  let n = Cr(s);
  const r = $o(s), a = Go(s);
  return n = e || n > 0 ? `${n}:` : "", `${t && s > 0 ? "-" : ""}${n}${i(r)}:${i(a)}`;
}
const O = { getIconUrl() {
  const s = new URL(this.config.iconUrl, window.location), e = window.location.host ? window.location.host : window.top.location.host, t = s.host !== e || Ee.isIE && !window.svg4everybody;
  return { url: this.config.iconUrl, cors: t };
}, findElements() {
  try {
    return this.elements.controls = ge.call(this, this.config.selectors.controls.wrapper), this.elements.buttons = { play: wt.call(this, this.config.selectors.buttons.play), pause: ge.call(this, this.config.selectors.buttons.pause), restart: ge.call(this, this.config.selectors.buttons.restart), rewind: ge.call(this, this.config.selectors.buttons.rewind), fastForward: ge.call(this, this.config.selectors.buttons.fastForward), mute: ge.call(this, this.config.selectors.buttons.mute), pip: ge.call(this, this.config.selectors.buttons.pip), airplay: ge.call(this, this.config.selectors.buttons.airplay), settings: ge.call(this, this.config.selectors.buttons.settings), captions: ge.call(this, this.config.selectors.buttons.captions), fullscreen: ge.call(this, this.config.selectors.buttons.fullscreen) }, this.elements.progress = ge.call(this, this.config.selectors.progress), this.elements.inputs = { seek: ge.call(this, this.config.selectors.inputs.seek), volume: ge.call(this, this.config.selectors.inputs.volume) }, this.elements.display = { buffer: ge.call(this, this.config.selectors.display.buffer), currentTime: ge.call(this, this.config.selectors.display.currentTime), duration: ge.call(this, this.config.selectors.display.duration) }, E.element(this.elements.progress) && (this.elements.display.seekTooltip = this.elements.progress.querySelector(`.${this.config.classNames.tooltip}`)), !0;
  } catch (s) {
    return this.debug.warn("It looks like there is a problem with your custom controls HTML", s), this.toggleNativeControls(!0), !1;
  }
}, createIcon(s, e) {
  const t = "http://www.w3.org/2000/svg", i = O.getIconUrl.call(this), n = `${i.cors ? "" : i.url}#${this.config.iconPrefix}`, r = document.createElementNS(t, "svg");
  as(r, he(e, { "aria-hidden": "true", focusable: "false" }));
  const a = document.createElementNS(t, "use"), o = `${n}-${s}`;
  return "href" in a && a.setAttributeNS("http://www.w3.org/1999/xlink", "href", o), a.setAttributeNS("http://www.w3.org/1999/xlink", "xlink:href", o), r.appendChild(a), r;
}, createLabel(s, e = {}) {
  const t = Te.get(s, this.config);
  return K("span", Bt(tt({}, e), { class: [e.class, this.config.classNames.hidden].filter(Boolean).join(" ") }), t);
}, createBadge(s) {
  if (E.empty(s)) return null;
  const e = K("span", { class: this.config.classNames.menu.value });
  return e.appendChild(K("span", { class: this.config.classNames.menu.badge }, s)), e;
}, createButton(s, e) {
  const t = he({}, e);
  let i = No(s);
  const n = { element: "button", toggle: !1, label: null, icon: null, labelPressed: null, iconPressed: null };
  switch (["element", "icon", "label"].forEach((a) => {
    Object.keys(t).includes(a) && (n[a] = t[a], delete t[a]);
  }), n.element !== "button" || Object.keys(t).includes("type") || (t.type = "button"), Object.keys(t).includes("class") ? t.class.split(" ").some((a) => a === this.config.classNames.control) || he(t, { class: `${t.class} ${this.config.classNames.control}` }) : t.class = this.config.classNames.control, s) {
    case "play":
      n.toggle = !0, n.label = "play", n.labelPressed = "pause", n.icon = "play", n.iconPressed = "pause";
      break;
    case "mute":
      n.toggle = !0, n.label = "mute", n.labelPressed = "unmute", n.icon = "volume", n.iconPressed = "muted";
      break;
    case "captions":
      n.toggle = !0, n.label = "enableCaptions", n.labelPressed = "disableCaptions", n.icon = "captions-off", n.iconPressed = "captions-on";
      break;
    case "fullscreen":
      n.toggle = !0, n.label = "enterFullscreen", n.labelPressed = "exitFullscreen", n.icon = "enter-fullscreen", n.iconPressed = "exit-fullscreen";
      break;
    case "play-large":
      t.class += ` ${this.config.classNames.control}--overlaid`, i = "play", n.label = "play", n.icon = "play";
      break;
    default:
      E.empty(n.label) && (n.label = i), E.empty(n.icon) && (n.icon = s);
  }
  const r = K(n.element);
  return n.toggle ? (r.appendChild(O.createIcon.call(this, n.iconPressed, { class: "icon--pressed" })), r.appendChild(O.createIcon.call(this, n.icon, { class: "icon--not-pressed" })), r.appendChild(O.createLabel.call(this, n.labelPressed, { class: "label--pressed" })), r.appendChild(O.createLabel.call(this, n.label, { class: "label--not-pressed" }))) : (r.appendChild(O.createIcon.call(this, n.icon)), r.appendChild(O.createLabel.call(this, n.label))), he(t, Ne(this.config.selectors.buttons[i], t)), as(r, t), i === "play" ? (E.array(this.elements.buttons[i]) || (this.elements.buttons[i] = []), this.elements.buttons[i].push(r)) : this.elements.buttons[i] = r, r;
}, createRange(s, e) {
  const t = K("input", he(Ne(this.config.selectors.inputs[s]), { type: "range", min: 0, max: 100, step: 0.01, value: 0, autocomplete: "off", role: "slider", "aria-label": Te.get(s, this.config), "aria-valuemin": 0, "aria-valuemax": 100, "aria-valuenow": 0 }, e));
  return this.elements.inputs[s] = t, O.updateRangeFill.call(this, t), lo.setup(t), t;
}, createProgress(s, e) {
  const t = K("progress", he(Ne(this.config.selectors.display[s]), { min: 0, max: 100, value: 0, role: "progressbar", "aria-hidden": !0 }, e));
  if (s !== "volume") {
    t.appendChild(K("span", null, "0"));
    const i = { played: "played", buffer: "buffered" }[s], n = i ? Te.get(i, this.config) : "";
    t.innerText = `% ${n.toLowerCase()}`;
  }
  return this.elements.display[s] = t, t;
}, createTime(s, e) {
  const t = Ne(this.config.selectors.display[s], e), i = K("div", he(t, { class: `${t.class ? t.class : ""} ${this.config.classNames.display.time} `.trim(), "aria-label": Te.get(s, this.config), role: "timer" }), "00:00");
  return this.elements.display[s] = i, i;
}, bindMenuItemShortcuts(s, e) {
  J.call(this, s, "keydown keyup", (t) => {
    if (![" ", "ArrowUp", "ArrowDown", "ArrowRight"].includes(t.key) || (t.preventDefault(), t.stopPropagation(), t.type === "keydown")) return;
    const i = at(s, '[role="menuitemradio"]');
    if (!i && [" ", "ArrowRight"].includes(t.key)) O.showMenuPanel.call(this, e, !0);
    else {
      let n;
      t.key !== " " && (t.key === "ArrowDown" || i && t.key === "ArrowRight" ? (n = s.nextElementSibling, E.element(n) || (n = s.parentNode.firstElementChild)) : (n = s.previousElementSibling, E.element(n) || (n = s.parentNode.lastElementChild)), Pi.call(this, n, !0));
    }
  }, !1), J.call(this, s, "keyup", (t) => {
    t.key === "Return" && O.focusFirstMenuItem.call(this, null, !0);
  });
}, createMenuItem({ value: s, list: e, type: t, title: i, badge: n = null, checked: r = !1 }) {
  const a = Ne(this.config.selectors.inputs[t]), o = K("button", he(a, { type: "button", role: "menuitemradio", class: `${this.config.classNames.control} ${a.class ? a.class : ""}`.trim(), "aria-checked": r, value: s })), l = K("span");
  l.innerHTML = i, E.element(n) && l.appendChild(n), o.appendChild(l), Object.defineProperty(o, "checked", { enumerable: !0, get: () => o.getAttribute("aria-checked") === "true", set(c) {
    c && Array.from(o.parentNode.children).filter((h) => at(h, '[role="menuitemradio"]')).forEach((h) => h.setAttribute("aria-checked", "false")), o.setAttribute("aria-checked", c ? "true" : "false");
  } }), this.listeners.bind(o, "click keyup", (c) => {
    if (!E.keyboardEvent(c) || c.key === " ") {
      switch (c.preventDefault(), c.stopPropagation(), o.checked = !0, t) {
        case "language":
          this.currentTrack = Number(s);
          break;
        case "quality":
          this.quality = s;
          break;
        case "speed":
          this.speed = parseFloat(s);
      }
      O.showMenuPanel.call(this, "home", E.keyboardEvent(c));
    }
  }, t, !1), O.bindMenuItemShortcuts.call(this, o, t), e.appendChild(o);
}, formatTime(s = 0, e = !1) {
  return E.number(s) ? Ii(s, Cr(this.duration) > 0, e) : s;
}, updateTimeDisplay(s = null, e = 0, t = !1) {
  E.element(s) && E.number(e) && (s.innerText = O.formatTime(e, t));
}, updateVolume() {
  this.supported.ui && (E.element(this.elements.inputs.volume) && O.setRange.call(this, this.elements.inputs.volume, this.muted ? 0 : this.volume), E.element(this.elements.buttons.mute) && (this.elements.buttons.mute.pressed = this.muted || this.volume === 0));
}, setRange(s, e = 0) {
  E.element(s) && (s.value = e, O.updateRangeFill.call(this, s));
}, updateProgress(s) {
  if (!this.supported.ui || !E.event(s)) return;
  let e = 0;
  const t = (i, n) => {
    const r = E.number(n) ? n : 0, a = E.element(i) ? i : this.elements.display.buffer;
    if (E.element(a)) {
      a.value = r;
      const o = a.getElementsByTagName("span")[0];
      E.element(o) && (o.childNodes[0].nodeValue = r);
    }
  };
  if (s) switch (s.type) {
    case "timeupdate":
    case "seeking":
    case "seeked":
      e = Fo(this.currentTime, this.duration), s.type === "timeupdate" && O.setRange.call(this, this.elements.inputs.seek, e);
      break;
    case "playing":
    case "progress":
      t(this.elements.display.buffer, 100 * this.buffered);
  }
}, updateRangeFill(s) {
  const e = E.event(s) ? s.target : s;
  if (E.element(e) && e.getAttribute("type") === "range") {
    if (at(e, this.config.selectors.inputs.seek)) {
      e.setAttribute("aria-valuenow", this.currentTime);
      const t = O.formatTime(this.currentTime), i = O.formatTime(this.duration), n = Te.get("seekLabel", this.config);
      e.setAttribute("aria-valuetext", n.replace("{currentTime}", t).replace("{duration}", i));
    } else if (at(e, this.config.selectors.inputs.volume)) {
      const t = 100 * e.value;
      e.setAttribute("aria-valuenow", t), e.setAttribute("aria-valuetext", `${t.toFixed(1)}%`);
    } else e.setAttribute("aria-valuenow", e.value);
    (Ee.isWebKit || Ee.isIPadOS) && e.style.setProperty("--value", e.value / e.max * 100 + "%");
  }
}, updateSeekTooltip(s) {
  var e, t;
  if (!this.config.tooltips.seek || !E.element(this.elements.inputs.seek) || !E.element(this.elements.display.seekTooltip) || this.duration === 0) return;
  const i = this.elements.display.seekTooltip, n = `${this.config.classNames.tooltip}--visible`, r = (h) => ie(i, n, h);
  if (this.touch) return void r(!1);
  let a = 0;
  const o = this.elements.progress.getBoundingClientRect();
  if (E.event(s)) a = 100 / o.width * (s.pageX - o.left);
  else {
    if (!ui(i, n)) return;
    a = parseFloat(i.style.left, 10);
  }
  a < 0 ? a = 0 : a > 100 && (a = 100);
  const l = this.duration / 100 * a;
  i.innerText = O.formatTime(l);
  const c = (e = this.config.markers) === null || e === void 0 || (t = e.points) === null || t === void 0 ? void 0 : t.find(({ time: h }) => h === Math.round(l));
  c && i.insertAdjacentHTML("afterbegin", `${c.label}<br>`), i.style.left = `${a}%`, E.event(s) && ["mouseenter", "mouseleave"].includes(s.type) && r(s.type === "mouseenter");
}, timeUpdate(s) {
  const e = !E.element(this.elements.display.duration) && this.config.invertTime;
  O.updateTimeDisplay.call(this, this.elements.display.currentTime, e ? this.duration - this.currentTime : this.currentTime, e), s && s.type === "timeupdate" && this.media.seeking || O.updateProgress.call(this, s);
}, durationUpdate() {
  if (!this.supported.ui || !this.config.invertTime && this.currentTime) return;
  if (this.duration >= ki(2, 32)) return it(this.elements.display.currentTime, !0), void it(this.elements.progress, !0);
  E.element(this.elements.inputs.seek) && this.elements.inputs.seek.setAttribute("aria-valuemax", this.duration);
  const s = E.element(this.elements.display.duration);
  !s && this.config.displayDuration && this.paused && O.updateTimeDisplay.call(this, this.elements.display.currentTime, this.duration), s && O.updateTimeDisplay.call(this, this.elements.display.duration, this.duration), this.config.markers.enabled && O.setMarkers.call(this), O.updateSeekTooltip.call(this);
}, toggleMenuButton(s, e) {
  it(this.elements.settings.buttons[s], !e);
}, updateSetting(s, e, t) {
  const i = this.elements.settings.panels[s];
  let n = null, r = e;
  if (s === "captions") n = this.currentTrack;
  else {
    if (n = E.empty(t) ? this[s] : t, E.empty(n) && (n = this.config[s].default), !E.empty(this.options[s]) && !this.options[s].includes(n)) return void this.debug.warn(`Unsupported value of '${n}' for ${s}`);
    if (!this.config[s].options.includes(n)) return void this.debug.warn(`Disabled value of '${n}' for ${s}`);
  }
  if (E.element(r) || (r = i && i.querySelector('[role="menu"]')), !E.element(r)) return;
  this.elements.settings.buttons[s].querySelector(`.${this.config.classNames.menu.value}`).innerHTML = O.getLabel.call(this, s, n);
  const a = r && r.querySelector(`[value="${n}"]`);
  E.element(a) && (a.checked = !0);
}, getLabel(s, e) {
  switch (s) {
    case "speed":
      return e === 1 ? Te.get("normal", this.config) : `${e}&times;`;
    case "quality":
      if (E.number(e)) {
        const t = Te.get(`qualityLabel.${e}`, this.config);
        return t.length ? t : `${e}p`;
      }
      return Ir(e);
    case "captions":
      return ee.getLabel.call(this);
    default:
      return null;
  }
}, setQualityMenu(s) {
  if (!E.element(this.elements.settings.panels.quality)) return;
  const e = "quality", t = this.elements.settings.panels.quality.querySelector('[role="menu"]');
  E.array(s) && (this.options.quality = os(s).filter((r) => this.config.quality.options.includes(r)));
  const i = !E.empty(this.options.quality) && this.options.quality.length > 1;
  if (O.toggleMenuButton.call(this, e, i), Zt(t), O.checkMenu.call(this), !i) return;
  const n = (r) => {
    const a = Te.get(`qualityBadge.${r}`, this.config);
    return a.length ? O.createBadge.call(this, a) : null;
  };
  this.options.quality.sort((r, a) => {
    const o = this.config.quality.options;
    return o.indexOf(r) > o.indexOf(a) ? 1 : -1;
  }).forEach((r) => {
    O.createMenuItem.call(this, { value: r, list: t, type: e, title: O.getLabel.call(this, "quality", r), badge: n(r) });
  }), O.updateSetting.call(this, e, t);
}, setCaptionsMenu() {
  if (!E.element(this.elements.settings.panels.captions)) return;
  const s = "captions", e = this.elements.settings.panels.captions.querySelector('[role="menu"]'), t = ee.getTracks.call(this), i = !!t.length;
  if (O.toggleMenuButton.call(this, s, i), Zt(e), O.checkMenu.call(this), !i) return;
  const n = t.map((r, a) => ({ value: a, checked: this.captions.toggled && this.currentTrack === a, title: ee.getLabel.call(this, r), badge: r.language && O.createBadge.call(this, r.language.toUpperCase()), list: e, type: "language" }));
  n.unshift({ value: -1, checked: !this.captions.toggled, title: Te.get("disabled", this.config), list: e, type: "language" }), n.forEach(O.createMenuItem.bind(this)), O.updateSetting.call(this, s, e);
}, setSpeedMenu() {
  if (!E.element(this.elements.settings.panels.speed)) return;
  const s = "speed", e = this.elements.settings.panels.speed.querySelector('[role="menu"]');
  this.options.speed = this.options.speed.filter((i) => i >= this.minimumSpeed && i <= this.maximumSpeed);
  const t = !E.empty(this.options.speed) && this.options.speed.length > 1;
  O.toggleMenuButton.call(this, s, t), Zt(e), O.checkMenu.call(this), t && (this.options.speed.forEach((i) => {
    O.createMenuItem.call(this, { value: i, list: e, type: s, title: O.getLabel.call(this, "speed", i) });
  }), O.updateSetting.call(this, s, e));
}, checkMenu() {
  const { buttons: s } = this.elements.settings, e = !E.empty(s) && Object.values(s).some((t) => !t.hidden);
  it(this.elements.settings.menu, !e);
}, focusFirstMenuItem(s, e = !1) {
  if (this.elements.settings.popup.hidden) return;
  let t = s;
  E.element(t) || (t = Object.values(this.elements.settings.panels).find((n) => !n.hidden));
  const i = t.querySelector('[role^="menuitem"]');
  Pi.call(this, i, e);
}, toggleMenu(s) {
  const { popup: e } = this.elements.settings, t = this.elements.buttons.settings;
  if (!E.element(e) || !E.element(t)) return;
  const { hidden: i } = e;
  let n = i;
  if (E.boolean(s)) n = s;
  else if (E.keyboardEvent(s) && s.key === "Escape") n = !1;
  else if (E.event(s)) {
    const r = E.function(s.composedPath) ? s.composedPath()[0] : s.target, a = e.contains(r);
    if (a || !a && s.target !== t && n) return;
  }
  t.setAttribute("aria-expanded", n), it(e, !n), ie(this.elements.container, this.config.classNames.menu.open, n), n && E.keyboardEvent(s) ? O.focusFirstMenuItem.call(this, null, !0) : n || i || Pi.call(this, t, E.keyboardEvent(s));
}, getMenuSize(s) {
  const e = s.cloneNode(!0);
  e.style.position = "absolute", e.style.opacity = 0, e.removeAttribute("hidden"), s.parentNode.appendChild(e);
  const t = e.scrollWidth, i = e.scrollHeight;
  return ze(e), { width: t, height: i };
}, showMenuPanel(s = "", e = !1) {
  const t = this.elements.container.querySelector(`#plyr-settings-${this.id}-${s}`);
  if (!E.element(t)) return;
  const i = t.parentNode, n = Array.from(i.children).find((r) => !r.hidden);
  if (ue.transitions && !ue.reducedMotion) {
    i.style.width = `${n.scrollWidth}px`, i.style.height = `${n.scrollHeight}px`;
    const r = O.getMenuSize.call(this, t), a = (o) => {
      o.target === i && ["width", "height"].includes(o.propertyName) && (i.style.width = "", i.style.height = "", Ri.call(this, i, rs, a));
    };
    J.call(this, i, rs, a), i.style.width = `${r.width}px`, i.style.height = `${r.height}px`;
  }
  it(n, !0), it(t, !1), O.focusFirstMenuItem.call(this, t, e);
}, setDownloadUrl() {
  const s = this.elements.buttons.download;
  E.element(s) && s.setAttribute("href", this.download);
}, create(s) {
  const { bindMenuItemShortcuts: e, createButton: t, createProgress: i, createRange: n, createTime: r, setQualityMenu: a, setSpeedMenu: o, showMenuPanel: l } = O;
  this.elements.controls = null, E.array(this.config.controls) && this.config.controls.includes("play-large") && this.elements.container.appendChild(t.call(this, "play-large"));
  const c = K("div", Ne(this.config.selectors.controls.wrapper));
  this.elements.controls = c;
  const h = { class: "plyr__controls__item" };
  return os(E.array(this.config.controls) ? this.config.controls : []).forEach((u) => {
    if (u === "restart" && c.appendChild(t.call(this, "restart", h)), u === "rewind" && c.appendChild(t.call(this, "rewind", h)), u === "play" && c.appendChild(t.call(this, "play", h)), u === "fast-forward" && c.appendChild(t.call(this, "fast-forward", h)), u === "progress") {
      const d = K("div", { class: `${h.class} plyr__progress__container` }), g = K("div", Ne(this.config.selectors.progress));
      if (g.appendChild(n.call(this, "seek", { id: `plyr-seek-${s.id}` })), g.appendChild(i.call(this, "buffer")), this.config.tooltips.seek) {
        const f = K("span", { class: this.config.classNames.tooltip }, "00:00");
        g.appendChild(f), this.elements.display.seekTooltip = f;
      }
      this.elements.progress = g, d.appendChild(this.elements.progress), c.appendChild(d);
    }
    if (u === "current-time" && c.appendChild(r.call(this, "currentTime", h)), u === "duration" && c.appendChild(r.call(this, "duration", h)), u === "mute" || u === "volume") {
      let { volume: d } = this.elements;
      if (E.element(d) && c.contains(d) || (d = K("div", he({}, h, { class: `${h.class} plyr__volume`.trim() })), this.elements.volume = d, c.appendChild(d)), u === "mute" && d.appendChild(t.call(this, "mute")), u === "volume" && !Ee.isIos && !Ee.isIPadOS) {
        const g = { max: 1, step: 0.05, value: this.config.volume };
        d.appendChild(n.call(this, "volume", he(g, { id: `plyr-volume-${s.id}` })));
      }
    }
    if (u === "captions" && c.appendChild(t.call(this, "captions", h)), u === "settings" && !E.empty(this.config.settings)) {
      const d = K("div", he({}, h, { class: `${h.class} plyr__menu`.trim(), hidden: "" }));
      d.appendChild(t.call(this, "settings", { "aria-haspopup": !0, "aria-controls": `plyr-settings-${s.id}`, "aria-expanded": !1 }));
      const g = K("div", { class: "plyr__menu__container", id: `plyr-settings-${s.id}`, hidden: "" }), f = K("div"), m = K("div", { id: `plyr-settings-${s.id}-home` }), y = K("div", { role: "menu" });
      m.appendChild(y), f.appendChild(m), this.elements.settings.panels.home = m, this.config.settings.forEach((T) => {
        const b = K("button", he(Ne(this.config.selectors.buttons.settings), { type: "button", class: `${this.config.classNames.control} ${this.config.classNames.control}--forward`, role: "menuitem", "aria-haspopup": !0, hidden: "" }));
        e.call(this, b, T), J.call(this, b, "click", () => {
          l.call(this, T, !1);
        });
        const v = K("span", null, Te.get(T, this.config)), A = K("span", { class: this.config.classNames.menu.value });
        A.innerHTML = s[T], v.appendChild(A), b.appendChild(v), y.appendChild(b);
        const x = K("div", { id: `plyr-settings-${s.id}-${T}`, hidden: "" }), w = K("button", { type: "button", class: `${this.config.classNames.control} ${this.config.classNames.control}--back` });
        w.appendChild(K("span", { "aria-hidden": !0 }, Te.get(T, this.config))), w.appendChild(K("span", { class: this.config.classNames.hidden }, Te.get("menuBack", this.config))), J.call(this, x, "keydown", (R) => {
          R.key === "ArrowLeft" && (R.preventDefault(), R.stopPropagation(), l.call(this, "home", !0));
        }, !1), J.call(this, w, "click", () => {
          l.call(this, "home", !1);
        }), x.appendChild(w), x.appendChild(K("div", { role: "menu" })), f.appendChild(x), this.elements.settings.buttons[T] = b, this.elements.settings.panels[T] = x;
      }), g.appendChild(f), d.appendChild(g), c.appendChild(d), this.elements.settings.popup = g, this.elements.settings.menu = d;
    }
    if (u === "pip" && ue.pip && c.appendChild(t.call(this, "pip", h)), u === "airplay" && ue.airplay && c.appendChild(t.call(this, "airplay", h)), u === "download") {
      const d = he({}, h, { element: "a", href: this.download, target: "_blank" });
      this.isHTML5 && (d.download = "");
      const { download: g } = this.config.urls;
      !E.url(g) && this.isEmbed && he(d, { icon: `logo-${this.provider}`, label: this.provider }), c.appendChild(t.call(this, "download", d));
    }
    u === "fullscreen" && c.appendChild(t.call(this, "fullscreen", h));
  }), this.isHTML5 && a.call(this, et.getQualityOptions.call(this)), o.call(this), c;
}, inject() {
  if (this.config.loadSprite) {
    const n = O.getIconUrl.call(this);
    n.cors && wr(n.url, "sprite-plyr");
  }
  this.id = Math.floor(1e4 * Math.random());
  let s = null;
  this.elements.controls = null;
  const e = { id: this.id, seektime: this.config.seekTime, title: this.config.title };
  let t = !0;
  E.function(this.config.controls) && (this.config.controls = this.config.controls.call(this, e)), this.config.controls || (this.config.controls = []), E.element(this.config.controls) || E.string(this.config.controls) ? s = this.config.controls : (s = O.create.call(this, { id: this.id, seektime: this.config.seekTime, speed: this.speed, quality: this.quality, captions: ee.getLabel.call(this) }), t = !1);
  let i;
  if (t && E.string(this.config.controls) && (s = ((n) => {
    let r = n;
    return Object.entries(e).forEach(([a, o]) => {
      r = Rt(r, `{${a}}`, o);
    }), r;
  })(s)), E.string(this.config.selectors.controls.container) && (i = document.querySelector(this.config.selectors.controls.container)), E.element(i) || (i = this.elements.container), i[E.element(s) ? "insertAdjacentElement" : "insertAdjacentHTML"]("afterbegin", s), E.element(this.elements.controls) || O.findElements.call(this), !E.empty(this.elements.buttons)) {
    const n = (r) => {
      const a = this.config.classNames.controlPressed;
      r.setAttribute("aria-pressed", "false"), Object.defineProperty(r, "pressed", { configurable: !0, enumerable: !0, get: () => ui(r, a), set(o = !1) {
        ie(r, a, o), r.setAttribute("aria-pressed", o ? "true" : "false");
      } });
    };
    Object.values(this.elements.buttons).filter(Boolean).forEach((r) => {
      E.array(r) || E.nodeList(r) ? Array.from(r).filter(Boolean).forEach(n) : n(r);
    });
  }
  if (Ee.isEdge && vr(i), this.config.tooltips.controls) {
    const { classNames: n, selectors: r } = this.config, a = `${r.controls.wrapper} ${r.labels} .${n.hidden}`, o = wt.call(this, a);
    Array.from(o).forEach((l) => {
      ie(l, this.config.classNames.hidden, !1), ie(l, this.config.classNames.tooltip, !0);
    });
  }
}, setMediaMetadata() {
  try {
    "mediaSession" in navigator && (navigator.mediaSession.metadata = new window.MediaMetadata({ title: this.config.mediaMetadata.title, artist: this.config.mediaMetadata.artist, album: this.config.mediaMetadata.album, artwork: this.config.mediaMetadata.artwork }));
  } catch (s) {
  }
}, setMarkers() {
  var s, e;
  if (!this.duration || this.elements.markers) return;
  const t = (s = this.config.markers) === null || s === void 0 || (e = s.points) === null || e === void 0 ? void 0 : e.filter(({ time: l }) => l > 0 && l < this.duration);
  if (t == null || !t.length) return;
  const i = document.createDocumentFragment(), n = document.createDocumentFragment();
  let r = null;
  const a = `${this.config.classNames.tooltip}--visible`, o = (l) => ie(r, a, l);
  t.forEach((l) => {
    const c = K("span", { class: this.config.classNames.marker }, ""), h = l.time / this.duration * 100 + "%";
    r && (c.addEventListener("mouseenter", () => {
      l.label || (r.style.left = h, r.innerHTML = l.label, o(!0));
    }), c.addEventListener("mouseleave", () => {
      o(!1);
    })), c.addEventListener("click", () => {
      this.currentTime = l.time;
    }), c.style.left = h, n.appendChild(c);
  }), i.appendChild(n), this.config.tooltips.seek || (r = K("span", { class: this.config.classNames.tooltip }, ""), i.appendChild(r)), this.elements.markers = { points: n, tip: r }, this.elements.progress.appendChild(i);
} };
function Dr(s, e = !0) {
  let t = s;
  if (e) {
    const i = document.createElement("a");
    i.href = t, t = i.href;
  }
  try {
    return new URL(t);
  } catch (i) {
    return null;
  }
}
function kr(s) {
  const e = new URLSearchParams();
  return E.object(s) && Object.entries(s).forEach(([t, i]) => {
    e.set(t, i);
  }), e;
}
const ee = { setup() {
  if (!this.supported.ui) return;
  if (!this.isVideo || this.isYouTube || this.isHTML5 && !ue.textTracks) return void (E.array(this.config.controls) && this.config.controls.includes("settings") && this.config.settings.includes("captions") && O.setCaptionsMenu.call(this));
  if (E.element(this.elements.captions) || (this.elements.captions = K("div", Ne(this.config.selectors.captions)), this.elements.captions.setAttribute("dir", "auto"), wo(this.elements.captions, this.elements.wrapper)), Ee.isIE && window.URL) {
    const i = this.media.querySelectorAll("track");
    Array.from(i).forEach((n) => {
      const r = n.getAttribute("src"), a = Dr(r);
      a !== null && a.hostname !== window.location.href.hostname && ["http:", "https:"].includes(a.protocol) && Nt(r, "blob").then((o) => {
        n.setAttribute("src", window.URL.createObjectURL(o));
      }).catch(() => {
        ze(n);
      });
    });
  }
  const s = os((navigator.languages || [navigator.language || navigator.userLanguage || "en"]).map((i) => i.split("-")[0]));
  let e = (this.storage.get("language") || this.config.captions.language || "auto").toLowerCase();
  e === "auto" && ([e] = s);
  let t = this.storage.get("captions");
  if (E.boolean(t) || ({ active: t } = this.config.captions), Object.assign(this.captions, { toggled: !1, active: t, language: e, languages: s }), this.isHTML5) {
    const i = this.config.captions.update ? "addtrack removetrack" : "removetrack";
    J.call(this, this.media.textTracks, i, ee.update.bind(this));
  }
  setTimeout(ee.update.bind(this), 0);
}, update() {
  const s = ee.getTracks.call(this, !0), { active: e, language: t, meta: i, currentTrackNode: n } = this.captions, r = !!s.find((a) => a.language === t);
  this.isHTML5 && this.isVideo && s.filter((a) => !i.get(a)).forEach((a) => {
    this.debug.log("Track added", a), i.set(a, { default: a.mode === "showing" }), a.mode === "showing" && (a.mode = "hidden"), J.call(this, a, "cuechange", () => ee.updateCues.call(this));
  }), (r && this.language !== t || !s.includes(n)) && (ee.setLanguage.call(this, t), ee.toggle.call(this, e && r)), this.elements && ie(this.elements.container, this.config.classNames.captions.enabled, !E.empty(s)), E.array(this.config.controls) && this.config.controls.includes("settings") && this.config.settings.includes("captions") && O.setCaptionsMenu.call(this);
}, toggle(s, e = !0) {
  if (!this.supported.ui) return;
  const { toggled: t } = this.captions, i = this.config.classNames.captions.active, n = E.nullOrUndefined(s) ? !t : s;
  if (n !== t) {
    if (e || (this.captions.active = n, this.storage.set({ captions: n })), !this.language && n && !e) {
      const r = ee.getTracks.call(this), a = ee.findTrack.call(this, [this.captions.language, ...this.captions.languages], !0);
      return this.captions.language = a.language, void ee.set.call(this, r.indexOf(a));
    }
    this.elements.buttons.captions && (this.elements.buttons.captions.pressed = n), ie(this.elements.container, i, n), this.captions.toggled = n, O.updateSetting.call(this, "captions"), W.call(this, this.media, n ? "captionsenabled" : "captionsdisabled");
  }
  setTimeout(() => {
    n && this.captions.toggled && (this.captions.currentTrackNode.mode = "hidden");
  });
}, set(s, e = !0) {
  const t = ee.getTracks.call(this);
  if (s !== -1) if (E.number(s)) if (s in t) {
    if (this.captions.currentTrack !== s) {
      this.captions.currentTrack = s;
      const i = t[s], { language: n } = i || {};
      this.captions.currentTrackNode = i, O.updateSetting.call(this, "captions"), e || (this.captions.language = n, this.storage.set({ language: n })), this.isVimeo && this.embed.enableTextTrack(n), W.call(this, this.media, "languagechange");
    }
    ee.toggle.call(this, !0, e), this.isHTML5 && this.isVideo && ee.updateCues.call(this);
  } else this.debug.warn("Track not found", s);
  else this.debug.warn("Invalid caption argument", s);
  else ee.toggle.call(this, !1, e);
}, setLanguage(s, e = !0) {
  if (!E.string(s)) return void this.debug.warn("Invalid language argument", s);
  const t = s.toLowerCase();
  this.captions.language = t;
  const i = ee.getTracks.call(this), n = ee.findTrack.call(this, [t]);
  ee.set.call(this, i.indexOf(n), e);
}, getTracks(s = !1) {
  return Array.from((this.media || {}).textTracks || []).filter((e) => !this.isHTML5 || s || this.captions.meta.has(e)).filter((e) => ["captions", "subtitles"].includes(e.kind));
}, findTrack(s, e = !1) {
  const t = ee.getTracks.call(this), i = (a) => Number((this.captions.meta.get(a) || {}).default), n = Array.from(t).sort((a, o) => i(o) - i(a));
  let r;
  return s.every((a) => (r = n.find((o) => o.language === a), !r)), r || (e ? n[0] : void 0);
}, getCurrentTrack() {
  return ee.getTracks.call(this)[this.currentTrack];
}, getLabel(s) {
  let e = s;
  return !E.track(e) && ue.textTracks && this.captions.toggled && (e = ee.getCurrentTrack.call(this)), E.track(e) ? E.empty(e.label) ? E.empty(e.language) ? Te.get("enabled", this.config) : s.language.toUpperCase() : e.label : Te.get("disabled", this.config);
}, updateCues(s) {
  if (!this.supported.ui) return;
  if (!E.element(this.elements.captions)) return void this.debug.warn("No captions element to render to");
  if (!E.nullOrUndefined(s) && !Array.isArray(s)) return void this.debug.warn("updateCues: Invalid input", s);
  let e = s;
  if (!e) {
    const i = ee.getCurrentTrack.call(this);
    e = Array.from((i || {}).activeCues || []).map((n) => n.getCueAsHTML()).map(Bo);
  }
  const t = e.map((i) => i.trim()).join(`
`);
  if (t !== this.elements.captions.innerHTML) {
    Zt(this.elements.captions);
    const i = K("span", Ne(this.config.selectors.caption));
    i.innerHTML = t, this.elements.captions.appendChild(i), W.call(this, this.media, "cuechange");
  }
} }, Pr = { enabled: !0, title: "", debug: !1, autoplay: !1, autopause: !0, playsinline: !0, seekTime: 10, volume: 1, muted: !1, duration: null, displayDuration: !0, invertTime: !0, toggleInvert: !0, ratio: null, clickToPlay: !0, hideControls: !0, resetOnEnd: !1, disableContextMenu: !0, loadSprite: !0, iconPrefix: "plyr", iconUrl: "https://cdn.plyr.io/3.7.8/plyr.svg", blankVideo: "https://cdn.plyr.io/static/blank.mp4", quality: { default: 576, options: [4320, 2880, 2160, 1440, 1080, 720, 576, 480, 360, 240], forced: !1, onChange: null }, loop: { active: !1 }, speed: { selected: 1, options: [0.5, 0.75, 1, 1.25, 1.5, 1.75, 2, 4] }, keyboard: { focused: !0, global: !1 }, tooltips: { controls: !1, seek: !0 }, captions: { active: !1, language: "auto", update: !1 }, fullscreen: { enabled: !0, fallback: !0, iosNative: !1 }, storage: { enabled: !0, key: "plyr" }, controls: ["play-large", "play", "progress", "current-time", "mute", "volume", "captions", "settings", "pip", "airplay", "fullscreen"], settings: ["captions", "quality", "speed"], i18n: { restart: "Restart", rewind: "Rewind {seektime}s", play: "Play", pause: "Pause", fastForward: "Forward {seektime}s", seek: "Seek", seekLabel: "{currentTime} of {duration}", played: "Played", buffered: "Buffered", currentTime: "Current time", duration: "Duration", volume: "Volume", mute: "Mute", unmute: "Unmute", enableCaptions: "Enable captions", disableCaptions: "Disable captions", download: "Download", enterFullscreen: "Enter fullscreen", exitFullscreen: "Exit fullscreen", frameTitle: "Player for {title}", captions: "Captions", settings: "Settings", pip: "PIP", menuBack: "Go back to previous menu", speed: "Speed", normal: "Normal", quality: "Quality", loop: "Loop", start: "Start", end: "End", all: "All", reset: "Reset", disabled: "Disabled", enabled: "Enabled", advertisement: "Ad", qualityBadge: { 2160: "4K", 1440: "HD", 1080: "HD", 720: "HD", 576: "SD", 480: "SD" } }, urls: { download: null, vimeo: { sdk: "https://player.vimeo.com/api/player.js", iframe: "https://player.vimeo.com/video/{0}?{1}", api: "https://vimeo.com/api/oembed.json?url={0}" }, youtube: { sdk: "https://www.youtube.com/iframe_api", api: "https://noembed.com/embed?url=https://www.youtube.com/watch?v={0}" }, googleIMA: { sdk: "https://imasdk.googleapis.com/js/sdkloader/ima3.js" } }, listeners: { seek: null, play: null, pause: null, restart: null, rewind: null, fastForward: null, mute: null, volume: null, captions: null, download: null, fullscreen: null, pip: null, airplay: null, speed: null, quality: null, loop: null, language: null }, events: ["ended", "progress", "stalled", "playing", "waiting", "canplay", "canplaythrough", "loadstart", "loadeddata", "loadedmetadata", "timeupdate", "volumechange", "play", "pause", "error", "seeking", "seeked", "emptied", "ratechange", "cuechange", "download", "enterfullscreen", "exitfullscreen", "captionsenabled", "captionsdisabled", "languagechange", "controlshidden", "controlsshown", "ready", "statechange", "qualitychange", "adsloaded", "adscontentpause", "adscontentresume", "adstarted", "adsmidpoint", "adscomplete", "adsallcomplete", "adsimpression", "adsclick"], selectors: { editable: "input, textarea, select, [contenteditable]", container: ".plyr", controls: { container: null, wrapper: ".plyr__controls" }, labels: "[data-plyr]", buttons: { play: '[data-plyr="play"]', pause: '[data-plyr="pause"]', restart: '[data-plyr="restart"]', rewind: '[data-plyr="rewind"]', fastForward: '[data-plyr="fast-forward"]', mute: '[data-plyr="mute"]', captions: '[data-plyr="captions"]', download: '[data-plyr="download"]', fullscreen: '[data-plyr="fullscreen"]', pip: '[data-plyr="pip"]', airplay: '[data-plyr="airplay"]', settings: '[data-plyr="settings"]', loop: '[data-plyr="loop"]' }, inputs: { seek: '[data-plyr="seek"]', volume: '[data-plyr="volume"]', speed: '[data-plyr="speed"]', language: '[data-plyr="language"]', quality: '[data-plyr="quality"]' }, display: { currentTime: ".plyr__time--current", duration: ".plyr__time--duration", buffer: ".plyr__progress__buffer", loop: ".plyr__progress__loop", volume: ".plyr__volume--display" }, progress: ".plyr__progress", captions: ".plyr__captions", caption: ".plyr__caption" }, classNames: { type: "plyr--{0}", provider: "plyr--{0}", video: "plyr__video-wrapper", embed: "plyr__video-embed", videoFixedRatio: "plyr__video-wrapper--fixed-ratio", embedContainer: "plyr__video-embed__container", poster: "plyr__poster", posterEnabled: "plyr__poster-enabled", ads: "plyr__ads", control: "plyr__control", controlPressed: "plyr__control--pressed", playing: "plyr--playing", paused: "plyr--paused", stopped: "plyr--stopped", loading: "plyr--loading", hover: "plyr--hover", tooltip: "plyr__tooltip", cues: "plyr__cues", marker: "plyr__progress__marker", hidden: "plyr__sr-only", hideControls: "plyr--hide-controls", isTouch: "plyr--is-touch", uiSupported: "plyr--full-ui", noTransition: "plyr--no-transition", display: { time: "plyr__time" }, menu: { value: "plyr__menu__value", badge: "plyr__badge", open: "plyr--menu-open" }, captions: { enabled: "plyr--captions-enabled", active: "plyr--captions-active" }, fullscreen: { enabled: "plyr--fullscreen-enabled", fallback: "plyr--fullscreen-fallback" }, pip: { supported: "plyr--pip-supported", active: "plyr--pip-active" }, airplay: { supported: "plyr--airplay-supported", active: "plyr--airplay-active" }, previewThumbnails: { thumbContainer: "plyr__preview-thumb", thumbContainerShown: "plyr__preview-thumb--is-shown", imageContainer: "plyr__preview-thumb__image-container", timeContainer: "plyr__preview-thumb__time-container", scrubbingContainer: "plyr__preview-scrubbing", scrubbingContainerShown: "plyr__preview-scrubbing--is-shown" } }, attributes: { embed: { provider: "data-plyr-provider", id: "data-plyr-embed-id", hash: "data-plyr-embed-hash" } }, ads: { enabled: !1, publisherId: "", tagUrl: "" }, previewThumbnails: { enabled: !1, src: "" }, vimeo: { byline: !1, portrait: !1, title: !1, speed: !0, transparent: !1, customControls: !0, referrerPolicy: null, premium: !1 }, youtube: { rel: 0, showinfo: 0, iv_load_policy: 3, modestbranding: 1, customControls: !0, noCookie: !1 }, mediaMetadata: { title: "", artist: "", album: "", artwork: [] }, markers: { enabled: !1, points: [] } }, _i = { active: "picture-in-picture", inactive: "inline" }, Ze = { html5: "html5", youtube: "youtube", vimeo: "vimeo" }, Oi = { audio: "audio", video: "video" };
function Ho(s) {
  return /^(https?:\/\/)?(www\.)?(youtube\.com|youtube-nocookie\.com|youtu\.?be)\/.+$/.test(s) ? Ze.youtube : /^https?:\/\/player.vimeo.com\/video\/\d{0,9}(?=\b|\/)/.test(s) ? Ze.vimeo : null;
}
const Fi = () => {
};
class Ko {
  constructor(e = !1) {
    this.enabled = window.console && e, this.enabled && this.log("Debugging enabled");
  }
  get log() {
    return this.enabled ? Function.prototype.bind.call(console.log, console) : Fi;
  }
  get warn() {
    return this.enabled ? Function.prototype.bind.call(console.warn, console) : Fi;
  }
  get error() {
    return this.enabled ? Function.prototype.bind.call(console.error, console) : Fi;
  }
}
class _e {
  constructor(e) {
    F(this, "onChange", () => {
      if (!this.supported) return;
      const t = this.player.elements.buttons.fullscreen;
      E.element(t) && (t.pressed = this.active);
      const i = this.target === this.player.media ? this.target : this.player.elements.container;
      W.call(this.player, i, this.active ? "enterfullscreen" : "exitfullscreen", !0);
    }), F(this, "toggleFallback", (t = !1) => {
      var i, n;
      if (t ? this.scrollPosition = { x: (i = window.scrollX) != null ? i : 0, y: (n = window.scrollY) != null ? n : 0 } : window.scrollTo(this.scrollPosition.x, this.scrollPosition.y), document.body.style.overflow = t ? "hidden" : "", ie(this.target, this.player.config.classNames.fullscreen.fallback, t), Ee.isIos) {
        let r = document.head.querySelector('meta[name="viewport"]');
        const a = "viewport-fit=cover";
        r || (r = document.createElement("meta"), r.setAttribute("name", "viewport"));
        const o = E.string(r.content) && r.content.includes(a);
        t ? (this.cleanupViewport = !o, o || (r.content += `,${a}`)) : this.cleanupViewport && (r.content = r.content.split(",").filter((l) => l.trim() !== a).join(","));
      }
      this.onChange();
    }), F(this, "trapFocus", (t) => {
      if (Ee.isIos || Ee.isIPadOS || !this.active || t.key !== "Tab") return;
      const i = document.activeElement, n = wt.call(this.player, "a[href], button:not(:disabled), input:not(:disabled), [tabindex]"), [r] = n, a = n[n.length - 1];
      i !== a || t.shiftKey ? i === r && t.shiftKey && (a.focus(), t.preventDefault()) : (r.focus(), t.preventDefault());
    }), F(this, "update", () => {
      if (this.supported) {
        let t;
        t = this.forceFallback ? "Fallback (forced)" : _e.nativeSupported ? "Native" : "Fallback", this.player.debug.log(`${t} fullscreen enabled`);
      } else this.player.debug.log("Fullscreen not supported and fallback disabled");
      ie(this.player.elements.container, this.player.config.classNames.fullscreen.enabled, this.supported);
    }), F(this, "enter", () => {
      this.supported && (Ee.isIos && this.player.config.fullscreen.iosNative ? this.player.isVimeo ? this.player.embed.requestFullscreen() : this.target.webkitEnterFullscreen() : !_e.nativeSupported || this.forceFallback ? this.toggleFallback(!0) : this.prefix ? E.empty(this.prefix) || this.target[`${this.prefix}Request${this.property}`]() : this.target.requestFullscreen({ navigationUI: "hide" }));
    }), F(this, "exit", () => {
      if (this.supported) if (Ee.isIos && this.player.config.fullscreen.iosNative) this.player.isVimeo ? this.player.embed.exitFullscreen() : this.target.webkitEnterFullscreen(), $e(this.player.play());
      else if (!_e.nativeSupported || this.forceFallback) this.toggleFallback(!1);
      else if (this.prefix) {
        if (!E.empty(this.prefix)) {
          const t = this.prefix === "moz" ? "Cancel" : "Exit";
          document[`${this.prefix}${t}${this.property}`]();
        }
      } else (document.cancelFullScreen || document.exitFullscreen).call(document);
    }), F(this, "toggle", () => {
      this.active ? this.exit() : this.enter();
    }), this.player = e, this.prefix = _e.prefix, this.property = _e.property, this.scrollPosition = { x: 0, y: 0 }, this.forceFallback = e.config.fullscreen.fallback === "force", this.player.elements.fullscreen = e.config.fullscreen.container && Co(this.player.elements.container, e.config.fullscreen.container), J.call(this.player, document, this.prefix === "ms" ? "MSFullscreenChange" : `${this.prefix}fullscreenchange`, () => {
      this.onChange();
    }), J.call(this.player, this.player.elements.container, "dblclick", (t) => {
      E.element(this.player.elements.controls) && this.player.elements.controls.contains(t.target) || this.player.listeners.proxy(t, this.toggle, "fullscreen");
    }), J.call(this, this.player.elements.container, "keydown", (t) => this.trapFocus(t)), this.update();
  }
  static get nativeSupported() {
    return !!(document.fullscreenEnabled || document.webkitFullscreenEnabled || document.mozFullScreenEnabled || document.msFullscreenEnabled);
  }
  get useNative() {
    return _e.nativeSupported && !this.forceFallback;
  }
  static get prefix() {
    if (E.function(document.exitFullscreen)) return "";
    let e = "";
    return ["webkit", "moz", "ms"].some((t) => !(!E.function(document[`${t}ExitFullscreen`]) && !E.function(document[`${t}CancelFullScreen`])) && (e = t, !0)), e;
  }
  static get property() {
    return this.prefix === "moz" ? "FullScreen" : "Fullscreen";
  }
  get supported() {
    return [this.player.config.fullscreen.enabled, this.player.isVideo, _e.nativeSupported || this.player.config.fullscreen.fallback, !this.player.isYouTube || _e.nativeSupported || !Ee.isIos || this.player.config.playsinline && !this.player.config.fullscreen.iosNative].every(Boolean);
  }
  get active() {
    if (!this.supported) return !1;
    if (!_e.nativeSupported || this.forceFallback) return ui(this.target, this.player.config.classNames.fullscreen.fallback);
    const e = this.prefix ? this.target.getRootNode()[`${this.prefix}${this.property}Element`] : this.target.getRootNode().fullscreenElement;
    return e && e.shadowRoot ? e === this.target.getRootNode().host : e === this.target;
  }
  get target() {
    var e;
    return Ee.isIos && this.player.config.fullscreen.iosNative ? this.player.media : (e = this.player.elements.fullscreen) != null ? e : this.player.elements.container;
  }
}
function ei(s, e = 1) {
  return new Promise((t, i) => {
    const n = new Image(), r = () => {
      delete n.onload, delete n.onerror, (n.naturalWidth >= e ? t : i)(n);
    };
    Object.assign(n, { onload: r, onerror: r, src: s });
  });
}
const oe = { addStyleHook() {
  ie(this.elements.container, this.config.selectors.container.replace(".", ""), !0), ie(this.elements.container, this.config.classNames.uiSupported, this.supported.ui);
}, toggleNativeControls(s = !1) {
  s && this.isHTML5 ? this.media.setAttribute("controls", "") : this.media.removeAttribute("controls");
}, build() {
  if (this.listeners.media(), !this.supported.ui) return this.debug.warn(`Basic support only for ${this.provider} ${this.type}`), void oe.toggleNativeControls.call(this, !0);
  E.element(this.elements.controls) || (O.inject.call(this), this.listeners.controls()), oe.toggleNativeControls.call(this), this.isHTML5 && ee.setup.call(this), this.volume = null, this.muted = null, this.loop = null, this.quality = null, this.speed = null, O.updateVolume.call(this), O.timeUpdate.call(this), O.durationUpdate.call(this), oe.checkPlaying.call(this), ie(this.elements.container, this.config.classNames.pip.supported, ue.pip && this.isHTML5 && this.isVideo), ie(this.elements.container, this.config.classNames.airplay.supported, ue.airplay && this.isHTML5), ie(this.elements.container, this.config.classNames.isTouch, this.touch), this.ready = !0, setTimeout(() => {
    W.call(this, this.media, "ready");
  }, 0), oe.setTitle.call(this), this.poster && oe.setPoster.call(this, this.poster, !1).catch(() => {
  }), this.config.duration && O.durationUpdate.call(this), this.config.mediaMetadata && O.setMediaMetadata.call(this);
}, setTitle() {
  let s = Te.get("play", this.config);
  if (E.string(this.config.title) && !E.empty(this.config.title) && (s += `, ${this.config.title}`), Array.from(this.elements.buttons.play || []).forEach((e) => {
    e.setAttribute("aria-label", s);
  }), this.isEmbed) {
    const e = ge.call(this, "iframe");
    if (!E.element(e)) return;
    const t = E.empty(this.config.title) ? "video" : this.config.title, i = Te.get("frameTitle", this.config);
    e.setAttribute("title", i.replace("{title}", t));
  }
}, togglePoster(s) {
  ie(this.elements.container, this.config.classNames.posterEnabled, s);
}, setPoster(s, e = !0) {
  return e && this.poster ? Promise.reject(new Error("Poster already set")) : (this.media.setAttribute("data-poster", s), this.elements.poster.removeAttribute("hidden"), Po.call(this).then(() => ei(s)).catch((t) => {
    throw s === this.poster && oe.togglePoster.call(this, !1), t;
  }).then(() => {
    if (s !== this.poster) throw new Error("setPoster cancelled by later call to setPoster");
  }).then(() => (Object.assign(this.elements.poster.style, { backgroundImage: `url('${s}')`, backgroundSize: "" }), oe.togglePoster.call(this, !0), s)));
}, checkPlaying(s) {
  ie(this.elements.container, this.config.classNames.playing, this.playing), ie(this.elements.container, this.config.classNames.paused, this.paused), ie(this.elements.container, this.config.classNames.stopped, this.stopped), Array.from(this.elements.buttons.play || []).forEach((e) => {
    Object.assign(e, { pressed: this.playing }), e.setAttribute("aria-label", Te.get(this.playing ? "pause" : "play", this.config));
  }), E.event(s) && s.type === "timeupdate" || oe.toggleControls.call(this);
}, checkLoading(s) {
  this.loading = ["stalled", "waiting"].includes(s.type), clearTimeout(this.timers.loading), this.timers.loading = setTimeout(() => {
    ie(this.elements.container, this.config.classNames.loading, this.loading), oe.toggleControls.call(this);
  }, this.loading ? 250 : 0);
}, toggleControls(s) {
  const { controls: e } = this.elements;
  if (e && this.config.hideControls) {
    const t = this.touch && this.lastSeekTime + 2e3 > Date.now();
    this.toggleControls(!!(s || this.loading || this.paused || e.pressed || e.hover || t));
  }
}, migrateStyles() {
  Object.values(tt({}, this.media.style)).filter((s) => !E.empty(s) && E.string(s) && s.startsWith("--plyr")).forEach((s) => {
    this.elements.container.style.setProperty(s, this.media.style.getPropertyValue(s)), this.media.style.removeProperty(s);
  }), E.empty(this.media.style) && this.media.removeAttribute("style");
} };
class Vo {
  constructor(e) {
    F(this, "firstTouch", () => {
      const { player: t } = this, { elements: i } = t;
      t.touch = !0, ie(i.container, t.config.classNames.isTouch, !0);
    }), F(this, "global", (t = !0) => {
      const { player: i } = this;
      i.config.keyboard.global && Ct.call(i, window, "keydown keyup", this.handleKey, t, !1), Ct.call(i, document.body, "click", this.toggleMenu, t), Cs.call(i, document.body, "touchstart", this.firstTouch);
    }), F(this, "container", () => {
      const { player: t } = this, { config: i, elements: n, timers: r } = t;
      !i.keyboard.global && i.keyboard.focused && J.call(t, n.container, "keydown keyup", this.handleKey, !1), J.call(t, n.container, "mousemove mouseleave touchstart touchmove enterfullscreen exitfullscreen", (l) => {
        const { controls: c } = n;
        c && l.type === "enterfullscreen" && (c.pressed = !1, c.hover = !1);
        let h = 0;
        ["touchstart", "touchmove", "mousemove"].includes(l.type) && (oe.toggleControls.call(t, !0), h = t.touch ? 3e3 : 2e3), clearTimeout(r.controls), r.controls = setTimeout(() => oe.toggleControls.call(t, !1), h);
      });
      const a = () => {
        if (!t.isVimeo || t.config.vimeo.premium) return;
        const l = n.wrapper, { active: c } = t.fullscreen, [h, u] = Ds.call(t), d = Ar(`aspect-ratio: ${h} / ${u}`);
        if (!c) return void (d ? (l.style.width = null, l.style.height = null) : (l.style.maxWidth = null, l.style.margin = null));
        const [g, f] = _o(), m = g / f > h / u;
        d ? (l.style.width = m ? "auto" : "100%", l.style.height = m ? "100%" : "auto") : (l.style.maxWidth = m ? f / u * h + "px" : null, l.style.margin = m ? "0 auto" : null);
      }, o = () => {
        clearTimeout(r.resized), r.resized = setTimeout(a, 50);
      };
      J.call(t, n.container, "enterfullscreen exitfullscreen", (l) => {
        const { target: c } = t.fullscreen;
        c === n.container && (!t.isEmbed && E.empty(t.config.ratio) || (a(), (l.type === "enterfullscreen" ? J : Ri).call(t, window, "resize", o)));
      });
    }), F(this, "media", () => {
      const { player: t } = this, { elements: i } = t;
      if (J.call(t, t.media, "timeupdate seeking seeked", (r) => O.timeUpdate.call(t, r)), J.call(t, t.media, "durationchange loadeddata loadedmetadata", (r) => O.durationUpdate.call(t, r)), J.call(t, t.media, "ended", () => {
        t.isHTML5 && t.isVideo && t.config.resetOnEnd && (t.restart(), t.pause());
      }), J.call(t, t.media, "progress playing seeking seeked", (r) => O.updateProgress.call(t, r)), J.call(t, t.media, "volumechange", (r) => O.updateVolume.call(t, r)), J.call(t, t.media, "playing play pause ended emptied timeupdate", (r) => oe.checkPlaying.call(t, r)), J.call(t, t.media, "waiting canplay seeked playing", (r) => oe.checkLoading.call(t, r)), t.supported.ui && t.config.clickToPlay && !t.isAudio) {
        const r = ge.call(t, `.${t.config.classNames.video}`);
        if (!E.element(r)) return;
        J.call(t, i.container, "click", (a) => {
          ([i.container, r].includes(a.target) || r.contains(a.target)) && (t.touch && t.config.hideControls || (t.ended ? (this.proxy(a, t.restart, "restart"), this.proxy(a, () => {
            $e(t.play());
          }, "play")) : this.proxy(a, () => {
            $e(t.togglePlay());
          }, "play")));
        });
      }
      t.supported.ui && t.config.disableContextMenu && J.call(t, i.wrapper, "contextmenu", (r) => {
        r.preventDefault();
      }, !1), J.call(t, t.media, "volumechange", () => {
        t.storage.set({ volume: t.volume, muted: t.muted });
      }), J.call(t, t.media, "ratechange", () => {
        O.updateSetting.call(t, "speed"), t.storage.set({ speed: t.speed });
      }), J.call(t, t.media, "qualitychange", (r) => {
        O.updateSetting.call(t, "quality", null, r.detail.quality);
      }), J.call(t, t.media, "ready qualitychange", () => {
        O.setDownloadUrl.call(t);
      });
      const n = t.config.events.concat(["keyup", "keydown"]).join(" ");
      J.call(t, t.media, n, (r) => {
        let { detail: a = {} } = r;
        r.type === "error" && (a = t.media.error), W.call(t, i.container, r.type, !0, a);
      });
    }), F(this, "proxy", (t, i, n) => {
      const { player: r } = this, a = r.config.listeners[n];
      let o = !0;
      E.function(a) && (o = a.call(r, t)), o !== !1 && E.function(i) && i.call(r, t);
    }), F(this, "bind", (t, i, n, r, a = !0) => {
      const { player: o } = this, l = o.config.listeners[r], c = E.function(l);
      J.call(o, t, i, (h) => this.proxy(h, n, r), a && !c);
    }), F(this, "controls", () => {
      const { player: t } = this, { elements: i } = t, n = Ee.isIE ? "change" : "input";
      if (i.buttons.play && Array.from(i.buttons.play).forEach((r) => {
        this.bind(r, "click", () => {
          $e(t.togglePlay());
        }, "play");
      }), this.bind(i.buttons.restart, "click", t.restart, "restart"), this.bind(i.buttons.rewind, "click", () => {
        t.lastSeekTime = Date.now(), t.rewind();
      }, "rewind"), this.bind(i.buttons.fastForward, "click", () => {
        t.lastSeekTime = Date.now(), t.forward();
      }, "fastForward"), this.bind(i.buttons.mute, "click", () => {
        t.muted = !t.muted;
      }, "mute"), this.bind(i.buttons.captions, "click", () => t.toggleCaptions()), this.bind(i.buttons.download, "click", () => {
        W.call(t, t.media, "download");
      }, "download"), this.bind(i.buttons.fullscreen, "click", () => {
        t.fullscreen.toggle();
      }, "fullscreen"), this.bind(i.buttons.pip, "click", () => {
        t.pip = "toggle";
      }, "pip"), this.bind(i.buttons.airplay, "click", t.airplay, "airplay"), this.bind(i.buttons.settings, "click", (r) => {
        r.stopPropagation(), r.preventDefault(), O.toggleMenu.call(t, r);
      }, null, !1), this.bind(i.buttons.settings, "keyup", (r) => {
        [" ", "Enter"].includes(r.key) && (r.key !== "Enter" ? (r.preventDefault(), r.stopPropagation(), O.toggleMenu.call(t, r)) : O.focusFirstMenuItem.call(t, null, !0));
      }, null, !1), this.bind(i.settings.menu, "keydown", (r) => {
        r.key === "Escape" && O.toggleMenu.call(t, r);
      }), this.bind(i.inputs.seek, "mousedown mousemove", (r) => {
        const a = i.progress.getBoundingClientRect(), o = 100 / a.width * (r.pageX - a.left);
        r.currentTarget.setAttribute("seek-value", o);
      }), this.bind(i.inputs.seek, "mousedown mouseup keydown keyup touchstart touchend", (r) => {
        const a = r.currentTarget, o = "play-on-seeked";
        if (E.keyboardEvent(r) && !["ArrowLeft", "ArrowRight"].includes(r.key)) return;
        t.lastSeekTime = Date.now();
        const l = a.hasAttribute(o), c = ["mouseup", "touchend", "keyup"].includes(r.type);
        l && c ? (a.removeAttribute(o), $e(t.play())) : !c && t.playing && (a.setAttribute(o, ""), t.pause());
      }), Ee.isIos) {
        const r = wt.call(t, 'input[type="range"]');
        Array.from(r).forEach((a) => this.bind(a, n, (o) => vr(o.target)));
      }
      this.bind(i.inputs.seek, n, (r) => {
        const a = r.currentTarget;
        let o = a.getAttribute("seek-value");
        E.empty(o) && (o = a.value), a.removeAttribute("seek-value"), t.currentTime = o / a.max * t.duration;
      }, "seek"), this.bind(i.progress, "mouseenter mouseleave mousemove", (r) => O.updateSeekTooltip.call(t, r)), this.bind(i.progress, "mousemove touchmove", (r) => {
        const { previewThumbnails: a } = t;
        a && a.loaded && a.startMove(r);
      }), this.bind(i.progress, "mouseleave touchend click", () => {
        const { previewThumbnails: r } = t;
        r && r.loaded && r.endMove(!1, !0);
      }), this.bind(i.progress, "mousedown touchstart", (r) => {
        const { previewThumbnails: a } = t;
        a && a.loaded && a.startScrubbing(r);
      }), this.bind(i.progress, "mouseup touchend", (r) => {
        const { previewThumbnails: a } = t;
        a && a.loaded && a.endScrubbing(r);
      }), Ee.isWebKit && Array.from(wt.call(t, 'input[type="range"]')).forEach((r) => {
        this.bind(r, "input", (a) => O.updateRangeFill.call(t, a.target));
      }), t.config.toggleInvert && !E.element(i.display.duration) && this.bind(i.display.currentTime, "click", () => {
        t.currentTime !== 0 && (t.config.invertTime = !t.config.invertTime, O.timeUpdate.call(t));
      }), this.bind(i.inputs.volume, n, (r) => {
        t.volume = r.target.value;
      }, "volume"), this.bind(i.controls, "mouseenter mouseleave", (r) => {
        i.controls.hover = !t.touch && r.type === "mouseenter";
      }), i.fullscreen && Array.from(i.fullscreen.children).filter((r) => !r.contains(i.container)).forEach((r) => {
        this.bind(r, "mouseenter mouseleave", (a) => {
          i.controls && (i.controls.hover = !t.touch && a.type === "mouseenter");
        });
      }), this.bind(i.controls, "mousedown mouseup touchstart touchend touchcancel", (r) => {
        i.controls.pressed = ["mousedown", "touchstart"].includes(r.type);
      }), this.bind(i.controls, "focusin", () => {
        const { config: r, timers: a } = t;
        ie(i.controls, r.classNames.noTransition, !0), oe.toggleControls.call(t, !0), setTimeout(() => {
          ie(i.controls, r.classNames.noTransition, !1);
        }, 0);
        const o = this.touch ? 3e3 : 4e3;
        clearTimeout(a.controls), a.controls = setTimeout(() => oe.toggleControls.call(t, !1), o);
      }), this.bind(i.inputs.volume, "wheel", (r) => {
        const a = r.webkitDirectionInvertedFromDevice, [o, l] = [r.deltaX, -r.deltaY].map((u) => a ? -u : u), c = Math.sign(Math.abs(o) > Math.abs(l) ? o : l);
        t.increaseVolume(c / 50);
        const { volume: h } = t.media;
        (c === 1 && h < 1 || c === -1 && h > 0) && r.preventDefault();
      }, "volume", !1);
    }), this.player = e, this.lastKey = null, this.focusTimer = null, this.lastKeyDown = null, this.handleKey = this.handleKey.bind(this), this.toggleMenu = this.toggleMenu.bind(this), this.firstTouch = this.firstTouch.bind(this);
  }
  handleKey(e) {
    const { player: t } = this, { elements: i } = t, { key: n, type: r, altKey: a, ctrlKey: o, metaKey: l, shiftKey: c } = e, h = r === "keydown", u = h && n === this.lastKey;
    if (!(a || o || l || c) && n) {
      if (h) {
        const g = document.activeElement;
        if (E.element(g)) {
          const { editable: f } = t.config.selectors, { seek: m } = i.inputs;
          if (g !== m && at(g, f) || e.key === " " && at(g, 'button, [role^="menuitem"]')) return;
        }
        switch ([" ", "ArrowLeft", "ArrowUp", "ArrowRight", "ArrowDown", "0", "1", "2", "3", "4", "5", "6", "7", "8", "9", "c", "f", "k", "l", "m"].includes(n) && (e.preventDefault(), e.stopPropagation()), n) {
          case "0":
          case "1":
          case "2":
          case "3":
          case "4":
          case "5":
          case "6":
          case "7":
          case "8":
          case "9":
            u || (d = parseInt(n, 10), t.currentTime = t.duration / 10 * d);
            break;
          case " ":
          case "k":
            u || $e(t.togglePlay());
            break;
          case "ArrowUp":
            t.increaseVolume(0.1);
            break;
          case "ArrowDown":
            t.decreaseVolume(0.1);
            break;
          case "m":
            u || (t.muted = !t.muted);
            break;
          case "ArrowRight":
            t.forward();
            break;
          case "ArrowLeft":
            t.rewind();
            break;
          case "f":
            t.fullscreen.toggle();
            break;
          case "c":
            u || t.toggleCaptions();
            break;
          case "l":
            t.loop = !t.loop;
        }
        n === "Escape" && !t.fullscreen.usingNative && t.fullscreen.active && t.fullscreen.toggle(), this.lastKey = n;
      } else this.lastKey = null;
      var d;
    }
  }
  toggleMenu(e) {
    O.toggleMenu.call(this.player, e);
  }
}
function Wo(s, e) {
  return s(e = { exports: {} }, e.exports), e.exports;
}
var Yo = Wo(function(s, e) {
  s.exports = function() {
    var t = function() {
    }, i = {}, n = {}, r = {};
    function a(d, g) {
      d = d.push ? d : [d];
      var f, m, y, T = [], b = d.length, v = b;
      for (f = function(A, x) {
        x.length && T.push(A), --v || g(T);
      }; b--; ) m = d[b], (y = n[m]) ? f(m, y) : (r[m] = r[m] || []).push(f);
    }
    function o(d, g) {
      if (d) {
        var f = r[d];
        if (n[d] = g, f) for (; f.length; ) f[0](d, g), f.splice(0, 1);
      }
    }
    function l(d, g) {
      d.call && (d = { success: d }), g.length ? (d.error || t)(g) : (d.success || t)(d);
    }
    function c(d, g, f, m) {
      var y, T, b = document, v = f.async, A = (f.numRetries || 0) + 1, x = f.before || t, w = d.replace(/[\?|#].*$/, ""), R = d.replace(/^(css|img)!/, "");
      m = m || 0, /(^css!|\.css$)/.test(w) ? ((T = b.createElement("link")).rel = "stylesheet", T.href = R, (y = "hideFocus" in T) && T.relList && (y = 0, T.rel = "preload", T.as = "style")) : /(^img!|\.(png|gif|jpg|svg|webp)$)/.test(w) ? (T = b.createElement("img")).src = R : ((T = b.createElement("script")).src = d, T.async = v === void 0 || v), T.onload = T.onerror = T.onbeforeload = function(k) {
        var _ = k.type[0];
        if (y) try {
          T.sheet.cssText.length || (_ = "e");
        } catch (C) {
          C.code != 18 && (_ = "e");
        }
        if (_ == "e") {
          if ((m += 1) < A) return c(d, g, f, m);
        } else if (T.rel == "preload" && T.as == "style") return T.rel = "stylesheet";
        g(d, _, k.defaultPrevented);
      }, x(d, T) !== !1 && b.head.appendChild(T);
    }
    function h(d, g, f) {
      var m, y, T = (d = d.push ? d : [d]).length, b = T, v = [];
      for (m = function(A, x, w) {
        if (x == "e" && v.push(A), x == "b") {
          if (!w) return;
          v.push(A);
        }
        --T || g(v);
      }, y = 0; y < b; y++) c(d[y], m, f);
    }
    function u(d, g, f) {
      var m, y;
      if (g && g.trim && (m = g), y = (m ? f : g) || {}, m) {
        if (m in i) throw "LoadJS";
        i[m] = !0;
      }
      function T(b, v) {
        h(d, function(A) {
          l(y, A), b && l({ success: b, error: v }, A), o(m, A);
        }, y);
      }
      if (y.returnPromise) return new Promise(T);
      T();
    }
    return u.ready = function(d, g) {
      return a(d, function(f) {
        l(g, f);
      }), u;
    }, u.done = function(d) {
      o(d, []);
    }, u.reset = function() {
      i = {}, n = {}, r = {};
    }, u.isDefined = function(d) {
      return d in i;
    }, u;
  }();
});
function ks(s) {
  return new Promise((e, t) => {
    Yo(s, { success: e, error: t });
  });
}
function jo(s) {
  return E.empty(s) ? null : E.number(Number(s)) ? s : s.match(/^.*(vimeo.com\/|video\/)(\d+).*/) ? RegExp.$2 : s;
}
function qo(s) {
  const e = s.match(/^.*(vimeo.com\/|video\/)(\d+)(\?.*&*h=|\/)+([\d,a-f]+)/);
  return e && e.length === 5 ? e[4] : null;
}
function St(s) {
  s && !this.embed.hasPlayed && (this.embed.hasPlayed = !0), this.media.paused === s && (this.media.paused = !s, W.call(this, this.media, s ? "play" : "pause"));
}
const cs = { setup() {
  const s = this;
  ie(s.elements.wrapper, s.config.classNames.embed, !0), s.options.speed = s.config.speed.options, Tt.call(s), E.object(window.Vimeo) ? cs.ready.call(s) : ks(s.config.urls.vimeo.sdk).then(() => {
    cs.ready.call(s);
  }).catch((e) => {
    s.debug.warn("Vimeo SDK (player.js) failed to load", e);
  });
}, ready() {
  const s = this, e = s.config.vimeo, b = e, { premium: t, referrerPolicy: i } = b, n = Zs(b, ["premium", "referrerPolicy"]);
  let r = s.media.getAttribute("src"), a = "";
  E.empty(r) ? (r = s.media.getAttribute(s.config.attributes.embed.id), a = s.media.getAttribute(s.config.attributes.embed.hash)) : a = qo(r);
  const o = a ? { h: a } : {};
  t && Object.assign(n, { controls: !1, sidedock: !1 });
  const l = kr(tt(tt({ loop: s.config.loop.active, autoplay: s.autoplay, muted: s.muted, gesture: "media", playsinline: s.config.playsinline }, o), n)), c = jo(r), h = K("iframe"), u = ls(s.config.urls.vimeo.iframe, c, l);
  if (h.setAttribute("src", u), h.setAttribute("allowfullscreen", ""), h.setAttribute("allow", ["autoplay", "fullscreen", "picture-in-picture", "encrypted-media", "accelerometer", "gyroscope"].join("; ")), E.empty(i) || h.setAttribute("referrerPolicy", i), t || !e.customControls) h.setAttribute("data-poster", s.poster), s.media = hi(h, s.media);
  else {
    const v = K("div", { class: s.config.classNames.embedContainer, "data-poster": s.poster });
    v.appendChild(h), s.media = hi(v, s.media);
  }
  e.customControls || Nt(ls(s.config.urls.vimeo.api, u)).then((v) => {
    !E.empty(v) && v.thumbnail_url && oe.setPoster.call(s, v.thumbnail_url).catch(() => {
    });
  }), s.embed = new window.Vimeo.Player(h, { autopause: s.config.autopause, muted: s.muted }), s.media.paused = !0, s.media.currentTime = 0, s.supported.ui && s.embed.disableTextTrack(), s.media.play = () => (St.call(s, !0), s.embed.play()), s.media.pause = () => (St.call(s, !1), s.embed.pause()), s.media.stop = () => {
    s.pause(), s.currentTime = 0;
  };
  let { currentTime: d } = s.media;
  Object.defineProperty(s.media, "currentTime", { get: () => d, set(v) {
    const { embed: A, media: x, paused: w, volume: R } = s, k = w && !A.hasPlayed;
    x.seeking = !0, W.call(s, x, "seeking"), Promise.resolve(k && A.setVolume(0)).then(() => A.setCurrentTime(v)).then(() => k && A.pause()).then(() => k && A.setVolume(R)).catch(() => {
    });
  } });
  let g = s.config.speed.selected;
  Object.defineProperty(s.media, "playbackRate", { get: () => g, set(v) {
    s.embed.setPlaybackRate(v).then(() => {
      g = v, W.call(s, s.media, "ratechange");
    }).catch(() => {
      s.options.speed = [1];
    });
  } });
  let { volume: f } = s.config;
  Object.defineProperty(s.media, "volume", { get: () => f, set(v) {
    s.embed.setVolume(v).then(() => {
      f = v, W.call(s, s.media, "volumechange");
    });
  } });
  let { muted: m } = s.config;
  Object.defineProperty(s.media, "muted", { get: () => m, set(v) {
    const A = !!E.boolean(v) && v;
    s.embed.setMuted(!!A || s.config.muted).then(() => {
      m = A, W.call(s, s.media, "volumechange");
    });
  } });
  let y, { loop: T } = s.config;
  Object.defineProperty(s.media, "loop", { get: () => T, set(v) {
    const A = E.boolean(v) ? v : s.config.loop.active;
    s.embed.setLoop(A).then(() => {
      T = A;
    });
  } }), s.embed.getVideoUrl().then((v) => {
    y = v, O.setDownloadUrl.call(s);
  }).catch((v) => {
    this.debug.warn(v);
  }), Object.defineProperty(s.media, "currentSrc", { get: () => y }), Object.defineProperty(s.media, "ended", { get: () => s.currentTime === s.duration }), Promise.all([s.embed.getVideoWidth(), s.embed.getVideoHeight()]).then((v) => {
    const [A, x] = v;
    s.embed.ratio = Rr(A, x), Tt.call(this);
  }), s.embed.setAutopause(s.config.autopause).then((v) => {
    s.config.autopause = v;
  }), s.embed.getVideoTitle().then((v) => {
    s.config.title = v, oe.setTitle.call(this);
  }), s.embed.getCurrentTime().then((v) => {
    d = v, W.call(s, s.media, "timeupdate");
  }), s.embed.getDuration().then((v) => {
    s.media.duration = v, W.call(s, s.media, "durationchange");
  }), s.embed.getTextTracks().then((v) => {
    s.media.textTracks = v, ee.setup.call(s);
  }), s.embed.on("cuechange", ({ cues: v = [] }) => {
    const A = v.map((x) => Uo(x.text));
    ee.updateCues.call(s, A);
  }), s.embed.on("loaded", () => {
    s.embed.getPaused().then((v) => {
      St.call(s, !v), v || W.call(s, s.media, "playing");
    }), E.element(s.embed.element) && s.supported.ui && s.embed.element.setAttribute("tabindex", -1);
  }), s.embed.on("bufferstart", () => {
    W.call(s, s.media, "waiting");
  }), s.embed.on("bufferend", () => {
    W.call(s, s.media, "playing");
  }), s.embed.on("play", () => {
    St.call(s, !0), W.call(s, s.media, "playing");
  }), s.embed.on("pause", () => {
    St.call(s, !1);
  }), s.embed.on("timeupdate", (v) => {
    s.media.seeking = !1, d = v.seconds, W.call(s, s.media, "timeupdate");
  }), s.embed.on("progress", (v) => {
    s.media.buffered = v.percent, W.call(s, s.media, "progress"), parseInt(v.percent, 10) === 1 && W.call(s, s.media, "canplaythrough"), s.embed.getDuration().then((A) => {
      A !== s.media.duration && (s.media.duration = A, W.call(s, s.media, "durationchange"));
    });
  }), s.embed.on("seeked", () => {
    s.media.seeking = !1, W.call(s, s.media, "seeked");
  }), s.embed.on("ended", () => {
    s.media.paused = !0, W.call(s, s.media, "ended");
  }), s.embed.on("error", (v) => {
    s.media.error = v, W.call(s, s.media, "error");
  }), e.customControls && setTimeout(() => oe.build.call(s), 0);
} };
function zo(s) {
  return E.empty(s) ? null : s.match(/^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/) ? RegExp.$2 : s;
}
function At(s) {
  s && !this.embed.hasPlayed && (this.embed.hasPlayed = !0), this.media.paused === s && (this.media.paused = !s, W.call(this, this.media, s ? "play" : "pause"));
}
function Xo(s) {
  return s.noCookie ? "https://www.youtube-nocookie.com" : window.location.protocol === "http:" ? "http://www.youtube.com" : void 0;
}
const ti = { setup() {
  if (ie(this.elements.wrapper, this.config.classNames.embed, !0), E.object(window.YT) && E.function(window.YT.Player)) ti.ready.call(this);
  else {
    const s = window.onYouTubeIframeAPIReady;
    window.onYouTubeIframeAPIReady = () => {
      E.function(s) && s(), ti.ready.call(this);
    }, ks(this.config.urls.youtube.sdk).catch((e) => {
      this.debug.warn("YouTube API failed to load", e);
    });
  }
}, getTitle(s) {
  Nt(ls(this.config.urls.youtube.api, s)).then((e) => {
    if (E.object(e)) {
      const { title: t, height: i, width: n } = e;
      this.config.title = t, oe.setTitle.call(this), this.embed.ratio = Rr(n, i);
    }
    Tt.call(this);
  }).catch(() => {
    Tt.call(this);
  });
}, ready() {
  const s = this, e = s.config.youtube, t = s.media && s.media.getAttribute("id");
  if (!E.empty(t) && t.startsWith("youtube-")) return;
  let i = s.media.getAttribute("src");
  E.empty(i) && (i = s.media.getAttribute(this.config.attributes.embed.id));
  const n = zo(i), r = K("div", { id: Oo(s.provider), "data-poster": e.customControls ? s.poster : void 0 });
  if (s.media = hi(r, s.media), e.customControls) {
    const a = (o) => `https://i.ytimg.com/vi/${n}/${o}default.jpg`;
    ei(a("maxres"), 121).catch(() => ei(a("sd"), 121)).catch(() => ei(a("hq"))).then((o) => oe.setPoster.call(s, o.src)).then((o) => {
      o.includes("maxres") || (s.elements.poster.style.backgroundSize = "cover");
    }).catch(() => {
    });
  }
  s.embed = new window.YT.Player(s.media, { videoId: n, host: Xo(e), playerVars: he({}, { autoplay: s.config.autoplay ? 1 : 0, hl: s.config.hl, controls: s.supported.ui && e.customControls ? 0 : 1, disablekb: 1, playsinline: s.config.playsinline && !s.config.fullscreen.iosNative ? 1 : 0, cc_load_policy: s.captions.active ? 1 : 0, cc_lang_pref: s.config.captions.language, widget_referrer: window ? window.location.href : null }, e), events: { onError(a) {
    if (!s.media.error) {
      const o = a.data, l = { 2: "The request contains an invalid parameter value. For example, this error occurs if you specify a video ID that does not have 11 characters, or if the video ID contains invalid characters, such as exclamation points or asterisks.", 5: "The requested content cannot be played in an HTML5 player or another error related to the HTML5 player has occurred.", 100: "The video requested was not found. This error occurs when a video has been removed (for any reason) or has been marked as private.", 101: "The owner of the requested video does not allow it to be played in embedded players.", 150: "The owner of the requested video does not allow it to be played in embedded players." }[o] || "An unknown error occurred";
      s.media.error = { code: o, message: l }, W.call(s, s.media, "error");
    }
  }, onPlaybackRateChange(a) {
    const o = a.target;
    s.media.playbackRate = o.getPlaybackRate(), W.call(s, s.media, "ratechange");
  }, onReady(a) {
    if (E.function(s.media.play)) return;
    const o = a.target;
    ti.getTitle.call(s, n), s.media.play = () => {
      At.call(s, !0), o.playVideo();
    }, s.media.pause = () => {
      At.call(s, !1), o.pauseVideo();
    }, s.media.stop = () => {
      o.stopVideo();
    }, s.media.duration = o.getDuration(), s.media.paused = !0, s.media.currentTime = 0, Object.defineProperty(s.media, "currentTime", { get: () => Number(o.getCurrentTime()), set(u) {
      s.paused && !s.embed.hasPlayed && s.embed.mute(), s.media.seeking = !0, W.call(s, s.media, "seeking"), o.seekTo(u);
    } }), Object.defineProperty(s.media, "playbackRate", { get: () => o.getPlaybackRate(), set(u) {
      o.setPlaybackRate(u);
    } });
    let { volume: l } = s.config;
    Object.defineProperty(s.media, "volume", { get: () => l, set(u) {
      l = u, o.setVolume(100 * l), W.call(s, s.media, "volumechange");
    } });
    let { muted: c } = s.config;
    Object.defineProperty(s.media, "muted", { get: () => c, set(u) {
      const d = E.boolean(u) ? u : c;
      c = d, o[d ? "mute" : "unMute"](), o.setVolume(100 * l), W.call(s, s.media, "volumechange");
    } }), Object.defineProperty(s.media, "currentSrc", { get: () => o.getVideoUrl() }), Object.defineProperty(s.media, "ended", { get: () => s.currentTime === s.duration });
    const h = o.getAvailablePlaybackRates();
    s.options.speed = h.filter((u) => s.config.speed.options.includes(u)), s.supported.ui && e.customControls && s.media.setAttribute("tabindex", -1), W.call(s, s.media, "timeupdate"), W.call(s, s.media, "durationchange"), clearInterval(s.timers.buffering), s.timers.buffering = setInterval(() => {
      s.media.buffered = o.getVideoLoadedFraction(), (s.media.lastBuffered === null || s.media.lastBuffered < s.media.buffered) && W.call(s, s.media, "progress"), s.media.lastBuffered = s.media.buffered, s.media.buffered === 1 && (clearInterval(s.timers.buffering), W.call(s, s.media, "canplaythrough"));
    }, 200), e.customControls && setTimeout(() => oe.build.call(s), 50);
  }, onStateChange(a) {
    const o = a.target;
    switch (clearInterval(s.timers.playing), s.media.seeking && [1, 2].includes(a.data) && (s.media.seeking = !1, W.call(s, s.media, "seeked")), a.data) {
      case -1:
        W.call(s, s.media, "timeupdate"), s.media.buffered = o.getVideoLoadedFraction(), W.call(s, s.media, "progress");
        break;
      case 0:
        At.call(s, !1), s.media.loop ? (o.stopVideo(), o.playVideo()) : W.call(s, s.media, "ended");
        break;
      case 1:
        e.customControls && !s.config.autoplay && s.media.paused && !s.embed.hasPlayed ? s.media.pause() : (At.call(s, !0), W.call(s, s.media, "playing"), s.timers.playing = setInterval(() => {
          W.call(s, s.media, "timeupdate");
        }, 50), s.media.duration !== o.getDuration() && (s.media.duration = o.getDuration(), W.call(s, s.media, "durationchange")));
        break;
      case 2:
        s.muted || s.embed.unMute(), At.call(s, !1);
        break;
      case 3:
        W.call(s, s.media, "waiting");
    }
    W.call(s, s.elements.container, "statechange", !1, { code: a.data });
  } } });
} }, _r = { setup() {
  this.media ? (ie(this.elements.container, this.config.classNames.type.replace("{0}", this.type), !0), ie(this.elements.container, this.config.classNames.provider.replace("{0}", this.provider), !0), this.isEmbed && ie(this.elements.container, this.config.classNames.type.replace("{0}", "video"), !0), this.isVideo && (this.elements.wrapper = K("div", { class: this.config.classNames.video }), xr(this.media, this.elements.wrapper), this.elements.poster = K("div", { class: this.config.classNames.poster }), this.elements.wrapper.appendChild(this.elements.poster)), this.isHTML5 ? et.setup.call(this) : this.isYouTube ? ti.setup.call(this) : this.isVimeo && cs.setup.call(this)) : this.debug.warn("No media element found!");
} };
class Qo {
  constructor(e) {
    F(this, "load", () => {
      this.enabled && (E.object(window.google) && E.object(window.google.ima) ? this.ready() : ks(this.player.config.urls.googleIMA.sdk).then(() => {
        this.ready();
      }).catch(() => {
        this.trigger("error", new Error("Google IMA SDK failed to load"));
      }));
    }), F(this, "ready", () => {
      var t;
      this.enabled || ((t = this).manager && t.manager.destroy(), t.elements.displayContainer && t.elements.displayContainer.destroy(), t.elements.container.remove()), this.startSafetyTimer(12e3, "ready()"), this.managerPromise.then(() => {
        this.clearSafetyTimer("onAdsManagerLoaded()");
      }), this.listeners(), this.setupIMA();
    }), F(this, "setupIMA", () => {
      this.elements.container = K("div", { class: this.player.config.classNames.ads }), this.player.elements.container.appendChild(this.elements.container), google.ima.settings.setVpaidMode(google.ima.ImaSdkSettings.VpaidMode.ENABLED), google.ima.settings.setLocale(this.player.config.ads.language), google.ima.settings.setDisableCustomPlaybackForIOS10Plus(this.player.config.playsinline), this.elements.displayContainer = new google.ima.AdDisplayContainer(this.elements.container, this.player.media), this.loader = new google.ima.AdsLoader(this.elements.displayContainer), this.loader.addEventListener(google.ima.AdsManagerLoadedEvent.Type.ADS_MANAGER_LOADED, (t) => this.onAdsManagerLoaded(t), !1), this.loader.addEventListener(google.ima.AdErrorEvent.Type.AD_ERROR, (t) => this.onAdError(t), !1), this.requestAds();
    }), F(this, "requestAds", () => {
      const { container: t } = this.player.elements;
      try {
        const i = new google.ima.AdsRequest();
        i.adTagUrl = this.tagUrl, i.linearAdSlotWidth = t.offsetWidth, i.linearAdSlotHeight = t.offsetHeight, i.nonLinearAdSlotWidth = t.offsetWidth, i.nonLinearAdSlotHeight = t.offsetHeight, i.forceNonLinearFullSlot = !1, i.setAdWillPlayMuted(!this.player.muted), this.loader.requestAds(i);
      } catch (i) {
        this.onAdError(i);
      }
    }), F(this, "pollCountdown", (t = !1) => {
      if (!t) return clearInterval(this.countdownTimer), void this.elements.container.removeAttribute("data-badge-text");
      this.countdownTimer = setInterval(() => {
        const i = Ii(Math.max(this.manager.getRemainingTime(), 0)), n = `${Te.get("advertisement", this.player.config)} - ${i}`;
        this.elements.container.setAttribute("data-badge-text", n);
      }, 100);
    }), F(this, "onAdsManagerLoaded", (t) => {
      if (!this.enabled) return;
      const i = new google.ima.AdsRenderingSettings();
      i.restoreCustomPlaybackStateOnAdBreakComplete = !0, i.enablePreloading = !0, this.manager = t.getAdsManager(this.player, i), this.cuePoints = this.manager.getCuePoints(), this.manager.addEventListener(google.ima.AdErrorEvent.Type.AD_ERROR, (n) => this.onAdError(n)), Object.keys(google.ima.AdEvent.Type).forEach((n) => {
        this.manager.addEventListener(google.ima.AdEvent.Type[n], (r) => this.onAdEvent(r));
      }), this.trigger("loaded");
    }), F(this, "addCuePoints", () => {
      E.empty(this.cuePoints) || this.cuePoints.forEach((t) => {
        if (t !== 0 && t !== -1 && t < this.player.duration) {
          const i = this.player.elements.progress;
          if (E.element(i)) {
            const n = 100 / this.player.duration * t, r = K("span", { class: this.player.config.classNames.cues });
            r.style.left = `${n.toString()}%`, i.appendChild(r);
          }
        }
      });
    }), F(this, "onAdEvent", (t) => {
      const { container: i } = this.player.elements, n = t.getAd(), r = t.getAdData();
      switch (((a) => {
        W.call(this.player, this.player.media, `ads${a.replace(/_/g, "").toLowerCase()}`);
      })(t.type), t.type) {
        case google.ima.AdEvent.Type.LOADED:
          this.trigger("loaded"), this.pollCountdown(!0), n.isLinear() || (n.width = i.offsetWidth, n.height = i.offsetHeight);
          break;
        case google.ima.AdEvent.Type.STARTED:
          this.manager.setVolume(this.player.volume);
          break;
        case google.ima.AdEvent.Type.ALL_ADS_COMPLETED:
          this.player.ended ? this.loadAds() : this.loader.contentComplete();
          break;
        case google.ima.AdEvent.Type.CONTENT_PAUSE_REQUESTED:
          this.pauseContent();
          break;
        case google.ima.AdEvent.Type.CONTENT_RESUME_REQUESTED:
          this.pollCountdown(), this.resumeContent();
          break;
        case google.ima.AdEvent.Type.LOG:
          r.adError && this.player.debug.warn(`Non-fatal ad error: ${r.adError.getMessage()}`);
      }
    }), F(this, "onAdError", (t) => {
      this.cancel(), this.player.debug.warn("Ads error", t);
    }), F(this, "listeners", () => {
      const { container: t } = this.player.elements;
      let i;
      this.player.on("canplay", () => {
        this.addCuePoints();
      }), this.player.on("ended", () => {
        this.loader.contentComplete();
      }), this.player.on("timeupdate", () => {
        i = this.player.currentTime;
      }), this.player.on("seeked", () => {
        const n = this.player.currentTime;
        E.empty(this.cuePoints) || this.cuePoints.forEach((r, a) => {
          i < r && r < n && (this.manager.discardAdBreak(), this.cuePoints.splice(a, 1));
        });
      }), window.addEventListener("resize", () => {
        this.manager && this.manager.resize(t.offsetWidth, t.offsetHeight, google.ima.ViewMode.NORMAL);
      });
    }), F(this, "play", () => {
      const { container: t } = this.player.elements;
      this.managerPromise || this.resumeContent(), this.managerPromise.then(() => {
        this.manager.setVolume(this.player.volume), this.elements.displayContainer.initialize();
        try {
          this.initialized || (this.manager.init(t.offsetWidth, t.offsetHeight, google.ima.ViewMode.NORMAL), this.manager.start()), this.initialized = !0;
        } catch (i) {
          this.onAdError(i);
        }
      }).catch(() => {
      });
    }), F(this, "resumeContent", () => {
      this.elements.container.style.zIndex = "", this.playing = !1, $e(this.player.media.play());
    }), F(this, "pauseContent", () => {
      this.elements.container.style.zIndex = 3, this.playing = !0, this.player.media.pause();
    }), F(this, "cancel", () => {
      this.initialized && this.resumeContent(), this.trigger("error"), this.loadAds();
    }), F(this, "loadAds", () => {
      this.managerPromise.then(() => {
        this.manager && this.manager.destroy(), this.managerPromise = new Promise((t) => {
          this.on("loaded", t), this.player.debug.log(this.manager);
        }), this.initialized = !1, this.requestAds();
      }).catch(() => {
      });
    }), F(this, "trigger", (t, ...i) => {
      const n = this.events[t];
      E.array(n) && n.forEach((r) => {
        E.function(r) && r.apply(this, i);
      });
    }), F(this, "on", (t, i) => (E.array(this.events[t]) || (this.events[t] = []), this.events[t].push(i), this)), F(this, "startSafetyTimer", (t, i) => {
      this.player.debug.log(`Safety timer invoked from: ${i}`), this.safetyTimer = setTimeout(() => {
        this.cancel(), this.clearSafetyTimer("startSafetyTimer()");
      }, t);
    }), F(this, "clearSafetyTimer", (t) => {
      E.nullOrUndefined(this.safetyTimer) || (this.player.debug.log(`Safety timer cleared from: ${t}`), clearTimeout(this.safetyTimer), this.safetyTimer = null);
    }), this.player = e, this.config = e.config.ads, this.playing = !1, this.initialized = !1, this.elements = { container: null, displayContainer: null }, this.manager = null, this.loader = null, this.cuePoints = null, this.events = {}, this.safetyTimer = null, this.countdownTimer = null, this.managerPromise = new Promise((t, i) => {
      this.on("loaded", t), this.on("error", i);
    }), this.load();
  }
  get enabled() {
    const { config: e } = this;
    return this.player.isHTML5 && this.player.isVideo && e.enabled && (!E.empty(e.publisherId) || E.url(e.tagUrl));
  }
  get tagUrl() {
    const { config: e } = this;
    return E.url(e.tagUrl) ? e.tagUrl : `https://go.aniview.com/api/adserver6/vast/?${kr({ AV_PUBLISHERID: "58c25bb0073ef448b1087ad6", AV_CHANNELID: "5a0458dc28a06145e4519d21", AV_URL: window.location.hostname, cb: Date.now(), AV_WIDTH: 640, AV_HEIGHT: 480, AV_CDIM2: e.publisherId })}`;
  }
}
function Or(s = 0, e = 0, t = 255) {
  return Math.min(Math.max(s, e), t);
}
const Jo = (s) => {
  const e = [];
  return s.split(/\r\n\r\n|\n\n|\r\r/).forEach((t) => {
    const i = {};
    t.split(/\r\n|\n|\r/).forEach((n) => {
      if (E.number(i.startTime)) {
        if (!E.empty(n.trim()) && E.empty(i.text)) {
          const r = n.trim().split("#xywh=");
          [i.text] = r, r[1] && ([i.x, i.y, i.w, i.h] = r[1].split(","));
        }
      } else {
        const r = n.match(/([0-9]{2})?:?([0-9]{2}):([0-9]{2}).([0-9]{2,3})( ?--> ?)([0-9]{2})?:?([0-9]{2}):([0-9]{2}).([0-9]{2,3})/);
        r && (i.startTime = 60 * Number(r[1] || 0) * 60 + 60 * Number(r[2]) + Number(r[3]) + +`0.${r[4]}`, i.endTime = 60 * Number(r[6] || 0) * 60 + 60 * Number(r[7]) + Number(r[8]) + +`0.${r[9]}`);
      }
    }), i.text && e.push(i);
  }), e;
}, cn = (s, e) => {
  const t = {};
  return s > e.width / e.height ? (t.width = e.width, t.height = 1 / s * e.width) : (t.height = e.height, t.width = s * e.height), t;
};
class hs {
  constructor(e) {
    F(this, "load", () => {
      this.player.elements.display.seekTooltip && (this.player.elements.display.seekTooltip.hidden = this.enabled), this.enabled && this.getThumbnails().then(() => {
        this.enabled && (this.render(), this.determineContainerAutoSizing(), this.listeners(), this.loaded = !0);
      });
    }), F(this, "getThumbnails", () => new Promise((t) => {
      const { src: i } = this.player.config.previewThumbnails;
      if (E.empty(i)) throw new Error("Missing previewThumbnails.src config attribute");
      const n = () => {
        this.thumbnails.sort((r, a) => r.height - a.height), this.player.debug.log("Preview thumbnails", this.thumbnails), t();
      };
      if (E.function(i)) i((r) => {
        this.thumbnails = r, n();
      });
      else {
        const r = (E.string(i) ? [i] : i).map((a) => this.getThumbnail(a));
        Promise.all(r).then(n);
      }
    })), F(this, "getThumbnail", (t) => new Promise((i) => {
      Nt(t).then((n) => {
        const r = { frames: Jo(n), height: null, urlPrefix: "" };
        r.frames[0].text.startsWith("/") || r.frames[0].text.startsWith("http://") || r.frames[0].text.startsWith("https://") || (r.urlPrefix = t.substring(0, t.lastIndexOf("/") + 1));
        const a = new Image();
        a.onload = () => {
          r.height = a.naturalHeight, r.width = a.naturalWidth, this.thumbnails.push(r), i();
        }, a.src = r.urlPrefix + r.frames[0].text;
      });
    })), F(this, "startMove", (t) => {
      if (this.loaded && E.event(t) && ["touchmove", "mousemove"].includes(t.type) && this.player.media.duration) {
        if (t.type === "touchmove") this.seekTime = this.player.media.duration * (this.player.elements.inputs.seek.value / 100);
        else {
          var i, n;
          const r = this.player.elements.progress.getBoundingClientRect(), a = 100 / r.width * (t.pageX - r.left);
          this.seekTime = this.player.media.duration * (a / 100), this.seekTime < 0 && (this.seekTime = 0), this.seekTime > this.player.media.duration - 1 && (this.seekTime = this.player.media.duration - 1), this.mousePosX = t.pageX, this.elements.thumb.time.innerText = Ii(this.seekTime);
          const o = (i = this.player.config.markers) === null || i === void 0 || (n = i.points) === null || n === void 0 ? void 0 : n.find(({ time: l }) => l === Math.round(this.seekTime));
          o && this.elements.thumb.time.insertAdjacentHTML("afterbegin", `${o.label}<br>`);
        }
        this.showImageAtCurrentTime();
      }
    }), F(this, "endMove", () => {
      this.toggleThumbContainer(!1, !0);
    }), F(this, "startScrubbing", (t) => {
      (E.nullOrUndefined(t.button) || t.button === !1 || t.button === 0) && (this.mouseDown = !0, this.player.media.duration && (this.toggleScrubbingContainer(!0), this.toggleThumbContainer(!1, !0), this.showImageAtCurrentTime()));
    }), F(this, "endScrubbing", () => {
      this.mouseDown = !1, Math.ceil(this.lastTime) === Math.ceil(this.player.media.currentTime) ? this.toggleScrubbingContainer(!1) : Cs.call(this.player, this.player.media, "timeupdate", () => {
        this.mouseDown || this.toggleScrubbingContainer(!1);
      });
    }), F(this, "listeners", () => {
      this.player.on("play", () => {
        this.toggleThumbContainer(!1, !0);
      }), this.player.on("seeked", () => {
        this.toggleThumbContainer(!1);
      }), this.player.on("timeupdate", () => {
        this.lastTime = this.player.media.currentTime;
      });
    }), F(this, "render", () => {
      this.elements.thumb.container = K("div", { class: this.player.config.classNames.previewThumbnails.thumbContainer }), this.elements.thumb.imageContainer = K("div", { class: this.player.config.classNames.previewThumbnails.imageContainer }), this.elements.thumb.container.appendChild(this.elements.thumb.imageContainer);
      const t = K("div", { class: this.player.config.classNames.previewThumbnails.timeContainer });
      this.elements.thumb.time = K("span", {}, "00:00"), t.appendChild(this.elements.thumb.time), this.elements.thumb.imageContainer.appendChild(t), E.element(this.player.elements.progress) && this.player.elements.progress.appendChild(this.elements.thumb.container), this.elements.scrubbing.container = K("div", { class: this.player.config.classNames.previewThumbnails.scrubbingContainer }), this.player.elements.wrapper.appendChild(this.elements.scrubbing.container);
    }), F(this, "destroy", () => {
      this.elements.thumb.container && this.elements.thumb.container.remove(), this.elements.scrubbing.container && this.elements.scrubbing.container.remove();
    }), F(this, "showImageAtCurrentTime", () => {
      this.mouseDown ? this.setScrubbingContainerSize() : this.setThumbContainerSizeAndPos();
      const t = this.thumbnails[0].frames.findIndex((r) => this.seekTime >= r.startTime && this.seekTime <= r.endTime), i = t >= 0;
      let n = 0;
      this.mouseDown || this.toggleThumbContainer(i), i && (this.thumbnails.forEach((r, a) => {
        this.loadedImages.includes(r.frames[t].text) && (n = a);
      }), t !== this.showingThumb && (this.showingThumb = t, this.loadImage(n)));
    }), F(this, "loadImage", (t = 0) => {
      const i = this.showingThumb, n = this.thumbnails[t], { urlPrefix: r } = n, a = n.frames[i], o = n.frames[i].text, l = r + o;
      if (this.currentImageElement && this.currentImageElement.dataset.filename === o) this.showImage(this.currentImageElement, a, t, i, o, !1), this.currentImageElement.dataset.index = i, this.removeOldImages(this.currentImageElement);
      else {
        this.loadingImage && this.usingSprites && (this.loadingImage.onload = null);
        const c = new Image();
        c.src = l, c.dataset.index = i, c.dataset.filename = o, this.showingThumbFilename = o, this.player.debug.log(`Loading image: ${l}`), c.onload = () => this.showImage(c, a, t, i, o, !0), this.loadingImage = c, this.removeOldImages(c);
      }
    }), F(this, "showImage", (t, i, n, r, a, o = !0) => {
      this.player.debug.log(`Showing thumb: ${a}. num: ${r}. qual: ${n}. newimg: ${o}`), this.setImageSizeAndOffset(t, i), o && (this.currentImageContainer.appendChild(t), this.currentImageElement = t, this.loadedImages.includes(a) || this.loadedImages.push(a)), this.preloadNearby(r, !0).then(this.preloadNearby(r, !1)).then(this.getHigherQuality(n, t, i, a));
    }), F(this, "removeOldImages", (t) => {
      Array.from(this.currentImageContainer.children).forEach((i) => {
        if (i.tagName.toLowerCase() !== "img") return;
        const n = this.usingSprites ? 500 : 1e3;
        if (i.dataset.index !== t.dataset.index && !i.dataset.deleting) {
          i.dataset.deleting = !0;
          const { currentImageContainer: r } = this;
          setTimeout(() => {
            r.removeChild(i), this.player.debug.log(`Removing thumb: ${i.dataset.filename}`);
          }, n);
        }
      });
    }), F(this, "preloadNearby", (t, i = !0) => new Promise((n) => {
      setTimeout(() => {
        const r = this.thumbnails[0].frames[t].text;
        if (this.showingThumbFilename === r) {
          let a;
          a = i ? this.thumbnails[0].frames.slice(t) : this.thumbnails[0].frames.slice(0, t).reverse();
          let o = !1;
          a.forEach((l) => {
            const c = l.text;
            if (c !== r && !this.loadedImages.includes(c)) {
              o = !0, this.player.debug.log(`Preloading thumb filename: ${c}`);
              const { urlPrefix: h } = this.thumbnails[0], u = h + c, d = new Image();
              d.src = u, d.onload = () => {
                this.player.debug.log(`Preloaded thumb filename: ${c}`), this.loadedImages.includes(c) || this.loadedImages.push(c), n();
              };
            }
          }), o || n();
        }
      }, 300);
    })), F(this, "getHigherQuality", (t, i, n, r) => {
      if (t < this.thumbnails.length - 1) {
        let a = i.naturalHeight;
        this.usingSprites && (a = n.h), a < this.thumbContainerHeight && setTimeout(() => {
          this.showingThumbFilename === r && (this.player.debug.log(`Showing higher quality thumb for: ${r}`), this.loadImage(t + 1));
        }, 300);
      }
    }), F(this, "toggleThumbContainer", (t = !1, i = !1) => {
      const n = this.player.config.classNames.previewThumbnails.thumbContainerShown;
      this.elements.thumb.container.classList.toggle(n, t), !t && i && (this.showingThumb = null, this.showingThumbFilename = null);
    }), F(this, "toggleScrubbingContainer", (t = !1) => {
      const i = this.player.config.classNames.previewThumbnails.scrubbingContainerShown;
      this.elements.scrubbing.container.classList.toggle(i, t), t || (this.showingThumb = null, this.showingThumbFilename = null);
    }), F(this, "determineContainerAutoSizing", () => {
      (this.elements.thumb.imageContainer.clientHeight > 20 || this.elements.thumb.imageContainer.clientWidth > 20) && (this.sizeSpecifiedInCSS = !0);
    }), F(this, "setThumbContainerSizeAndPos", () => {
      const { imageContainer: t } = this.elements.thumb;
      if (this.sizeSpecifiedInCSS) {
        if (t.clientHeight > 20 && t.clientWidth < 20) {
          const i = Math.floor(t.clientHeight * this.thumbAspectRatio);
          t.style.width = `${i}px`;
        } else if (t.clientHeight < 20 && t.clientWidth > 20) {
          const i = Math.floor(t.clientWidth / this.thumbAspectRatio);
          t.style.height = `${i}px`;
        }
      } else {
        const i = Math.floor(this.thumbContainerHeight * this.thumbAspectRatio);
        t.style.height = `${this.thumbContainerHeight}px`, t.style.width = `${i}px`;
      }
      this.setThumbContainerPos();
    }), F(this, "setThumbContainerPos", () => {
      const t = this.player.elements.progress.getBoundingClientRect(), i = this.player.elements.container.getBoundingClientRect(), { container: n } = this.elements.thumb, r = i.left - t.left + 10, a = i.right - t.left - n.clientWidth - 10, o = this.mousePosX - t.left - n.clientWidth / 2, l = Or(o, r, a);
      n.style.left = `${l}px`, n.style.setProperty("--preview-arrow-offset", o - l + "px");
    }), F(this, "setScrubbingContainerSize", () => {
      const { width: t, height: i } = cn(this.thumbAspectRatio, { width: this.player.media.clientWidth, height: this.player.media.clientHeight });
      this.elements.scrubbing.container.style.width = `${t}px`, this.elements.scrubbing.container.style.height = `${i}px`;
    }), F(this, "setImageSizeAndOffset", (t, i) => {
      if (!this.usingSprites) return;
      const n = this.thumbContainerHeight / i.h;
      t.style.height = t.naturalHeight * n + "px", t.style.width = t.naturalWidth * n + "px", t.style.left = `-${i.x * n}px`, t.style.top = `-${i.y * n}px`;
    }), this.player = e, this.thumbnails = [], this.loaded = !1, this.lastMouseMoveTime = Date.now(), this.mouseDown = !1, this.loadedImages = [], this.elements = { thumb: {}, scrubbing: {} }, this.load();
  }
  get enabled() {
    return this.player.isHTML5 && this.player.isVideo && this.player.config.previewThumbnails.enabled;
  }
  get currentImageContainer() {
    return this.mouseDown ? this.elements.scrubbing.container : this.elements.thumb.imageContainer;
  }
  get usingSprites() {
    return Object.keys(this.thumbnails[0].frames[0]).includes("w");
  }
  get thumbAspectRatio() {
    return this.usingSprites ? this.thumbnails[0].frames[0].w / this.thumbnails[0].frames[0].h : this.thumbnails[0].width / this.thumbnails[0].height;
  }
  get thumbContainerHeight() {
    if (this.mouseDown) {
      const { height: e } = cn(this.thumbAspectRatio, { width: this.player.media.clientWidth, height: this.player.media.clientHeight });
      return e;
    }
    return this.sizeSpecifiedInCSS ? this.elements.thumb.imageContainer.clientHeight : Math.floor(this.player.media.clientWidth / this.thumbAspectRatio / 4);
  }
  get currentImageElement() {
    return this.mouseDown ? this.currentScrubbingImageElement : this.currentThumbnailImageElement;
  }
  set currentImageElement(e) {
    this.mouseDown ? this.currentScrubbingImageElement = e : this.currentThumbnailImageElement = e;
  }
}
const us = { insertElements(s, e) {
  E.string(e) ? rn(s, this.media, { src: e }) : E.array(e) && e.forEach((t) => {
    rn(s, this.media, t);
  });
}, change(s) {
  br(s, "sources.length") ? (et.cancelRequests.call(this), this.destroy.call(this, () => {
    this.options.quality = [], ze(this.media), this.media = null, E.element(this.elements.container) && this.elements.container.removeAttribute("class");
    const { sources: e, type: t } = s, [{ provider: i = Ze.html5, src: n }] = e, r = i === "html5" ? t : "div", a = i === "html5" ? {} : { src: n };
    Object.assign(this, { provider: i, type: t, supported: ue.check(t, i, this.config.playsinline), media: K(r, a) }), this.elements.container.appendChild(this.media), E.boolean(s.autoplay) && (this.config.autoplay = s.autoplay), this.isHTML5 && (this.config.crossorigin && this.media.setAttribute("crossorigin", ""), this.config.autoplay && this.media.setAttribute("autoplay", ""), E.empty(s.poster) || (this.poster = s.poster), this.config.loop.active && this.media.setAttribute("loop", ""), this.config.muted && this.media.setAttribute("muted", ""), this.config.playsinline && this.media.setAttribute("playsinline", "")), oe.addStyleHook.call(this), this.isHTML5 && us.insertElements.call(this, "source", e), this.config.title = s.title, _r.setup.call(this), this.isHTML5 && Object.keys(s).includes("tracks") && us.insertElements.call(this, "track", s.tracks), (this.isHTML5 || this.isEmbed && !this.supported.ui) && oe.build.call(this), this.isHTML5 && this.media.load(), E.empty(s.previewThumbnails) || (Object.assign(this.config.previewThumbnails, s.previewThumbnails), this.previewThumbnails && this.previewThumbnails.loaded && (this.previewThumbnails.destroy(), this.previewThumbnails = null), this.config.previewThumbnails.enabled && (this.previewThumbnails = new hs(this))), this.fullscreen.update();
  }, !0)) : this.debug.warn("Invalid source format");
} };
class fi {
  constructor(e, t) {
    if (F(this, "play", () => E.function(this.media.play) ? (this.ads && this.ads.enabled && this.ads.managerPromise.then(() => this.ads.play()).catch(() => $e(this.media.play())), this.media.play()) : null), F(this, "pause", () => this.playing && E.function(this.media.pause) ? this.media.pause() : null), F(this, "togglePlay", (o) => (E.boolean(o) ? o : !this.playing) ? this.play() : this.pause()), F(this, "stop", () => {
      this.isHTML5 ? (this.pause(), this.restart()) : E.function(this.media.stop) && this.media.stop();
    }), F(this, "restart", () => {
      this.currentTime = 0;
    }), F(this, "rewind", (o) => {
      this.currentTime -= E.number(o) ? o : this.config.seekTime;
    }), F(this, "forward", (o) => {
      this.currentTime += E.number(o) ? o : this.config.seekTime;
    }), F(this, "increaseVolume", (o) => {
      const l = this.media.muted ? 0 : this.volume;
      this.volume = l + (E.number(o) ? o : 0);
    }), F(this, "decreaseVolume", (o) => {
      this.increaseVolume(-o);
    }), F(this, "airplay", () => {
      ue.airplay && this.media.webkitShowPlaybackTargetPicker();
    }), F(this, "toggleControls", (o) => {
      if (this.supported.ui && !this.isAudio) {
        const l = ui(this.elements.container, this.config.classNames.hideControls), c = o === void 0 ? void 0 : !o, h = ie(this.elements.container, this.config.classNames.hideControls, c);
        if (h && E.array(this.config.controls) && this.config.controls.includes("settings") && !E.empty(this.config.settings) && O.toggleMenu.call(this, !1), h !== l) {
          const u = h ? "controlshidden" : "controlsshown";
          W.call(this, this.media, u);
        }
        return !h;
      }
      return !1;
    }), F(this, "on", (o, l) => {
      J.call(this, this.elements.container, o, l);
    }), F(this, "once", (o, l) => {
      Cs.call(this, this.elements.container, o, l);
    }), F(this, "off", (o, l) => {
      Ri(this.elements.container, o, l);
    }), F(this, "destroy", (o, l = !1) => {
      if (!this.ready) return;
      const c = () => {
        document.body.style.overflow = "", this.embed = null, l ? (Object.keys(this.elements).length && (ze(this.elements.buttons.play), ze(this.elements.captions), ze(this.elements.controls), ze(this.elements.wrapper), this.elements.buttons.play = null, this.elements.captions = null, this.elements.controls = null, this.elements.wrapper = null), E.function(o) && o()) : (ko.call(this), et.cancelRequests.call(this), hi(this.elements.original, this.elements.container), W.call(this, this.elements.original, "destroyed", !0), E.function(o) && o.call(this.elements.original), this.ready = !1, setTimeout(() => {
          this.elements = null, this.media = null;
        }, 200));
      };
      this.stop(), clearTimeout(this.timers.loading), clearTimeout(this.timers.controls), clearTimeout(this.timers.resized), this.isHTML5 ? (oe.toggleNativeControls.call(this, !0), c()) : this.isYouTube ? (clearInterval(this.timers.buffering), clearInterval(this.timers.playing), this.embed !== null && E.function(this.embed.destroy) && this.embed.destroy(), c()) : this.isVimeo && (this.embed !== null && this.embed.unload().then(c), setTimeout(c, 200));
    }), F(this, "supports", (o) => ue.mime.call(this, o)), this.timers = {}, this.ready = !1, this.loading = !1, this.failed = !1, this.touch = ue.touch, this.media = e, E.string(this.media) && (this.media = document.querySelectorAll(this.media)), (window.jQuery && this.media instanceof jQuery || E.nodeList(this.media) || E.array(this.media)) && (this.media = this.media[0]), this.config = he({}, Pr, fi.defaults, t || {}, (() => {
      try {
        return JSON.parse(this.media.getAttribute("data-plyr-config"));
      } catch (o) {
        return {};
      }
    })()), this.elements = { container: null, fullscreen: null, captions: null, buttons: {}, display: {}, progress: {}, inputs: {}, settings: { popup: null, menu: null, panels: {}, buttons: {} } }, this.captions = { active: null, currentTrack: -1, meta: /* @__PURE__ */ new WeakMap() }, this.fullscreen = { active: !1 }, this.options = { speed: [], quality: [] }, this.debug = new Ko(this.config.debug), this.debug.log("Config", this.config), this.debug.log("Support", ue), E.nullOrUndefined(this.media) || !E.element(this.media)) return void this.debug.error("Setup failed: no suitable element passed");
    if (this.media.plyr) return void this.debug.warn("Target already setup");
    if (!this.config.enabled) return void this.debug.error("Setup failed: disabled by config");
    if (!ue.check().api) return void this.debug.error("Setup failed: no support");
    const i = this.media.cloneNode(!0);
    i.autoplay = !1, this.elements.original = i;
    const n = this.media.tagName.toLowerCase();
    let r = null, a = null;
    switch (n) {
      case "div":
        if (r = this.media.querySelector("iframe"), E.element(r)) {
          if (a = Dr(r.getAttribute("src")), this.provider = Ho(a.toString()), this.elements.container = this.media, this.media = r, this.elements.container.className = "", a.search.length) {
            const o = ["1", "true"];
            o.includes(a.searchParams.get("autoplay")) && (this.config.autoplay = !0), o.includes(a.searchParams.get("loop")) && (this.config.loop.active = !0), this.isYouTube ? (this.config.playsinline = o.includes(a.searchParams.get("playsinline")), this.config.youtube.hl = a.searchParams.get("hl")) : this.config.playsinline = !0;
          }
        } else this.provider = this.media.getAttribute(this.config.attributes.embed.provider), this.media.removeAttribute(this.config.attributes.embed.provider);
        if (E.empty(this.provider) || !Object.values(Ze).includes(this.provider)) return void this.debug.error("Setup failed: Invalid provider");
        this.type = Oi.video;
        break;
      case "video":
      case "audio":
        this.type = n, this.provider = Ze.html5, this.media.hasAttribute("crossorigin") && (this.config.crossorigin = !0), this.media.hasAttribute("autoplay") && (this.config.autoplay = !0), (this.media.hasAttribute("playsinline") || this.media.hasAttribute("webkit-playsinline")) && (this.config.playsinline = !0), this.media.hasAttribute("muted") && (this.config.muted = !0), this.media.hasAttribute("loop") && (this.config.loop.active = !0);
        break;
      default:
        return void this.debug.error("Setup failed: unsupported type");
    }
    this.supported = ue.check(this.type, this.provider), this.supported.api ? (this.eventListeners = [], this.listeners = new Vo(this), this.storage = new Dt(this), this.media.plyr = this, E.element(this.elements.container) || (this.elements.container = K("div"), xr(this.media, this.elements.container)), oe.migrateStyles.call(this), oe.addStyleHook.call(this), _r.setup.call(this), this.config.debug && J.call(this, this.elements.container, this.config.events.join(" "), (o) => {
      this.debug.log(`event: ${o.type}`);
    }), this.fullscreen = new _e(this), (this.isHTML5 || this.isEmbed && !this.supported.ui) && oe.build.call(this), this.listeners.container(), this.listeners.global(), this.config.ads.enabled && (this.ads = new Qo(this)), this.isHTML5 && this.config.autoplay && this.once("canplay", () => $e(this.play())), this.lastSeekTime = 0, this.config.previewThumbnails.enabled && (this.previewThumbnails = new hs(this))) : this.debug.error("Setup failed: no support");
  }
  get isHTML5() {
    return this.provider === Ze.html5;
  }
  get isEmbed() {
    return this.isYouTube || this.isVimeo;
  }
  get isYouTube() {
    return this.provider === Ze.youtube;
  }
  get isVimeo() {
    return this.provider === Ze.vimeo;
  }
  get isVideo() {
    return this.type === Oi.video;
  }
  get isAudio() {
    return this.type === Oi.audio;
  }
  get playing() {
    return !!(this.ready && !this.paused && !this.ended);
  }
  get paused() {
    return !!this.media.paused;
  }
  get stopped() {
    return !!(this.paused && this.currentTime === 0);
  }
  get ended() {
    return !!this.media.ended;
  }
  set currentTime(e) {
    if (!this.duration) return;
    const t = E.number(e) && e > 0;
    this.media.currentTime = t ? Math.min(e, this.duration) : 0, this.debug.log(`Seeking to ${this.currentTime} seconds`);
  }
  get currentTime() {
    return Number(this.media.currentTime);
  }
  get buffered() {
    const { buffered: e } = this.media;
    return E.number(e) ? e : e && e.length && this.duration > 0 ? e.end(0) / this.duration : 0;
  }
  get seeking() {
    return !!this.media.seeking;
  }
  get duration() {
    const e = parseFloat(this.config.duration), t = (this.media || {}).duration, i = E.number(t) && t !== 1 / 0 ? t : 0;
    return e || i;
  }
  set volume(e) {
    let t = e;
    E.string(t) && (t = Number(t)), E.number(t) || (t = this.storage.get("volume")), E.number(t) || ({ volume: t } = this.config), t > 1 && (t = 1), t < 0 && (t = 0), this.config.volume = t, this.media.volume = t, !E.empty(e) && this.muted && t > 0 && (this.muted = !1);
  }
  get volume() {
    return Number(this.media.volume);
  }
  set muted(e) {
    let t = e;
    E.boolean(t) || (t = this.storage.get("muted")), E.boolean(t) || (t = this.config.muted), this.config.muted = t, this.media.muted = t;
  }
  get muted() {
    return !!this.media.muted;
  }
  get hasAudio() {
    return !this.isHTML5 || !!this.isAudio || !!this.media.mozHasAudio || !!this.media.webkitAudioDecodedByteCount || !!(this.media.audioTracks && this.media.audioTracks.length);
  }
  set speed(e) {
    let t = null;
    E.number(e) && (t = e), E.number(t) || (t = this.storage.get("speed")), E.number(t) || (t = this.config.speed.selected);
    const { minimumSpeed: i, maximumSpeed: n } = this;
    t = Or(t, i, n), this.config.speed.selected = t, setTimeout(() => {
      this.media && (this.media.playbackRate = t);
    }, 0);
  }
  get speed() {
    return Number(this.media.playbackRate);
  }
  get minimumSpeed() {
    return this.isYouTube ? Math.min(...this.options.speed) : this.isVimeo ? 0.5 : 0.0625;
  }
  get maximumSpeed() {
    return this.isYouTube ? Math.max(...this.options.speed) : this.isVimeo ? 2 : 16;
  }
  set quality(e) {
    const t = this.config.quality, i = this.options.quality;
    if (!i.length) return;
    let n = [!E.empty(e) && Number(e), this.storage.get("quality"), t.selected, t.default].find(E.number), r = !0;
    if (!i.includes(n)) {
      const a = Sr(i, n);
      this.debug.warn(`Unsupported quality option: ${n}, using ${a} instead`), n = a, r = !1;
    }
    t.selected = n, this.media.quality = n, r && this.storage.set({ quality: n });
  }
  get quality() {
    return this.media.quality;
  }
  set loop(e) {
    const t = E.boolean(e) ? e : this.config.loop.active;
    this.config.loop.active = t, this.media.loop = t;
  }
  get loop() {
    return !!this.media.loop;
  }
  set source(e) {
    us.change.call(this, e);
  }
  get source() {
    return this.media.currentSrc;
  }
  get download() {
    const { download: e } = this.config.urls;
    return E.url(e) ? e : this.source;
  }
  set download(e) {
    E.url(e) && (this.config.urls.download = e, O.setDownloadUrl.call(this));
  }
  set poster(e) {
    this.isVideo ? oe.setPoster.call(this, e, !1).catch(() => {
    }) : this.debug.warn("Poster can only be set for video");
  }
  get poster() {
    return this.isVideo ? this.media.getAttribute("poster") || this.media.getAttribute("data-poster") : null;
  }
  get ratio() {
    if (!this.isVideo) return null;
    const e = di(Ds.call(this));
    return E.array(e) ? e.join(":") : e;
  }
  set ratio(e) {
    this.isVideo ? E.string(e) && Lr(e) ? (this.config.ratio = di(e), Tt.call(this)) : this.debug.error(`Invalid aspect ratio specified (${e})`) : this.debug.warn("Aspect ratio can only be set for video");
  }
  set autoplay(e) {
    this.config.autoplay = E.boolean(e) ? e : this.config.autoplay;
  }
  get autoplay() {
    return !!this.config.autoplay;
  }
  toggleCaptions(e) {
    ee.toggle.call(this, e, !1);
  }
  set currentTrack(e) {
    ee.set.call(this, e, !1), ee.setup.call(this);
  }
  get currentTrack() {
    const { toggled: e, currentTrack: t } = this.captions;
    return e ? t : -1;
  }
  set language(e) {
    ee.setLanguage.call(this, e, !1);
  }
  get language() {
    return (ee.getCurrentTrack.call(this) || {}).language;
  }
  set pip(e) {
    if (!ue.pip) return;
    const t = E.boolean(e) ? e : !this.pip;
    E.function(this.media.webkitSetPresentationMode) && this.media.webkitSetPresentationMode(t ? _i.active : _i.inactive), E.function(this.media.requestPictureInPicture) && (!this.pip && t ? this.media.requestPictureInPicture() : this.pip && !t && document.exitPictureInPicture());
  }
  get pip() {
    return ue.pip ? E.empty(this.media.webkitPresentationMode) ? this.media === document.pictureInPictureElement : this.media.webkitPresentationMode === _i.active : null;
  }
  setPreviewThumbnails(e) {
    this.previewThumbnails && this.previewThumbnails.loaded && (this.previewThumbnails.destroy(), this.previewThumbnails = null), Object.assign(this.config.previewThumbnails, e), this.config.previewThumbnails.enabled && (this.previewThumbnails = new hs(this));
  }
  static supported(e, t) {
    return ue.check(e, t);
  }
  static loadSprite(e, t) {
    return wr(e, t);
  }
  static setup(e, t = {}) {
    let i = null;
    return E.string(e) ? i = Array.from(document.querySelectorAll(e)) : E.nodeList(e) ? i = Array.from(e) : E.array(e) && (i = e.filter(E.element)), E.empty(i) ? null : i.map((n) => new fi(n, t));
  }
}
fi.defaults = Io(Pr);
function Zo(s) {
  return s && s.__esModule && Object.prototype.hasOwnProperty.call(s, "default") ? s.default : s;
}
var Fr = { exports: {} };
(function(s, e) {
  (function(t) {
    var i = /^(?=((?:[a-zA-Z0-9+\-.]+:)?))\1(?=((?:\/\/[^\/?#]*)?))\2(?=((?:(?:[^?#\/]*\/)*[^;?#\/]*)?))\3((?:;[^?#]*)?)(\?[^#]*)?(#[^]*)?$/, n = /^(?=([^\/?#]*))\1([^]*)$/, r = /(?:\/|^)\.(?=\/)/g, a = /(?:\/|^)\.\.\/(?!\.\.\/)[^\/]*(?=\/)/g, o = {
      // If opts.alwaysNormalize is true then the path will always be normalized even when it starts with / or //
      // E.g
      // With opts.alwaysNormalize = false (default, spec compliant)
      // http://a.com/b/cd + /e/f/../g => http://a.com/e/f/../g
      // With opts.alwaysNormalize = true (not spec compliant)
      // http://a.com/b/cd + /e/f/../g => http://a.com/e/g
      buildAbsoluteURL: function(l, c, h) {
        if (h = h || {}, l = l.trim(), c = c.trim(), !c) {
          if (!h.alwaysNormalize)
            return l;
          var u = o.parseURL(l);
          if (!u)
            throw new Error("Error trying to parse base URL.");
          return u.path = o.normalizePath(
            u.path
          ), o.buildURLFromParts(u);
        }
        var d = o.parseURL(c);
        if (!d)
          throw new Error("Error trying to parse relative URL.");
        if (d.scheme)
          return h.alwaysNormalize ? (d.path = o.normalizePath(d.path), o.buildURLFromParts(d)) : c;
        var g = o.parseURL(l);
        if (!g)
          throw new Error("Error trying to parse base URL.");
        if (!g.netLoc && g.path && g.path[0] !== "/") {
          var f = n.exec(g.path);
          g.netLoc = f[1], g.path = f[2];
        }
        g.netLoc && !g.path && (g.path = "/");
        var m = {
          // 2c) Otherwise, the embedded URL inherits the scheme of
          // the base URL.
          scheme: g.scheme,
          netLoc: d.netLoc,
          path: null,
          params: d.params,
          query: d.query,
          fragment: d.fragment
        };
        if (!d.netLoc && (m.netLoc = g.netLoc, d.path[0] !== "/"))
          if (!d.path)
            m.path = g.path, d.params || (m.params = g.params, d.query || (m.query = g.query));
          else {
            var y = g.path, T = y.substring(0, y.lastIndexOf("/") + 1) + d.path;
            m.path = o.normalizePath(T);
          }
        return m.path === null && (m.path = h.alwaysNormalize ? o.normalizePath(d.path) : d.path), o.buildURLFromParts(m);
      },
      parseURL: function(l) {
        var c = i.exec(l);
        return c ? {
          scheme: c[1] || "",
          netLoc: c[2] || "",
          path: c[3] || "",
          params: c[4] || "",
          query: c[5] || "",
          fragment: c[6] || ""
        } : null;
      },
      normalizePath: function(l) {
        for (l = l.split("").reverse().join("").replace(r, ""); l.length !== (l = l.replace(a, "")).length; )
          ;
        return l.split("").reverse().join("");
      },
      buildURLFromParts: function(l) {
        return l.scheme + l.netLoc + l.path + l.params + l.query + l.fragment;
      }
    };
    s.exports = o;
  })();
})(Fr);
var Ps = Fr.exports;
function hn(s, e) {
  var t = Object.keys(s);
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(s);
    e && (i = i.filter(function(n) {
      return Object.getOwnPropertyDescriptor(s, n).enumerable;
    })), t.push.apply(t, i);
  }
  return t;
}
function be(s) {
  for (var e = 1; e < arguments.length; e++) {
    var t = arguments[e] != null ? arguments[e] : {};
    e % 2 ? hn(Object(t), !0).forEach(function(i) {
      il(s, i, t[i]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(s, Object.getOwnPropertyDescriptors(t)) : hn(Object(t)).forEach(function(i) {
      Object.defineProperty(s, i, Object.getOwnPropertyDescriptor(t, i));
    });
  }
  return s;
}
function el(s, e) {
  if (typeof s != "object" || !s) return s;
  var t = s[Symbol.toPrimitive];
  if (t !== void 0) {
    var i = t.call(s, e);
    if (typeof i != "object") return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (e === "string" ? String : Number)(s);
}
function tl(s) {
  var e = el(s, "string");
  return typeof e == "symbol" ? e : String(e);
}
function il(s, e, t) {
  return e = tl(e), e in s ? Object.defineProperty(s, e, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : s[e] = t, s;
}
function fe() {
  return fe = Object.assign ? Object.assign.bind() : function(s) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var i in t)
        Object.prototype.hasOwnProperty.call(t, i) && (s[i] = t[i]);
    }
    return s;
  }, fe.apply(this, arguments);
}
const U = Number.isFinite || function(s) {
  return typeof s == "number" && isFinite(s);
}, sl = Number.isSafeInteger || function(s) {
  return typeof s == "number" && Math.abs(s) <= nl;
}, nl = Number.MAX_SAFE_INTEGER || 9007199254740991;
let p = /* @__PURE__ */ function(s) {
  return s.MEDIA_ATTACHING = "hlsMediaAttaching", s.MEDIA_ATTACHED = "hlsMediaAttached", s.MEDIA_DETACHING = "hlsMediaDetaching", s.MEDIA_DETACHED = "hlsMediaDetached", s.BUFFER_RESET = "hlsBufferReset", s.BUFFER_CODECS = "hlsBufferCodecs", s.BUFFER_CREATED = "hlsBufferCreated", s.BUFFER_APPENDING = "hlsBufferAppending", s.BUFFER_APPENDED = "hlsBufferAppended", s.BUFFER_EOS = "hlsBufferEos", s.BUFFER_FLUSHING = "hlsBufferFlushing", s.BUFFER_FLUSHED = "hlsBufferFlushed", s.MANIFEST_LOADING = "hlsManifestLoading", s.MANIFEST_LOADED = "hlsManifestLoaded", s.MANIFEST_PARSED = "hlsManifestParsed", s.LEVEL_SWITCHING = "hlsLevelSwitching", s.LEVEL_SWITCHED = "hlsLevelSwitched", s.LEVEL_LOADING = "hlsLevelLoading", s.LEVEL_LOADED = "hlsLevelLoaded", s.LEVEL_UPDATED = "hlsLevelUpdated", s.LEVEL_PTS_UPDATED = "hlsLevelPtsUpdated", s.LEVELS_UPDATED = "hlsLevelsUpdated", s.AUDIO_TRACKS_UPDATED = "hlsAudioTracksUpdated", s.AUDIO_TRACK_SWITCHING = "hlsAudioTrackSwitching", s.AUDIO_TRACK_SWITCHED = "hlsAudioTrackSwitched", s.AUDIO_TRACK_LOADING = "hlsAudioTrackLoading", s.AUDIO_TRACK_LOADED = "hlsAudioTrackLoaded", s.SUBTITLE_TRACKS_UPDATED = "hlsSubtitleTracksUpdated", s.SUBTITLE_TRACKS_CLEARED = "hlsSubtitleTracksCleared", s.SUBTITLE_TRACK_SWITCH = "hlsSubtitleTrackSwitch", s.SUBTITLE_TRACK_LOADING = "hlsSubtitleTrackLoading", s.SUBTITLE_TRACK_LOADED = "hlsSubtitleTrackLoaded", s.SUBTITLE_FRAG_PROCESSED = "hlsSubtitleFragProcessed", s.CUES_PARSED = "hlsCuesParsed", s.NON_NATIVE_TEXT_TRACKS_FOUND = "hlsNonNativeTextTracksFound", s.INIT_PTS_FOUND = "hlsInitPtsFound", s.FRAG_LOADING = "hlsFragLoading", s.FRAG_LOAD_EMERGENCY_ABORTED = "hlsFragLoadEmergencyAborted", s.FRAG_LOADED = "hlsFragLoaded", s.FRAG_DECRYPTED = "hlsFragDecrypted", s.FRAG_PARSING_INIT_SEGMENT = "hlsFragParsingInitSegment", s.FRAG_PARSING_USERDATA = "hlsFragParsingUserdata", s.FRAG_PARSING_METADATA = "hlsFragParsingMetadata", s.FRAG_PARSED = "hlsFragParsed", s.FRAG_BUFFERED = "hlsFragBuffered", s.FRAG_CHANGED = "hlsFragChanged", s.FPS_DROP = "hlsFpsDrop", s.FPS_DROP_LEVEL_CAPPING = "hlsFpsDropLevelCapping", s.MAX_AUTO_LEVEL_UPDATED = "hlsMaxAutoLevelUpdated", s.ERROR = "hlsError", s.DESTROYING = "hlsDestroying", s.KEY_LOADING = "hlsKeyLoading", s.KEY_LOADED = "hlsKeyLoaded", s.LIVE_BACK_BUFFER_REACHED = "hlsLiveBackBufferReached", s.BACK_BUFFER_REACHED = "hlsBackBufferReached", s.STEERING_MANIFEST_LOADED = "hlsSteeringManifestLoaded", s;
}({}), V = /* @__PURE__ */ function(s) {
  return s.NETWORK_ERROR = "networkError", s.MEDIA_ERROR = "mediaError", s.KEY_SYSTEM_ERROR = "keySystemError", s.MUX_ERROR = "muxError", s.OTHER_ERROR = "otherError", s;
}({}), I = /* @__PURE__ */ function(s) {
  return s.KEY_SYSTEM_NO_KEYS = "keySystemNoKeys", s.KEY_SYSTEM_NO_ACCESS = "keySystemNoAccess", s.KEY_SYSTEM_NO_SESSION = "keySystemNoSession", s.KEY_SYSTEM_NO_CONFIGURED_LICENSE = "keySystemNoConfiguredLicense", s.KEY_SYSTEM_LICENSE_REQUEST_FAILED = "keySystemLicenseRequestFailed", s.KEY_SYSTEM_SERVER_CERTIFICATE_REQUEST_FAILED = "keySystemServerCertificateRequestFailed", s.KEY_SYSTEM_SERVER_CERTIFICATE_UPDATE_FAILED = "keySystemServerCertificateUpdateFailed", s.KEY_SYSTEM_SESSION_UPDATE_FAILED = "keySystemSessionUpdateFailed", s.KEY_SYSTEM_STATUS_OUTPUT_RESTRICTED = "keySystemStatusOutputRestricted", s.KEY_SYSTEM_STATUS_INTERNAL_ERROR = "keySystemStatusInternalError", s.MANIFEST_LOAD_ERROR = "manifestLoadError", s.MANIFEST_LOAD_TIMEOUT = "manifestLoadTimeOut", s.MANIFEST_PARSING_ERROR = "manifestParsingError", s.MANIFEST_INCOMPATIBLE_CODECS_ERROR = "manifestIncompatibleCodecsError", s.LEVEL_EMPTY_ERROR = "levelEmptyError", s.LEVEL_LOAD_ERROR = "levelLoadError", s.LEVEL_LOAD_TIMEOUT = "levelLoadTimeOut", s.LEVEL_PARSING_ERROR = "levelParsingError", s.LEVEL_SWITCH_ERROR = "levelSwitchError", s.AUDIO_TRACK_LOAD_ERROR = "audioTrackLoadError", s.AUDIO_TRACK_LOAD_TIMEOUT = "audioTrackLoadTimeOut", s.SUBTITLE_LOAD_ERROR = "subtitleTrackLoadError", s.SUBTITLE_TRACK_LOAD_TIMEOUT = "subtitleTrackLoadTimeOut", s.FRAG_LOAD_ERROR = "fragLoadError", s.FRAG_LOAD_TIMEOUT = "fragLoadTimeOut", s.FRAG_DECRYPT_ERROR = "fragDecryptError", s.FRAG_PARSING_ERROR = "fragParsingError", s.FRAG_GAP = "fragGap", s.REMUX_ALLOC_ERROR = "remuxAllocError", s.KEY_LOAD_ERROR = "keyLoadError", s.KEY_LOAD_TIMEOUT = "keyLoadTimeOut", s.BUFFER_ADD_CODEC_ERROR = "bufferAddCodecError", s.BUFFER_INCOMPATIBLE_CODECS_ERROR = "bufferIncompatibleCodecsError", s.BUFFER_APPEND_ERROR = "bufferAppendError", s.BUFFER_APPENDING_ERROR = "bufferAppendingError", s.BUFFER_STALLED_ERROR = "bufferStalledError", s.BUFFER_FULL_ERROR = "bufferFullError", s.BUFFER_SEEK_OVER_HOLE = "bufferSeekOverHole", s.BUFFER_NUDGE_ON_STALL = "bufferNudgeOnStall", s.INTERNAL_EXCEPTION = "internalException", s.INTERNAL_ABORTED = "aborted", s.UNKNOWN = "unknown", s;
}({});
const nt = function() {
}, ds = {
  trace: nt,
  debug: nt,
  log: nt,
  warn: nt,
  info: nt,
  error: nt
};
let It = ds;
function rl(s) {
  const e = self.console[s];
  return e ? e.bind(self.console, `[${s}] >`) : nt;
}
function al(s, ...e) {
  e.forEach(function(t) {
    It[t] = s[t] ? s[t].bind(s) : rl(t);
  });
}
function ol(s, e) {
  if (typeof console == "object" && s === !0 || typeof s == "object") {
    al(
      s,
      // Remove out from list here to hard-disable a log-level
      // 'trace',
      "debug",
      "log",
      "info",
      "warn",
      "error"
    );
    try {
      It.log(`Debug logs enabled for "${e}" in hls.js version 1.5.20`);
    } catch (t) {
      It = ds;
    }
  } else
    It = ds;
}
const S = It, ll = /^(\d+)x(\d+)$/, un = /(.+?)=(".*?"|.*?)(?:,|$)/g;
class ce {
  constructor(e) {
    typeof e == "string" && (e = ce.parseAttrList(e)), fe(this, e);
  }
  get clientAttrs() {
    return Object.keys(this).filter((e) => e.substring(0, 2) === "X-");
  }
  decimalInteger(e) {
    const t = parseInt(this[e], 10);
    return t > Number.MAX_SAFE_INTEGER ? 1 / 0 : t;
  }
  hexadecimalInteger(e) {
    if (this[e]) {
      let t = (this[e] || "0x").slice(2);
      t = (t.length & 1 ? "0" : "") + t;
      const i = new Uint8Array(t.length / 2);
      for (let n = 0; n < t.length / 2; n++)
        i[n] = parseInt(t.slice(n * 2, n * 2 + 2), 16);
      return i;
    } else
      return null;
  }
  hexadecimalIntegerAsNumber(e) {
    const t = parseInt(this[e], 16);
    return t > Number.MAX_SAFE_INTEGER ? 1 / 0 : t;
  }
  decimalFloatingPoint(e) {
    return parseFloat(this[e]);
  }
  optionalFloat(e, t) {
    const i = this[e];
    return i ? parseFloat(i) : t;
  }
  enumeratedString(e) {
    return this[e];
  }
  bool(e) {
    return this[e] === "YES";
  }
  decimalResolution(e) {
    const t = ll.exec(this[e]);
    if (t !== null)
      return {
        width: parseInt(t[1], 10),
        height: parseInt(t[2], 10)
      };
  }
  static parseAttrList(e) {
    let t;
    const i = {}, n = '"';
    for (un.lastIndex = 0; (t = un.exec(e)) !== null; ) {
      let r = t[2];
      r.indexOf(n) === 0 && r.lastIndexOf(n) === r.length - 1 && (r = r.slice(1, -1));
      const a = t[1].trim();
      i[a] = r;
    }
    return i;
  }
}
function cl(s) {
  return s !== "ID" && s !== "CLASS" && s !== "START-DATE" && s !== "DURATION" && s !== "END-DATE" && s !== "END-ON-NEXT";
}
function hl(s) {
  return s === "SCTE35-OUT" || s === "SCTE35-IN";
}
class Mr {
  constructor(e, t) {
    if (this.attr = void 0, this._startDate = void 0, this._endDate = void 0, this._badValueForSameId = void 0, t) {
      const i = t.attr;
      for (const n in i)
        if (Object.prototype.hasOwnProperty.call(e, n) && e[n] !== i[n]) {
          S.warn(`DATERANGE tag attribute: "${n}" does not match for tags with ID: "${e.ID}"`), this._badValueForSameId = n;
          break;
        }
      e = fe(new ce({}), i, e);
    }
    if (this.attr = e, this._startDate = new Date(e["START-DATE"]), "END-DATE" in this.attr) {
      const i = new Date(this.attr["END-DATE"]);
      U(i.getTime()) && (this._endDate = i);
    }
  }
  get id() {
    return this.attr.ID;
  }
  get class() {
    return this.attr.CLASS;
  }
  get startDate() {
    return this._startDate;
  }
  get endDate() {
    if (this._endDate)
      return this._endDate;
    const e = this.duration;
    return e !== null ? new Date(this._startDate.getTime() + e * 1e3) : null;
  }
  get duration() {
    if ("DURATION" in this.attr) {
      const e = this.attr.decimalFloatingPoint("DURATION");
      if (U(e))
        return e;
    } else if (this._endDate)
      return (this._endDate.getTime() - this._startDate.getTime()) / 1e3;
    return null;
  }
  get plannedDuration() {
    return "PLANNED-DURATION" in this.attr ? this.attr.decimalFloatingPoint("PLANNED-DURATION") : null;
  }
  get endOnNext() {
    return this.attr.bool("END-ON-NEXT");
  }
  get isValid() {
    return !!this.id && !this._badValueForSameId && U(this.startDate.getTime()) && (this.duration === null || this.duration >= 0) && (!this.endOnNext || !!this.class);
  }
}
class wi {
  constructor() {
    this.aborted = !1, this.loaded = 0, this.retry = 0, this.total = 0, this.chunkCount = 0, this.bwEstimate = 0, this.loading = {
      start: 0,
      first: 0,
      end: 0
    }, this.parsing = {
      start: 0,
      end: 0
    }, this.buffering = {
      start: 0,
      first: 0,
      end: 0
    };
  }
}
var re = {
  AUDIO: "audio",
  VIDEO: "video",
  AUDIOVIDEO: "audiovideo"
};
class Nr {
  constructor(e) {
    this._byteRange = null, this._url = null, this.baseurl = void 0, this.relurl = void 0, this.elementaryStreams = {
      [re.AUDIO]: null,
      [re.VIDEO]: null,
      [re.AUDIOVIDEO]: null
    }, this.baseurl = e;
  }
  // setByteRange converts a EXT-X-BYTERANGE attribute into a two element array
  setByteRange(e, t) {
    const i = e.split("@", 2);
    let n;
    i.length === 1 ? n = (t == null ? void 0 : t.byteRangeEndOffset) || 0 : n = parseInt(i[1]), this._byteRange = [n, parseInt(i[0]) + n];
  }
  get byteRange() {
    return this._byteRange ? this._byteRange : [];
  }
  get byteRangeStartOffset() {
    return this.byteRange[0];
  }
  get byteRangeEndOffset() {
    return this.byteRange[1];
  }
  get url() {
    return !this._url && this.baseurl && this.relurl && (this._url = Ps.buildAbsoluteURL(this.baseurl, this.relurl, {
      alwaysNormalize: !0
    })), this._url || "";
  }
  set url(e) {
    this._url = e;
  }
}
class Mi extends Nr {
  constructor(e, t) {
    super(t), this._decryptdata = null, this.rawProgramDateTime = null, this.programDateTime = null, this.tagList = [], this.duration = 0, this.sn = 0, this.levelkeys = void 0, this.type = void 0, this.loader = null, this.keyLoader = null, this.level = -1, this.cc = 0, this.startPTS = void 0, this.endPTS = void 0, this.startDTS = void 0, this.endDTS = void 0, this.start = 0, this.deltaPTS = void 0, this.maxStartPTS = void 0, this.minEndPTS = void 0, this.stats = new wi(), this.data = void 0, this.bitrateTest = !1, this.title = null, this.initSegment = null, this.endList = void 0, this.gap = void 0, this.urlId = 0, this.type = e;
  }
  get decryptdata() {
    const {
      levelkeys: e
    } = this;
    if (!e && !this._decryptdata)
      return null;
    if (!this._decryptdata && this.levelkeys && !this.levelkeys.NONE) {
      const t = this.levelkeys.identity;
      if (t)
        this._decryptdata = t.getDecryptData(this.sn);
      else {
        const i = Object.keys(this.levelkeys);
        if (i.length === 1)
          return this._decryptdata = this.levelkeys[i[0]].getDecryptData(this.sn);
      }
    }
    return this._decryptdata;
  }
  get end() {
    return this.start + this.duration;
  }
  get endProgramDateTime() {
    if (this.programDateTime === null || !U(this.programDateTime))
      return null;
    const e = U(this.duration) ? this.duration : 0;
    return this.programDateTime + e * 1e3;
  }
  get encrypted() {
    var e;
    if ((e = this._decryptdata) != null && e.encrypted)
      return !0;
    if (this.levelkeys) {
      const t = Object.keys(this.levelkeys), i = t.length;
      if (i > 1 || i === 1 && this.levelkeys[t[0]].encrypted)
        return !0;
    }
    return !1;
  }
  setKeyFormat(e) {
    if (this.levelkeys) {
      const t = this.levelkeys[e];
      t && !this._decryptdata && (this._decryptdata = t.getDecryptData(this.sn));
    }
  }
  abortRequests() {
    var e, t;
    (e = this.loader) == null || e.abort(), (t = this.keyLoader) == null || t.abort();
  }
  setElementaryStreamInfo(e, t, i, n, r, a = !1) {
    const {
      elementaryStreams: o
    } = this, l = o[e];
    if (!l) {
      o[e] = {
        startPTS: t,
        endPTS: i,
        startDTS: n,
        endDTS: r,
        partial: a
      };
      return;
    }
    l.startPTS = Math.min(l.startPTS, t), l.endPTS = Math.max(l.endPTS, i), l.startDTS = Math.min(l.startDTS, n), l.endDTS = Math.max(l.endDTS, r);
  }
  clearElementaryStreamInfo() {
    const {
      elementaryStreams: e
    } = this;
    e[re.AUDIO] = null, e[re.VIDEO] = null, e[re.AUDIOVIDEO] = null;
  }
}
class ul extends Nr {
  constructor(e, t, i, n, r) {
    super(i), this.fragOffset = 0, this.duration = 0, this.gap = !1, this.independent = !1, this.relurl = void 0, this.fragment = void 0, this.index = void 0, this.stats = new wi(), this.duration = e.decimalFloatingPoint("DURATION"), this.gap = e.bool("GAP"), this.independent = e.bool("INDEPENDENT"), this.relurl = e.enumeratedString("URI"), this.fragment = t, this.index = n;
    const a = e.enumeratedString("BYTERANGE");
    a && this.setByteRange(a, r), r && (this.fragOffset = r.fragOffset + r.duration);
  }
  get start() {
    return this.fragment.start + this.fragOffset;
  }
  get end() {
    return this.start + this.duration;
  }
  get loaded() {
    const {
      elementaryStreams: e
    } = this;
    return !!(e.audio || e.video || e.audiovideo);
  }
}
const dl = 10;
class fl {
  constructor(e) {
    this.PTSKnown = !1, this.alignedSliding = !1, this.averagetargetduration = void 0, this.endCC = 0, this.endSN = 0, this.fragments = void 0, this.fragmentHint = void 0, this.partList = null, this.dateRanges = void 0, this.live = !0, this.ageHeader = 0, this.advancedDateTime = void 0, this.updated = !0, this.advanced = !0, this.availabilityDelay = void 0, this.misses = 0, this.startCC = 0, this.startSN = 0, this.startTimeOffset = null, this.targetduration = 0, this.totalduration = 0, this.type = null, this.url = void 0, this.m3u8 = "", this.version = null, this.canBlockReload = !1, this.canSkipUntil = 0, this.canSkipDateRanges = !1, this.skippedSegments = 0, this.recentlyRemovedDateranges = void 0, this.partHoldBack = 0, this.holdBack = 0, this.partTarget = 0, this.preloadHint = void 0, this.renditionReports = void 0, this.tuneInGoal = 0, this.deltaUpdateFailed = void 0, this.driftStartTime = 0, this.driftEndTime = 0, this.driftStart = 0, this.driftEnd = 0, this.encryptedFragments = void 0, this.playlistParsingError = null, this.variableList = null, this.hasVariableRefs = !1, this.fragments = [], this.encryptedFragments = [], this.dateRanges = {}, this.url = e;
  }
  reloaded(e) {
    if (!e) {
      this.advanced = !0, this.updated = !0;
      return;
    }
    const t = this.lastPartSn - e.lastPartSn, i = this.lastPartIndex - e.lastPartIndex;
    this.updated = this.endSN !== e.endSN || !!i || !!t || !this.live, this.advanced = this.endSN > e.endSN || t > 0 || t === 0 && i > 0, this.updated || this.advanced ? this.misses = Math.floor(e.misses * 0.6) : this.misses = e.misses + 1, this.availabilityDelay = e.availabilityDelay;
  }
  get hasProgramDateTime() {
    return this.fragments.length ? U(this.fragments[this.fragments.length - 1].programDateTime) : !1;
  }
  get levelTargetDuration() {
    return this.averagetargetduration || this.targetduration || dl;
  }
  get drift() {
    const e = this.driftEndTime - this.driftStartTime;
    return e > 0 ? (this.driftEnd - this.driftStart) * 1e3 / e : 1;
  }
  get edge() {
    return this.partEnd || this.fragmentEnd;
  }
  get partEnd() {
    var e;
    return (e = this.partList) != null && e.length ? this.partList[this.partList.length - 1].end : this.fragmentEnd;
  }
  get fragmentEnd() {
    var e;
    return (e = this.fragments) != null && e.length ? this.fragments[this.fragments.length - 1].end : 0;
  }
  get age() {
    return this.advancedDateTime ? Math.max(Date.now() - this.advancedDateTime, 0) / 1e3 : 0;
  }
  get lastPartIndex() {
    var e;
    return (e = this.partList) != null && e.length ? this.partList[this.partList.length - 1].index : -1;
  }
  get lastPartSn() {
    var e;
    return (e = this.partList) != null && e.length ? this.partList[this.partList.length - 1].fragment.sn : this.endSN;
  }
}
function _s(s) {
  return Uint8Array.from(atob(s), (e) => e.charCodeAt(0));
}
function gl(s) {
  const e = fs(s).subarray(0, 16), t = new Uint8Array(16);
  return t.set(e, 16 - e.length), t;
}
function ml(s) {
  const e = function(i, n, r) {
    const a = i[n];
    i[n] = i[r], i[r] = a;
  };
  e(s, 0, 3), e(s, 1, 2), e(s, 4, 5), e(s, 6, 7);
}
function pl(s) {
  const e = s.split(":");
  let t = null;
  if (e[0] === "data" && e.length === 2) {
    const i = e[1].split(";"), n = i[i.length - 1].split(",");
    if (n.length === 2) {
      const r = n[0] === "base64", a = n[1];
      r ? (i.splice(-1, 1), t = _s(a)) : t = gl(a);
    }
  }
  return t;
}
function fs(s) {
  return Uint8Array.from(unescape(encodeURIComponent(s)), (e) => e.charCodeAt(0));
}
const Et = typeof self != "undefined" ? self : void 0;
var se = {
  CLEARKEY: "org.w3.clearkey",
  FAIRPLAY: "com.apple.fps",
  PLAYREADY: "com.microsoft.playready",
  WIDEVINE: "com.widevine.alpha"
}, Ie = {
  CLEARKEY: "org.w3.clearkey",
  FAIRPLAY: "com.apple.streamingkeydelivery",
  PLAYREADY: "com.microsoft.playready",
  WIDEVINE: "urn:uuid:edef8ba9-79d6-4ace-a3c8-27dcd51d21ed"
};
function Ni(s) {
  switch (s) {
    case Ie.FAIRPLAY:
      return se.FAIRPLAY;
    case Ie.PLAYREADY:
      return se.PLAYREADY;
    case Ie.WIDEVINE:
      return se.WIDEVINE;
    case Ie.CLEARKEY:
      return se.CLEARKEY;
  }
}
var $t = {
  CENC: "1077efecc0b24d02ace33c1e52e2fb4b",
  CLEARKEY: "e2719d58a985b3c9781ab030af78d30e",
  PLAYREADY: "9a04f07998404286ab92e65be0885f95",
  WIDEVINE: "edef8ba979d64acea3c827dcd51d21ed"
};
function Ui(s) {
  if (s === $t.WIDEVINE)
    return se.WIDEVINE;
  if (s === $t.PLAYREADY)
    return se.PLAYREADY;
  if (s === $t.CENC || s === $t.CLEARKEY)
    return se.CLEARKEY;
}
function Bi(s) {
  switch (s) {
    case se.FAIRPLAY:
      return Ie.FAIRPLAY;
    case se.PLAYREADY:
      return Ie.PLAYREADY;
    case se.WIDEVINE:
      return Ie.WIDEVINE;
    case se.CLEARKEY:
      return Ie.CLEARKEY;
  }
}
function Gt(s) {
  const {
    drmSystems: e,
    widevineLicenseUrl: t
  } = s, i = e ? [se.FAIRPLAY, se.WIDEVINE, se.PLAYREADY, se.CLEARKEY].filter((n) => !!e[n]) : [];
  return !i[se.WIDEVINE] && t && i.push(se.WIDEVINE), i;
}
const Ur = function(s) {
  return Et != null && (s = Et.navigator) != null && s.requestMediaKeySystemAccess ? self.navigator.requestMediaKeySystemAccess.bind(self.navigator) : null;
}();
function yl(s, e, t, i) {
  let n;
  switch (s) {
    case se.FAIRPLAY:
      n = ["cenc", "sinf"];
      break;
    case se.WIDEVINE:
    case se.PLAYREADY:
      n = ["cenc"];
      break;
    case se.CLEARKEY:
      n = ["cenc", "keyids"];
      break;
    default:
      throw new Error(`Unknown key-system: ${s}`);
  }
  return Tl(n, e, t, i);
}
function Tl(s, e, t, i) {
  return [{
    initDataTypes: s,
    persistentState: i.persistentState || "optional",
    distinctiveIdentifier: i.distinctiveIdentifier || "optional",
    sessionTypes: i.sessionTypes || [i.sessionType || "temporary"],
    audioCapabilities: e.map((r) => ({
      contentType: `audio/mp4; codecs="${r}"`,
      robustness: i.audioRobustness || "",
      encryptionScheme: i.audioEncryptionScheme || null
    })),
    videoCapabilities: t.map((r) => ({
      contentType: `video/mp4; codecs="${r}"`,
      robustness: i.videoRobustness || "",
      encryptionScheme: i.videoEncryptionScheme || null
    }))
  }];
}
function Br(s) {
  const e = new Uint16Array(s.buffer, s.byteOffset, s.byteLength / 2), t = String.fromCharCode.apply(null, Array.from(e)), i = t.substring(t.indexOf("<"), t.length), a = new DOMParser().parseFromString(i, "text/xml").getElementsByTagName("KID")[0];
  if (a) {
    const o = a.childNodes[0] ? a.childNodes[0].nodeValue : a.getAttribute("VALUE");
    if (o) {
      const l = _s(o).subarray(0, 16);
      return ml(l), l;
    }
  }
  return null;
}
function lt(s, e, t) {
  return Uint8Array.prototype.slice ? s.slice(e, t) : new Uint8Array(Array.prototype.slice.call(s, e, t));
}
const Os = (s, e) => e + 10 <= s.length && s[e] === 73 && s[e + 1] === 68 && s[e + 2] === 51 && s[e + 3] < 255 && s[e + 4] < 255 && s[e + 6] < 128 && s[e + 7] < 128 && s[e + 8] < 128 && s[e + 9] < 128, $r = (s, e) => e + 10 <= s.length && s[e] === 51 && s[e + 1] === 68 && s[e + 2] === 73 && s[e + 3] < 255 && s[e + 4] < 255 && s[e + 6] < 128 && s[e + 7] < 128 && s[e + 8] < 128 && s[e + 9] < 128, kt = (s, e) => {
  const t = e;
  let i = 0;
  for (; Os(s, e); ) {
    i += 10;
    const n = Ci(s, e + 6);
    i += n, $r(s, e + 10) && (i += 10), e += i;
  }
  if (i > 0)
    return s.subarray(t, t + i);
}, Ci = (s, e) => {
  let t = 0;
  return t = (s[e] & 127) << 21, t |= (s[e + 1] & 127) << 14, t |= (s[e + 2] & 127) << 7, t |= s[e + 3] & 127, t;
}, El = (s, e) => Os(s, e) && Ci(s, e + 6) + 10 <= s.length - e, Fs = (s) => {
  const e = Hr(s);
  for (let t = 0; t < e.length; t++) {
    const i = e[t];
    if (Gr(i))
      return Ll(i);
  }
}, Gr = (s) => s && s.key === "PRIV" && s.info === "com.apple.streaming.transportStreamTimestamp", vl = (s) => {
  const e = String.fromCharCode(s[0], s[1], s[2], s[3]), t = Ci(s, 4), i = 10;
  return {
    type: e,
    size: t,
    data: s.subarray(i, i + t)
  };
}, Hr = (s) => {
  let e = 0;
  const t = [];
  for (; Os(s, e); ) {
    const i = Ci(s, e + 6);
    e += 10;
    const n = e + i;
    for (; e + 8 < n; ) {
      const r = vl(s.subarray(e)), a = bl(r);
      a && t.push(a), e += r.size + 10;
    }
    $r(s, e) && (e += 10);
  }
  return t;
}, bl = (s) => s.type === "PRIV" ? xl(s) : s.type[0] === "W" ? Al(s) : Sl(s), xl = (s) => {
  if (s.size < 2)
    return;
  const e = Ke(s.data, !0), t = new Uint8Array(s.data.subarray(e.length + 1));
  return {
    key: s.type,
    info: e,
    data: t.buffer
  };
}, Sl = (s) => {
  if (s.size < 2)
    return;
  if (s.type === "TXXX") {
    let t = 1;
    const i = Ke(s.data.subarray(t), !0);
    t += i.length + 1;
    const n = Ke(s.data.subarray(t));
    return {
      key: s.type,
      info: i,
      data: n
    };
  }
  const e = Ke(s.data.subarray(1));
  return {
    key: s.type,
    data: e
  };
}, Al = (s) => {
  if (s.type === "WXXX") {
    if (s.size < 2)
      return;
    let t = 1;
    const i = Ke(s.data.subarray(t), !0);
    t += i.length + 1;
    const n = Ke(s.data.subarray(t));
    return {
      key: s.type,
      info: i,
      data: n
    };
  }
  const e = Ke(s.data);
  return {
    key: s.type,
    data: e
  };
}, Ll = (s) => {
  if (s.data.byteLength === 8) {
    const e = new Uint8Array(s.data), t = e[3] & 1;
    let i = (e[4] << 23) + (e[5] << 15) + (e[6] << 7) + e[7];
    return i /= 45, t && (i += 4772185884e-2), Math.round(i);
  }
}, Ke = (s, e = !1) => {
  const t = Rl();
  if (t) {
    const c = t.decode(s);
    if (e) {
      const h = c.indexOf("\0");
      return h !== -1 ? c.substring(0, h) : c;
    }
    return c.replace(/\0/g, "");
  }
  const i = s.length;
  let n, r, a, o = "", l = 0;
  for (; l < i; ) {
    if (n = s[l++], n === 0 && e)
      return o;
    if (n === 0 || n === 3)
      continue;
    switch (n >> 4) {
      case 0:
      case 1:
      case 2:
      case 3:
      case 4:
      case 5:
      case 6:
      case 7:
        o += String.fromCharCode(n);
        break;
      case 12:
      case 13:
        r = s[l++], o += String.fromCharCode((n & 31) << 6 | r & 63);
        break;
      case 14:
        r = s[l++], a = s[l++], o += String.fromCharCode((n & 15) << 12 | (r & 63) << 6 | (a & 63) << 0);
        break;
    }
  }
  return o;
};
let $i;
function Rl() {
  if (!navigator.userAgent.includes("PlayStation 4"))
    return !$i && typeof self.TextDecoder != "undefined" && ($i = new self.TextDecoder("utf-8")), $i;
}
const Ue = {
  hexDump: function(s) {
    let e = "";
    for (let t = 0; t < s.length; t++) {
      let i = s[t].toString(16);
      i.length < 2 && (i = "0" + i), e += i;
    }
    return e;
  }
}, gi = Math.pow(2, 32) - 1, Il = [].push, Kr = {
  video: 1,
  audio: 2,
  id3: 3,
  text: 4
};
function me(s) {
  return String.fromCharCode.apply(null, s);
}
function Vr(s, e) {
  const t = s[e] << 8 | s[e + 1];
  return t < 0 ? 65536 + t : t;
}
function $(s, e) {
  const t = Wr(s, e);
  return t < 0 ? 4294967296 + t : t;
}
function dn(s, e) {
  let t = $(s, e);
  return t *= Math.pow(2, 32), t += $(s, e + 4), t;
}
function Wr(s, e) {
  return s[e] << 24 | s[e + 1] << 16 | s[e + 2] << 8 | s[e + 3];
}
function Gi(s, e, t) {
  s[e] = t >> 24, s[e + 1] = t >> 16 & 255, s[e + 2] = t >> 8 & 255, s[e + 3] = t & 255;
}
function wl(s) {
  const e = s.byteLength;
  for (let t = 0; t < e; ) {
    const i = $(s, t);
    if (i > 8 && s[t + 4] === 109 && s[t + 5] === 111 && s[t + 6] === 111 && s[t + 7] === 102)
      return !0;
    t = i > 1 ? t + i : e;
  }
  return !1;
}
function z(s, e) {
  const t = [];
  if (!e.length)
    return t;
  const i = s.byteLength;
  for (let n = 0; n < i; ) {
    const r = $(s, n), a = me(s.subarray(n + 4, n + 8)), o = r > 1 ? n + r : i;
    if (a === e[0])
      if (e.length === 1)
        t.push(s.subarray(n + 8, o));
      else {
        const l = z(s.subarray(n + 8, o), e.slice(1));
        l.length && Il.apply(t, l);
      }
    n = o;
  }
  return t;
}
function Cl(s) {
  const e = [], t = s[0];
  let i = 8;
  const n = $(s, i);
  i += 4;
  let r = 0, a = 0;
  t === 0 ? (r = $(s, i), a = $(s, i + 4), i += 8) : (r = dn(s, i), a = dn(s, i + 8), i += 16), i += 2;
  let o = s.length + a;
  const l = Vr(s, i);
  i += 2;
  for (let c = 0; c < l; c++) {
    let h = i;
    const u = $(s, h);
    h += 4;
    const d = u & 2147483647;
    if ((u & 2147483648) >>> 31 === 1)
      return S.warn("SIDX has hierarchical references (not supported)"), null;
    const f = $(s, h);
    h += 4, e.push({
      referenceSize: d,
      subsegmentDuration: f,
      // unscaled
      info: {
        duration: f / n,
        start: o,
        end: o + d - 1
      }
    }), o += d, h += 4, i = h;
  }
  return {
    earliestPresentationTime: r,
    timescale: n,
    version: t,
    referencesCount: l,
    references: e
  };
}
function Yr(s) {
  const e = [], t = z(s, ["moov", "trak"]);
  for (let n = 0; n < t.length; n++) {
    const r = t[n], a = z(r, ["tkhd"])[0];
    if (a) {
      let o = a[0];
      const l = $(a, o === 0 ? 12 : 20), c = z(r, ["mdia", "mdhd"])[0];
      if (c) {
        o = c[0];
        const h = $(c, o === 0 ? 12 : 20), u = z(r, ["mdia", "hdlr"])[0];
        if (u) {
          const d = me(u.subarray(8, 12)), g = {
            soun: re.AUDIO,
            vide: re.VIDEO
          }[d];
          if (g) {
            const f = z(r, ["mdia", "minf", "stbl", "stsd"])[0], m = Dl(f);
            e[l] = {
              timescale: h,
              type: g
            }, e[g] = be({
              timescale: h,
              id: l
            }, m);
          }
        }
      }
    }
  }
  return z(s, ["moov", "mvex", "trex"]).forEach((n) => {
    const r = $(n, 4), a = e[r];
    a && (a.default = {
      duration: $(n, 12),
      flags: $(n, 20)
    });
  }), e;
}
function Dl(s) {
  const e = s.subarray(8), t = e.subarray(86), i = me(e.subarray(4, 8));
  let n = i;
  const r = i === "enca" || i === "encv";
  if (r) {
    const o = z(e, [i])[0].subarray(i === "enca" ? 28 : 78);
    z(o, ["sinf"]).forEach((c) => {
      const h = z(c, ["schm"])[0];
      if (h) {
        const u = me(h.subarray(4, 8));
        if (u === "cbcs" || u === "cenc") {
          const d = z(c, ["frma"])[0];
          d && (n = me(d));
        }
      }
    });
  }
  switch (n) {
    case "avc1":
    case "avc2":
    case "avc3":
    case "avc4": {
      const a = z(t, ["avcC"])[0];
      n += "." + Ht(a[1]) + Ht(a[2]) + Ht(a[3]);
      break;
    }
    case "mp4a": {
      const a = z(e, [i])[0], o = z(a.subarray(28), ["esds"])[0];
      if (o && o.length > 12) {
        let l = 4;
        if (o[l++] !== 3)
          break;
        l = Hi(o, l), l += 2;
        const c = o[l++];
        if (c & 128 && (l += 2), c & 64 && (l += o[l++]), o[l++] !== 4)
          break;
        l = Hi(o, l);
        const h = o[l++];
        if (h === 64)
          n += "." + Ht(h);
        else
          break;
        if (l += 12, o[l++] !== 5)
          break;
        l = Hi(o, l);
        const u = o[l++];
        let d = (u & 248) >> 3;
        d === 31 && (d += 1 + ((u & 7) << 3) + ((o[l] & 224) >> 5)), n += "." + d;
      }
      break;
    }
    case "hvc1":
    case "hev1": {
      const a = z(t, ["hvcC"])[0], o = a[1], l = ["", "A", "B", "C"][o >> 6], c = o & 31, h = $(a, 2), u = (o & 32) >> 5 ? "H" : "L", d = a[12], g = a.subarray(6, 12);
      n += "." + l + c, n += "." + h.toString(16).toUpperCase(), n += "." + u + d;
      let f = "";
      for (let m = g.length; m--; ) {
        const y = g[m];
        (y || f) && (f = "." + y.toString(16).toUpperCase() + f);
      }
      n += f;
      break;
    }
    case "dvh1":
    case "dvhe": {
      const a = z(t, ["dvcC"])[0], o = a[2] >> 1 & 127, l = a[2] << 5 & 32 | a[3] >> 3 & 31;
      n += "." + Me(o) + "." + Me(l);
      break;
    }
    case "vp09": {
      const a = z(t, ["vpcC"])[0], o = a[4], l = a[5], c = a[6] >> 4 & 15;
      n += "." + Me(o) + "." + Me(l) + "." + Me(c);
      break;
    }
    case "av01": {
      const a = z(t, ["av1C"])[0], o = a[1] >>> 5, l = a[1] & 31, c = a[2] >>> 7 ? "H" : "M", h = (a[2] & 64) >> 6, u = (a[2] & 32) >> 5, d = o === 2 && h ? u ? 12 : 10 : h ? 10 : 8, g = (a[2] & 16) >> 4, f = (a[2] & 8) >> 3, m = (a[2] & 4) >> 2, y = a[2] & 3;
      n += "." + o + "." + Me(l) + c + "." + Me(d) + "." + g + "." + f + m + y + "." + Me(1) + "." + Me(1) + "." + Me(1) + "." + 0;
      break;
    }
  }
  return {
    codec: n,
    encrypted: r
  };
}
function Hi(s, e) {
  const t = e + 5;
  for (; s[e++] & 128 && e < t; )
    ;
  return e;
}
function Ht(s) {
  return ("0" + s.toString(16).toUpperCase()).slice(-2);
}
function Me(s) {
  return (s < 10 ? "0" : "") + s;
}
function kl(s, e) {
  if (!s || !e)
    return s;
  const t = e.keyId;
  return t && e.isCommonEncryption && z(s, ["moov", "trak"]).forEach((n) => {
    const a = z(n, ["mdia", "minf", "stbl", "stsd"])[0].subarray(8);
    let o = z(a, ["enca"]);
    const l = o.length > 0;
    l || (o = z(a, ["encv"])), o.forEach((c) => {
      const h = l ? c.subarray(28) : c.subarray(78);
      z(h, ["sinf"]).forEach((d) => {
        const g = jr(d);
        if (g) {
          const f = g.subarray(8, 24);
          f.some((m) => m !== 0) || (S.log(`[eme] Patching keyId in 'enc${l ? "a" : "v"}>sinf>>tenc' box: ${Ue.hexDump(f)} -> ${Ue.hexDump(t)}`), g.set(t, 8));
        }
      });
    });
  }), s;
}
function jr(s) {
  const e = z(s, ["schm"])[0];
  if (e) {
    const t = me(e.subarray(4, 8));
    if (t === "cbcs" || t === "cenc")
      return z(s, ["schi", "tenc"])[0];
  }
  return null;
}
function Pl(s, e) {
  return z(e, ["moof", "traf"]).reduce((t, i) => {
    const n = z(i, ["tfdt"])[0], r = n[0], a = z(i, ["tfhd"]).reduce((o, l) => {
      const c = $(l, 4), h = s[c];
      if (h) {
        let u = $(n, 4);
        if (r === 1) {
          if (u === gi)
            return S.warn("[mp4-demuxer]: Ignoring assumed invalid signed 64-bit track fragment decode time"), o;
          u *= gi + 1, u += $(n, 8);
        }
        const d = h.timescale || 9e4, g = u / d;
        if (U(g) && (o === null || g < o))
          return g;
      }
      return o;
    }, null);
    return a !== null && U(a) && (t === null || a < t) ? a : t;
  }, null);
}
function _l(s, e) {
  let t = 0, i = 0, n = 0;
  const r = z(s, ["moof", "traf"]);
  for (let a = 0; a < r.length; a++) {
    const o = r[a], l = z(o, ["tfhd"])[0], c = $(l, 4), h = e[c];
    if (!h)
      continue;
    const u = h.default, d = $(l, 0) | (u == null ? void 0 : u.flags);
    let g = u == null ? void 0 : u.duration;
    d & 8 && (d & 2 ? g = $(l, 12) : g = $(l, 8));
    const f = h.timescale || 9e4, m = z(o, ["trun"]);
    for (let y = 0; y < m.length; y++) {
      if (t = Ol(m[y]), !t && g) {
        const T = $(m[y], 4);
        t = g * T;
      }
      h.type === re.VIDEO ? i += t / f : h.type === re.AUDIO && (n += t / f);
    }
  }
  if (i === 0 && n === 0) {
    let a = 1 / 0, o = 0, l = 0;
    const c = z(s, ["sidx"]);
    for (let h = 0; h < c.length; h++) {
      const u = Cl(c[h]);
      if (u != null && u.references) {
        a = Math.min(a, u.earliestPresentationTime / u.timescale);
        const d = u.references.reduce((g, f) => g + f.info.duration || 0, 0);
        o = Math.max(o, d + u.earliestPresentationTime / u.timescale), l = o - a;
      }
    }
    if (l && U(l))
      return l;
  }
  return i || n;
}
function Ol(s) {
  const e = $(s, 0);
  let t = 8;
  e & 1 && (t += 4), e & 4 && (t += 4);
  let i = 0;
  const n = $(s, 4);
  for (let r = 0; r < n; r++) {
    if (e & 256) {
      const a = $(s, t);
      i += a, t += 4;
    }
    e & 512 && (t += 4), e & 1024 && (t += 4), e & 2048 && (t += 4);
  }
  return i;
}
function Fl(s, e, t) {
  z(e, ["moof", "traf"]).forEach((i) => {
    z(i, ["tfhd"]).forEach((n) => {
      const r = $(n, 4), a = s[r];
      if (!a)
        return;
      const o = a.timescale || 9e4;
      z(i, ["tfdt"]).forEach((l) => {
        const c = l[0], h = t * o;
        if (h) {
          let u = $(l, 4);
          if (c === 0)
            u -= h, u = Math.max(u, 0), Gi(l, 4, u);
          else {
            u *= Math.pow(2, 32), u += $(l, 8), u -= h, u = Math.max(u, 0);
            const d = Math.floor(u / (gi + 1)), g = Math.floor(u % (gi + 1));
            Gi(l, 4, d), Gi(l, 8, g);
          }
        }
      });
    });
  });
}
function Ml(s) {
  const e = {
    valid: null,
    remainder: null
  }, t = z(s, ["moof"]);
  if (t.length < 2)
    return e.remainder = s, e;
  const i = t[t.length - 1];
  return e.valid = lt(s, 0, i.byteOffset - 8), e.remainder = lt(s, i.byteOffset - 8), e;
}
function ke(s, e) {
  const t = new Uint8Array(s.length + e.length);
  return t.set(s), t.set(e, s.length), t;
}
function fn(s, e) {
  const t = [], i = e.samples, n = e.timescale, r = e.id;
  let a = !1;
  return z(i, ["moof"]).map((l) => {
    const c = l.byteOffset - 8;
    z(l, ["traf"]).map((u) => {
      const d = z(u, ["tfdt"]).map((g) => {
        const f = g[0];
        let m = $(g, 4);
        return f === 1 && (m *= Math.pow(2, 32), m += $(g, 8)), m / n;
      })[0];
      return d !== void 0 && (s = d), z(u, ["tfhd"]).map((g) => {
        const f = $(g, 4), m = $(g, 0) & 16777215, y = (m & 1) !== 0, T = (m & 2) !== 0, b = (m & 8) !== 0;
        let v = 0;
        const A = (m & 16) !== 0;
        let x = 0;
        const w = (m & 32) !== 0;
        let R = 8;
        f === r && (y && (R += 8), T && (R += 4), b && (v = $(g, R), R += 4), A && (x = $(g, R), R += 4), w && (R += 4), e.type === "video" && (a = Nl(e.codec)), z(u, ["trun"]).map((k) => {
          const _ = k[0], C = $(k, 0) & 16777215, P = (C & 1) !== 0;
          let q = 0;
          const M = (C & 4) !== 0, j = (C & 256) !== 0;
          let Y = 0;
          const H = (C & 512) !== 0;
          let Z = 0;
          const ae = (C & 1024) !== 0, B = (C & 2048) !== 0;
          let N = 0;
          const te = $(k, 4);
          let X = 8;
          P && (q = $(k, X), X += 4), M && (X += 4);
          let ne = q + c;
          for (let de = 0; de < te; de++) {
            if (j ? (Y = $(k, X), X += 4) : Y = v, H ? (Z = $(k, X), X += 4) : Z = x, ae && (X += 4), B && (_ === 0 ? N = $(k, X) : N = Wr(k, X), X += 4), e.type === re.VIDEO) {
              let pe = 0;
              for (; pe < Z; ) {
                const xe = $(i, ne);
                if (ne += 4, Ul(a, i[ne])) {
                  const we = i.subarray(ne, ne + xe);
                  qr(we, a ? 2 : 1, s + N / n, t);
                }
                ne += xe, pe += xe + 4;
              }
            }
            s += Y / n;
          }
        }));
      });
    });
  }), t;
}
function Nl(s) {
  if (!s)
    return !1;
  const e = s.indexOf("."), t = e < 0 ? s : s.substring(0, e);
  return t === "hvc1" || t === "hev1" || // Dolby Vision
  t === "dvh1" || t === "dvhe";
}
function Ul(s, e) {
  if (s) {
    const t = e >> 1 & 63;
    return t === 39 || t === 40;
  } else
    return (e & 31) === 6;
}
function qr(s, e, t, i) {
  const n = zr(s);
  let r = 0;
  r += e;
  let a = 0, o = 0, l = 0;
  for (; r < n.length; ) {
    a = 0;
    do {
      if (r >= n.length)
        break;
      l = n[r++], a += l;
    } while (l === 255);
    o = 0;
    do {
      if (r >= n.length)
        break;
      l = n[r++], o += l;
    } while (l === 255);
    const c = n.length - r;
    let h = r;
    if (o < c)
      r += o;
    else if (o > c) {
      S.error(`Malformed SEI payload. ${o} is too small, only ${c} bytes left to parse.`);
      break;
    }
    if (a === 4) {
      if (n[h++] === 181) {
        const d = Vr(n, h);
        if (h += 2, d === 49) {
          const g = $(n, h);
          if (h += 4, g === 1195456820) {
            const f = n[h++];
            if (f === 3) {
              const m = n[h++], y = 31 & m, T = 64 & m, b = T ? 2 + y * 3 : 0, v = new Uint8Array(b);
              if (T) {
                v[0] = m;
                for (let A = 1; A < b; A++)
                  v[A] = n[h++];
              }
              i.push({
                type: f,
                payloadType: a,
                pts: t,
                bytes: v
              });
            }
          }
        }
      }
    } else if (a === 5 && o > 16) {
      const u = [];
      for (let f = 0; f < 16; f++) {
        const m = n[h++].toString(16);
        u.push(m.length == 1 ? "0" + m : m), (f === 3 || f === 5 || f === 7 || f === 9) && u.push("-");
      }
      const d = o - 16, g = new Uint8Array(d);
      for (let f = 0; f < d; f++)
        g[f] = n[h++];
      i.push({
        payloadType: a,
        pts: t,
        uuid: u.join(""),
        userData: Ke(g),
        userDataBytes: g
      });
    }
  }
}
function zr(s) {
  const e = s.byteLength, t = [];
  let i = 1;
  for (; i < e - 2; )
    s[i] === 0 && s[i + 1] === 0 && s[i + 2] === 3 ? (t.push(i + 2), i += 2) : i++;
  if (t.length === 0)
    return s;
  const n = e - t.length, r = new Uint8Array(n);
  let a = 0;
  for (i = 0; i < n; a++, i++)
    a === t[0] && (a++, t.shift()), r[i] = s[a];
  return r;
}
function Bl(s) {
  const e = s[0];
  let t = "", i = "", n = 0, r = 0, a = 0, o = 0, l = 0, c = 0;
  if (e === 0) {
    for (; me(s.subarray(c, c + 1)) !== "\0"; )
      t += me(s.subarray(c, c + 1)), c += 1;
    for (t += me(s.subarray(c, c + 1)), c += 1; me(s.subarray(c, c + 1)) !== "\0"; )
      i += me(s.subarray(c, c + 1)), c += 1;
    i += me(s.subarray(c, c + 1)), c += 1, n = $(s, 12), r = $(s, 16), o = $(s, 20), l = $(s, 24), c = 28;
  } else if (e === 1) {
    c += 4, n = $(s, c), c += 4;
    const u = $(s, c);
    c += 4;
    const d = $(s, c);
    for (c += 4, a = ki(2, 32) * u + d, sl(a) || (a = Number.MAX_SAFE_INTEGER, S.warn("Presentation time exceeds safe integer limit and wrapped to max safe integer in parsing emsg box")), o = $(s, c), c += 4, l = $(s, c), c += 4; me(s.subarray(c, c + 1)) !== "\0"; )
      t += me(s.subarray(c, c + 1)), c += 1;
    for (t += me(s.subarray(c, c + 1)), c += 1; me(s.subarray(c, c + 1)) !== "\0"; )
      i += me(s.subarray(c, c + 1)), c += 1;
    i += me(s.subarray(c, c + 1)), c += 1;
  }
  const h = s.subarray(c, s.byteLength);
  return {
    schemeIdUri: t,
    value: i,
    timeScale: n,
    presentationTime: a,
    presentationTimeDelta: r,
    eventDuration: o,
    id: l,
    payload: h
  };
}
function $l(s, ...e) {
  const t = e.length;
  let i = 8, n = t;
  for (; n--; )
    i += e[n].byteLength;
  const r = new Uint8Array(i);
  for (r[0] = i >> 24 & 255, r[1] = i >> 16 & 255, r[2] = i >> 8 & 255, r[3] = i & 255, r.set(s, 4), n = 0, i = 8; n < t; n++)
    r.set(e[n], i), i += e[n].byteLength;
  return r;
}
function Gl(s, e, t) {
  if (s.byteLength !== 16)
    throw new RangeError("Invalid system id");
  let i, n;
  i = 0, n = new Uint8Array();
  let r;
  i > 0 ? (r = new Uint8Array(4), e.length > 0 && new DataView(r.buffer).setUint32(0, e.length, !1)) : r = new Uint8Array();
  const a = new Uint8Array(4);
  return t && t.byteLength > 0 && new DataView(a.buffer).setUint32(0, t.byteLength, !1), $l(
    [112, 115, 115, 104],
    new Uint8Array([
      i,
      0,
      0,
      0
      // Flags
    ]),
    s,
    // 16 bytes
    r,
    n,
    a,
    t || new Uint8Array()
  );
}
function Hl(s) {
  const e = [];
  if (s instanceof ArrayBuffer) {
    const t = s.byteLength;
    let i = 0;
    for (; i + 32 < t; ) {
      const n = new DataView(s, i), r = Kl(n);
      e.push(r), i += r.size;
    }
  }
  return e;
}
function Kl(s) {
  const e = s.getUint32(0), t = s.byteOffset, i = s.byteLength;
  if (i < e)
    return {
      offset: t,
      size: i
    };
  if (s.getUint32(4) !== 1886614376)
    return {
      offset: t,
      size: e
    };
  const r = s.getUint32(8) >>> 24;
  if (r !== 0 && r !== 1)
    return {
      offset: t,
      size: e
    };
  const a = s.buffer, o = Ue.hexDump(new Uint8Array(a, t + 12, 16)), l = s.getUint32(28);
  let c = null, h = null;
  if (r === 0) {
    if (e - 32 < l || l < 22)
      return {
        offset: t,
        size: e
      };
    h = new Uint8Array(a, t + 32, l);
  } else if (r === 1) {
    if (!l || i < t + 32 + l * 16 + 16)
      return {
        offset: t,
        size: e
      };
    c = [];
    for (let u = 0; u < l; u++)
      c.push(new Uint8Array(a, t + 32 + u * 16, 16));
  }
  return {
    version: r,
    systemId: o,
    kids: c,
    data: h,
    offset: t,
    size: e
  };
}
let Kt = {};
class Pt {
  static clearKeyUriToKeyIdMap() {
    Kt = {};
  }
  constructor(e, t, i, n = [1], r = null) {
    this.uri = void 0, this.method = void 0, this.keyFormat = void 0, this.keyFormatVersions = void 0, this.encrypted = void 0, this.isCommonEncryption = void 0, this.iv = null, this.key = null, this.keyId = null, this.pssh = null, this.method = e, this.uri = t, this.keyFormat = i, this.keyFormatVersions = n, this.iv = r, this.encrypted = e ? e !== "NONE" : !1, this.isCommonEncryption = this.encrypted && e !== "AES-128";
  }
  isSupported() {
    if (this.method) {
      if (this.method === "AES-128" || this.method === "NONE")
        return !0;
      if (this.keyFormat === "identity")
        return this.method === "SAMPLE-AES";
      switch (this.keyFormat) {
        case Ie.FAIRPLAY:
        case Ie.WIDEVINE:
        case Ie.PLAYREADY:
        case Ie.CLEARKEY:
          return ["ISO-23001-7", "SAMPLE-AES", "SAMPLE-AES-CENC", "SAMPLE-AES-CTR"].indexOf(this.method) !== -1;
      }
    }
    return !1;
  }
  getDecryptData(e) {
    if (!this.encrypted || !this.uri)
      return null;
    if (this.method === "AES-128" && this.uri && !this.iv) {
      typeof e != "number" && (this.method === "AES-128" && !this.iv && S.warn(`missing IV for initialization segment with method="${this.method}" - compliance issue`), e = 0);
      const i = Vl(e);
      return new Pt(this.method, this.uri, "identity", this.keyFormatVersions, i);
    }
    const t = pl(this.uri);
    if (t)
      switch (this.keyFormat) {
        case Ie.WIDEVINE:
          this.pssh = t, t.length >= 22 && (this.keyId = t.subarray(t.length - 22, t.length - 6));
          break;
        case Ie.PLAYREADY: {
          const i = new Uint8Array([154, 4, 240, 121, 152, 64, 66, 134, 171, 146, 230, 91, 224, 136, 95, 149]);
          this.pssh = Gl(i, null, t), this.keyId = Br(t);
          break;
        }
        default: {
          let i = t.subarray(0, 16);
          if (i.length !== 16) {
            const n = new Uint8Array(16);
            n.set(i, 16 - i.length), i = n;
          }
          this.keyId = i;
          break;
        }
      }
    if (!this.keyId || this.keyId.byteLength !== 16) {
      let i = Kt[this.uri];
      if (!i) {
        const n = Object.keys(Kt).length % Number.MAX_SAFE_INTEGER;
        i = new Uint8Array(16), new DataView(i.buffer, 12, 4).setUint32(0, n), Kt[this.uri] = i;
      }
      this.keyId = i;
    }
    return this;
  }
}
function Vl(s) {
  const e = new Uint8Array(16);
  for (let t = 12; t < 16; t++)
    e[t] = s >> 8 * (15 - t) & 255;
  return e;
}
const Xr = /\{\$([a-zA-Z0-9-_]+)\}/g;
function gn(s) {
  return Xr.test(s);
}
function Re(s, e, t) {
  if (s.variableList !== null || s.hasVariableRefs)
    for (let i = t.length; i--; ) {
      const n = t[i], r = e[n];
      r && (e[n] = gs(s, r));
    }
}
function gs(s, e) {
  if (s.variableList !== null || s.hasVariableRefs) {
    const t = s.variableList;
    return e.replace(Xr, (i) => {
      const n = i.substring(2, i.length - 1), r = t == null ? void 0 : t[n];
      return r === void 0 ? (s.playlistParsingError || (s.playlistParsingError = new Error(`Missing preceding EXT-X-DEFINE tag for Variable Reference: "${n}"`)), i) : r;
    });
  }
  return e;
}
function mn(s, e, t) {
  let i = s.variableList;
  i || (s.variableList = i = {});
  let n, r;
  if ("QUERYPARAM" in e) {
    n = e.QUERYPARAM;
    try {
      const a = new self.URL(t).searchParams;
      if (a.has(n))
        r = a.get(n);
      else
        throw new Error(`"${n}" does not match any query parameter in URI: "${t}"`);
    } catch (a) {
      s.playlistParsingError || (s.playlistParsingError = new Error(`EXT-X-DEFINE QUERYPARAM: ${a.message}`));
    }
  } else
    n = e.NAME, r = e.VALUE;
  n in i ? s.playlistParsingError || (s.playlistParsingError = new Error(`EXT-X-DEFINE duplicate Variable Name declarations: "${n}"`)) : i[n] = r || "";
}
function Wl(s, e, t) {
  const i = e.IMPORT;
  if (t && i in t) {
    let n = s.variableList;
    n || (s.variableList = n = {}), n[i] = t[i];
  } else
    s.playlistParsingError || (s.playlistParsingError = new Error(`EXT-X-DEFINE IMPORT attribute not found in Multivariant Playlist: "${i}"`));
}
function ht(s = !0) {
  return typeof self == "undefined" ? void 0 : (s || !self.MediaSource) && self.ManagedMediaSource || self.MediaSource || self.WebKitMediaSource;
}
function Yl(s) {
  return typeof self != "undefined" && s === self.ManagedMediaSource;
}
const mi = {
  audio: {
    a3ds: 1,
    "ac-3": 0.95,
    "ac-4": 1,
    alac: 0.9,
    alaw: 1,
    dra1: 1,
    "dts+": 1,
    "dts-": 1,
    dtsc: 1,
    dtse: 1,
    dtsh: 1,
    "ec-3": 0.9,
    enca: 1,
    fLaC: 0.9,
    // MP4-RA listed codec entry for FLAC
    flac: 0.9,
    // legacy browser codec name for FLAC
    FLAC: 0.9,
    // some manifests may list "FLAC" with Apple's tools
    g719: 1,
    g726: 1,
    m4ae: 1,
    mha1: 1,
    mha2: 1,
    mhm1: 1,
    mhm2: 1,
    mlpa: 1,
    mp4a: 1,
    "raw ": 1,
    Opus: 1,
    opus: 1,
    // browsers expect this to be lowercase despite MP4RA says 'Opus'
    samr: 1,
    sawb: 1,
    sawp: 1,
    sevc: 1,
    sqcp: 1,
    ssmv: 1,
    twos: 1,
    ulaw: 1
  },
  video: {
    avc1: 1,
    avc2: 1,
    avc3: 1,
    avc4: 1,
    avcp: 1,
    av01: 0.8,
    drac: 1,
    dva1: 1,
    dvav: 1,
    dvh1: 0.7,
    dvhe: 0.7,
    encv: 1,
    hev1: 0.75,
    hvc1: 0.75,
    mjp2: 1,
    mp4v: 1,
    mvc1: 1,
    mvc2: 1,
    mvc3: 1,
    mvc4: 1,
    resv: 1,
    rv60: 1,
    s263: 1,
    svc1: 1,
    svc2: 1,
    "vc-1": 1,
    vp08: 1,
    vp09: 0.9
  },
  text: {
    stpp: 1,
    wvtt: 1
  }
};
function jl(s, e) {
  const t = mi[e];
  return !!t && !!t[s.slice(0, 4)];
}
function Ki(s, e, t = !0) {
  return !s.split(",").some((i) => !Qr(i, e, t));
}
function Qr(s, e, t = !0) {
  var i;
  const n = ht(t);
  return (i = n == null ? void 0 : n.isTypeSupported(_t(s, e))) != null ? i : !1;
}
function _t(s, e) {
  return `${e}/mp4;codecs="${s}"`;
}
function pn(s) {
  if (s) {
    const e = s.substring(0, 4);
    return mi.video[e];
  }
  return 2;
}
function pi(s) {
  return s.split(",").reduce((e, t) => {
    const i = mi.video[t];
    return i ? (i * 2 + e) / (e ? 3 : 2) : (mi.audio[t] + e) / (e ? 2 : 1);
  }, 0);
}
const Vi = {};
function ql(s, e = !0) {
  if (Vi[s])
    return Vi[s];
  const t = {
    flac: ["flac", "fLaC", "FLAC"],
    opus: ["opus", "Opus"]
  }[s];
  for (let i = 0; i < t.length; i++)
    if (Qr(t[i], "audio", e))
      return Vi[s] = t[i], t[i];
  return s;
}
const zl = /flac|opus/i;
function yi(s, e = !0) {
  return s.replace(zl, (t) => ql(t.toLowerCase(), e));
}
function yn(s, e) {
  return s && s !== "mp4a" ? s : e && e.split(",")[0];
}
function Xl(s) {
  const e = s.split(",");
  for (let t = 0; t < e.length; t++) {
    const i = e[t].split(".");
    if (i.length > 2) {
      let n = i.shift() + ".";
      n += parseInt(i.shift()).toString(16), n += ("000" + parseInt(i.shift()).toString(16)).slice(-4), e[t] = n;
    }
  }
  return e.join(",");
}
const Tn = /#EXT-X-STREAM-INF:([^\r\n]*)(?:[\r\n](?:#[^\r\n]*)?)*([^\r\n]+)|#EXT-X-(SESSION-DATA|SESSION-KEY|DEFINE|CONTENT-STEERING|START):([^\r\n]*)[\r\n]+/g, En = /#EXT-X-MEDIA:(.*)/g, Ql = /^#EXT(?:INF|-X-TARGETDURATION):/m, vn = new RegExp([
  /#EXTINF:\s*(\d*(?:\.\d+)?)(?:,(.*)\s+)?/.source,
  // duration (#EXTINF:<duration>,<title>), group 1 => duration, group 2 => title
  /(?!#) *(\S[^\r\n]*)/.source,
  // segment URI, group 3 => the URI (note newline is not eaten)
  /#EXT-X-BYTERANGE:*(.+)/.source,
  // next segment's byterange, group 4 => range spec (x@y)
  /#EXT-X-PROGRAM-DATE-TIME:(.+)/.source,
  // next segment's program date/time group 5 => the datetime spec
  /#.*/.source
  // All other non-segment oriented tags will match with all groups empty
].join("|"), "g"), Jl = new RegExp([/#(EXTM3U)/.source, /#EXT-X-(DATERANGE|DEFINE|KEY|MAP|PART|PART-INF|PLAYLIST-TYPE|PRELOAD-HINT|RENDITION-REPORT|SERVER-CONTROL|SKIP|START):(.+)/.source, /#EXT-X-(BITRATE|DISCONTINUITY-SEQUENCE|MEDIA-SEQUENCE|TARGETDURATION|VERSION): *(\d+)/.source, /#EXT-X-(DISCONTINUITY|ENDLIST|GAP|INDEPENDENT-SEGMENTS)/.source, /(#)([^:]*):(.*)/.source, /(#)(.*)(?:.*)\r?\n?/.source].join("|"));
class Ge {
  static findGroup(e, t) {
    for (let i = 0; i < e.length; i++) {
      const n = e[i];
      if (n.id === t)
        return n;
    }
  }
  static resolve(e, t) {
    return Ps.buildAbsoluteURL(t, e, {
      alwaysNormalize: !0
    });
  }
  static isMediaPlaylist(e) {
    return Ql.test(e);
  }
  static parseMasterPlaylist(e, t) {
    const i = gn(e), n = {
      contentSteering: null,
      levels: [],
      playlistParsingError: null,
      sessionData: null,
      sessionKeys: null,
      startTimeOffset: null,
      variableList: null,
      hasVariableRefs: i
    }, r = [];
    Tn.lastIndex = 0;
    let a;
    for (; (a = Tn.exec(e)) != null; )
      if (a[1]) {
        var o;
        const c = new ce(a[1]);
        Re(n, c, ["CODECS", "SUPPLEMENTAL-CODECS", "ALLOWED-CPC", "PATHWAY-ID", "STABLE-VARIANT-ID", "AUDIO", "VIDEO", "SUBTITLES", "CLOSED-CAPTIONS", "NAME"]);
        const h = gs(n, a[2]), u = {
          attrs: c,
          bitrate: c.decimalInteger("BANDWIDTH") || c.decimalInteger("AVERAGE-BANDWIDTH"),
          name: c.NAME,
          url: Ge.resolve(h, t)
        }, d = c.decimalResolution("RESOLUTION");
        d && (u.width = d.width, u.height = d.height), Zl(c.CODECS, u), (o = u.unknownCodecs) != null && o.length || r.push(u), n.levels.push(u);
      } else if (a[3]) {
        const c = a[3], h = a[4];
        switch (c) {
          case "SESSION-DATA": {
            const u = new ce(h);
            Re(n, u, ["DATA-ID", "LANGUAGE", "VALUE", "URI"]);
            const d = u["DATA-ID"];
            d && (n.sessionData === null && (n.sessionData = {}), n.sessionData[d] = u);
            break;
          }
          case "SESSION-KEY": {
            const u = bn(h, t, n);
            u.encrypted && u.isSupported() ? (n.sessionKeys === null && (n.sessionKeys = []), n.sessionKeys.push(u)) : S.warn(`[Keys] Ignoring invalid EXT-X-SESSION-KEY tag: "${h}"`);
            break;
          }
          case "DEFINE": {
            {
              const u = new ce(h);
              Re(n, u, ["NAME", "VALUE", "QUERYPARAM"]), mn(n, u, t);
            }
            break;
          }
          case "CONTENT-STEERING": {
            const u = new ce(h);
            Re(n, u, ["SERVER-URI", "PATHWAY-ID"]), n.contentSteering = {
              uri: Ge.resolve(u["SERVER-URI"], t),
              pathwayId: u["PATHWAY-ID"] || "."
            };
            break;
          }
          case "START": {
            n.startTimeOffset = xn(h);
            break;
          }
        }
      }
    const l = r.length > 0 && r.length < n.levels.length;
    return n.levels = l ? r : n.levels, n.levels.length === 0 && (n.playlistParsingError = new Error("no levels found in manifest")), n;
  }
  static parseMasterPlaylistMedia(e, t, i) {
    let n;
    const r = {}, a = i.levels, o = {
      AUDIO: a.map((c) => ({
        id: c.attrs.AUDIO,
        audioCodec: c.audioCodec
      })),
      SUBTITLES: a.map((c) => ({
        id: c.attrs.SUBTITLES,
        textCodec: c.textCodec
      })),
      "CLOSED-CAPTIONS": []
    };
    let l = 0;
    for (En.lastIndex = 0; (n = En.exec(e)) !== null; ) {
      const c = new ce(n[1]), h = c.TYPE;
      if (h) {
        const u = o[h], d = r[h] || [];
        r[h] = d, Re(i, c, ["URI", "GROUP-ID", "LANGUAGE", "ASSOC-LANGUAGE", "STABLE-RENDITION-ID", "NAME", "INSTREAM-ID", "CHARACTERISTICS", "CHANNELS"]);
        const g = c.LANGUAGE, f = c["ASSOC-LANGUAGE"], m = c.CHANNELS, y = c.CHARACTERISTICS, T = c["INSTREAM-ID"], b = {
          attrs: c,
          bitrate: 0,
          id: l++,
          groupId: c["GROUP-ID"] || "",
          name: c.NAME || g || "",
          type: h,
          default: c.bool("DEFAULT"),
          autoselect: c.bool("AUTOSELECT"),
          forced: c.bool("FORCED"),
          lang: g,
          url: c.URI ? Ge.resolve(c.URI, t) : ""
        };
        if (f && (b.assocLang = f), m && (b.channels = m), y && (b.characteristics = y), T && (b.instreamId = T), u != null && u.length) {
          const v = Ge.findGroup(u, b.groupId) || u[0];
          Sn(b, v, "audioCodec"), Sn(b, v, "textCodec");
        }
        d.push(b);
      }
    }
    return r;
  }
  static parseLevelPlaylist(e, t, i, n, r, a) {
    const o = new fl(t), l = o.fragments;
    let c = null, h = 0, u = 0, d = 0, g = 0, f = null, m = new Mi(n, t), y, T, b, v = -1, A = !1, x = null;
    for (vn.lastIndex = 0, o.m3u8 = e, o.hasVariableRefs = gn(e); (y = vn.exec(e)) !== null; ) {
      A && (A = !1, m = new Mi(n, t), m.start = d, m.sn = h, m.cc = g, m.level = i, c && (m.initSegment = c, m.rawProgramDateTime = c.rawProgramDateTime, c.rawProgramDateTime = null, x && (m.setByteRange(x), x = null)));
      const _ = y[1];
      if (_) {
        m.duration = parseFloat(_);
        const C = (" " + y[2]).slice(1);
        m.title = C || null, m.tagList.push(C ? ["INF", _, C] : ["INF", _]);
      } else if (y[3]) {
        if (U(m.duration)) {
          m.start = d, b && Rn(m, b, o), m.sn = h, m.level = i, m.cc = g, l.push(m);
          const C = (" " + y[3]).slice(1);
          m.relurl = gs(o, C), An(m, f), f = m, d += m.duration, h++, u = 0, A = !0;
        }
      } else if (y[4]) {
        const C = (" " + y[4]).slice(1);
        f ? m.setByteRange(C, f) : m.setByteRange(C);
      } else if (y[5])
        m.rawProgramDateTime = (" " + y[5]).slice(1), m.tagList.push(["PROGRAM-DATE-TIME", m.rawProgramDateTime]), v === -1 && (v = l.length);
      else {
        if (y = y[0].match(Jl), !y) {
          S.warn("No matches on slow regex match for level playlist!");
          continue;
        }
        for (T = 1; T < y.length && typeof y[T] == "undefined"; T++)
          ;
        const C = (" " + y[T]).slice(1), P = (" " + y[T + 1]).slice(1), q = y[T + 2] ? (" " + y[T + 2]).slice(1) : "";
        switch (C) {
          case "PLAYLIST-TYPE":
            o.type = P.toUpperCase();
            break;
          case "MEDIA-SEQUENCE":
            h = o.startSN = parseInt(P);
            break;
          case "SKIP": {
            const M = new ce(P);
            Re(o, M, ["RECENTLY-REMOVED-DATERANGES"]);
            const j = M.decimalInteger("SKIPPED-SEGMENTS");
            if (U(j)) {
              o.skippedSegments = j;
              for (let H = j; H--; )
                l.unshift(null);
              h += j;
            }
            const Y = M.enumeratedString("RECENTLY-REMOVED-DATERANGES");
            Y && (o.recentlyRemovedDateranges = Y.split("	"));
            break;
          }
          case "TARGETDURATION":
            o.targetduration = Math.max(parseInt(P), 1);
            break;
          case "VERSION":
            o.version = parseInt(P);
            break;
          case "INDEPENDENT-SEGMENTS":
          case "EXTM3U":
            break;
          case "ENDLIST":
            o.live = !1;
            break;
          case "#":
            (P || q) && m.tagList.push(q ? [P, q] : [P]);
            break;
          case "DISCONTINUITY":
            g++, m.tagList.push(["DIS"]);
            break;
          case "GAP":
            m.gap = !0, m.tagList.push([C]);
            break;
          case "BITRATE":
            m.tagList.push([C, P]);
            break;
          case "DATERANGE": {
            const M = new ce(P);
            Re(o, M, ["ID", "CLASS", "START-DATE", "END-DATE", "SCTE35-CMD", "SCTE35-OUT", "SCTE35-IN"]), Re(o, M, M.clientAttrs);
            const j = new Mr(M, o.dateRanges[M.ID]);
            j.isValid || o.skippedSegments ? o.dateRanges[j.id] = j : S.warn(`Ignoring invalid DATERANGE tag: "${P}"`), m.tagList.push(["EXT-X-DATERANGE", P]);
            break;
          }
          case "DEFINE": {
            {
              const M = new ce(P);
              Re(o, M, ["NAME", "VALUE", "IMPORT", "QUERYPARAM"]), "IMPORT" in M ? Wl(o, M, a) : mn(o, M, t);
            }
            break;
          }
          case "DISCONTINUITY-SEQUENCE":
            g = parseInt(P);
            break;
          case "KEY": {
            const M = bn(P, t, o);
            if (M.isSupported()) {
              if (M.method === "NONE") {
                b = void 0;
                break;
              }
              b || (b = {}), b[M.keyFormat] && (b = fe({}, b)), b[M.keyFormat] = M;
            } else
              S.warn(`[Keys] Ignoring invalid EXT-X-KEY tag: "${P}"`);
            break;
          }
          case "START":
            o.startTimeOffset = xn(P);
            break;
          case "MAP": {
            const M = new ce(P);
            if (Re(o, M, ["BYTERANGE", "URI"]), m.duration) {
              const j = new Mi(n, t);
              Ln(j, M, i, b), c = j, m.initSegment = c, c.rawProgramDateTime && !m.rawProgramDateTime && (m.rawProgramDateTime = c.rawProgramDateTime);
            } else {
              const j = m.byteRangeEndOffset;
              if (j) {
                const Y = m.byteRangeStartOffset;
                x = `${j - Y}@${Y}`;
              } else
                x = null;
              Ln(m, M, i, b), c = m, A = !0;
            }
            break;
          }
          case "SERVER-CONTROL": {
            const M = new ce(P);
            o.canBlockReload = M.bool("CAN-BLOCK-RELOAD"), o.canSkipUntil = M.optionalFloat("CAN-SKIP-UNTIL", 0), o.canSkipDateRanges = o.canSkipUntil > 0 && M.bool("CAN-SKIP-DATERANGES"), o.partHoldBack = M.optionalFloat("PART-HOLD-BACK", 0), o.holdBack = M.optionalFloat("HOLD-BACK", 0);
            break;
          }
          case "PART-INF": {
            const M = new ce(P);
            o.partTarget = M.decimalFloatingPoint("PART-TARGET");
            break;
          }
          case "PART": {
            let M = o.partList;
            M || (M = o.partList = []);
            const j = u > 0 ? M[M.length - 1] : void 0, Y = u++, H = new ce(P);
            Re(o, H, ["BYTERANGE", "URI"]);
            const Z = new ul(H, m, t, Y, j);
            M.push(Z), m.duration += Z.duration;
            break;
          }
          case "PRELOAD-HINT": {
            const M = new ce(P);
            Re(o, M, ["URI"]), o.preloadHint = M;
            break;
          }
          case "RENDITION-REPORT": {
            const M = new ce(P);
            Re(o, M, ["URI"]), o.renditionReports = o.renditionReports || [], o.renditionReports.push(M);
            break;
          }
          default:
            S.warn(`line parsed but not handled: ${y}`);
            break;
        }
      }
    }
    f && !f.relurl ? (l.pop(), d -= f.duration, o.partList && (o.fragmentHint = f)) : o.partList && (An(m, f), m.cc = g, o.fragmentHint = m, b && Rn(m, b, o));
    const w = l.length, R = l[0], k = l[w - 1];
    if (d += o.skippedSegments * o.targetduration, d > 0 && w && k) {
      o.averagetargetduration = d / w;
      const _ = k.sn;
      o.endSN = _ !== "initSegment" ? _ : 0, o.live || (k.endList = !0), R && (o.startCC = R.cc);
    } else
      o.endSN = 0, o.startCC = 0;
    return o.fragmentHint && (d += o.fragmentHint.duration), o.totalduration = d, o.endCC = g, v > 0 && ec(l, v), o;
  }
}
function bn(s, e, t) {
  var i, n;
  const r = new ce(s);
  Re(t, r, ["KEYFORMAT", "KEYFORMATVERSIONS", "URI", "IV", "URI"]);
  const a = (i = r.METHOD) != null ? i : "", o = r.URI, l = r.hexadecimalInteger("IV"), c = r.KEYFORMATVERSIONS, h = (n = r.KEYFORMAT) != null ? n : "identity";
  o && r.IV && !l && S.error(`Invalid IV: ${r.IV}`);
  const u = o ? Ge.resolve(o, e) : "", d = (c || "1").split("/").map(Number).filter(Number.isFinite);
  return new Pt(a, u, h, d, l);
}
function xn(s) {
  const t = new ce(s).decimalFloatingPoint("TIME-OFFSET");
  return U(t) ? t : null;
}
function Zl(s, e) {
  let t = (s || "").split(/[ ,]+/).filter((i) => i);
  ["video", "audio", "text"].forEach((i) => {
    const n = t.filter((r) => jl(r, i));
    n.length && (e[`${i}Codec`] = n.join(","), t = t.filter((r) => n.indexOf(r) === -1));
  }), e.unknownCodecs = t;
}
function Sn(s, e, t) {
  const i = e[t];
  i && (s[t] = i);
}
function ec(s, e) {
  let t = s[e];
  for (let i = e; i--; ) {
    const n = s[i];
    if (!n)
      return;
    n.programDateTime = t.programDateTime - n.duration * 1e3, t = n;
  }
}
function An(s, e) {
  s.rawProgramDateTime ? s.programDateTime = Date.parse(s.rawProgramDateTime) : e != null && e.programDateTime && (s.programDateTime = e.endProgramDateTime), U(s.programDateTime) || (s.programDateTime = null, s.rawProgramDateTime = null);
}
function Ln(s, e, t, i) {
  s.relurl = e.URI, e.BYTERANGE && s.setByteRange(e.BYTERANGE), s.level = t, s.sn = "initSegment", i && (s.levelkeys = i), s.initSegment = null;
}
function Rn(s, e, t) {
  s.levelkeys = e;
  const {
    encryptedFragments: i
  } = t;
  (!i.length || i[i.length - 1].levelkeys !== e) && Object.keys(e).some((n) => e[n].isCommonEncryption) && i.push(s);
}
var Q = {
  MANIFEST: "manifest",
  LEVEL: "level",
  AUDIO_TRACK: "audioTrack",
  SUBTITLE_TRACK: "subtitleTrack"
}, G = {
  MAIN: "main",
  AUDIO: "audio",
  SUBTITLE: "subtitle"
};
function In(s) {
  const {
    type: e
  } = s;
  switch (e) {
    case Q.AUDIO_TRACK:
      return G.AUDIO;
    case Q.SUBTITLE_TRACK:
      return G.SUBTITLE;
    default:
      return G.MAIN;
  }
}
function Wi(s, e) {
  let t = s.url;
  return (t === void 0 || t.indexOf("data:") === 0) && (t = e.url), t;
}
class tc {
  constructor(e) {
    this.hls = void 0, this.loaders = /* @__PURE__ */ Object.create(null), this.variableList = null, this.hls = e, this.registerListeners();
  }
  startLoad(e) {
  }
  stopLoad() {
    this.destroyInternalLoaders();
  }
  registerListeners() {
    const {
      hls: e
    } = this;
    e.on(p.MANIFEST_LOADING, this.onManifestLoading, this), e.on(p.LEVEL_LOADING, this.onLevelLoading, this), e.on(p.AUDIO_TRACK_LOADING, this.onAudioTrackLoading, this), e.on(p.SUBTITLE_TRACK_LOADING, this.onSubtitleTrackLoading, this);
  }
  unregisterListeners() {
    const {
      hls: e
    } = this;
    e.off(p.MANIFEST_LOADING, this.onManifestLoading, this), e.off(p.LEVEL_LOADING, this.onLevelLoading, this), e.off(p.AUDIO_TRACK_LOADING, this.onAudioTrackLoading, this), e.off(p.SUBTITLE_TRACK_LOADING, this.onSubtitleTrackLoading, this);
  }
  /**
   * Returns defaults or configured loader-type overloads (pLoader and loader config params)
   */
  createInternalLoader(e) {
    const t = this.hls.config, i = t.pLoader, n = t.loader, r = i || n, a = new r(t);
    return this.loaders[e.type] = a, a;
  }
  getInternalLoader(e) {
    return this.loaders[e.type];
  }
  resetInternalLoader(e) {
    this.loaders[e] && delete this.loaders[e];
  }
  /**
   * Call `destroy` on all internal loader instances mapped (one per context type)
   */
  destroyInternalLoaders() {
    for (const e in this.loaders) {
      const t = this.loaders[e];
      t && t.destroy(), this.resetInternalLoader(e);
    }
  }
  destroy() {
    this.variableList = null, this.unregisterListeners(), this.destroyInternalLoaders();
  }
  onManifestLoading(e, t) {
    const {
      url: i
    } = t;
    this.variableList = null, this.load({
      id: null,
      level: 0,
      responseType: "text",
      type: Q.MANIFEST,
      url: i,
      deliveryDirectives: null
    });
  }
  onLevelLoading(e, t) {
    const {
      id: i,
      level: n,
      pathwayId: r,
      url: a,
      deliveryDirectives: o
    } = t;
    this.load({
      id: i,
      level: n,
      pathwayId: r,
      responseType: "text",
      type: Q.LEVEL,
      url: a,
      deliveryDirectives: o
    });
  }
  onAudioTrackLoading(e, t) {
    const {
      id: i,
      groupId: n,
      url: r,
      deliveryDirectives: a
    } = t;
    this.load({
      id: i,
      groupId: n,
      level: null,
      responseType: "text",
      type: Q.AUDIO_TRACK,
      url: r,
      deliveryDirectives: a
    });
  }
  onSubtitleTrackLoading(e, t) {
    const {
      id: i,
      groupId: n,
      url: r,
      deliveryDirectives: a
    } = t;
    this.load({
      id: i,
      groupId: n,
      level: null,
      responseType: "text",
      type: Q.SUBTITLE_TRACK,
      url: r,
      deliveryDirectives: a
    });
  }
  load(e) {
    var t;
    const i = this.hls.config;
    let n = this.getInternalLoader(e);
    if (n) {
      const c = n.context;
      if (c && c.url === e.url && c.level === e.level) {
        S.trace("[playlist-loader]: playlist request ongoing");
        return;
      }
      S.log(`[playlist-loader]: aborting previous loader for type: ${e.type}`), n.abort();
    }
    let r;
    if (e.type === Q.MANIFEST ? r = i.manifestLoadPolicy.default : r = fe({}, i.playlistLoadPolicy.default, {
      timeoutRetry: null,
      errorRetry: null
    }), n = this.createInternalLoader(e), U((t = e.deliveryDirectives) == null ? void 0 : t.part)) {
      let c;
      if (e.type === Q.LEVEL && e.level !== null ? c = this.hls.levels[e.level].details : e.type === Q.AUDIO_TRACK && e.id !== null ? c = this.hls.audioTracks[e.id].details : e.type === Q.SUBTITLE_TRACK && e.id !== null && (c = this.hls.subtitleTracks[e.id].details), c) {
        const h = c.partTarget, u = c.targetduration;
        if (h && u) {
          const d = Math.max(h * 3, u * 0.8) * 1e3;
          r = fe({}, r, {
            maxTimeToFirstByteMs: Math.min(d, r.maxTimeToFirstByteMs),
            maxLoadTimeMs: Math.min(d, r.maxTimeToFirstByteMs)
          });
        }
      }
    }
    const a = r.errorRetry || r.timeoutRetry || {}, o = {
      loadPolicy: r,
      timeout: r.maxLoadTimeMs,
      maxRetry: a.maxNumRetry || 0,
      retryDelay: a.retryDelayMs || 0,
      maxRetryDelay: a.maxRetryDelayMs || 0
    }, l = {
      onSuccess: (c, h, u, d) => {
        const g = this.getInternalLoader(u);
        this.resetInternalLoader(u.type);
        const f = c.data;
        if (f.indexOf("#EXTM3U") !== 0) {
          this.handleManifestParsingError(c, u, new Error("no EXTM3U delimiter"), d || null, h);
          return;
        }
        h.parsing.start = performance.now(), Ge.isMediaPlaylist(f) ? this.handleTrackOrLevelPlaylist(c, h, u, d || null, g) : this.handleMasterPlaylist(c, h, u, d);
      },
      onError: (c, h, u, d) => {
        this.handleNetworkError(h, u, !1, c, d);
      },
      onTimeout: (c, h, u) => {
        this.handleNetworkError(h, u, !0, void 0, c);
      }
    };
    n.load(e, o, l);
  }
  handleMasterPlaylist(e, t, i, n) {
    const r = this.hls, a = e.data, o = Wi(e, i), l = Ge.parseMasterPlaylist(a, o);
    if (l.playlistParsingError) {
      this.handleManifestParsingError(e, i, l.playlistParsingError, n, t);
      return;
    }
    const {
      contentSteering: c,
      levels: h,
      sessionData: u,
      sessionKeys: d,
      startTimeOffset: g,
      variableList: f
    } = l;
    this.variableList = f;
    const {
      AUDIO: m = [],
      SUBTITLES: y,
      "CLOSED-CAPTIONS": T
    } = Ge.parseMasterPlaylistMedia(a, o, l);
    m.length && !m.some((v) => !v.url) && h[0].audioCodec && !h[0].attrs.AUDIO && (S.log("[playlist-loader]: audio codec signaled in quality level, but no embedded audio track signaled, create one"), m.unshift({
      type: "main",
      name: "main",
      groupId: "main",
      default: !1,
      autoselect: !1,
      forced: !1,
      id: -1,
      attrs: new ce({}),
      bitrate: 0,
      url: ""
    })), r.trigger(p.MANIFEST_LOADED, {
      levels: h,
      audioTracks: m,
      subtitles: y,
      captions: T,
      contentSteering: c,
      url: o,
      stats: t,
      networkDetails: n,
      sessionData: u,
      sessionKeys: d,
      startTimeOffset: g,
      variableList: f
    });
  }
  handleTrackOrLevelPlaylist(e, t, i, n, r) {
    const a = this.hls, {
      id: o,
      level: l,
      type: c
    } = i, h = Wi(e, i), u = 0, d = U(l) ? l : U(o) ? o : 0, g = In(i), f = Ge.parseLevelPlaylist(e.data, h, d, g, u, this.variableList);
    if (c === Q.MANIFEST) {
      const m = {
        attrs: new ce({}),
        bitrate: 0,
        details: f,
        name: "",
        url: h
      };
      a.trigger(p.MANIFEST_LOADED, {
        levels: [m],
        audioTracks: [],
        url: h,
        stats: t,
        networkDetails: n,
        sessionData: null,
        sessionKeys: null,
        contentSteering: null,
        startTimeOffset: null,
        variableList: null
      });
    }
    t.parsing.end = performance.now(), i.levelDetails = f, this.handlePlaylistLoaded(f, e, t, i, n, r);
  }
  handleManifestParsingError(e, t, i, n, r) {
    this.hls.trigger(p.ERROR, {
      type: V.NETWORK_ERROR,
      details: I.MANIFEST_PARSING_ERROR,
      fatal: t.type === Q.MANIFEST,
      url: e.url,
      err: i,
      error: i,
      reason: i.message,
      response: e,
      context: t,
      networkDetails: n,
      stats: r
    });
  }
  handleNetworkError(e, t, i = !1, n, r) {
    let a = `A network ${i ? "timeout" : "error" + (n ? " (status " + n.code + ")" : "")} occurred while loading ${e.type}`;
    e.type === Q.LEVEL ? a += `: ${e.level} id: ${e.id}` : (e.type === Q.AUDIO_TRACK || e.type === Q.SUBTITLE_TRACK) && (a += ` id: ${e.id} group-id: "${e.groupId}"`);
    const o = new Error(a);
    S.warn(`[playlist-loader]: ${a}`);
    let l = I.UNKNOWN, c = !1;
    const h = this.getInternalLoader(e);
    switch (e.type) {
      case Q.MANIFEST:
        l = i ? I.MANIFEST_LOAD_TIMEOUT : I.MANIFEST_LOAD_ERROR, c = !0;
        break;
      case Q.LEVEL:
        l = i ? I.LEVEL_LOAD_TIMEOUT : I.LEVEL_LOAD_ERROR, c = !1;
        break;
      case Q.AUDIO_TRACK:
        l = i ? I.AUDIO_TRACK_LOAD_TIMEOUT : I.AUDIO_TRACK_LOAD_ERROR, c = !1;
        break;
      case Q.SUBTITLE_TRACK:
        l = i ? I.SUBTITLE_TRACK_LOAD_TIMEOUT : I.SUBTITLE_LOAD_ERROR, c = !1;
        break;
    }
    h && this.resetInternalLoader(e.type);
    const u = {
      type: V.NETWORK_ERROR,
      details: l,
      fatal: c,
      url: e.url,
      loader: h,
      context: e,
      error: o,
      networkDetails: t,
      stats: r
    };
    if (n) {
      const d = (t == null ? void 0 : t.url) || e.url;
      u.response = be({
        url: d,
        data: void 0
      }, n);
    }
    this.hls.trigger(p.ERROR, u);
  }
  handlePlaylistLoaded(e, t, i, n, r, a) {
    const o = this.hls, {
      type: l,
      level: c,
      id: h,
      groupId: u,
      deliveryDirectives: d
    } = n, g = Wi(t, n), f = In(n), m = typeof n.level == "number" && f === G.MAIN ? c : void 0;
    if (!e.fragments.length) {
      const T = new Error("No Segments found in Playlist");
      o.trigger(p.ERROR, {
        type: V.NETWORK_ERROR,
        details: I.LEVEL_EMPTY_ERROR,
        fatal: !1,
        url: g,
        error: T,
        reason: T.message,
        response: t,
        context: n,
        level: m,
        parent: f,
        networkDetails: r,
        stats: i
      });
      return;
    }
    e.targetduration || (e.playlistParsingError = new Error("Missing Target Duration"));
    const y = e.playlistParsingError;
    if (y) {
      o.trigger(p.ERROR, {
        type: V.NETWORK_ERROR,
        details: I.LEVEL_PARSING_ERROR,
        fatal: !1,
        url: g,
        error: y,
        reason: y.message,
        response: t,
        context: n,
        level: m,
        parent: f,
        networkDetails: r,
        stats: i
      });
      return;
    }
    switch (e.live && a && (a.getCacheAge && (e.ageHeader = a.getCacheAge() || 0), (!a.getCacheAge || isNaN(e.ageHeader)) && (e.ageHeader = 0)), l) {
      case Q.MANIFEST:
      case Q.LEVEL:
        o.trigger(p.LEVEL_LOADED, {
          details: e,
          level: m || 0,
          id: h || 0,
          stats: i,
          networkDetails: r,
          deliveryDirectives: d
        });
        break;
      case Q.AUDIO_TRACK:
        o.trigger(p.AUDIO_TRACK_LOADED, {
          details: e,
          id: h || 0,
          groupId: u || "",
          stats: i,
          networkDetails: r,
          deliveryDirectives: d
        });
        break;
      case Q.SUBTITLE_TRACK:
        o.trigger(p.SUBTITLE_TRACK_LOADED, {
          details: e,
          id: h || 0,
          groupId: u || "",
          stats: i,
          networkDetails: r,
          deliveryDirectives: d
        });
        break;
    }
  }
}
function Jr(s, e) {
  let t;
  try {
    t = new Event("addtrack");
  } catch (i) {
    t = document.createEvent("Event"), t.initEvent("addtrack", !1, !1);
  }
  t.track = s, e.dispatchEvent(t);
}
function Zr(s, e) {
  const t = s.mode;
  if (t === "disabled" && (s.mode = "hidden"), s.cues && !s.cues.getCueById(e.id))
    try {
      if (s.addCue(e), !s.cues.getCueById(e.id))
        throw new Error(`addCue is failed for: ${e}`);
    } catch (i) {
      S.debug(`[texttrack-utils]: ${i}`);
      try {
        const n = new self.TextTrackCue(e.startTime, e.endTime, e.text);
        n.id = e.id, s.addCue(n);
      } catch (n) {
        S.debug(`[texttrack-utils]: Legacy TextTrackCue fallback failed: ${n}`);
      }
    }
  t === "disabled" && (s.mode = t);
}
function mt(s) {
  const e = s.mode;
  if (e === "disabled" && (s.mode = "hidden"), s.cues)
    for (let t = s.cues.length; t--; )
      s.removeCue(s.cues[t]);
  e === "disabled" && (s.mode = e);
}
function ms(s, e, t, i) {
  const n = s.mode;
  if (n === "disabled" && (s.mode = "hidden"), s.cues && s.cues.length > 0) {
    const r = sc(s.cues, e, t);
    for (let a = 0; a < r.length; a++)
      (!i || i(r[a])) && s.removeCue(r[a]);
  }
  n === "disabled" && (s.mode = n);
}
function ic(s, e) {
  if (e < s[0].startTime)
    return 0;
  const t = s.length - 1;
  if (e > s[t].endTime)
    return -1;
  let i = 0, n = t;
  for (; i <= n; ) {
    const r = Math.floor((n + i) / 2);
    if (e < s[r].startTime)
      n = r - 1;
    else if (e > s[r].startTime && i < t)
      i = r + 1;
    else
      return r;
  }
  return s[i].startTime - e < e - s[n].startTime ? i : n;
}
function sc(s, e, t) {
  const i = [], n = ic(s, e);
  if (n > -1)
    for (let r = n, a = s.length; r < a; r++) {
      const o = s[r];
      if (o.startTime >= e && o.endTime <= t)
        i.push(o);
      else if (o.startTime > t)
        return i;
    }
  return i;
}
function ii(s) {
  const e = [];
  for (let t = 0; t < s.length; t++) {
    const i = s[t];
    (i.kind === "subtitles" || i.kind === "captions") && i.label && e.push(s[t]);
  }
  return e;
}
var Fe = {
  audioId3: "org.id3",
  dateRange: "com.apple.quicktime.HLS",
  emsg: "https://aomedia.org/emsg/ID3"
};
const nc = 0.25;
function ps() {
  if (typeof self != "undefined")
    return self.VTTCue || self.TextTrackCue;
}
function wn(s, e, t, i, n) {
  let r = new s(e, t, "");
  try {
    r.value = i, n && (r.type = n);
  } catch (a) {
    r = new s(e, t, JSON.stringify(n ? be({
      type: n
    }, i) : i));
  }
  return r;
}
const Vt = (() => {
  const s = ps();
  try {
    s && new s(0, Number.POSITIVE_INFINITY, "");
  } catch (e) {
    return Number.MAX_VALUE;
  }
  return Number.POSITIVE_INFINITY;
})();
function Yi(s, e) {
  return s.getTime() / 1e3 - e;
}
function rc(s) {
  return Uint8Array.from(s.replace(/^0x/, "").replace(/([\da-fA-F]{2}) ?/g, "0x$1 ").replace(/ +$/, "").split(" ")).buffer;
}
class ac {
  constructor(e) {
    this.hls = void 0, this.id3Track = null, this.media = null, this.dateRangeCuesAppended = {}, this.hls = e, this._registerListeners();
  }
  destroy() {
    this._unregisterListeners(), this.id3Track = null, this.media = null, this.dateRangeCuesAppended = {}, this.hls = null;
  }
  _registerListeners() {
    const {
      hls: e
    } = this;
    e.on(p.MEDIA_ATTACHED, this.onMediaAttached, this), e.on(p.MEDIA_DETACHING, this.onMediaDetaching, this), e.on(p.MANIFEST_LOADING, this.onManifestLoading, this), e.on(p.FRAG_PARSING_METADATA, this.onFragParsingMetadata, this), e.on(p.BUFFER_FLUSHING, this.onBufferFlushing, this), e.on(p.LEVEL_UPDATED, this.onLevelUpdated, this);
  }
  _unregisterListeners() {
    const {
      hls: e
    } = this;
    e.off(p.MEDIA_ATTACHED, this.onMediaAttached, this), e.off(p.MEDIA_DETACHING, this.onMediaDetaching, this), e.off(p.MANIFEST_LOADING, this.onManifestLoading, this), e.off(p.FRAG_PARSING_METADATA, this.onFragParsingMetadata, this), e.off(p.BUFFER_FLUSHING, this.onBufferFlushing, this), e.off(p.LEVEL_UPDATED, this.onLevelUpdated, this);
  }
  // Add ID3 metatadata text track.
  onMediaAttached(e, t) {
    this.media = t.media;
  }
  onMediaDetaching() {
    this.id3Track && (mt(this.id3Track), this.id3Track = null, this.media = null, this.dateRangeCuesAppended = {});
  }
  onManifestLoading() {
    this.dateRangeCuesAppended = {};
  }
  createTrack(e) {
    const t = this.getID3Track(e.textTracks);
    return t.mode = "hidden", t;
  }
  getID3Track(e) {
    if (this.media) {
      for (let t = 0; t < e.length; t++) {
        const i = e[t];
        if (i.kind === "metadata" && i.label === "id3")
          return Jr(i, this.media), i;
      }
      return this.media.addTextTrack("metadata", "id3");
    }
  }
  onFragParsingMetadata(e, t) {
    if (!this.media)
      return;
    const {
      hls: {
        config: {
          enableEmsgMetadataCues: i,
          enableID3MetadataCues: n
        }
      }
    } = this;
    if (!i && !n)
      return;
    const {
      samples: r
    } = t;
    this.id3Track || (this.id3Track = this.createTrack(this.media));
    const a = ps();
    if (a)
      for (let o = 0; o < r.length; o++) {
        const l = r[o].type;
        if (l === Fe.emsg && !i || !n)
          continue;
        const c = Hr(r[o].data);
        if (c) {
          const h = r[o].pts;
          let u = h + r[o].duration;
          u > Vt && (u = Vt), u - h <= 0 && (u = h + nc);
          for (let g = 0; g < c.length; g++) {
            const f = c[g];
            if (!Gr(f)) {
              this.updateId3CueEnds(h, l);
              const m = wn(a, h, u, f, l);
              m && this.id3Track.addCue(m);
            }
          }
        }
      }
  }
  updateId3CueEnds(e, t) {
    var i;
    const n = (i = this.id3Track) == null ? void 0 : i.cues;
    if (n)
      for (let r = n.length; r--; ) {
        const a = n[r];
        a.type === t && a.startTime < e && a.endTime === Vt && (a.endTime = e);
      }
  }
  onBufferFlushing(e, {
    startOffset: t,
    endOffset: i,
    type: n
  }) {
    const {
      id3Track: r,
      hls: a
    } = this;
    if (!a)
      return;
    const {
      config: {
        enableEmsgMetadataCues: o,
        enableID3MetadataCues: l
      }
    } = a;
    if (r && (o || l)) {
      let c;
      n === "audio" ? c = (h) => h.type === Fe.audioId3 && l : n === "video" ? c = (h) => h.type === Fe.emsg && o : c = (h) => h.type === Fe.audioId3 && l || h.type === Fe.emsg && o, ms(r, t, i, c);
    }
  }
  onLevelUpdated(e, {
    details: t
  }) {
    if (!this.media || !t.hasProgramDateTime || !this.hls.config.enableDateRangeMetadataCues)
      return;
    const {
      dateRangeCuesAppended: i,
      id3Track: n
    } = this, {
      dateRanges: r
    } = t, a = Object.keys(r);
    if (n) {
      const h = Object.keys(i).filter((u) => !a.includes(u));
      for (let u = h.length; u--; ) {
        const d = h[u];
        Object.keys(i[d].cues).forEach((g) => {
          n.removeCue(i[d].cues[g]);
        }), delete i[d];
      }
    }
    const o = t.fragments[t.fragments.length - 1];
    if (a.length === 0 || !U(o == null ? void 0 : o.programDateTime))
      return;
    this.id3Track || (this.id3Track = this.createTrack(this.media));
    const l = o.programDateTime / 1e3 - o.start, c = ps();
    for (let h = 0; h < a.length; h++) {
      const u = a[h], d = r[u], g = Yi(d.startDate, l), f = i[u], m = (f == null ? void 0 : f.cues) || {};
      let y = (f == null ? void 0 : f.durationKnown) || !1, T = Vt;
      const b = d.endDate;
      if (b)
        T = Yi(b, l), y = !0;
      else if (d.endOnNext && !y) {
        const A = a.reduce((x, w) => {
          if (w !== d.id) {
            const R = r[w];
            if (R.class === d.class && R.startDate > d.startDate && (!x || d.startDate < x.startDate))
              return R;
          }
          return x;
        }, null);
        A && (T = Yi(A.startDate, l), y = !0);
      }
      const v = Object.keys(d.attr);
      for (let A = 0; A < v.length; A++) {
        const x = v[A];
        if (!cl(x))
          continue;
        const w = m[x];
        if (w)
          y && !f.durationKnown && (w.endTime = T);
        else if (c) {
          let R = d.attr[x];
          hl(x) && (R = rc(R));
          const k = wn(c, g, T, {
            key: x,
            data: R
          }, Fe.dateRange);
          k && (k.id = u, this.id3Track.addCue(k), m[x] = k);
        }
      }
      i[u] = {
        cues: m,
        dateRange: d,
        durationKnown: y
      };
    }
  }
}
class oc {
  constructor(e) {
    this.hls = void 0, this.config = void 0, this.media = null, this.levelDetails = null, this.currentTime = 0, this.stallCount = 0, this._latency = null, this.timeupdateHandler = () => this.timeupdate(), this.hls = e, this.config = e.config, this.registerListeners();
  }
  get latency() {
    return this._latency || 0;
  }
  get maxLatency() {
    const {
      config: e,
      levelDetails: t
    } = this;
    return e.liveMaxLatencyDuration !== void 0 ? e.liveMaxLatencyDuration : t ? e.liveMaxLatencyDurationCount * t.targetduration : 0;
  }
  get targetLatency() {
    const {
      levelDetails: e
    } = this;
    if (e === null)
      return null;
    const {
      holdBack: t,
      partHoldBack: i,
      targetduration: n
    } = e, {
      liveSyncDuration: r,
      liveSyncDurationCount: a,
      lowLatencyMode: o
    } = this.config, l = this.hls.userConfig;
    let c = o && i || t;
    (l.liveSyncDuration || l.liveSyncDurationCount || c === 0) && (c = r !== void 0 ? r : a * n);
    const h = n;
    return c + Math.min(this.stallCount * 1, h);
  }
  get liveSyncPosition() {
    const e = this.estimateLiveEdge(), t = this.targetLatency, i = this.levelDetails;
    if (e === null || t === null || i === null)
      return null;
    const n = i.edge, r = e - t - this.edgeStalled, a = n - i.totalduration, o = n - (this.config.lowLatencyMode && i.partTarget || i.targetduration);
    return Math.min(Math.max(a, r), o);
  }
  get drift() {
    const {
      levelDetails: e
    } = this;
    return e === null ? 1 : e.drift;
  }
  get edgeStalled() {
    const {
      levelDetails: e
    } = this;
    if (e === null)
      return 0;
    const t = (this.config.lowLatencyMode && e.partTarget || e.targetduration) * 3;
    return Math.max(e.age - t, 0);
  }
  get forwardBufferLength() {
    const {
      media: e,
      levelDetails: t
    } = this;
    if (!e || !t)
      return 0;
    const i = e.buffered.length;
    return (i ? e.buffered.end(i - 1) : t.edge) - this.currentTime;
  }
  destroy() {
    this.unregisterListeners(), this.onMediaDetaching(), this.levelDetails = null, this.hls = this.timeupdateHandler = null;
  }
  registerListeners() {
    this.hls.on(p.MEDIA_ATTACHED, this.onMediaAttached, this), this.hls.on(p.MEDIA_DETACHING, this.onMediaDetaching, this), this.hls.on(p.MANIFEST_LOADING, this.onManifestLoading, this), this.hls.on(p.LEVEL_UPDATED, this.onLevelUpdated, this), this.hls.on(p.ERROR, this.onError, this);
  }
  unregisterListeners() {
    this.hls.off(p.MEDIA_ATTACHED, this.onMediaAttached, this), this.hls.off(p.MEDIA_DETACHING, this.onMediaDetaching, this), this.hls.off(p.MANIFEST_LOADING, this.onManifestLoading, this), this.hls.off(p.LEVEL_UPDATED, this.onLevelUpdated, this), this.hls.off(p.ERROR, this.onError, this);
  }
  onMediaAttached(e, t) {
    this.media = t.media, this.media.addEventListener("timeupdate", this.timeupdateHandler);
  }
  onMediaDetaching() {
    this.media && (this.media.removeEventListener("timeupdate", this.timeupdateHandler), this.media = null);
  }
  onManifestLoading() {
    this.levelDetails = null, this._latency = null, this.stallCount = 0;
  }
  onLevelUpdated(e, {
    details: t
  }) {
    this.levelDetails = t, t.advanced && this.timeupdate(), !t.live && this.media && this.media.removeEventListener("timeupdate", this.timeupdateHandler);
  }
  onError(e, t) {
    var i;
    t.details === I.BUFFER_STALLED_ERROR && (this.stallCount++, (i = this.levelDetails) != null && i.live && S.warn("[playback-rate-controller]: Stall detected, adjusting target latency"));
  }
  timeupdate() {
    const {
      media: e,
      levelDetails: t
    } = this;
    if (!e || !t)
      return;
    this.currentTime = e.currentTime;
    const i = this.computeLatency();
    if (i === null)
      return;
    this._latency = i;
    const {
      lowLatencyMode: n,
      maxLiveSyncPlaybackRate: r
    } = this.config;
    if (!n || r === 1 || !t.live)
      return;
    const a = this.targetLatency;
    if (a === null)
      return;
    const o = i - a, l = Math.min(this.maxLatency, a + t.targetduration);
    if (o < l && o > 0.05 && this.forwardBufferLength > 1) {
      const h = Math.min(2, Math.max(1, r)), u = Math.round(2 / (1 + Math.exp(-0.75 * o - this.edgeStalled)) * 20) / 20;
      e.playbackRate = Math.min(h, Math.max(1, u));
    } else e.playbackRate !== 1 && e.playbackRate !== 0 && (e.playbackRate = 1);
  }
  estimateLiveEdge() {
    const {
      levelDetails: e
    } = this;
    return e === null ? null : e.edge + e.age;
  }
  computeLatency() {
    const e = this.estimateLiveEdge();
    return e === null ? null : e - this.currentTime;
  }
}
const ys = ["NONE", "TYPE-0", "TYPE-1", null];
function lc(s) {
  return ys.indexOf(s) > -1;
}
const Ti = ["SDR", "PQ", "HLG"];
function cc(s) {
  return !!s && Ti.indexOf(s) > -1;
}
var si = {
  No: "",
  Yes: "YES",
  v2: "v2"
};
function Cn(s) {
  const {
    canSkipUntil: e,
    canSkipDateRanges: t,
    age: i
  } = s, n = i < e / 2;
  return e && n ? t ? si.v2 : si.Yes : si.No;
}
class Dn {
  constructor(e, t, i) {
    this.msn = void 0, this.part = void 0, this.skip = void 0, this.msn = e, this.part = t, this.skip = i;
  }
  addDirectives(e) {
    const t = new self.URL(e);
    return this.msn !== void 0 && t.searchParams.set("_HLS_msn", this.msn.toString()), this.part !== void 0 && t.searchParams.set("_HLS_part", this.part.toString()), this.skip && t.searchParams.set("_HLS_skip", this.skip), t.href;
  }
}
class vt {
  constructor(e) {
    this._attrs = void 0, this.audioCodec = void 0, this.bitrate = void 0, this.codecSet = void 0, this.url = void 0, this.frameRate = void 0, this.height = void 0, this.id = void 0, this.name = void 0, this.videoCodec = void 0, this.width = void 0, this.details = void 0, this.fragmentError = 0, this.loadError = 0, this.loaded = void 0, this.realBitrate = 0, this.supportedPromise = void 0, this.supportedResult = void 0, this._avgBitrate = 0, this._audioGroups = void 0, this._subtitleGroups = void 0, this._urlId = 0, this.url = [e.url], this._attrs = [e.attrs], this.bitrate = e.bitrate, e.details && (this.details = e.details), this.id = e.id || 0, this.name = e.name, this.width = e.width || 0, this.height = e.height || 0, this.frameRate = e.attrs.optionalFloat("FRAME-RATE", 0), this._avgBitrate = e.attrs.decimalInteger("AVERAGE-BANDWIDTH"), this.audioCodec = e.audioCodec, this.videoCodec = e.videoCodec, this.codecSet = [e.videoCodec, e.audioCodec].filter((t) => !!t).map((t) => t.substring(0, 4)).join(","), this.addGroupId("audio", e.attrs.AUDIO), this.addGroupId("text", e.attrs.SUBTITLES);
  }
  get maxBitrate() {
    return Math.max(this.realBitrate, this.bitrate);
  }
  get averageBitrate() {
    return this._avgBitrate || this.realBitrate || this.bitrate;
  }
  get attrs() {
    return this._attrs[0];
  }
  get codecs() {
    return this.attrs.CODECS || "";
  }
  get pathwayId() {
    return this.attrs["PATHWAY-ID"] || ".";
  }
  get videoRange() {
    return this.attrs["VIDEO-RANGE"] || "SDR";
  }
  get score() {
    return this.attrs.optionalFloat("SCORE", 0);
  }
  get uri() {
    return this.url[0] || "";
  }
  hasAudioGroup(e) {
    return kn(this._audioGroups, e);
  }
  hasSubtitleGroup(e) {
    return kn(this._subtitleGroups, e);
  }
  get audioGroups() {
    return this._audioGroups;
  }
  get subtitleGroups() {
    return this._subtitleGroups;
  }
  addGroupId(e, t) {
    if (t) {
      if (e === "audio") {
        let i = this._audioGroups;
        i || (i = this._audioGroups = []), i.indexOf(t) === -1 && i.push(t);
      } else if (e === "text") {
        let i = this._subtitleGroups;
        i || (i = this._subtitleGroups = []), i.indexOf(t) === -1 && i.push(t);
      }
    }
  }
  // Deprecated methods (retained for backwards compatibility)
  get urlId() {
    return 0;
  }
  set urlId(e) {
  }
  get audioGroupIds() {
    return this.audioGroups ? [this.audioGroupId] : void 0;
  }
  get textGroupIds() {
    return this.subtitleGroups ? [this.textGroupId] : void 0;
  }
  get audioGroupId() {
    var e;
    return (e = this.audioGroups) == null ? void 0 : e[0];
  }
  get textGroupId() {
    var e;
    return (e = this.subtitleGroups) == null ? void 0 : e[0];
  }
  addFallback() {
  }
}
function kn(s, e) {
  return !e || !s ? !1 : s.indexOf(e) !== -1;
}
function ji(s, e) {
  const t = e.startPTS;
  if (U(t)) {
    let i = 0, n;
    e.sn > s.sn ? (i = t - s.start, n = s) : (i = s.start - t, n = e), n.duration !== i && (n.duration = i);
  } else e.sn > s.sn ? s.cc === e.cc && s.minEndPTS ? e.start = s.start + (s.minEndPTS - s.start) : e.start = s.start + s.duration : e.start = Math.max(s.start - e.duration, 0);
}
function ea(s, e, t, i, n, r) {
  i - t <= 0 && (S.warn("Fragment should have a positive duration", e), i = t + e.duration, r = n + e.duration);
  let o = t, l = i;
  const c = e.startPTS, h = e.endPTS;
  if (U(c)) {
    const y = Math.abs(c - t);
    U(e.deltaPTS) ? e.deltaPTS = Math.max(y, e.deltaPTS) : e.deltaPTS = y, o = Math.max(t, c), t = Math.min(t, c), n = Math.min(n, e.startDTS), l = Math.min(i, h), i = Math.max(i, h), r = Math.max(r, e.endDTS);
  }
  const u = t - e.start;
  e.start !== 0 && (e.start = t), e.duration = i - e.start, e.startPTS = t, e.maxStartPTS = o, e.startDTS = n, e.endPTS = i, e.minEndPTS = l, e.endDTS = r;
  const d = e.sn;
  if (!s || d < s.startSN || d > s.endSN)
    return 0;
  let g;
  const f = d - s.startSN, m = s.fragments;
  for (m[f] = e, g = f; g > 0; g--)
    ji(m[g], m[g - 1]);
  for (g = f; g < m.length - 1; g++)
    ji(m[g], m[g + 1]);
  return s.fragmentHint && ji(m[m.length - 1], s.fragmentHint), s.PTSKnown = s.alignedSliding = !0, u;
}
function hc(s, e) {
  let t = null;
  const i = s.fragments;
  for (let o = i.length - 1; o >= 0; o--) {
    const l = i[o].initSegment;
    if (l) {
      t = l;
      break;
    }
  }
  s.fragmentHint && delete s.fragmentHint.endPTS;
  let n;
  fc(s, e, (o, l, c, h) => {
    if (e.skippedSegments && l.cc !== o.cc) {
      const u = o.cc - l.cc;
      for (let d = c; d < h.length; d++)
        h[d].cc += u;
    }
    U(o.startPTS) && U(o.endPTS) && (l.start = l.startPTS = o.startPTS, l.startDTS = o.startDTS, l.maxStartPTS = o.maxStartPTS, l.endPTS = o.endPTS, l.endDTS = o.endDTS, l.minEndPTS = o.minEndPTS, l.duration = o.endPTS - o.startPTS, l.duration && (n = l), e.PTSKnown = e.alignedSliding = !0), l.elementaryStreams = o.elementaryStreams, l.loader = o.loader, l.stats = o.stats, o.initSegment && (l.initSegment = o.initSegment, t = o.initSegment);
  });
  const r = e.fragments;
  if (t && (e.fragmentHint ? r.concat(e.fragmentHint) : r).forEach((l) => {
    var c;
    l && (!l.initSegment || l.initSegment.relurl === ((c = t) == null ? void 0 : c.relurl)) && (l.initSegment = t);
  }), e.skippedSegments) {
    if (e.deltaUpdateFailed = r.some((o) => !o), e.deltaUpdateFailed) {
      S.warn("[level-helper] Previous playlist missing segments skipped in delta playlist");
      for (let o = e.skippedSegments; o--; )
        r.shift();
      e.startSN = r[0].sn;
    } else
      e.canSkipDateRanges && (e.dateRanges = uc(s.dateRanges, e.dateRanges, e.recentlyRemovedDateranges));
    e.startCC = e.fragments[0].cc, e.endCC = r[r.length - 1].cc;
  }
  dc(s.partList, e.partList, (o, l) => {
    l.elementaryStreams = o.elementaryStreams, l.stats = o.stats;
  }), n ? ea(e, n, n.startPTS, n.endPTS, n.startDTS, n.endDTS) : ta(s, e), r.length && (e.totalduration = e.edge - r[0].start), e.driftStartTime = s.driftStartTime, e.driftStart = s.driftStart;
  const a = e.advancedDateTime;
  if (e.advanced && a) {
    const o = e.edge;
    e.driftStart || (e.driftStartTime = a, e.driftStart = o), e.driftEndTime = a, e.driftEnd = o;
  } else
    e.driftEndTime = s.driftEndTime, e.driftEnd = s.driftEnd, e.advancedDateTime = s.advancedDateTime;
}
function uc(s, e, t) {
  const i = fe({}, s);
  return t && t.forEach((n) => {
    delete i[n];
  }), Object.keys(e).forEach((n) => {
    const r = new Mr(e[n].attr, i[n]);
    r.isValid ? i[n] = r : S.warn(`Ignoring invalid Playlist Delta Update DATERANGE tag: "${JSON.stringify(e[n].attr)}"`);
  }), i;
}
function dc(s, e, t) {
  if (s && e) {
    let i = 0;
    for (let n = 0, r = s.length; n <= r; n++) {
      const a = s[n], o = e[n + i];
      a && o && a.index === o.index && a.fragment.sn === o.fragment.sn ? t(a, o) : i--;
    }
  }
}
function fc(s, e, t) {
  const i = e.skippedSegments, n = Math.max(s.startSN, e.startSN) - e.startSN, r = (s.fragmentHint ? 1 : 0) + (i ? e.endSN : Math.min(s.endSN, e.endSN)) - e.startSN, a = e.startSN - s.startSN, o = e.fragmentHint ? e.fragments.concat(e.fragmentHint) : e.fragments, l = s.fragmentHint ? s.fragments.concat(s.fragmentHint) : s.fragments;
  for (let c = n; c <= r; c++) {
    const h = l[a + c];
    let u = o[c];
    i && !u && c < i && (u = e.fragments[c] = h), h && u && t(h, u, c, o);
  }
}
function ta(s, e) {
  const t = e.startSN + e.skippedSegments - s.startSN, i = s.fragments;
  t < 0 || t >= i.length || Ts(e, i[t].start);
}
function Ts(s, e) {
  if (e) {
    const t = s.fragments;
    for (let i = s.skippedSegments; i < t.length; i++)
      t[i].start += e;
    s.fragmentHint && (s.fragmentHint.start += e);
  }
}
function gc(s, e = 1 / 0) {
  let t = 1e3 * s.targetduration;
  if (s.updated) {
    const i = s.fragments;
    if (i.length && t * 4 > e) {
      const r = i[i.length - 1].duration * 1e3;
      r < t && (t = r);
    }
  } else
    t /= 2;
  return Math.round(t);
}
function mc(s, e, t) {
  if (!(s != null && s.details))
    return null;
  const i = s.details;
  let n = i.fragments[e - i.startSN];
  return n || (n = i.fragmentHint, n && n.sn === e) ? n : e < i.startSN && t && t.sn === e ? t : null;
}
function Pn(s, e, t) {
  var i;
  return s != null && s.details ? ia((i = s.details) == null ? void 0 : i.partList, e, t) : null;
}
function ia(s, e, t) {
  if (s)
    for (let i = s.length; i--; ) {
      const n = s[i];
      if (n.index === t && n.fragment.sn === e)
        return n;
    }
  return null;
}
function sa(s) {
  s.forEach((e, t) => {
    const {
      details: i
    } = e;
    i != null && i.fragments && i.fragments.forEach((n) => {
      n.level = t;
    });
  });
}
function Ei(s) {
  switch (s.details) {
    case I.FRAG_LOAD_TIMEOUT:
    case I.KEY_LOAD_TIMEOUT:
    case I.LEVEL_LOAD_TIMEOUT:
    case I.MANIFEST_LOAD_TIMEOUT:
      return !0;
  }
  return !1;
}
function _n(s, e) {
  const t = Ei(e);
  return s.default[`${t ? "timeout" : "error"}Retry`];
}
function Ms(s, e) {
  const t = s.backoff === "linear" ? 1 : Math.pow(2, e);
  return Math.min(t * s.retryDelayMs, s.maxRetryDelayMs);
}
function On(s) {
  return be(be({}, s), {
    errorRetry: null,
    timeoutRetry: null
  });
}
function vi(s, e, t, i) {
  if (!s)
    return !1;
  const n = i == null ? void 0 : i.code, r = e < s.maxNumRetry && (pc(n) || !!t);
  return s.shouldRetry ? s.shouldRetry(s, e, t, i, r) : r;
}
function pc(s) {
  return s === 0 && navigator.onLine === !1 || !!s && (s < 400 || s > 499);
}
const na = {
  /**
   * Searches for an item in an array which matches a certain condition.
   * This requires the condition to only match one item in the array,
   * and for the array to be ordered.
   *
   * @param list The array to search.
   * @param comparisonFn
   *      Called and provided a candidate item as the first argument.
   *      Should return:
   *          > -1 if the item should be located at a lower index than the provided item.
   *          > 1 if the item should be located at a higher index than the provided item.
   *          > 0 if the item is the item you're looking for.
   *
   * @returns the object if found, otherwise returns null
   */
  search: function(s, e) {
    let t = 0, i = s.length - 1, n = null, r = null;
    for (; t <= i; ) {
      n = (t + i) / 2 | 0, r = s[n];
      const a = e(r);
      if (a > 0)
        t = n + 1;
      else if (a < 0)
        i = n - 1;
      else
        return r;
    }
    return null;
  }
};
function yc(s, e, t) {
  if (e === null || !Array.isArray(s) || !s.length || !U(e))
    return null;
  const i = s[0].programDateTime;
  if (e < (i || 0))
    return null;
  const n = s[s.length - 1].endProgramDateTime;
  if (e >= (n || 0))
    return null;
  t = t || 0;
  for (let r = 0; r < s.length; ++r) {
    const a = s[r];
    if (Ec(e, t, a))
      return a;
  }
  return null;
}
function bi(s, e, t = 0, i = 0, n = 5e-3) {
  let r = null;
  if (s) {
    r = e[s.sn - e[0].sn + 1] || null;
    const o = s.endDTS - t;
    o > 0 && o < 15e-7 && (t += 15e-7);
  } else t === 0 && e[0].start === 0 && (r = e[0]);
  if (r && ((!s || s.level === r.level) && Es(t, i, r) === 0 || Tc(r, s, Math.min(n, i))))
    return r;
  const a = na.search(e, Es.bind(null, t, i));
  return a && (a !== s || !r) ? a : r;
}
function Tc(s, e, t) {
  if (e && e.start === 0 && e.level < s.level && (e.endPTS || 0) > 0) {
    const i = e.tagList.reduce((n, r) => (r[0] === "INF" && (n += parseFloat(r[1])), n), t);
    return s.start <= i;
  }
  return !1;
}
function Es(s = 0, e = 0, t) {
  if (t.start <= s && t.start + t.duration > s)
    return 0;
  const i = Math.min(e, t.duration + (t.deltaPTS ? t.deltaPTS : 0));
  return t.start + t.duration - i <= s ? 1 : t.start - i > s && t.start ? -1 : 0;
}
function Ec(s, e, t) {
  const i = Math.min(e, t.duration + (t.deltaPTS ? t.deltaPTS : 0)) * 1e3;
  return (t.endProgramDateTime || 0) - i > s;
}
function vc(s, e) {
  return na.search(s, (t) => t.cc < e ? 1 : t.cc > e ? -1 : 0);
}
var Se = {
  DoNothing: 0,
  SendAlternateToPenaltyBox: 2,
  RemoveAlternatePermanently: 3,
  RetryRequest: 5
}, Pe = {
  None: 0,
  MoveAllAlternatesMatchingHost: 1,
  MoveAllAlternatesMatchingHDCP: 2
};
class bc {
  constructor(e) {
    this.hls = void 0, this.playlistError = 0, this.penalizedRenditions = {}, this.log = void 0, this.warn = void 0, this.error = void 0, this.hls = e, this.log = S.log.bind(S, "[info]:"), this.warn = S.warn.bind(S, "[warning]:"), this.error = S.error.bind(S, "[error]:"), this.registerListeners();
  }
  registerListeners() {
    const e = this.hls;
    e.on(p.ERROR, this.onError, this), e.on(p.MANIFEST_LOADING, this.onManifestLoading, this), e.on(p.LEVEL_UPDATED, this.onLevelUpdated, this);
  }
  unregisterListeners() {
    const e = this.hls;
    e && (e.off(p.ERROR, this.onError, this), e.off(p.ERROR, this.onErrorOut, this), e.off(p.MANIFEST_LOADING, this.onManifestLoading, this), e.off(p.LEVEL_UPDATED, this.onLevelUpdated, this));
  }
  destroy() {
    this.unregisterListeners(), this.hls = null, this.penalizedRenditions = {};
  }
  startLoad(e) {
  }
  stopLoad() {
    this.playlistError = 0;
  }
  getVariantLevelIndex(e) {
    return (e == null ? void 0 : e.type) === G.MAIN ? e.level : this.hls.loadLevel;
  }
  onManifestLoading() {
    this.playlistError = 0, this.penalizedRenditions = {};
  }
  onLevelUpdated() {
    this.playlistError = 0;
  }
  onError(e, t) {
    var i, n;
    if (t.fatal)
      return;
    const r = this.hls, a = t.context;
    switch (t.details) {
      case I.FRAG_LOAD_ERROR:
      case I.FRAG_LOAD_TIMEOUT:
      case I.KEY_LOAD_ERROR:
      case I.KEY_LOAD_TIMEOUT:
        t.errorAction = this.getFragRetryOrSwitchAction(t);
        return;
      case I.FRAG_PARSING_ERROR:
        if ((i = t.frag) != null && i.gap) {
          t.errorAction = {
            action: Se.DoNothing,
            flags: Pe.None
          };
          return;
        }
      // falls through
      case I.FRAG_GAP:
      case I.FRAG_DECRYPT_ERROR: {
        t.errorAction = this.getFragRetryOrSwitchAction(t), t.errorAction.action = Se.SendAlternateToPenaltyBox;
        return;
      }
      case I.LEVEL_EMPTY_ERROR:
      case I.LEVEL_PARSING_ERROR:
        {
          var o, l;
          const c = t.parent === G.MAIN ? t.level : r.loadLevel;
          t.details === I.LEVEL_EMPTY_ERROR && ((o = t.context) != null && (l = o.levelDetails) != null && l.live) ? t.errorAction = this.getPlaylistRetryOrSwitchAction(t, c) : (t.levelRetry = !1, t.errorAction = this.getLevelSwitchAction(t, c));
        }
        return;
      case I.LEVEL_LOAD_ERROR:
      case I.LEVEL_LOAD_TIMEOUT:
        typeof (a == null ? void 0 : a.level) == "number" && (t.errorAction = this.getPlaylistRetryOrSwitchAction(t, a.level));
        return;
      case I.AUDIO_TRACK_LOAD_ERROR:
      case I.AUDIO_TRACK_LOAD_TIMEOUT:
      case I.SUBTITLE_LOAD_ERROR:
      case I.SUBTITLE_TRACK_LOAD_TIMEOUT:
        if (a) {
          const c = r.levels[r.loadLevel];
          if (c && (a.type === Q.AUDIO_TRACK && c.hasAudioGroup(a.groupId) || a.type === Q.SUBTITLE_TRACK && c.hasSubtitleGroup(a.groupId))) {
            t.errorAction = this.getPlaylistRetryOrSwitchAction(t, r.loadLevel), t.errorAction.action = Se.SendAlternateToPenaltyBox, t.errorAction.flags = Pe.MoveAllAlternatesMatchingHost;
            return;
          }
        }
        return;
      case I.KEY_SYSTEM_STATUS_OUTPUT_RESTRICTED:
        {
          const c = r.levels[r.loadLevel], h = c == null ? void 0 : c.attrs["HDCP-LEVEL"];
          h ? t.errorAction = {
            action: Se.SendAlternateToPenaltyBox,
            flags: Pe.MoveAllAlternatesMatchingHDCP,
            hdcpLevel: h
          } : this.keySystemError(t);
        }
        return;
      case I.BUFFER_ADD_CODEC_ERROR:
      case I.REMUX_ALLOC_ERROR:
      case I.BUFFER_APPEND_ERROR:
        t.errorAction = this.getLevelSwitchAction(t, (n = t.level) != null ? n : r.loadLevel);
        return;
      case I.INTERNAL_EXCEPTION:
      case I.BUFFER_APPENDING_ERROR:
      case I.BUFFER_FULL_ERROR:
      case I.LEVEL_SWITCH_ERROR:
      case I.BUFFER_STALLED_ERROR:
      case I.BUFFER_SEEK_OVER_HOLE:
      case I.BUFFER_NUDGE_ON_STALL:
        t.errorAction = {
          action: Se.DoNothing,
          flags: Pe.None
        };
        return;
    }
    t.type === V.KEY_SYSTEM_ERROR && this.keySystemError(t);
  }
  keySystemError(e) {
    const t = this.getVariantLevelIndex(e.frag);
    e.levelRetry = !1, e.errorAction = this.getLevelSwitchAction(e, t);
  }
  getPlaylistRetryOrSwitchAction(e, t) {
    const i = this.hls, n = _n(i.config.playlistLoadPolicy, e), r = this.playlistError++;
    if (vi(n, r, Ei(e), e.response))
      return {
        action: Se.RetryRequest,
        flags: Pe.None,
        retryConfig: n,
        retryCount: r
      };
    const o = this.getLevelSwitchAction(e, t);
    return n && (o.retryConfig = n, o.retryCount = r), o;
  }
  getFragRetryOrSwitchAction(e) {
    const t = this.hls, i = this.getVariantLevelIndex(e.frag), n = t.levels[i], {
      fragLoadPolicy: r,
      keyLoadPolicy: a
    } = t.config, o = _n(e.details.startsWith("key") ? a : r, e), l = t.levels.reduce((h, u) => h + u.fragmentError, 0);
    if (n && (e.details !== I.FRAG_GAP && n.fragmentError++, vi(o, l, Ei(e), e.response)))
      return {
        action: Se.RetryRequest,
        flags: Pe.None,
        retryConfig: o,
        retryCount: l
      };
    const c = this.getLevelSwitchAction(e, i);
    return o && (c.retryConfig = o, c.retryCount = l), c;
  }
  getLevelSwitchAction(e, t) {
    const i = this.hls;
    t == null && (t = i.loadLevel);
    const n = this.hls.levels[t];
    if (n) {
      var r, a;
      const c = e.details;
      n.loadError++, c === I.BUFFER_APPEND_ERROR && n.fragmentError++;
      let h = -1;
      const {
        levels: u,
        loadLevel: d,
        minAutoLevel: g,
        maxAutoLevel: f
      } = i;
      i.autoLevelEnabled || (i.loadLevel = -1);
      const m = (r = e.frag) == null ? void 0 : r.type, T = (m === G.AUDIO && c === I.FRAG_PARSING_ERROR || e.sourceBufferName === "audio" && (c === I.BUFFER_ADD_CODEC_ERROR || c === I.BUFFER_APPEND_ERROR)) && u.some(({
        audioCodec: w
      }) => n.audioCodec !== w), v = e.sourceBufferName === "video" && (c === I.BUFFER_ADD_CODEC_ERROR || c === I.BUFFER_APPEND_ERROR) && u.some(({
        codecSet: w,
        audioCodec: R
      }) => n.codecSet !== w && n.audioCodec === R), {
        type: A,
        groupId: x
      } = (a = e.context) != null ? a : {};
      for (let w = u.length; w--; ) {
        const R = (w + d) % u.length;
        if (R !== d && R >= g && R <= f && u[R].loadError === 0) {
          var o, l;
          const k = u[R];
          if (c === I.FRAG_GAP && m === G.MAIN && e.frag) {
            const _ = u[R].details;
            if (_) {
              const C = bi(e.frag, _.fragments, e.frag.start);
              if (C != null && C.gap)
                continue;
            }
          } else {
            if (A === Q.AUDIO_TRACK && k.hasAudioGroup(x) || A === Q.SUBTITLE_TRACK && k.hasSubtitleGroup(x))
              continue;
            if (m === G.AUDIO && (o = n.audioGroups) != null && o.some((_) => k.hasAudioGroup(_)) || m === G.SUBTITLE && (l = n.subtitleGroups) != null && l.some((_) => k.hasSubtitleGroup(_)) || T && n.audioCodec === k.audioCodec || !T && n.audioCodec !== k.audioCodec || v && n.codecSet === k.codecSet)
              continue;
          }
          h = R;
          break;
        }
      }
      if (h > -1 && i.loadLevel !== h)
        return e.levelRetry = !0, this.playlistError = 0, {
          action: Se.SendAlternateToPenaltyBox,
          flags: Pe.None,
          nextAutoLevel: h
        };
    }
    return {
      action: Se.SendAlternateToPenaltyBox,
      flags: Pe.MoveAllAlternatesMatchingHost
    };
  }
  onErrorOut(e, t) {
    var i;
    switch ((i = t.errorAction) == null ? void 0 : i.action) {
      case Se.DoNothing:
        break;
      case Se.SendAlternateToPenaltyBox:
        this.sendAlternateToPenaltyBox(t), !t.errorAction.resolved && t.details !== I.FRAG_GAP ? t.fatal = !0 : /MediaSource readyState: ended/.test(t.error.message) && (this.warn(`MediaSource ended after "${t.sourceBufferName}" sourceBuffer append error. Attempting to recover from media error.`), this.hls.recoverMediaError());
        break;
    }
    if (t.fatal) {
      this.hls.stopLoad();
      return;
    }
  }
  sendAlternateToPenaltyBox(e) {
    const t = this.hls, i = e.errorAction;
    if (!i)
      return;
    const {
      flags: n,
      hdcpLevel: r,
      nextAutoLevel: a
    } = i;
    switch (n) {
      case Pe.None:
        this.switchLevel(e, a);
        break;
      case Pe.MoveAllAlternatesMatchingHDCP:
        r && (t.maxHdcpLevel = ys[ys.indexOf(r) - 1], i.resolved = !0), this.warn(`Restricting playback to HDCP-LEVEL of "${t.maxHdcpLevel}" or lower`);
        break;
    }
    i.resolved || this.switchLevel(e, a);
  }
  switchLevel(e, t) {
    t !== void 0 && e.errorAction && (this.warn(`switching to level ${t} after ${e.details}`), this.hls.nextAutoLevel = t, e.errorAction.resolved = !0, this.hls.nextLoadLevel = this.hls.nextAutoLevel);
  }
}
class Ns {
  constructor(e, t) {
    this.hls = void 0, this.timer = -1, this.requestScheduled = -1, this.canLoad = !1, this.log = void 0, this.warn = void 0, this.log = S.log.bind(S, `${t}:`), this.warn = S.warn.bind(S, `${t}:`), this.hls = e;
  }
  destroy() {
    this.clearTimer(), this.hls = this.log = this.warn = null;
  }
  clearTimer() {
    this.timer !== -1 && (self.clearTimeout(this.timer), this.timer = -1);
  }
  startLoad() {
    this.canLoad = !0, this.requestScheduled = -1, this.loadPlaylist();
  }
  stopLoad() {
    this.canLoad = !1, this.clearTimer();
  }
  switchParams(e, t, i) {
    const n = t == null ? void 0 : t.renditionReports;
    if (n) {
      let r = -1;
      for (let a = 0; a < n.length; a++) {
        const o = n[a];
        let l;
        try {
          l = new self.URL(o.URI, t.url).href;
        } catch (c) {
          S.warn(`Could not construct new URL for Rendition Report: ${c}`), l = o.URI || "";
        }
        if (l === e) {
          r = a;
          break;
        } else l === e.substring(0, l.length) && (r = a);
      }
      if (r !== -1) {
        const a = n[r], o = parseInt(a["LAST-MSN"]) || (t == null ? void 0 : t.lastPartSn);
        let l = parseInt(a["LAST-PART"]) || (t == null ? void 0 : t.lastPartIndex);
        if (this.hls.config.lowLatencyMode) {
          const h = Math.min(t.age - t.partTarget, t.targetduration);
          l >= 0 && h > t.partTarget && (l += 1);
        }
        const c = i && Cn(i);
        return new Dn(o, l >= 0 ? l : void 0, c);
      }
    }
  }
  loadPlaylist(e) {
    this.requestScheduled === -1 && (this.requestScheduled = self.performance.now());
  }
  shouldLoadPlaylist(e) {
    return this.canLoad && !!e && !!e.url && (!e.details || e.details.live);
  }
  shouldReloadPlaylist(e) {
    return this.timer === -1 && this.requestScheduled === -1 && this.shouldLoadPlaylist(e);
  }
  playlistLoaded(e, t, i) {
    const {
      details: n,
      stats: r
    } = t, a = self.performance.now(), o = r.loading.first ? Math.max(0, a - r.loading.first) : 0;
    if (n.advancedDateTime = Date.now() - o, n.live || i != null && i.live) {
      if (n.reloaded(i), i && this.log(`live playlist ${e} ${n.advanced ? "REFRESHED " + n.lastPartSn + "-" + n.lastPartIndex : n.updated ? "UPDATED" : "MISSED"}`), i && n.fragments.length > 0 && hc(i, n), !this.canLoad || !n.live)
        return;
      let l, c, h;
      if (n.canBlockReload && n.endSN && n.advanced) {
        const y = this.hls.config.lowLatencyMode, T = n.lastPartSn, b = n.endSN, v = n.lastPartIndex, A = v !== -1, x = T === b, w = y ? 0 : v;
        A ? (c = x ? b + 1 : T, h = x ? w : v + 1) : c = b + 1;
        const R = n.age, k = R + n.ageHeader;
        let _ = Math.min(k - n.partTarget, n.targetduration * 1.5);
        if (_ > 0) {
          if (i && _ > i.tuneInGoal)
            this.warn(`CDN Tune-in goal increased from: ${i.tuneInGoal} to: ${_} with playlist age: ${n.age}`), _ = 0;
          else {
            const C = Math.floor(_ / n.targetduration);
            if (c += C, h !== void 0) {
              const P = Math.round(_ % n.targetduration / n.partTarget);
              h += P;
            }
            this.log(`CDN Tune-in age: ${n.ageHeader}s last advanced ${R.toFixed(2)}s goal: ${_} skip sn ${C} to part ${h}`);
          }
          n.tuneInGoal = _;
        }
        if (l = this.getDeliveryDirectives(n, t.deliveryDirectives, c, h), y || !x) {
          this.loadPlaylist(l);
          return;
        }
      } else (n.canBlockReload || n.canSkipUntil) && (l = this.getDeliveryDirectives(n, t.deliveryDirectives, c, h));
      const u = this.hls.mainForwardBufferInfo, d = u ? u.end - u.len : 0, g = (n.edge - d) * 1e3, f = gc(n, g);
      n.updated && a > this.requestScheduled + f && (this.requestScheduled = r.loading.start), c !== void 0 && n.canBlockReload ? this.requestScheduled = r.loading.first + f - (n.partTarget * 1e3 || 1e3) : this.requestScheduled === -1 || this.requestScheduled + f < a ? this.requestScheduled = a : this.requestScheduled - a <= 0 && (this.requestScheduled += f);
      let m = this.requestScheduled - a;
      m = Math.max(0, m), this.log(`reload live playlist ${e} in ${Math.round(m)} ms`), this.timer = self.setTimeout(() => this.loadPlaylist(l), m);
    } else
      this.clearTimer();
  }
  getDeliveryDirectives(e, t, i, n) {
    let r = Cn(e);
    return t != null && t.skip && e.deltaUpdateFailed && (i = t.msn, n = t.part, r = si.No), new Dn(i, n, r);
  }
  checkRetry(e) {
    const t = e.details, i = Ei(e), n = e.errorAction, {
      action: r,
      retryCount: a = 0,
      retryConfig: o
    } = n || {}, l = !!n && !!o && (r === Se.RetryRequest || !n.resolved && r === Se.SendAlternateToPenaltyBox);
    if (l) {
      var c;
      if (this.requestScheduled = -1, a >= o.maxNumRetry)
        return !1;
      if (i && (c = e.context) != null && c.deliveryDirectives)
        this.warn(`Retrying playlist loading ${a + 1}/${o.maxNumRetry} after "${t}" without delivery-directives`), this.loadPlaylist();
      else {
        const h = Ms(o, a);
        this.timer = self.setTimeout(() => this.loadPlaylist(), h), this.warn(`Retrying playlist loading ${a + 1}/${o.maxNumRetry} after "${t}" in ${h}ms`);
      }
      e.levelRetry = !0, n.resolved = !0;
    }
    return l;
  }
}
class ut {
  //  About half of the estimated value will be from the last |halfLife| samples by weight.
  constructor(e, t = 0, i = 0) {
    this.halfLife = void 0, this.alpha_ = void 0, this.estimate_ = void 0, this.totalWeight_ = void 0, this.halfLife = e, this.alpha_ = e ? Math.exp(Math.log(0.5) / e) : 0, this.estimate_ = t, this.totalWeight_ = i;
  }
  sample(e, t) {
    const i = Math.pow(this.alpha_, e);
    this.estimate_ = t * (1 - i) + i * this.estimate_, this.totalWeight_ += e;
  }
  getTotalWeight() {
    return this.totalWeight_;
  }
  getEstimate() {
    if (this.alpha_) {
      const e = 1 - Math.pow(this.alpha_, this.totalWeight_);
      if (e)
        return this.estimate_ / e;
    }
    return this.estimate_;
  }
}
class xc {
  constructor(e, t, i, n = 100) {
    this.defaultEstimate_ = void 0, this.minWeight_ = void 0, this.minDelayMs_ = void 0, this.slow_ = void 0, this.fast_ = void 0, this.defaultTTFB_ = void 0, this.ttfb_ = void 0, this.defaultEstimate_ = i, this.minWeight_ = 1e-3, this.minDelayMs_ = 50, this.slow_ = new ut(e), this.fast_ = new ut(t), this.defaultTTFB_ = n, this.ttfb_ = new ut(e);
  }
  update(e, t) {
    const {
      slow_: i,
      fast_: n,
      ttfb_: r
    } = this;
    i.halfLife !== e && (this.slow_ = new ut(e, i.getEstimate(), i.getTotalWeight())), n.halfLife !== t && (this.fast_ = new ut(t, n.getEstimate(), n.getTotalWeight())), r.halfLife !== e && (this.ttfb_ = new ut(e, r.getEstimate(), r.getTotalWeight()));
  }
  sample(e, t) {
    e = Math.max(e, this.minDelayMs_);
    const i = 8 * t, n = e / 1e3, r = i / n;
    this.fast_.sample(n, r), this.slow_.sample(n, r);
  }
  sampleTTFB(e) {
    const t = e / 1e3, i = Math.sqrt(2) * Math.exp(-Math.pow(t, 2) / 2);
    this.ttfb_.sample(i, Math.max(e, 5));
  }
  canEstimate() {
    return this.fast_.getTotalWeight() >= this.minWeight_;
  }
  getEstimate() {
    return this.canEstimate() ? Math.min(this.fast_.getEstimate(), this.slow_.getEstimate()) : this.defaultEstimate_;
  }
  getEstimateTTFB() {
    return this.ttfb_.getTotalWeight() >= this.minWeight_ ? this.ttfb_.getEstimate() : this.defaultTTFB_;
  }
  destroy() {
  }
}
const ra = {
  supported: !0,
  configurations: [],
  decodingInfoResults: [{
    supported: !0,
    powerEfficient: !0,
    smooth: !0
  }]
}, Fn = {};
function Sc(s, e, t, i, n, r) {
  const a = s.audioCodec ? s.audioGroups : null, o = r == null ? void 0 : r.audioCodec, l = r == null ? void 0 : r.channels, c = l ? parseInt(l) : o ? 1 / 0 : 2;
  let h = null;
  if (a != null && a.length)
    try {
      a.length === 1 && a[0] ? h = e.groups[a[0]].channels : h = a.reduce((u, d) => {
        if (d) {
          const g = e.groups[d];
          if (!g)
            throw new Error(`Audio track group ${d} not found`);
          Object.keys(g.channels).forEach((f) => {
            u[f] = (u[f] || 0) + g.channels[f];
          });
        }
        return u;
      }, {
        2: 0
      });
    } catch (u) {
      return !0;
    }
  return s.videoCodec !== void 0 && (s.width > 1920 && s.height > 1088 || s.height > 1920 && s.width > 1088 || s.frameRate > Math.max(i, 30) || s.videoRange !== "SDR" && s.videoRange !== t || s.bitrate > Math.max(n, 8e6)) || !!h && U(c) && Object.keys(h).some((u) => parseInt(u) > c);
}
function Ac(s, e, t) {
  const i = s.videoCodec, n = s.audioCodec;
  if (!i || !n || !t)
    return Promise.resolve(ra);
  const r = {
    width: s.width,
    height: s.height,
    bitrate: Math.ceil(Math.max(s.bitrate * 0.9, s.averageBitrate)),
    // Assume a framerate of 30fps since MediaCapabilities will not accept Level default of 0.
    framerate: s.frameRate || 30
  }, a = s.videoRange;
  a !== "SDR" && (r.transferFunction = a.toLowerCase());
  const o = i.split(",").map((l) => ({
    type: "media-source",
    video: be(be({}, r), {}, {
      contentType: _t(l, "video")
    })
  }));
  return n && s.audioGroups && s.audioGroups.forEach((l) => {
    var c;
    l && ((c = e.groups[l]) == null || c.tracks.forEach((h) => {
      if (h.groupId === l) {
        const u = h.channels || "", d = parseFloat(u);
        U(d) && d > 2 && o.push.apply(o, n.split(",").map((g) => ({
          type: "media-source",
          audio: {
            contentType: _t(g, "audio"),
            channels: "" + d
            // spatialRendering:
            //   audioCodec === 'ec-3' && channels.indexOf('JOC'),
          }
        })));
      }
    }));
  }), Promise.all(o.map((l) => {
    const c = Lc(l);
    return Fn[c] || (Fn[c] = t.decodingInfo(l));
  })).then((l) => ({
    supported: !l.some((c) => !c.supported),
    configurations: o,
    decodingInfoResults: l
  })).catch((l) => ({
    supported: !1,
    configurations: o,
    decodingInfoResults: [],
    error: l
  }));
}
function Lc(s) {
  const {
    audio: e,
    video: t
  } = s, i = t || e;
  if (i) {
    const n = i.contentType.split('"')[1];
    if (t)
      return `r${t.height}x${t.width}f${Math.ceil(t.framerate)}${t.transferFunction || "sd"}_${n}_${Math.ceil(t.bitrate / 1e5)}`;
    if (e)
      return `c${e.channels}${e.spatialRendering ? "s" : "n"}_${n}`;
  }
  return "";
}
function Rc() {
  if (typeof matchMedia == "function") {
    const s = matchMedia("(dynamic-range: high)"), e = matchMedia("bad query");
    if (s.media !== e.media)
      return s.matches === !0;
  }
  return !1;
}
function Ic(s, e) {
  let t = !1, i = [];
  return s && (t = s !== "SDR", i = [s]), e && (i = e.allowedVideoRanges || Ti.slice(0), t = e.preferHDR !== void 0 ? e.preferHDR : Rc(), t ? i = i.filter((n) => n !== "SDR") : i = ["SDR"]), {
    preferHDR: t,
    allowedVideoRanges: i
  };
}
function wc(s, e, t, i, n) {
  const r = Object.keys(s), a = i == null ? void 0 : i.channels, o = i == null ? void 0 : i.audioCodec, l = a && parseInt(a) === 2;
  let c = !0, h = !1, u = 1 / 0, d = 1 / 0, g = 1 / 0, f = 0, m = [];
  const {
    preferHDR: y,
    allowedVideoRanges: T
  } = Ic(e, n);
  for (let x = r.length; x--; ) {
    const w = s[r[x]];
    c = w.channels[2] > 0, u = Math.min(u, w.minHeight), d = Math.min(d, w.minFramerate), g = Math.min(g, w.minBitrate);
    const R = T.filter((k) => w.videoRanges[k] > 0);
    R.length > 0 && (h = !0, m = R);
  }
  u = U(u) ? u : 0, d = U(d) ? d : 0;
  const b = Math.max(1080, u), v = Math.max(30, d);
  return g = U(g) ? g : t, t = Math.max(g, t), h || (e = void 0, m = []), {
    codecSet: r.reduce((x, w) => {
      const R = s[w];
      if (w === x)
        return x;
      if (R.minBitrate > t)
        return We(w, `min bitrate of ${R.minBitrate} > current estimate of ${t}`), x;
      if (!R.hasDefaultAudio)
        return We(w, "no renditions with default or auto-select sound found"), x;
      if (o && w.indexOf(o.substring(0, 4)) % 5 !== 0)
        return We(w, `audio codec preference "${o}" not found`), x;
      if (a && !l) {
        if (!R.channels[a])
          return We(w, `no renditions with ${a} channel sound found (channels options: ${Object.keys(R.channels)})`), x;
      } else if ((!o || l) && c && R.channels[2] === 0)
        return We(w, "no renditions with stereo sound found"), x;
      return R.minHeight > b ? (We(w, `min resolution of ${R.minHeight} > maximum of ${b}`), x) : R.minFramerate > v ? (We(w, `min framerate of ${R.minFramerate} > maximum of ${v}`), x) : m.some((k) => R.videoRanges[k] > 0) ? R.maxScore < f ? (We(w, `max score of ${R.maxScore} < selected max of ${f}`), x) : x && (pi(w) >= pi(x) || R.fragmentError > s[x].fragmentError) ? x : (f = R.maxScore, w) : (We(w, `no variants with VIDEO-RANGE of ${JSON.stringify(m)} found`), x);
    }, void 0),
    videoRanges: m,
    preferHDR: y,
    minFramerate: d,
    minBitrate: g
  };
}
function We(s, e) {
  S.log(`[abr] start candidates with "${s}" ignored because ${e}`);
}
function Cc(s) {
  return s.reduce((e, t) => {
    let i = e.groups[t.groupId];
    i || (i = e.groups[t.groupId] = {
      tracks: [],
      channels: {
        2: 0
      },
      hasDefault: !1,
      hasAutoSelect: !1
    }), i.tracks.push(t);
    const n = t.channels || "2";
    return i.channels[n] = (i.channels[n] || 0) + 1, i.hasDefault = i.hasDefault || t.default, i.hasAutoSelect = i.hasAutoSelect || t.autoselect, i.hasDefault && (e.hasDefaultAudio = !0), i.hasAutoSelect && (e.hasAutoSelectAudio = !0), e;
  }, {
    hasDefaultAudio: !1,
    hasAutoSelectAudio: !1,
    groups: {}
  });
}
function Dc(s, e, t, i) {
  return s.slice(t, i + 1).reduce((n, r) => {
    if (!r.codecSet)
      return n;
    const a = r.audioGroups;
    let o = n[r.codecSet];
    o || (n[r.codecSet] = o = {
      minBitrate: 1 / 0,
      minHeight: 1 / 0,
      minFramerate: 1 / 0,
      maxScore: 0,
      videoRanges: {
        SDR: 0
      },
      channels: {
        2: 0
      },
      hasDefaultAudio: !a,
      fragmentError: 0
    }), o.minBitrate = Math.min(o.minBitrate, r.bitrate);
    const l = Math.min(r.height, r.width);
    return o.minHeight = Math.min(o.minHeight, l), o.minFramerate = Math.min(o.minFramerate, r.frameRate), o.maxScore = Math.max(o.maxScore, r.score), o.fragmentError += r.fragmentError, o.videoRanges[r.videoRange] = (o.videoRanges[r.videoRange] || 0) + 1, a && a.forEach((c) => {
      if (!c)
        return;
      const h = e.groups[c];
      h && (o.hasDefaultAudio = o.hasDefaultAudio || e.hasDefaultAudio ? h.hasDefault : h.hasAutoSelect || !e.hasDefaultAudio && !e.hasAutoSelectAudio, Object.keys(h.channels).forEach((u) => {
        o.channels[u] = (o.channels[u] || 0) + h.channels[u];
      }));
    }), n;
  }, {});
}
function He(s, e, t) {
  if ("attrs" in s) {
    const i = e.indexOf(s);
    if (i !== -1)
      return i;
  }
  for (let i = 0; i < e.length; i++) {
    const n = e[i];
    if (ct(s, n, t))
      return i;
  }
  return -1;
}
function ct(s, e, t) {
  const {
    groupId: i,
    name: n,
    lang: r,
    assocLang: a,
    default: o
  } = s, l = s.forced;
  return (i === void 0 || e.groupId === i) && (n === void 0 || e.name === n) && (r === void 0 || e.lang === r) && (r === void 0 || e.assocLang === a) && (o === void 0 || e.default === o) && (l === void 0 || e.forced === l) && (!("characteristics" in s) || kc(s.characteristics || "", e.characteristics)) && (t === void 0 || t(s, e));
}
function kc(s, e = "") {
  const t = s.split(","), i = e.split(",");
  return t.length === i.length && !t.some((n) => i.indexOf(n) === -1);
}
function rt(s, e) {
  const {
    audioCodec: t,
    channels: i
  } = s;
  return (t === void 0 || (e.audioCodec || "").substring(0, 4) === t.substring(0, 4)) && (i === void 0 || i === (e.channels || "2"));
}
function Pc(s, e, t, i, n) {
  const r = e[i], o = e.reduce((d, g, f) => {
    const m = g.uri;
    return (d[m] || (d[m] = [])).push(f), d;
  }, {})[r.uri];
  o.length > 1 && (i = Math.max.apply(Math, o));
  const l = r.videoRange, c = r.frameRate, h = r.codecSet.substring(0, 4), u = Mn(e, i, (d) => {
    if (d.videoRange !== l || d.frameRate !== c || d.codecSet.substring(0, 4) !== h)
      return !1;
    const g = d.audioGroups, f = t.filter((m) => !g || g.indexOf(m.groupId) !== -1);
    return He(s, f, n) > -1;
  });
  return u > -1 ? u : Mn(e, i, (d) => {
    const g = d.audioGroups, f = t.filter((m) => !g || g.indexOf(m.groupId) !== -1);
    return He(s, f, n) > -1;
  });
}
function Mn(s, e, t) {
  for (let i = e; i > -1; i--)
    if (t(s[i]))
      return i;
  for (let i = e + 1; i < s.length; i++)
    if (t(s[i]))
      return i;
  return -1;
}
class _c {
  constructor(e) {
    this.hls = void 0, this.lastLevelLoadSec = 0, this.lastLoadedFragLevel = -1, this.firstSelection = -1, this._nextAutoLevel = -1, this.nextAutoLevelKey = "", this.audioTracksByGroup = null, this.codecTiers = null, this.timer = -1, this.fragCurrent = null, this.partCurrent = null, this.bitrateTestDelay = 0, this.bwEstimator = void 0, this._abandonRulesCheck = () => {
      const {
        fragCurrent: t,
        partCurrent: i,
        hls: n
      } = this, {
        autoLevelEnabled: r,
        media: a
      } = n;
      if (!t || !a)
        return;
      const o = performance.now(), l = i ? i.stats : t.stats, c = i ? i.duration : t.duration, h = o - l.loading.start, u = n.minAutoLevel;
      if (l.aborted || l.loaded && l.loaded === l.total || t.level <= u) {
        this.clearTimer(), this._nextAutoLevel = -1;
        return;
      }
      if (!r || a.paused || !a.playbackRate || !a.readyState)
        return;
      const d = n.mainForwardBufferInfo;
      if (d === null)
        return;
      const g = this.bwEstimator.getEstimateTTFB(), f = Math.abs(a.playbackRate);
      if (h <= Math.max(g, 1e3 * (c / (f * 2))))
        return;
      const m = d.len / f, y = l.loading.first ? l.loading.first - l.loading.start : -1, T = l.loaded && y > -1, b = this.getBwEstimate(), v = n.levels, A = v[t.level], x = l.total || Math.max(l.loaded, Math.round(c * A.averageBitrate / 8));
      let w = T ? h - y : h;
      w < 1 && T && (w = Math.min(h, l.loaded * 8 / b));
      const R = T ? l.loaded * 1e3 / w : 0, k = R ? (x - l.loaded) / R : x * 8 / b + g / 1e3;
      if (k <= m)
        return;
      const _ = R ? R * 8 : b;
      let C = Number.POSITIVE_INFINITY, P;
      for (P = t.level - 1; P > u; P--) {
        const M = v[P].maxBitrate;
        if (C = this.getTimeToLoadFrag(g / 1e3, _, c * M, !v[P].details), C < m)
          break;
      }
      if (C >= k || C > c * 10)
        return;
      n.nextLoadLevel = n.nextAutoLevel = P, T ? this.bwEstimator.sample(h - Math.min(g, y), l.loaded) : this.bwEstimator.sampleTTFB(h);
      const q = v[P].maxBitrate;
      this.getBwEstimate() * this.hls.config.abrBandWidthUpFactor > q && this.resetEstimator(q), this.clearTimer(), S.warn(`[abr] Fragment ${t.sn}${i ? " part " + i.index : ""} of level ${t.level} is loading too slowly;
      Time to underbuffer: ${m.toFixed(3)} s
      Estimated load time for current fragment: ${k.toFixed(3)} s
      Estimated load time for down switch fragment: ${C.toFixed(3)} s
      TTFB estimate: ${y | 0} ms
      Current BW estimate: ${U(b) ? b | 0 : "Unknown"} bps
      New BW estimate: ${this.getBwEstimate() | 0} bps
      Switching to level ${P} @ ${q | 0} bps`), n.trigger(p.FRAG_LOAD_EMERGENCY_ABORTED, {
        frag: t,
        part: i,
        stats: l
      });
    }, this.hls = e, this.bwEstimator = this.initEstimator(), this.registerListeners();
  }
  resetEstimator(e) {
    e && (S.log(`setting initial bwe to ${e}`), this.hls.config.abrEwmaDefaultEstimate = e), this.firstSelection = -1, this.bwEstimator = this.initEstimator();
  }
  initEstimator() {
    const e = this.hls.config;
    return new xc(e.abrEwmaSlowVoD, e.abrEwmaFastVoD, e.abrEwmaDefaultEstimate);
  }
  registerListeners() {
    const {
      hls: e
    } = this;
    e.on(p.MANIFEST_LOADING, this.onManifestLoading, this), e.on(p.FRAG_LOADING, this.onFragLoading, this), e.on(p.FRAG_LOADED, this.onFragLoaded, this), e.on(p.FRAG_BUFFERED, this.onFragBuffered, this), e.on(p.LEVEL_SWITCHING, this.onLevelSwitching, this), e.on(p.LEVEL_LOADED, this.onLevelLoaded, this), e.on(p.LEVELS_UPDATED, this.onLevelsUpdated, this), e.on(p.MAX_AUTO_LEVEL_UPDATED, this.onMaxAutoLevelUpdated, this), e.on(p.ERROR, this.onError, this);
  }
  unregisterListeners() {
    const {
      hls: e
    } = this;
    e && (e.off(p.MANIFEST_LOADING, this.onManifestLoading, this), e.off(p.FRAG_LOADING, this.onFragLoading, this), e.off(p.FRAG_LOADED, this.onFragLoaded, this), e.off(p.FRAG_BUFFERED, this.onFragBuffered, this), e.off(p.LEVEL_SWITCHING, this.onLevelSwitching, this), e.off(p.LEVEL_LOADED, this.onLevelLoaded, this), e.off(p.LEVELS_UPDATED, this.onLevelsUpdated, this), e.off(p.MAX_AUTO_LEVEL_UPDATED, this.onMaxAutoLevelUpdated, this), e.off(p.ERROR, this.onError, this));
  }
  destroy() {
    this.unregisterListeners(), this.clearTimer(), this.hls = this._abandonRulesCheck = null, this.fragCurrent = this.partCurrent = null;
  }
  onManifestLoading(e, t) {
    this.lastLoadedFragLevel = -1, this.firstSelection = -1, this.lastLevelLoadSec = 0, this.fragCurrent = this.partCurrent = null, this.onLevelsUpdated(), this.clearTimer();
  }
  onLevelsUpdated() {
    this.lastLoadedFragLevel > -1 && this.fragCurrent && (this.lastLoadedFragLevel = this.fragCurrent.level), this._nextAutoLevel = -1, this.onMaxAutoLevelUpdated(), this.codecTiers = null, this.audioTracksByGroup = null;
  }
  onMaxAutoLevelUpdated() {
    this.firstSelection = -1, this.nextAutoLevelKey = "";
  }
  onFragLoading(e, t) {
    const i = t.frag;
    if (!this.ignoreFragment(i)) {
      if (!i.bitrateTest) {
        var n;
        this.fragCurrent = i, this.partCurrent = (n = t.part) != null ? n : null;
      }
      this.clearTimer(), this.timer = self.setInterval(this._abandonRulesCheck, 100);
    }
  }
  onLevelSwitching(e, t) {
    this.clearTimer();
  }
  onError(e, t) {
    if (!t.fatal)
      switch (t.details) {
        case I.BUFFER_ADD_CODEC_ERROR:
        case I.BUFFER_APPEND_ERROR:
          this.lastLoadedFragLevel = -1, this.firstSelection = -1;
          break;
        case I.FRAG_LOAD_TIMEOUT: {
          const i = t.frag, {
            fragCurrent: n,
            partCurrent: r
          } = this;
          if (i && n && i.sn === n.sn && i.level === n.level) {
            const a = performance.now(), o = r ? r.stats : i.stats, l = a - o.loading.start, c = o.loading.first ? o.loading.first - o.loading.start : -1;
            if (o.loaded && c > -1) {
              const u = this.bwEstimator.getEstimateTTFB();
              this.bwEstimator.sample(l - Math.min(u, c), o.loaded);
            } else
              this.bwEstimator.sampleTTFB(l);
          }
          break;
        }
      }
  }
  getTimeToLoadFrag(e, t, i, n) {
    const r = e + i / t, a = n ? this.lastLevelLoadSec : 0;
    return r + a;
  }
  onLevelLoaded(e, t) {
    const i = this.hls.config, {
      loading: n
    } = t.stats, r = n.end - n.start;
    U(r) && (this.lastLevelLoadSec = r / 1e3), t.details.live ? this.bwEstimator.update(i.abrEwmaSlowLive, i.abrEwmaFastLive) : this.bwEstimator.update(i.abrEwmaSlowVoD, i.abrEwmaFastVoD);
  }
  onFragLoaded(e, {
    frag: t,
    part: i
  }) {
    const n = i ? i.stats : t.stats;
    if (t.type === G.MAIN && this.bwEstimator.sampleTTFB(n.loading.first - n.loading.start), !this.ignoreFragment(t)) {
      if (this.clearTimer(), t.level === this._nextAutoLevel && (this._nextAutoLevel = -1), this.firstSelection = -1, this.hls.config.abrMaxWithRealBitrate) {
        const r = i ? i.duration : t.duration, a = this.hls.levels[t.level], o = (a.loaded ? a.loaded.bytes : 0) + n.loaded, l = (a.loaded ? a.loaded.duration : 0) + r;
        a.loaded = {
          bytes: o,
          duration: l
        }, a.realBitrate = Math.round(8 * o / l);
      }
      if (t.bitrateTest) {
        const r = {
          stats: n,
          frag: t,
          part: i,
          id: t.type
        };
        this.onFragBuffered(p.FRAG_BUFFERED, r), t.bitrateTest = !1;
      } else
        this.lastLoadedFragLevel = t.level;
    }
  }
  onFragBuffered(e, t) {
    const {
      frag: i,
      part: n
    } = t, r = n != null && n.stats.loaded ? n.stats : i.stats;
    if (r.aborted || this.ignoreFragment(i))
      return;
    const a = r.parsing.end - r.loading.start - Math.min(r.loading.first - r.loading.start, this.bwEstimator.getEstimateTTFB());
    this.bwEstimator.sample(a, r.loaded), r.bwEstimate = this.getBwEstimate(), i.bitrateTest ? this.bitrateTestDelay = a / 1e3 : this.bitrateTestDelay = 0;
  }
  ignoreFragment(e) {
    return e.type !== G.MAIN || e.sn === "initSegment";
  }
  clearTimer() {
    this.timer > -1 && (self.clearInterval(this.timer), this.timer = -1);
  }
  get firstAutoLevel() {
    const {
      maxAutoLevel: e,
      minAutoLevel: t
    } = this.hls, i = this.getBwEstimate(), n = this.hls.config.maxStarvationDelay, r = this.findBestLevel(i, t, e, 0, n, 1, 1);
    if (r > -1)
      return r;
    const a = this.hls.firstLevel, o = Math.min(Math.max(a, t), e);
    return S.warn(`[abr] Could not find best starting auto level. Defaulting to first in playlist ${a} clamped to ${o}`), o;
  }
  get forcedAutoLevel() {
    return this.nextAutoLevelKey ? -1 : this._nextAutoLevel;
  }
  // return next auto level
  get nextAutoLevel() {
    const e = this.forcedAutoLevel, i = this.bwEstimator.canEstimate(), n = this.lastLoadedFragLevel > -1;
    if (e !== -1 && (!i || !n || this.nextAutoLevelKey === this.getAutoLevelKey()))
      return e;
    const r = i && n ? this.getNextABRAutoLevel() : this.firstAutoLevel;
    if (e !== -1) {
      const a = this.hls.levels;
      if (a.length > Math.max(e, r) && a[e].loadError <= a[r].loadError)
        return e;
    }
    return this._nextAutoLevel = r, this.nextAutoLevelKey = this.getAutoLevelKey(), r;
  }
  getAutoLevelKey() {
    return `${this.getBwEstimate()}_${this.getStarvationDelay().toFixed(2)}`;
  }
  getNextABRAutoLevel() {
    const {
      fragCurrent: e,
      partCurrent: t,
      hls: i
    } = this, {
      maxAutoLevel: n,
      config: r,
      minAutoLevel: a
    } = i, o = t ? t.duration : e ? e.duration : 0, l = this.getBwEstimate(), c = this.getStarvationDelay();
    let h = r.abrBandWidthFactor, u = r.abrBandWidthUpFactor;
    if (c) {
      const y = this.findBestLevel(l, a, n, c, 0, h, u);
      if (y >= 0)
        return y;
    }
    let d = o ? Math.min(o, r.maxStarvationDelay) : r.maxStarvationDelay;
    if (!c) {
      const y = this.bitrateTestDelay;
      y && (d = (o ? Math.min(o, r.maxLoadingDelay) : r.maxLoadingDelay) - y, S.info(`[abr] bitrate test took ${Math.round(1e3 * y)}ms, set first fragment max fetchDuration to ${Math.round(1e3 * d)} ms`), h = u = 1);
    }
    const g = this.findBestLevel(l, a, n, c, d, h, u);
    if (S.info(`[abr] ${c ? "rebuffering expected" : "buffer is empty"}, optimal quality level ${g}`), g > -1)
      return g;
    const f = i.levels[a], m = i.levels[i.loadLevel];
    return (f == null ? void 0 : f.bitrate) < (m == null ? void 0 : m.bitrate) ? a : i.loadLevel;
  }
  getStarvationDelay() {
    const e = this.hls, t = e.media;
    if (!t)
      return 1 / 0;
    const i = t && t.playbackRate !== 0 ? Math.abs(t.playbackRate) : 1, n = e.mainForwardBufferInfo;
    return (n ? n.len : 0) / i;
  }
  getBwEstimate() {
    return this.bwEstimator.canEstimate() ? this.bwEstimator.getEstimate() : this.hls.config.abrEwmaDefaultEstimate;
  }
  findBestLevel(e, t, i, n, r, a, o) {
    var l;
    const c = n + r, h = this.lastLoadedFragLevel, u = h === -1 ? this.hls.firstLevel : h, {
      fragCurrent: d,
      partCurrent: g
    } = this, {
      levels: f,
      allAudioTracks: m,
      loadLevel: y,
      config: T
    } = this.hls;
    if (f.length === 1)
      return 0;
    const b = f[u], v = !!(b != null && (l = b.details) != null && l.live), A = y === -1 || h === -1;
    let x, w = "SDR", R = (b == null ? void 0 : b.frameRate) || 0;
    const {
      audioPreference: k,
      videoPreference: _
    } = T, C = this.audioTracksByGroup || (this.audioTracksByGroup = Cc(m));
    if (A) {
      if (this.firstSelection !== -1)
        return this.firstSelection;
      const Y = this.codecTiers || (this.codecTiers = Dc(f, C, t, i)), H = wc(Y, w, e, k, _), {
        codecSet: Z,
        videoRanges: ae,
        minFramerate: B,
        minBitrate: N,
        preferHDR: te
      } = H;
      x = Z, w = te ? ae[ae.length - 1] : ae[0], R = B, e = Math.max(e, N), S.log(`[abr] picked start tier ${JSON.stringify(H)}`);
    } else
      x = b == null ? void 0 : b.codecSet, w = b == null ? void 0 : b.videoRange;
    const P = g ? g.duration : d ? d.duration : 0, q = this.bwEstimator.getEstimateTTFB() / 1e3, M = [];
    for (let Y = i; Y >= t; Y--) {
      var j;
      const H = f[Y], Z = Y > u;
      if (!H)
        continue;
      if (T.useMediaCapabilities && !H.supportedResult && !H.supportedPromise) {
        const de = navigator.mediaCapabilities;
        typeof (de == null ? void 0 : de.decodingInfo) == "function" && Sc(H, C, w, R, e, k) ? (H.supportedPromise = Ac(H, C, de), H.supportedPromise.then((pe) => {
          if (!this.hls)
            return;
          H.supportedResult = pe;
          const xe = this.hls.levels, we = xe.indexOf(H);
          pe.error ? S.warn(`[abr] MediaCapabilities decodingInfo error: "${pe.error}" for level ${we} ${JSON.stringify(pe)}`) : pe.supported || (S.warn(`[abr] Unsupported MediaCapabilities decodingInfo result for level ${we} ${JSON.stringify(pe)}`), we > -1 && xe.length > 1 && (S.log(`[abr] Removing unsupported level ${we}`), this.hls.removeLevel(we)));
        })) : H.supportedResult = ra;
      }
      if (x && H.codecSet !== x || w && H.videoRange !== w || Z && R > H.frameRate || !Z && R > 0 && R < H.frameRate || H.supportedResult && !((j = H.supportedResult.decodingInfoResults) != null && j[0].smooth)) {
        M.push(Y);
        continue;
      }
      const ae = H.details, B = (g ? ae == null ? void 0 : ae.partTarget : ae == null ? void 0 : ae.averagetargetduration) || P;
      let N;
      Z ? N = o * e : N = a * e;
      const te = P && n >= P * 2 && r === 0 ? f[Y].averageBitrate : f[Y].maxBitrate, X = this.getTimeToLoadFrag(q, N, te * B, ae === void 0);
      if (
        // if adjusted bw is greater than level bitrate AND
        N >= te && // no level change, or new level has no error history
        (Y === h || H.loadError === 0 && H.fragmentError === 0) && // fragment fetchDuration unknown OR live stream OR fragment fetchDuration less than max allowed fetch duration, then this level matches
        // we don't account for max Fetch Duration for live streams, this is to avoid switching down when near the edge of live sliding window ...
        // special case to support startLevel = -1 (bitrateTest) on live streams : in that case we should not exit loop so that findBestLevel will return -1
        (X <= q || !U(X) || v && !this.bitrateTestDelay || X < c)
      ) {
        const de = this.forcedAutoLevel;
        return Y !== y && (de === -1 || de !== y) && (M.length && S.trace(`[abr] Skipped level(s) ${M.join(",")} of ${i} max with CODECS and VIDEO-RANGE:"${f[M[0]].codecs}" ${f[M[0]].videoRange}; not compatible with "${b.codecs}" ${w}`), S.info(`[abr] switch candidate:${u}->${Y} adjustedbw(${Math.round(N)})-bitrate=${Math.round(N - te)} ttfb:${q.toFixed(1)} avgDuration:${B.toFixed(1)} maxFetchDuration:${c.toFixed(1)} fetchDuration:${X.toFixed(1)} firstSelection:${A} codecSet:${x} videoRange:${w} hls.loadLevel:${y}`)), A && (this.firstSelection = Y), Y;
      }
    }
    return -1;
  }
  set nextAutoLevel(e) {
    const {
      maxAutoLevel: t,
      minAutoLevel: i
    } = this.hls, n = Math.min(Math.max(e, i), t);
    this._nextAutoLevel !== n && (this.nextAutoLevelKey = "", this._nextAutoLevel = n);
  }
}
class Oc {
  constructor() {
    this._boundTick = void 0, this._tickTimer = null, this._tickInterval = null, this._tickCallCount = 0, this._boundTick = this.tick.bind(this);
  }
  destroy() {
    this.onHandlerDestroying(), this.onHandlerDestroyed();
  }
  onHandlerDestroying() {
    this.clearNextTick(), this.clearInterval();
  }
  onHandlerDestroyed() {
  }
  hasInterval() {
    return !!this._tickInterval;
  }
  hasNextTick() {
    return !!this._tickTimer;
  }
  /**
   * @param millis - Interval time (ms)
   * @eturns True when interval has been scheduled, false when already scheduled (no effect)
   */
  setInterval(e) {
    return this._tickInterval ? !1 : (this._tickCallCount = 0, this._tickInterval = self.setInterval(this._boundTick, e), !0);
  }
  /**
   * @returns True when interval was cleared, false when none was set (no effect)
   */
  clearInterval() {
    return this._tickInterval ? (self.clearInterval(this._tickInterval), this._tickInterval = null, !0) : !1;
  }
  /**
   * @returns True when timeout was cleared, false when none was set (no effect)
   */
  clearNextTick() {
    return this._tickTimer ? (self.clearTimeout(this._tickTimer), this._tickTimer = null, !0) : !1;
  }
  /**
   * Will call the subclass doTick implementation in this main loop tick
   * or in the next one (via setTimeout(,0)) in case it has already been called
   * in this tick (in case this is a re-entrant call).
   */
  tick() {
    this._tickCallCount++, this._tickCallCount === 1 && (this.doTick(), this._tickCallCount > 1 && this.tickImmediate(), this._tickCallCount = 0);
  }
  tickImmediate() {
    this.clearNextTick(), this._tickTimer = self.setTimeout(this._boundTick, 0);
  }
  /**
   * For subclass to implement task logic
   * @abstract
   */
  doTick() {
  }
}
var ve = {
  NOT_LOADED: "NOT_LOADED",
  APPENDING: "APPENDING",
  PARTIAL: "PARTIAL",
  OK: "OK"
};
class Fc {
  constructor(e) {
    this.activePartLists = /* @__PURE__ */ Object.create(null), this.endListFragments = /* @__PURE__ */ Object.create(null), this.fragments = /* @__PURE__ */ Object.create(null), this.timeRanges = /* @__PURE__ */ Object.create(null), this.bufferPadding = 0.2, this.hls = void 0, this.hasGaps = !1, this.hls = e, this._registerListeners();
  }
  _registerListeners() {
    const {
      hls: e
    } = this;
    e.on(p.BUFFER_APPENDED, this.onBufferAppended, this), e.on(p.FRAG_BUFFERED, this.onFragBuffered, this), e.on(p.FRAG_LOADED, this.onFragLoaded, this);
  }
  _unregisterListeners() {
    const {
      hls: e
    } = this;
    e.off(p.BUFFER_APPENDED, this.onBufferAppended, this), e.off(p.FRAG_BUFFERED, this.onFragBuffered, this), e.off(p.FRAG_LOADED, this.onFragLoaded, this);
  }
  destroy() {
    this._unregisterListeners(), this.fragments = // @ts-ignore
    this.activePartLists = // @ts-ignore
    this.endListFragments = this.timeRanges = null;
  }
  /**
   * Return a Fragment or Part with an appended range that matches the position and levelType
   * Otherwise, return null
   */
  getAppendedFrag(e, t) {
    const i = this.activePartLists[t];
    if (i)
      for (let n = i.length; n--; ) {
        const r = i[n];
        if (!r)
          break;
        const a = r.end;
        if (r.start <= e && a !== null && e <= a)
          return r;
      }
    return this.getBufferedFrag(e, t);
  }
  /**
   * Return a buffered Fragment that matches the position and levelType.
   * A buffered Fragment is one whose loading, parsing and appending is done (completed or "partial" meaning aborted).
   * If not found any Fragment, return null
   */
  getBufferedFrag(e, t) {
    const {
      fragments: i
    } = this, n = Object.keys(i);
    for (let r = n.length; r--; ) {
      const a = i[n[r]];
      if ((a == null ? void 0 : a.body.type) === t && a.buffered) {
        const o = a.body;
        if (o.start <= e && e <= o.end)
          return o;
      }
    }
    return null;
  }
  /**
   * Partial fragments effected by coded frame eviction will be removed
   * The browser will unload parts of the buffer to free up memory for new buffer data
   * Fragments will need to be reloaded when the buffer is freed up, removing partial fragments will allow them to reload(since there might be parts that are still playable)
   */
  detectEvictedFragments(e, t, i, n) {
    this.timeRanges && (this.timeRanges[e] = t);
    const r = (n == null ? void 0 : n.fragment.sn) || -1;
    Object.keys(this.fragments).forEach((a) => {
      const o = this.fragments[a];
      if (!o || r >= o.body.sn)
        return;
      if (!o.buffered && !o.loaded) {
        o.body.type === i && this.removeFragment(o.body);
        return;
      }
      const l = o.range[e];
      l && l.time.some((c) => {
        const h = !this.isTimeBuffered(c.startPTS, c.endPTS, t);
        return h && this.removeFragment(o.body), h;
      });
    });
  }
  /**
   * Checks if the fragment passed in is loaded in the buffer properly
   * Partially loaded fragments will be registered as a partial fragment
   */
  detectPartialFragments(e) {
    const t = this.timeRanges, {
      frag: i,
      part: n
    } = e;
    if (!t || i.sn === "initSegment")
      return;
    const r = dt(i), a = this.fragments[r];
    if (!a || a.buffered && i.gap)
      return;
    const o = !i.relurl;
    Object.keys(t).forEach((l) => {
      const c = i.elementaryStreams[l];
      if (!c)
        return;
      const h = t[l], u = o || c.partial === !0;
      a.range[l] = this.getBufferedTimes(i, n, u, h);
    }), a.loaded = null, Object.keys(a.range).length ? (a.buffered = !0, (a.body.endList = i.endList || a.body.endList) && (this.endListFragments[a.body.type] = a), Wt(a) || this.removeParts(i.sn - 1, i.type)) : this.removeFragment(a.body);
  }
  removeParts(e, t) {
    const i = this.activePartLists[t];
    i && (this.activePartLists[t] = i.filter((n) => n.fragment.sn >= e));
  }
  fragBuffered(e, t) {
    const i = dt(e);
    let n = this.fragments[i];
    !n && t && (n = this.fragments[i] = {
      body: e,
      appendedPTS: null,
      loaded: null,
      buffered: !1,
      range: /* @__PURE__ */ Object.create(null)
    }, e.gap && (this.hasGaps = !0)), n && (n.loaded = null, n.buffered = !0);
  }
  getBufferedTimes(e, t, i, n) {
    const r = {
      time: [],
      partial: i
    }, a = e.start, o = e.end, l = e.minEndPTS || o, c = e.maxStartPTS || a;
    for (let h = 0; h < n.length; h++) {
      const u = n.start(h) - this.bufferPadding, d = n.end(h) + this.bufferPadding;
      if (c >= u && l <= d) {
        r.time.push({
          startPTS: Math.max(a, n.start(h)),
          endPTS: Math.min(o, n.end(h))
        });
        break;
      } else if (a < d && o > u) {
        const g = Math.max(a, n.start(h)), f = Math.min(o, n.end(h));
        f > g && (r.partial = !0, r.time.push({
          startPTS: g,
          endPTS: f
        }));
      } else if (o <= u)
        break;
    }
    return r;
  }
  /**
   * Gets the partial fragment for a certain time
   */
  getPartialFragment(e) {
    let t = null, i, n, r, a = 0;
    const {
      bufferPadding: o,
      fragments: l
    } = this;
    return Object.keys(l).forEach((c) => {
      const h = l[c];
      h && Wt(h) && (n = h.body.start - o, r = h.body.end + o, e >= n && e <= r && (i = Math.min(e - n, r - e), a <= i && (t = h.body, a = i)));
    }), t;
  }
  isEndListAppended(e) {
    const t = this.endListFragments[e];
    return t !== void 0 && (t.buffered || Wt(t));
  }
  getState(e) {
    const t = dt(e), i = this.fragments[t];
    return i ? i.buffered ? Wt(i) ? ve.PARTIAL : ve.OK : ve.APPENDING : ve.NOT_LOADED;
  }
  isTimeBuffered(e, t, i) {
    let n, r;
    for (let a = 0; a < i.length; a++) {
      if (n = i.start(a) - this.bufferPadding, r = i.end(a) + this.bufferPadding, e >= n && t <= r)
        return !0;
      if (t <= n)
        return !1;
    }
    return !1;
  }
  onFragLoaded(e, t) {
    const {
      frag: i,
      part: n
    } = t;
    if (i.sn === "initSegment" || i.bitrateTest)
      return;
    const r = n ? null : t, a = dt(i);
    this.fragments[a] = {
      body: i,
      appendedPTS: null,
      loaded: r,
      buffered: !1,
      range: /* @__PURE__ */ Object.create(null)
    };
  }
  onBufferAppended(e, t) {
    const {
      frag: i,
      part: n,
      timeRanges: r
    } = t;
    if (i.sn === "initSegment")
      return;
    const a = i.type;
    if (n) {
      let o = this.activePartLists[a];
      o || (this.activePartLists[a] = o = []), o.push(n);
    }
    this.timeRanges = r, Object.keys(r).forEach((o) => {
      const l = r[o];
      this.detectEvictedFragments(o, l, a, n);
    });
  }
  onFragBuffered(e, t) {
    this.detectPartialFragments(t);
  }
  hasFragment(e) {
    const t = dt(e);
    return !!this.fragments[t];
  }
  hasParts(e) {
    var t;
    return !!((t = this.activePartLists[e]) != null && t.length);
  }
  removeFragmentsInRange(e, t, i, n, r) {
    n && !this.hasGaps || Object.keys(this.fragments).forEach((a) => {
      const o = this.fragments[a];
      if (!o)
        return;
      const l = o.body;
      l.type !== i || n && !l.gap || l.start < t && l.end > e && (o.buffered || r) && this.removeFragment(l);
    });
  }
  removeFragment(e) {
    const t = dt(e);
    e.stats.loaded = 0, e.clearElementaryStreamInfo();
    const i = this.activePartLists[e.type];
    if (i) {
      const n = e.sn;
      this.activePartLists[e.type] = i.filter((r) => r.fragment.sn !== n);
    }
    delete this.fragments[t], e.endList && delete this.endListFragments[e.type];
  }
  removeAllFragments() {
    this.fragments = /* @__PURE__ */ Object.create(null), this.endListFragments = /* @__PURE__ */ Object.create(null), this.activePartLists = /* @__PURE__ */ Object.create(null), this.hasGaps = !1;
  }
}
function Wt(s) {
  var e, t, i;
  return s.buffered && (s.body.gap || ((e = s.range.video) == null ? void 0 : e.partial) || ((t = s.range.audio) == null ? void 0 : t.partial) || ((i = s.range.audiovideo) == null ? void 0 : i.partial));
}
function dt(s) {
  return `${s.type}_${s.level}_${s.sn}`;
}
const Mc = {
  length: 0,
  start: () => 0,
  end: () => 0
};
class le {
  /**
   * Return true if `media`'s buffered include `position`
   */
  static isBuffered(e, t) {
    try {
      if (e) {
        const i = le.getBuffered(e);
        for (let n = 0; n < i.length; n++)
          if (t >= i.start(n) && t <= i.end(n))
            return !0;
      }
    } catch (i) {
    }
    return !1;
  }
  static bufferInfo(e, t, i) {
    try {
      if (e) {
        const n = le.getBuffered(e), r = [];
        let a;
        for (a = 0; a < n.length; a++)
          r.push({
            start: n.start(a),
            end: n.end(a)
          });
        return this.bufferedInfo(r, t, i);
      }
    } catch (n) {
    }
    return {
      len: 0,
      start: t,
      end: t,
      nextStart: void 0
    };
  }
  static bufferedInfo(e, t, i) {
    t = Math.max(0, t), e.sort(function(c, h) {
      const u = c.start - h.start;
      return u || h.end - c.end;
    });
    let n = [];
    if (i)
      for (let c = 0; c < e.length; c++) {
        const h = n.length;
        if (h) {
          const u = n[h - 1].end;
          e[c].start - u < i ? e[c].end > u && (n[h - 1].end = e[c].end) : n.push(e[c]);
        } else
          n.push(e[c]);
      }
    else
      n = e;
    let r = 0, a, o = t, l = t;
    for (let c = 0; c < n.length; c++) {
      const h = n[c].start, u = n[c].end;
      if (t + i >= h && t < u)
        o = h, l = u, r = l - t;
      else if (t + i < h) {
        a = h;
        break;
      }
    }
    return {
      len: r,
      start: o || 0,
      end: l || 0,
      nextStart: a
    };
  }
  /**
   * Safe method to get buffered property.
   * SourceBuffer.buffered may throw if SourceBuffer is removed from it's MediaSource
   */
  static getBuffered(e) {
    try {
      return e.buffered;
    } catch (t) {
      return S.log("failed to get media.buffered", t), Mc;
    }
  }
}
class Us {
  constructor(e, t, i, n = 0, r = -1, a = !1) {
    this.level = void 0, this.sn = void 0, this.part = void 0, this.id = void 0, this.size = void 0, this.partial = void 0, this.transmuxing = Yt(), this.buffering = {
      audio: Yt(),
      video: Yt(),
      audiovideo: Yt()
    }, this.level = e, this.sn = t, this.id = i, this.size = n, this.part = r, this.partial = a;
  }
}
function Yt() {
  return {
    start: 0,
    executeStart: 0,
    executeEnd: 0,
    end: 0
  };
}
function ni(s, e) {
  for (let i = 0, n = s.length; i < n; i++) {
    var t;
    if (((t = s[i]) == null ? void 0 : t.cc) === e)
      return s[i];
  }
  return null;
}
function Nc(s, e, t) {
  return !!(e && (t.endCC > t.startCC || s && s.cc < t.startCC));
}
function Uc(s, e) {
  const t = s.fragments, i = e.fragments;
  if (!i.length || !t.length) {
    S.log("No fragments to align");
    return;
  }
  const n = ni(t, i[0].cc);
  if (!n || n && !n.startPTS) {
    S.log("No frag in previous level to align on");
    return;
  }
  return n;
}
function Nn(s, e) {
  if (s) {
    const t = s.start + e;
    s.start = s.startPTS = t, s.endPTS = t + s.duration;
  }
}
function aa(s, e) {
  const t = e.fragments;
  for (let i = 0, n = t.length; i < n; i++)
    Nn(t[i], s);
  e.fragmentHint && Nn(e.fragmentHint, s), e.alignedSliding = !0;
}
function Bc(s, e, t) {
  e && ($c(s, t, e), !t.alignedSliding && e && xi(t, e), !t.alignedSliding && e && !t.skippedSegments && ta(e, t));
}
function $c(s, e, t) {
  if (Nc(s, t, e)) {
    const i = Uc(t, e);
    i && U(i.start) && (S.log(`Adjusting PTS using last level due to CC increase within current level ${e.url}`), aa(i.start, e));
  }
}
function xi(s, e) {
  if (!s.hasProgramDateTime || !e.hasProgramDateTime)
    return;
  const t = s.fragments, i = e.fragments;
  if (!t.length || !i.length)
    return;
  let n, r;
  const a = Math.min(e.endCC, s.endCC);
  e.startCC < a && s.startCC < a && (n = ni(i, a), r = ni(t, a)), (!n || !r) && (n = i[Math.floor(i.length / 2)], r = ni(t, n.cc) || t[Math.floor(t.length / 2)]);
  const o = n.programDateTime, l = r.programDateTime;
  if (!o || !l)
    return;
  const c = (l - o) / 1e3 - (r.start - n.start);
  aa(c, s);
}
const Un = Math.pow(2, 17);
class Gc {
  constructor(e) {
    this.config = void 0, this.loader = null, this.partLoadTimeout = -1, this.config = e;
  }
  destroy() {
    this.loader && (this.loader.destroy(), this.loader = null);
  }
  abort() {
    this.loader && this.loader.abort();
  }
  load(e, t) {
    const i = e.url;
    if (!i)
      return Promise.reject(new je({
        type: V.NETWORK_ERROR,
        details: I.FRAG_LOAD_ERROR,
        fatal: !1,
        frag: e,
        error: new Error(`Fragment does not have a ${i ? "part list" : "url"}`),
        networkDetails: null
      }));
    this.abort();
    const n = this.config, r = n.fLoader, a = n.loader;
    return new Promise((o, l) => {
      if (this.loader && this.loader.destroy(), e.gap)
        if (e.tagList.some((g) => g[0] === "GAP")) {
          l($n(e));
          return;
        } else
          e.gap = !1;
      const c = this.loader = e.loader = r ? new r(n) : new a(n), h = Bn(e), u = On(n.fragLoadPolicy.default), d = {
        loadPolicy: u,
        timeout: u.maxLoadTimeMs,
        maxRetry: 0,
        retryDelay: 0,
        maxRetryDelay: 0,
        highWaterMark: e.sn === "initSegment" ? 1 / 0 : Un
      };
      e.stats = c.stats, c.load(h, d, {
        onSuccess: (g, f, m, y) => {
          this.resetLoader(e, c);
          let T = g.data;
          m.resetIV && e.decryptdata && (e.decryptdata.iv = new Uint8Array(T.slice(0, 16)), T = T.slice(16)), o({
            frag: e,
            part: null,
            payload: T,
            networkDetails: y
          });
        },
        onError: (g, f, m, y) => {
          this.resetLoader(e, c), l(new je({
            type: V.NETWORK_ERROR,
            details: I.FRAG_LOAD_ERROR,
            fatal: !1,
            frag: e,
            response: be({
              url: i,
              data: void 0
            }, g),
            error: new Error(`HTTP Error ${g.code} ${g.text}`),
            networkDetails: m,
            stats: y
          }));
        },
        onAbort: (g, f, m) => {
          this.resetLoader(e, c), l(new je({
            type: V.NETWORK_ERROR,
            details: I.INTERNAL_ABORTED,
            fatal: !1,
            frag: e,
            error: new Error("Aborted"),
            networkDetails: m,
            stats: g
          }));
        },
        onTimeout: (g, f, m) => {
          this.resetLoader(e, c), l(new je({
            type: V.NETWORK_ERROR,
            details: I.FRAG_LOAD_TIMEOUT,
            fatal: !1,
            frag: e,
            error: new Error(`Timeout after ${d.timeout}ms`),
            networkDetails: m,
            stats: g
          }));
        },
        onProgress: (g, f, m, y) => {
          t && t({
            frag: e,
            part: null,
            payload: m,
            networkDetails: y
          });
        }
      });
    });
  }
  loadPart(e, t, i) {
    this.abort();
    const n = this.config, r = n.fLoader, a = n.loader;
    return new Promise((o, l) => {
      if (this.loader && this.loader.destroy(), e.gap || t.gap) {
        l($n(e, t));
        return;
      }
      const c = this.loader = e.loader = r ? new r(n) : new a(n), h = Bn(e, t), u = On(n.fragLoadPolicy.default), d = {
        loadPolicy: u,
        timeout: u.maxLoadTimeMs,
        maxRetry: 0,
        retryDelay: 0,
        maxRetryDelay: 0,
        highWaterMark: Un
      };
      t.stats = c.stats, c.load(h, d, {
        onSuccess: (g, f, m, y) => {
          this.resetLoader(e, c), this.updateStatsFromPart(e, t);
          const T = {
            frag: e,
            part: t,
            payload: g.data,
            networkDetails: y
          };
          i(T), o(T);
        },
        onError: (g, f, m, y) => {
          this.resetLoader(e, c), l(new je({
            type: V.NETWORK_ERROR,
            details: I.FRAG_LOAD_ERROR,
            fatal: !1,
            frag: e,
            part: t,
            response: be({
              url: h.url,
              data: void 0
            }, g),
            error: new Error(`HTTP Error ${g.code} ${g.text}`),
            networkDetails: m,
            stats: y
          }));
        },
        onAbort: (g, f, m) => {
          e.stats.aborted = t.stats.aborted, this.resetLoader(e, c), l(new je({
            type: V.NETWORK_ERROR,
            details: I.INTERNAL_ABORTED,
            fatal: !1,
            frag: e,
            part: t,
            error: new Error("Aborted"),
            networkDetails: m,
            stats: g
          }));
        },
        onTimeout: (g, f, m) => {
          this.resetLoader(e, c), l(new je({
            type: V.NETWORK_ERROR,
            details: I.FRAG_LOAD_TIMEOUT,
            fatal: !1,
            frag: e,
            part: t,
            error: new Error(`Timeout after ${d.timeout}ms`),
            networkDetails: m,
            stats: g
          }));
        }
      });
    });
  }
  updateStatsFromPart(e, t) {
    const i = e.stats, n = t.stats, r = n.total;
    if (i.loaded += n.loaded, r) {
      const l = Math.round(e.duration / t.duration), c = Math.min(Math.round(i.loaded / r), l), u = (l - c) * Math.round(i.loaded / c);
      i.total = i.loaded + u;
    } else
      i.total = Math.max(i.loaded, i.total);
    const a = i.loading, o = n.loading;
    a.start ? a.first += o.first - o.start : (a.start = o.start, a.first = o.first), a.end = o.end;
  }
  resetLoader(e, t) {
    e.loader = null, this.loader === t && (self.clearTimeout(this.partLoadTimeout), this.loader = null), t.destroy();
  }
}
function Bn(s, e = null) {
  const t = e || s, i = {
    frag: s,
    part: e,
    responseType: "arraybuffer",
    url: t.url,
    headers: {},
    rangeStart: 0,
    rangeEnd: 0
  }, n = t.byteRangeStartOffset, r = t.byteRangeEndOffset;
  if (U(n) && U(r)) {
    var a;
    let o = n, l = r;
    if (s.sn === "initSegment" && ((a = s.decryptdata) == null ? void 0 : a.method) === "AES-128") {
      const c = r - n;
      c % 16 && (l = r + (16 - c % 16)), n !== 0 && (i.resetIV = !0, o = n - 16);
    }
    i.rangeStart = o, i.rangeEnd = l;
  }
  return i;
}
function $n(s, e) {
  const t = new Error(`GAP ${s.gap ? "tag" : "attribute"} found`), i = {
    type: V.MEDIA_ERROR,
    details: I.FRAG_GAP,
    fatal: !1,
    frag: s,
    error: t,
    networkDetails: null
  };
  return e && (i.part = e), (e || s).stats.aborted = !0, new je(i);
}
class je extends Error {
  constructor(e) {
    super(e.error.message), this.data = void 0, this.data = e;
  }
}
class Hc {
  constructor(e, t) {
    this.subtle = void 0, this.aesIV = void 0, this.subtle = e, this.aesIV = t;
  }
  decrypt(e, t) {
    return this.subtle.decrypt({
      name: "AES-CBC",
      iv: this.aesIV
    }, t, e);
  }
}
class Kc {
  constructor(e, t) {
    this.subtle = void 0, this.key = void 0, this.subtle = e, this.key = t;
  }
  expandKey() {
    return this.subtle.importKey("raw", this.key, {
      name: "AES-CBC"
    }, !1, ["encrypt", "decrypt"]);
  }
}
function Vc(s) {
  const e = s.byteLength, t = e && new DataView(s.buffer).getUint8(e - 1);
  return t ? lt(s, 0, e - t) : s;
}
class Wc {
  constructor() {
    this.rcon = [0, 1, 2, 4, 8, 16, 32, 64, 128, 27, 54], this.subMix = [new Uint32Array(256), new Uint32Array(256), new Uint32Array(256), new Uint32Array(256)], this.invSubMix = [new Uint32Array(256), new Uint32Array(256), new Uint32Array(256), new Uint32Array(256)], this.sBox = new Uint32Array(256), this.invSBox = new Uint32Array(256), this.key = new Uint32Array(0), this.ksRows = 0, this.keySize = 0, this.keySchedule = void 0, this.invKeySchedule = void 0, this.initTable();
  }
  // Using view.getUint32() also swaps the byte order.
  uint8ArrayToUint32Array_(e) {
    const t = new DataView(e), i = new Uint32Array(4);
    for (let n = 0; n < 4; n++)
      i[n] = t.getUint32(n * 4);
    return i;
  }
  initTable() {
    const e = this.sBox, t = this.invSBox, i = this.subMix, n = i[0], r = i[1], a = i[2], o = i[3], l = this.invSubMix, c = l[0], h = l[1], u = l[2], d = l[3], g = new Uint32Array(256);
    let f = 0, m = 0, y = 0;
    for (y = 0; y < 256; y++)
      y < 128 ? g[y] = y << 1 : g[y] = y << 1 ^ 283;
    for (y = 0; y < 256; y++) {
      let T = m ^ m << 1 ^ m << 2 ^ m << 3 ^ m << 4;
      T = T >>> 8 ^ T & 255 ^ 99, e[f] = T, t[T] = f;
      const b = g[f], v = g[b], A = g[v];
      let x = g[T] * 257 ^ T * 16843008;
      n[f] = x << 24 | x >>> 8, r[f] = x << 16 | x >>> 16, a[f] = x << 8 | x >>> 24, o[f] = x, x = A * 16843009 ^ v * 65537 ^ b * 257 ^ f * 16843008, c[T] = x << 24 | x >>> 8, h[T] = x << 16 | x >>> 16, u[T] = x << 8 | x >>> 24, d[T] = x, f ? (f = b ^ g[g[g[A ^ b]]], m ^= g[g[m]]) : f = m = 1;
    }
  }
  expandKey(e) {
    const t = this.uint8ArrayToUint32Array_(e);
    let i = !0, n = 0;
    for (; n < t.length && i; )
      i = t[n] === this.key[n], n++;
    if (i)
      return;
    this.key = t;
    const r = this.keySize = t.length;
    if (r !== 4 && r !== 6 && r !== 8)
      throw new Error("Invalid aes key size=" + r);
    const a = this.ksRows = (r + 6 + 1) * 4;
    let o, l;
    const c = this.keySchedule = new Uint32Array(a), h = this.invKeySchedule = new Uint32Array(a), u = this.sBox, d = this.rcon, g = this.invSubMix, f = g[0], m = g[1], y = g[2], T = g[3];
    let b, v;
    for (o = 0; o < a; o++) {
      if (o < r) {
        b = c[o] = t[o];
        continue;
      }
      v = b, o % r === 0 ? (v = v << 8 | v >>> 24, v = u[v >>> 24] << 24 | u[v >>> 16 & 255] << 16 | u[v >>> 8 & 255] << 8 | u[v & 255], v ^= d[o / r | 0] << 24) : r > 6 && o % r === 4 && (v = u[v >>> 24] << 24 | u[v >>> 16 & 255] << 16 | u[v >>> 8 & 255] << 8 | u[v & 255]), c[o] = b = (c[o - r] ^ v) >>> 0;
    }
    for (l = 0; l < a; l++)
      o = a - l, l & 3 ? v = c[o] : v = c[o - 4], l < 4 || o <= 4 ? h[l] = v : h[l] = f[u[v >>> 24]] ^ m[u[v >>> 16 & 255]] ^ y[u[v >>> 8 & 255]] ^ T[u[v & 255]], h[l] = h[l] >>> 0;
  }
  // Adding this as a method greatly improves performance.
  networkToHostOrderSwap(e) {
    return e << 24 | (e & 65280) << 8 | (e & 16711680) >> 8 | e >>> 24;
  }
  decrypt(e, t, i) {
    const n = this.keySize + 6, r = this.invKeySchedule, a = this.invSBox, o = this.invSubMix, l = o[0], c = o[1], h = o[2], u = o[3], d = this.uint8ArrayToUint32Array_(i);
    let g = d[0], f = d[1], m = d[2], y = d[3];
    const T = new Int32Array(e), b = new Int32Array(T.length);
    let v, A, x, w, R, k, _, C, P, q, M, j, Y, H;
    const Z = this.networkToHostOrderSwap;
    for (; t < T.length; ) {
      for (P = Z(T[t]), q = Z(T[t + 1]), M = Z(T[t + 2]), j = Z(T[t + 3]), R = P ^ r[0], k = j ^ r[1], _ = M ^ r[2], C = q ^ r[3], Y = 4, H = 1; H < n; H++)
        v = l[R >>> 24] ^ c[k >> 16 & 255] ^ h[_ >> 8 & 255] ^ u[C & 255] ^ r[Y], A = l[k >>> 24] ^ c[_ >> 16 & 255] ^ h[C >> 8 & 255] ^ u[R & 255] ^ r[Y + 1], x = l[_ >>> 24] ^ c[C >> 16 & 255] ^ h[R >> 8 & 255] ^ u[k & 255] ^ r[Y + 2], w = l[C >>> 24] ^ c[R >> 16 & 255] ^ h[k >> 8 & 255] ^ u[_ & 255] ^ r[Y + 3], R = v, k = A, _ = x, C = w, Y = Y + 4;
      v = a[R >>> 24] << 24 ^ a[k >> 16 & 255] << 16 ^ a[_ >> 8 & 255] << 8 ^ a[C & 255] ^ r[Y], A = a[k >>> 24] << 24 ^ a[_ >> 16 & 255] << 16 ^ a[C >> 8 & 255] << 8 ^ a[R & 255] ^ r[Y + 1], x = a[_ >>> 24] << 24 ^ a[C >> 16 & 255] << 16 ^ a[R >> 8 & 255] << 8 ^ a[k & 255] ^ r[Y + 2], w = a[C >>> 24] << 24 ^ a[R >> 16 & 255] << 16 ^ a[k >> 8 & 255] << 8 ^ a[_ & 255] ^ r[Y + 3], b[t] = Z(v ^ g), b[t + 1] = Z(w ^ f), b[t + 2] = Z(x ^ m), b[t + 3] = Z(A ^ y), g = P, f = q, m = M, y = j, t = t + 4;
    }
    return b.buffer;
  }
}
const Yc = 16;
class Bs {
  constructor(e, {
    removePKCS7Padding: t = !0
  } = {}) {
    if (this.logEnabled = !0, this.removePKCS7Padding = void 0, this.subtle = null, this.softwareDecrypter = null, this.key = null, this.fastAesKey = null, this.remainderData = null, this.currentIV = null, this.currentResult = null, this.useSoftware = void 0, this.useSoftware = e.enableSoftwareAES, this.removePKCS7Padding = t, t)
      try {
        const i = self.crypto;
        i && (this.subtle = i.subtle || i.webkitSubtle);
      } catch (i) {
      }
    this.useSoftware = !this.subtle;
  }
  destroy() {
    this.subtle = null, this.softwareDecrypter = null, this.key = null, this.fastAesKey = null, this.remainderData = null, this.currentIV = null, this.currentResult = null;
  }
  isSync() {
    return this.useSoftware;
  }
  flush() {
    const {
      currentResult: e,
      remainderData: t
    } = this;
    if (!e || t)
      return this.reset(), null;
    const i = new Uint8Array(e);
    return this.reset(), this.removePKCS7Padding ? Vc(i) : i;
  }
  reset() {
    this.currentResult = null, this.currentIV = null, this.remainderData = null, this.softwareDecrypter && (this.softwareDecrypter = null);
  }
  decrypt(e, t, i) {
    return this.useSoftware ? new Promise((n, r) => {
      this.softwareDecrypt(new Uint8Array(e), t, i);
      const a = this.flush();
      a ? n(a.buffer) : r(new Error("[softwareDecrypt] Failed to decrypt data"));
    }) : this.webCryptoDecrypt(new Uint8Array(e), t, i);
  }
  // Software decryption is progressive. Progressive decryption may not return a result on each call. Any cached
  // data is handled in the flush() call
  softwareDecrypt(e, t, i) {
    const {
      currentIV: n,
      currentResult: r,
      remainderData: a
    } = this;
    this.logOnce("JS AES decrypt"), a && (e = ke(a, e), this.remainderData = null);
    const o = this.getValidChunk(e);
    if (!o.length)
      return null;
    n && (i = n);
    let l = this.softwareDecrypter;
    l || (l = this.softwareDecrypter = new Wc()), l.expandKey(t);
    const c = r;
    return this.currentResult = l.decrypt(o.buffer, 0, i), this.currentIV = lt(o, -16).buffer, c || null;
  }
  webCryptoDecrypt(e, t, i) {
    if (this.key !== t || !this.fastAesKey) {
      if (!this.subtle)
        return Promise.resolve(this.onWebCryptoError(e, t, i));
      this.key = t, this.fastAesKey = new Kc(this.subtle, t);
    }
    return this.fastAesKey.expandKey().then((n) => this.subtle ? (this.logOnce("WebCrypto AES decrypt"), new Hc(this.subtle, new Uint8Array(i)).decrypt(e.buffer, n)) : Promise.reject(new Error("web crypto not initialized"))).catch((n) => (S.warn(`[decrypter]: WebCrypto Error, disable WebCrypto API, ${n.name}: ${n.message}`), this.onWebCryptoError(e, t, i)));
  }
  onWebCryptoError(e, t, i) {
    this.useSoftware = !0, this.logEnabled = !0, this.softwareDecrypt(e, t, i);
    const n = this.flush();
    if (n)
      return n.buffer;
    throw new Error("WebCrypto and softwareDecrypt: failed to decrypt data");
  }
  getValidChunk(e) {
    let t = e;
    const i = e.length - e.length % Yc;
    return i !== e.length && (t = lt(e, 0, i), this.remainderData = lt(e, i)), t;
  }
  logOnce(e) {
    this.logEnabled && (S.log(`[decrypter]: ${e}`), this.logEnabled = !1);
  }
}
const jc = {
  toString: function(s) {
    let e = "";
    const t = s.length;
    for (let i = 0; i < t; i++)
      e += `[${s.start(i).toFixed(3)}-${s.end(i).toFixed(3)}]`;
    return e;
  }
}, D = {
  STOPPED: "STOPPED",
  IDLE: "IDLE",
  KEY_LOADING: "KEY_LOADING",
  FRAG_LOADING: "FRAG_LOADING",
  FRAG_LOADING_WAITING_RETRY: "FRAG_LOADING_WAITING_RETRY",
  WAITING_TRACK: "WAITING_TRACK",
  PARSING: "PARSING",
  PARSED: "PARSED",
  ENDED: "ENDED",
  ERROR: "ERROR",
  WAITING_INIT_PTS: "WAITING_INIT_PTS",
  WAITING_LEVEL: "WAITING_LEVEL"
};
class $s extends Oc {
  constructor(e, t, i, n, r) {
    super(), this.hls = void 0, this.fragPrevious = null, this.fragCurrent = null, this.fragmentTracker = void 0, this.transmuxer = null, this._state = D.STOPPED, this.playlistType = void 0, this.media = null, this.mediaBuffer = null, this.config = void 0, this.bitrateTest = !1, this.lastCurrentTime = 0, this.nextLoadPosition = 0, this.startPosition = 0, this.startTimeOffset = null, this.loadedmetadata = !1, this.retryDate = 0, this.levels = null, this.fragmentLoader = void 0, this.keyLoader = void 0, this.levelLastLoaded = null, this.startFragRequested = !1, this.decrypter = void 0, this.initPTS = [], this.buffering = !0, this.onvseeking = null, this.onvended = null, this.logPrefix = "", this.log = void 0, this.warn = void 0, this.playlistType = r, this.logPrefix = n, this.log = S.log.bind(S, `${n}:`), this.warn = S.warn.bind(S, `${n}:`), this.hls = e, this.fragmentLoader = new Gc(e.config), this.keyLoader = i, this.fragmentTracker = t, this.config = e.config, this.decrypter = new Bs(e.config), e.on(p.MANIFEST_LOADED, this.onManifestLoaded, this);
  }
  doTick() {
    this.onTickEnd();
  }
  onTickEnd() {
  }
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  startLoad(e) {
  }
  stopLoad() {
    this.fragmentLoader.abort(), this.keyLoader.abort(this.playlistType);
    const e = this.fragCurrent;
    e != null && e.loader && (e.abortRequests(), this.fragmentTracker.removeFragment(e)), this.resetTransmuxer(), this.fragCurrent = null, this.fragPrevious = null, this.clearInterval(), this.clearNextTick(), this.state = D.STOPPED;
  }
  pauseBuffering() {
    this.buffering = !1;
  }
  resumeBuffering() {
    this.buffering = !0;
  }
  _streamEnded(e, t) {
    if (t.live || e.nextStart || !e.end || !this.media)
      return !1;
    const i = t.partList;
    if (i != null && i.length) {
      const r = i[i.length - 1];
      return le.isBuffered(this.media, r.start + r.duration / 2);
    }
    const n = t.fragments[t.fragments.length - 1].type;
    return this.fragmentTracker.isEndListAppended(n);
  }
  getLevelDetails() {
    if (this.levels && this.levelLastLoaded !== null) {
      var e;
      return (e = this.levelLastLoaded) == null ? void 0 : e.details;
    }
  }
  onMediaAttached(e, t) {
    const i = this.media = this.mediaBuffer = t.media;
    this.onvseeking = this.onMediaSeeking.bind(this), this.onvended = this.onMediaEnded.bind(this), i.addEventListener("seeking", this.onvseeking), i.addEventListener("ended", this.onvended);
    const n = this.config;
    this.levels && n.autoStartLoad && this.state === D.STOPPED && this.startLoad(n.startPosition);
  }
  onMediaDetaching() {
    const e = this.media;
    e != null && e.ended && (this.log("MSE detaching and video ended, reset startPosition"), this.startPosition = this.lastCurrentTime = 0), e && this.onvseeking && this.onvended && (e.removeEventListener("seeking", this.onvseeking), e.removeEventListener("ended", this.onvended), this.onvseeking = this.onvended = null), this.keyLoader && this.keyLoader.detach(), this.media = this.mediaBuffer = null, this.loadedmetadata = !1, this.fragmentTracker.removeAllFragments(), this.stopLoad();
  }
  onMediaSeeking() {
    const {
      config: e,
      fragCurrent: t,
      media: i,
      mediaBuffer: n,
      state: r
    } = this, a = i ? i.currentTime : 0, o = le.bufferInfo(n || i, a, e.maxBufferHole);
    if (this.log(`media seeking to ${U(a) ? a.toFixed(3) : a}, state: ${r}`), this.state === D.ENDED)
      this.resetLoadingState();
    else if (t) {
      const l = e.maxFragLookUpTolerance, c = t.start - l, h = t.start + t.duration + l;
      if (!o.len || h < o.start || c > o.end) {
        const u = a > h;
        (a < c || u) && (u && t.loader && (this.log("seeking outside of buffer while fragment load in progress, cancel fragment load"), t.abortRequests(), this.resetLoadingState()), this.fragPrevious = null);
      }
    }
    i && (this.fragmentTracker.removeFragmentsInRange(a, 1 / 0, this.playlistType, !0), this.lastCurrentTime = a), !this.loadedmetadata && !o.len && (this.nextLoadPosition = this.startPosition = a), this.tickImmediate();
  }
  onMediaEnded() {
    this.startPosition = this.lastCurrentTime = 0;
  }
  onManifestLoaded(e, t) {
    this.startTimeOffset = t.startTimeOffset, this.initPTS = [];
  }
  onHandlerDestroying() {
    this.hls.off(p.MANIFEST_LOADED, this.onManifestLoaded, this), this.stopLoad(), super.onHandlerDestroying(), this.hls = null;
  }
  onHandlerDestroyed() {
    this.state = D.STOPPED, this.fragmentLoader && this.fragmentLoader.destroy(), this.keyLoader && this.keyLoader.destroy(), this.decrypter && this.decrypter.destroy(), this.hls = this.log = this.warn = this.decrypter = this.keyLoader = this.fragmentLoader = this.fragmentTracker = null, super.onHandlerDestroyed();
  }
  loadFragment(e, t, i) {
    this._loadFragForPlayback(e, t, i);
  }
  _loadFragForPlayback(e, t, i) {
    const n = (r) => {
      if (this.fragContextChanged(e)) {
        this.warn(`Fragment ${e.sn}${r.part ? " p: " + r.part.index : ""} of level ${e.level} was dropped during download.`), this.fragmentTracker.removeFragment(e);
        return;
      }
      e.stats.chunkCount++, this._handleFragmentLoadProgress(r);
    };
    this._doFragLoad(e, t, i, n).then((r) => {
      if (!r)
        return;
      const a = this.state;
      if (this.fragContextChanged(e)) {
        (a === D.FRAG_LOADING || !this.fragCurrent && a === D.PARSING) && (this.fragmentTracker.removeFragment(e), this.state = D.IDLE);
        return;
      }
      "payload" in r && (this.log(`Loaded fragment ${e.sn} of level ${e.level}`), this.hls.trigger(p.FRAG_LOADED, r)), this._handleFragmentLoadComplete(r);
    }).catch((r) => {
      this.state === D.STOPPED || this.state === D.ERROR || (this.warn(`Frag error: ${(r == null ? void 0 : r.message) || r}`), this.resetFragmentLoading(e));
    });
  }
  clearTrackerIfNeeded(e) {
    var t;
    const {
      fragmentTracker: i
    } = this;
    if (i.getState(e) === ve.APPENDING) {
      const r = e.type, a = this.getFwdBufferInfo(this.mediaBuffer, r), o = Math.max(e.duration, a ? a.len : this.config.maxBufferLength), l = this.backtrackFragment;
      ((l ? e.sn - l.sn : 0) === 1 || this.reduceMaxBufferLength(o, e.duration)) && i.removeFragment(e);
    } else ((t = this.mediaBuffer) == null ? void 0 : t.buffered.length) === 0 ? i.removeAllFragments() : i.hasParts(e.type) && (i.detectPartialFragments({
      frag: e,
      part: null,
      stats: e.stats,
      id: e.type
    }), i.getState(e) === ve.PARTIAL && i.removeFragment(e));
  }
  checkLiveUpdate(e) {
    if (e.updated && !e.live) {
      const t = e.fragments[e.fragments.length - 1];
      this.fragmentTracker.detectPartialFragments({
        frag: t,
        part: null,
        stats: t.stats,
        id: t.type
      });
    }
    e.fragments[0] || (e.deltaUpdateFailed = !0);
  }
  flushMainBuffer(e, t, i = null) {
    if (!(e - t))
      return;
    const n = {
      startOffset: e,
      endOffset: t,
      type: i
    };
    this.hls.trigger(p.BUFFER_FLUSHING, n);
  }
  _loadInitSegment(e, t) {
    this._doFragLoad(e, t).then((i) => {
      if (!i || this.fragContextChanged(e) || !this.levels)
        throw new Error("init load aborted");
      return i;
    }).then((i) => {
      const {
        hls: n
      } = this, {
        payload: r
      } = i, a = e.decryptdata;
      if (r && r.byteLength > 0 && a != null && a.key && a.iv && a.method === "AES-128") {
        const o = self.performance.now();
        return this.decrypter.decrypt(new Uint8Array(r), a.key.buffer, a.iv.buffer).catch((l) => {
          throw n.trigger(p.ERROR, {
            type: V.MEDIA_ERROR,
            details: I.FRAG_DECRYPT_ERROR,
            fatal: !1,
            error: l,
            reason: l.message,
            frag: e
          }), l;
        }).then((l) => {
          const c = self.performance.now();
          return n.trigger(p.FRAG_DECRYPTED, {
            frag: e,
            payload: l,
            stats: {
              tstart: o,
              tdecrypt: c
            }
          }), i.payload = l, this.completeInitSegmentLoad(i);
        });
      }
      return this.completeInitSegmentLoad(i);
    }).catch((i) => {
      this.state === D.STOPPED || this.state === D.ERROR || (this.warn(i), this.resetFragmentLoading(e));
    });
  }
  completeInitSegmentLoad(e) {
    const {
      levels: t
    } = this;
    if (!t)
      throw new Error("init load aborted, missing levels");
    const i = e.frag.stats;
    this.state = D.IDLE, e.frag.data = new Uint8Array(e.payload), i.parsing.start = i.buffering.start = self.performance.now(), i.parsing.end = i.buffering.end = self.performance.now(), this.tick();
  }
  fragContextChanged(e) {
    const {
      fragCurrent: t
    } = this;
    return !e || !t || e.sn !== t.sn || e.level !== t.level;
  }
  fragBufferedComplete(e, t) {
    var i, n, r, a;
    const o = this.mediaBuffer ? this.mediaBuffer : this.media;
    if (this.log(`Buffered ${e.type} sn: ${e.sn}${t ? " part: " + t.index : ""} of ${this.playlistType === G.MAIN ? "level" : "track"} ${e.level} (frag:[${((i = e.startPTS) != null ? i : NaN).toFixed(3)}-${((n = e.endPTS) != null ? n : NaN).toFixed(3)}] > buffer:${o ? jc.toString(le.getBuffered(o)) : "(detached)"})`), e.sn !== "initSegment") {
      var l;
      if (e.type !== G.SUBTITLE) {
        const h = e.elementaryStreams;
        if (!Object.keys(h).some((u) => !!h[u])) {
          this.state = D.IDLE;
          return;
        }
      }
      const c = (l = this.levels) == null ? void 0 : l[e.level];
      c != null && c.fragmentError && (this.log(`Resetting level fragment error count of ${c.fragmentError} on frag buffered`), c.fragmentError = 0);
    }
    this.state = D.IDLE, o && (!this.loadedmetadata && e.type == G.MAIN && o.buffered.length && ((r = this.fragCurrent) == null ? void 0 : r.sn) === ((a = this.fragPrevious) == null ? void 0 : a.sn) && (this.loadedmetadata = !0, this.seekToStartPos()), this.tick());
  }
  seekToStartPos() {
  }
  _handleFragmentLoadComplete(e) {
    const {
      transmuxer: t
    } = this;
    if (!t)
      return;
    const {
      frag: i,
      part: n,
      partsLoaded: r
    } = e, a = !r || r.length === 0 || r.some((l) => !l), o = new Us(i.level, i.sn, i.stats.chunkCount + 1, 0, n ? n.index : -1, !a);
    t.flush(o);
  }
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  _handleFragmentLoadProgress(e) {
  }
  _doFragLoad(e, t, i = null, n) {
    var r;
    const a = t == null ? void 0 : t.details;
    if (!this.levels || !a)
      throw new Error(`frag load aborted, missing level${a ? "" : " detail"}s`);
    let o = null;
    if (e.encrypted && !((r = e.decryptdata) != null && r.key) ? (this.log(`Loading key for ${e.sn} of [${a.startSN}-${a.endSN}], ${this.logPrefix === "[stream-controller]" ? "level" : "track"} ${e.level}`), this.state = D.KEY_LOADING, this.fragCurrent = e, o = this.keyLoader.load(e).then((h) => {
      if (!this.fragContextChanged(h.frag))
        return this.hls.trigger(p.KEY_LOADED, h), this.state === D.KEY_LOADING && (this.state = D.IDLE), h;
    }), this.hls.trigger(p.KEY_LOADING, {
      frag: e
    }), this.fragCurrent === null && (o = Promise.reject(new Error("frag load aborted, context changed in KEY_LOADING")))) : !e.encrypted && a.encryptedFragments.length && this.keyLoader.loadClear(e, a.encryptedFragments), i = Math.max(e.start, i || 0), this.config.lowLatencyMode && e.sn !== "initSegment") {
      const h = a.partList;
      if (h && n) {
        i > e.end && a.fragmentHint && (e = a.fragmentHint);
        const u = this.getNextPart(h, e, i);
        if (u > -1) {
          const d = h[u];
          this.log(`Loading part sn: ${e.sn} p: ${d.index} cc: ${e.cc} of playlist [${a.startSN}-${a.endSN}] parts [0-${u}-${h.length - 1}] ${this.logPrefix === "[stream-controller]" ? "level" : "track"}: ${e.level}, target: ${parseFloat(i.toFixed(3))}`), this.nextLoadPosition = d.start + d.duration, this.state = D.FRAG_LOADING;
          let g;
          return o ? g = o.then((f) => !f || this.fragContextChanged(f.frag) ? null : this.doFragPartsLoad(e, d, t, n)).catch((f) => this.handleFragLoadError(f)) : g = this.doFragPartsLoad(e, d, t, n).catch((f) => this.handleFragLoadError(f)), this.hls.trigger(p.FRAG_LOADING, {
            frag: e,
            part: d,
            targetBufferTime: i
          }), this.fragCurrent === null ? Promise.reject(new Error("frag load aborted, context changed in FRAG_LOADING parts")) : g;
        } else if (!e.url || this.loadedEndOfParts(h, i))
          return Promise.resolve(null);
      }
    }
    this.log(`Loading fragment ${e.sn} cc: ${e.cc} ${a ? "of [" + a.startSN + "-" + a.endSN + "] " : ""}${this.logPrefix === "[stream-controller]" ? "level" : "track"}: ${e.level}, target: ${parseFloat(i.toFixed(3))}`), U(e.sn) && !this.bitrateTest && (this.nextLoadPosition = e.start + e.duration), this.state = D.FRAG_LOADING;
    const l = this.config.progressive;
    let c;
    return l && o ? c = o.then((h) => !h || this.fragContextChanged(h == null ? void 0 : h.frag) ? null : this.fragmentLoader.load(e, n)).catch((h) => this.handleFragLoadError(h)) : c = Promise.all([this.fragmentLoader.load(e, l ? n : void 0), o]).then(([h]) => (!l && h && n && n(h), h)).catch((h) => this.handleFragLoadError(h)), this.hls.trigger(p.FRAG_LOADING, {
      frag: e,
      targetBufferTime: i
    }), this.fragCurrent === null ? Promise.reject(new Error("frag load aborted, context changed in FRAG_LOADING")) : c;
  }
  doFragPartsLoad(e, t, i, n) {
    return new Promise((r, a) => {
      var o;
      const l = [], c = (o = i.details) == null ? void 0 : o.partList, h = (u) => {
        this.fragmentLoader.loadPart(e, u, n).then((d) => {
          l[u.index] = d;
          const g = d.part;
          this.hls.trigger(p.FRAG_LOADED, d);
          const f = Pn(i, e.sn, u.index + 1) || ia(c, e.sn, u.index + 1);
          if (f)
            h(f);
          else
            return r({
              frag: e,
              part: g,
              partsLoaded: l
            });
        }).catch(a);
      };
      h(t);
    });
  }
  handleFragLoadError(e) {
    if ("data" in e) {
      const t = e.data;
      e.data && t.details === I.INTERNAL_ABORTED ? this.handleFragLoadAborted(t.frag, t.part) : this.hls.trigger(p.ERROR, t);
    } else
      this.hls.trigger(p.ERROR, {
        type: V.OTHER_ERROR,
        details: I.INTERNAL_EXCEPTION,
        err: e,
        error: e,
        fatal: !0
      });
    return null;
  }
  _handleTransmuxerFlush(e) {
    const t = this.getCurrentContext(e);
    if (!t || this.state !== D.PARSING) {
      !this.fragCurrent && this.state !== D.STOPPED && this.state !== D.ERROR && (this.state = D.IDLE);
      return;
    }
    const {
      frag: i,
      part: n,
      level: r
    } = t, a = self.performance.now();
    i.stats.parsing.end = a, n && (n.stats.parsing.end = a), this.updateLevelTiming(i, n, r, e.partial);
  }
  getCurrentContext(e) {
    const {
      levels: t,
      fragCurrent: i
    } = this, {
      level: n,
      sn: r,
      part: a
    } = e;
    if (!(t != null && t[n]))
      return this.warn(`Levels object was unset while buffering fragment ${r} of level ${n}. The current chunk will not be buffered.`), null;
    const o = t[n], l = a > -1 ? Pn(o, r, a) : null, c = l ? l.fragment : mc(o, r, i);
    return c ? (i && i !== c && (c.stats = i.stats), {
      frag: c,
      part: l,
      level: o
    }) : null;
  }
  bufferFragmentData(e, t, i, n, r) {
    var a;
    if (!e || this.state !== D.PARSING)
      return;
    const {
      data1: o,
      data2: l
    } = e;
    let c = o;
    if (o && l && (c = ke(o, l)), !((a = c) != null && a.length))
      return;
    const h = {
      type: e.type,
      frag: t,
      part: i,
      chunkMeta: n,
      parent: t.type,
      data: c
    };
    if (this.hls.trigger(p.BUFFER_APPENDING, h), e.dropped && e.independent && !i) {
      if (r)
        return;
      this.flushBufferGap(t);
    }
  }
  flushBufferGap(e) {
    const t = this.media;
    if (!t)
      return;
    if (!le.isBuffered(t, t.currentTime)) {
      this.flushMainBuffer(0, e.start);
      return;
    }
    const i = t.currentTime, n = le.bufferInfo(t, i, 0), r = e.duration, a = Math.min(this.config.maxFragLookUpTolerance * 2, r * 0.25), o = Math.max(Math.min(e.start - a, n.end - a), i + a);
    e.start - o > a && this.flushMainBuffer(o, e.start);
  }
  getFwdBufferInfo(e, t) {
    const i = this.getLoadPosition();
    return U(i) ? this.getFwdBufferInfoAtPos(e, i, t) : null;
  }
  getFwdBufferInfoAtPos(e, t, i) {
    const {
      config: {
        maxBufferHole: n
      }
    } = this, r = le.bufferInfo(e, t, n);
    if (r.len === 0 && r.nextStart !== void 0) {
      const a = this.fragmentTracker.getBufferedFrag(t, i);
      if (a && r.nextStart < a.end)
        return le.bufferInfo(e, t, Math.max(r.nextStart, n));
    }
    return r;
  }
  getMaxBufferLength(e) {
    const {
      config: t
    } = this;
    let i;
    return e ? i = Math.max(8 * t.maxBufferSize / e, t.maxBufferLength) : i = t.maxBufferLength, Math.min(i, t.maxMaxBufferLength);
  }
  reduceMaxBufferLength(e, t) {
    const i = this.config, n = Math.max(Math.min(e - t, i.maxBufferLength), t), r = Math.max(e - t * 3, i.maxMaxBufferLength / 2, n);
    return r >= n ? (i.maxMaxBufferLength = r, this.warn(`Reduce max buffer length to ${r}s`), !0) : !1;
  }
  getAppendedFrag(e, t = G.MAIN) {
    const i = this.fragmentTracker.getAppendedFrag(e, G.MAIN);
    return i && "fragment" in i ? i.fragment : i;
  }
  getNextFragment(e, t) {
    const i = t.fragments, n = i.length;
    if (!n)
      return null;
    const {
      config: r
    } = this, a = i[0].start;
    let o;
    if (t.live) {
      const l = r.initialLiveManifestSize;
      if (n < l)
        return this.warn(`Not enough fragments to start playback (have: ${n}, need: ${l})`), null;
      (!t.PTSKnown && !this.startFragRequested && this.startPosition === -1 || e < a) && (o = this.getInitialLiveFragment(t, i), this.startPosition = this.nextLoadPosition = o ? this.hls.liveSyncPosition || o.start : e);
    } else e <= a && (o = i[0]);
    if (!o) {
      const l = r.lowLatencyMode ? t.partEnd : t.fragmentEnd;
      o = this.getFragmentAtPosition(e, l, t);
    }
    return this.mapToInitFragWhenRequired(o);
  }
  isLoopLoading(e, t) {
    const i = this.fragmentTracker.getState(e);
    return (i === ve.OK || i === ve.PARTIAL && !!e.gap) && this.nextLoadPosition > t;
  }
  getNextFragmentLoopLoading(e, t, i, n, r) {
    const a = e.gap, o = this.getNextFragment(this.nextLoadPosition, t);
    if (o === null)
      return o;
    if (e = o, a && e && !e.gap && i.nextStart) {
      const l = this.getFwdBufferInfoAtPos(this.mediaBuffer ? this.mediaBuffer : this.media, i.nextStart, n);
      if (l !== null && i.len + l.len >= r)
        return this.log(`buffer full after gaps in "${n}" playlist starting at sn: ${e.sn}`), null;
    }
    return e;
  }
  mapToInitFragWhenRequired(e) {
    return e != null && e.initSegment && !(e != null && e.initSegment.data) && !this.bitrateTest ? e.initSegment : e;
  }
  getNextPart(e, t, i) {
    let n = -1, r = !1, a = !0;
    for (let o = 0, l = e.length; o < l; o++) {
      const c = e[o];
      if (a = a && !c.independent, n > -1 && i < c.start)
        break;
      const h = c.loaded;
      h ? n = -1 : (r || c.independent || a) && c.fragment === t && (n = o), r = h;
    }
    return n;
  }
  loadedEndOfParts(e, t) {
    const i = e[e.length - 1];
    return i && t > i.start && i.loaded;
  }
  /*
   This method is used find the best matching first fragment for a live playlist. This fragment is used to calculate the
   "sliding" of the playlist, which is its offset from the start of playback. After sliding we can compute the real
   start and end times for each fragment in the playlist (after which this method will not need to be called).
  */
  getInitialLiveFragment(e, t) {
    const i = this.fragPrevious;
    let n = null;
    if (i) {
      if (e.hasProgramDateTime && (this.log(`Live playlist, switching playlist, load frag with same PDT: ${i.programDateTime}`), n = yc(t, i.endProgramDateTime, this.config.maxFragLookUpTolerance)), !n) {
        const r = i.sn + 1;
        if (r >= e.startSN && r <= e.endSN) {
          const a = t[r - e.startSN];
          i.cc === a.cc && (n = a, this.log(`Live playlist, switching playlist, load frag with next SN: ${n.sn}`));
        }
        n || (n = vc(t, i.cc), n && this.log(`Live playlist, switching playlist, load frag with same CC: ${n.sn}`));
      }
    } else {
      const r = this.hls.liveSyncPosition;
      r !== null && (n = this.getFragmentAtPosition(r, this.bitrateTest ? e.fragmentEnd : e.edge, e));
    }
    return n;
  }
  /*
  This method finds the best matching fragment given the provided position.
   */
  getFragmentAtPosition(e, t, i) {
    const {
      config: n
    } = this;
    let {
      fragPrevious: r
    } = this, {
      fragments: a,
      endSN: o
    } = i;
    const {
      fragmentHint: l
    } = i, {
      maxFragLookUpTolerance: c
    } = n, h = i.partList, u = !!(n.lowLatencyMode && h != null && h.length && l);
    u && l && !this.bitrateTest && (a = a.concat(l), o = l.sn);
    let d;
    if (e < t) {
      const g = e > t - c ? 0 : c;
      d = bi(r, a, e, g);
    } else
      d = a[a.length - 1];
    if (d) {
      const g = d.sn - i.startSN, f = this.fragmentTracker.getState(d);
      if ((f === ve.OK || f === ve.PARTIAL && d.gap) && (r = d), r && d.sn === r.sn && (!u || h[0].fragment.sn > d.sn) && r && d.level === r.level) {
        const y = a[g + 1];
        d.sn < o && this.fragmentTracker.getState(y) !== ve.OK ? d = y : d = null;
      }
    }
    return d;
  }
  synchronizeToLiveEdge(e) {
    const {
      config: t,
      media: i
    } = this;
    if (!i)
      return;
    const n = this.hls.liveSyncPosition, r = i.currentTime, a = e.fragments[0].start, o = e.edge, l = r >= a - t.maxFragLookUpTolerance && r <= o;
    if (n !== null && i.duration > n && (r < n || !l)) {
      const c = t.liveMaxLatencyDuration !== void 0 ? t.liveMaxLatencyDuration : t.liveMaxLatencyDurationCount * e.targetduration;
      (!l && i.readyState < 4 || r < o - c) && (this.loadedmetadata || (this.nextLoadPosition = n), i.readyState && (this.warn(`Playback: ${r.toFixed(3)} is located too far from the end of live sliding playlist: ${o}, reset currentTime to : ${n.toFixed(3)}`), i.currentTime = n));
    }
  }
  alignPlaylists(e, t, i) {
    const n = e.fragments.length;
    if (!n)
      return this.warn("No fragments in live playlist"), 0;
    const r = e.fragments[0].start, a = !t, o = e.alignedSliding && U(r);
    if (a || !o && !r) {
      const {
        fragPrevious: l
      } = this;
      Bc(l, i, e);
      const c = e.fragments[0].start;
      return this.log(`Live playlist sliding: ${c.toFixed(2)} start-sn: ${t ? t.startSN : "na"}->${e.startSN} prev-sn: ${l ? l.sn : "na"} fragments: ${n}`), c;
    }
    return r;
  }
  waitForCdnTuneIn(e) {
    return e.live && e.canBlockReload && e.partTarget && e.tuneInGoal > Math.max(e.partHoldBack, e.partTarget * 3);
  }
  setStartPosition(e, t) {
    let i = this.startPosition;
    if (i < t && (i = -1), i === -1 || this.lastCurrentTime === -1) {
      const n = this.startTimeOffset !== null, r = n ? this.startTimeOffset : e.startTimeOffset;
      r !== null && U(r) ? (i = t + r, r < 0 && (i += e.totalduration), i = Math.min(Math.max(t, i), t + e.totalduration), this.log(`Start time offset ${r} found in ${n ? "multivariant" : "media"} playlist, adjust startPosition to ${i}`), this.startPosition = i) : e.live ? i = this.hls.liveSyncPosition || t : this.startPosition = i = 0, this.lastCurrentTime = i;
    }
    this.nextLoadPosition = i;
  }
  getLoadPosition() {
    const {
      media: e
    } = this;
    let t = 0;
    return this.loadedmetadata && e ? t = e.currentTime : this.nextLoadPosition && (t = this.nextLoadPosition), t;
  }
  handleFragLoadAborted(e, t) {
    this.transmuxer && e.sn !== "initSegment" && e.stats.aborted && (this.warn(`Fragment ${e.sn}${t ? " part " + t.index : ""} of level ${e.level} was aborted`), this.resetFragmentLoading(e));
  }
  resetFragmentLoading(e) {
    (!this.fragCurrent || !this.fragContextChanged(e) && this.state !== D.FRAG_LOADING_WAITING_RETRY) && (this.state = D.IDLE);
  }
  onFragmentOrKeyLoadError(e, t) {
    if (t.chunkMeta && !t.frag) {
      const h = this.getCurrentContext(t.chunkMeta);
      h && (t.frag = h.frag);
    }
    const i = t.frag;
    if (!i || i.type !== e || !this.levels)
      return;
    if (this.fragContextChanged(i)) {
      var n;
      this.warn(`Frag load error must match current frag to retry ${i.url} > ${(n = this.fragCurrent) == null ? void 0 : n.url}`);
      return;
    }
    const r = t.details === I.FRAG_GAP;
    r && this.fragmentTracker.fragBuffered(i, !0);
    const a = t.errorAction, {
      action: o,
      retryCount: l = 0,
      retryConfig: c
    } = a || {};
    if (a && o === Se.RetryRequest && c) {
      this.resetStartWhenNotLoaded(this.levelLastLoaded);
      const h = Ms(c, l);
      this.warn(`Fragment ${i.sn} of ${e} ${i.level} errored with ${t.details}, retrying loading ${l + 1}/${c.maxNumRetry} in ${h}ms`), a.resolved = !0, this.retryDate = self.performance.now() + h, this.state = D.FRAG_LOADING_WAITING_RETRY;
    } else if (c && a)
      if (this.resetFragmentErrors(e), l < c.maxNumRetry)
        !r && o !== Se.RemoveAlternatePermanently && (a.resolved = !0);
      else {
        S.warn(`${t.details} reached or exceeded max retry (${l})`);
        return;
      }
    else (a == null ? void 0 : a.action) === Se.SendAlternateToPenaltyBox ? this.state = D.WAITING_LEVEL : this.state = D.ERROR;
    this.tickImmediate();
  }
  reduceLengthAndFlushBuffer(e) {
    if (this.state === D.PARSING || this.state === D.PARSED) {
      const t = e.frag, i = e.parent, n = this.getFwdBufferInfo(this.mediaBuffer, i), r = n && n.len > 0.5;
      r && this.reduceMaxBufferLength(n.len, (t == null ? void 0 : t.duration) || 10);
      const a = !r;
      return a && this.warn(`Buffer full error while media.currentTime is not buffered, flush ${i} buffer`), t && (this.fragmentTracker.removeFragment(t), this.nextLoadPosition = t.start), this.resetLoadingState(), a;
    }
    return !1;
  }
  resetFragmentErrors(e) {
    e === G.AUDIO && (this.fragCurrent = null), this.loadedmetadata || (this.startFragRequested = !1), this.state !== D.STOPPED && (this.state = D.IDLE);
  }
  afterBufferFlushed(e, t, i) {
    if (!e)
      return;
    const n = le.getBuffered(e);
    this.fragmentTracker.detectEvictedFragments(t, n, i), this.state === D.ENDED && this.resetLoadingState();
  }
  resetLoadingState() {
    this.log("Reset loading state"), this.fragCurrent = null, this.fragPrevious = null, this.state = D.IDLE;
  }
  resetStartWhenNotLoaded(e) {
    if (!this.loadedmetadata) {
      this.startFragRequested = !1;
      const t = e ? e.details : null;
      t != null && t.live ? (this.startPosition = -1, this.setStartPosition(t, 0), this.resetLoadingState()) : this.nextLoadPosition = this.startPosition;
    }
  }
  resetWhenMissingContext(e) {
    this.warn(`The loading context changed while buffering fragment ${e.sn} of level ${e.level}. This chunk will not be buffered.`), this.removeUnbufferedFrags(), this.resetStartWhenNotLoaded(this.levelLastLoaded), this.resetLoadingState();
  }
  removeUnbufferedFrags(e = 0) {
    this.fragmentTracker.removeFragmentsInRange(e, 1 / 0, this.playlistType, !1, !0);
  }
  updateLevelTiming(e, t, i, n) {
    var r;
    const a = i.details;
    if (!a) {
      this.warn("level.details undefined");
      return;
    }
    if (!Object.keys(e.elementaryStreams).reduce((l, c) => {
      const h = e.elementaryStreams[c];
      if (h) {
        const u = h.endPTS - h.startPTS;
        if (u <= 0)
          return this.warn(`Could not parse fragment ${e.sn} ${c} duration reliably (${u})`), l || !1;
        const d = n ? 0 : ea(a, e, h.startPTS, h.endPTS, h.startDTS, h.endDTS);
        return this.hls.trigger(p.LEVEL_PTS_UPDATED, {
          details: a,
          level: i,
          drift: d,
          type: c,
          frag: e,
          start: h.startPTS,
          end: h.endPTS
        }), !0;
      }
      return l;
    }, !1) && ((r = this.transmuxer) == null ? void 0 : r.error) === null) {
      const l = new Error(`Found no media in fragment ${e.sn} of level ${e.level} resetting transmuxer to fallback to playlist timing`);
      if (i.fragmentError === 0 && (i.fragmentError++, e.gap = !0, this.fragmentTracker.removeFragment(e), this.fragmentTracker.fragBuffered(e, !0)), this.warn(l.message), this.hls.trigger(p.ERROR, {
        type: V.MEDIA_ERROR,
        details: I.FRAG_PARSING_ERROR,
        fatal: !1,
        error: l,
        frag: e,
        reason: `Found no media in msn ${e.sn} of level "${i.url}"`
      }), !this.hls)
        return;
      this.resetTransmuxer();
    }
    this.state = D.PARSED, this.hls.trigger(p.FRAG_PARSED, {
      frag: e,
      part: t
    });
  }
  resetTransmuxer() {
    this.transmuxer && (this.transmuxer.destroy(), this.transmuxer = null);
  }
  recoverWorkerError(e) {
    e.event === "demuxerWorker" && (this.fragmentTracker.removeAllFragments(), this.resetTransmuxer(), this.resetStartWhenNotLoaded(this.levelLastLoaded), this.resetLoadingState());
  }
  set state(e) {
    const t = this._state;
    t !== e && (this._state = e, this.log(`${t}->${e}`));
  }
  get state() {
    return this._state;
  }
}
class oa {
  constructor() {
    this.chunks = [], this.dataLength = 0;
  }
  push(e) {
    this.chunks.push(e), this.dataLength += e.length;
  }
  flush() {
    const {
      chunks: e,
      dataLength: t
    } = this;
    let i;
    if (e.length)
      e.length === 1 ? i = e[0] : i = qc(e, t);
    else return new Uint8Array(0);
    return this.reset(), i;
  }
  reset() {
    this.chunks.length = 0, this.dataLength = 0;
  }
}
function qc(s, e) {
  const t = new Uint8Array(e);
  let i = 0;
  for (let n = 0; n < s.length; n++) {
    const r = s[n];
    t.set(r, i), i += r.length;
  }
  return t;
}
function zc() {
  return typeof __HLS_WORKER_BUNDLE__ == "function";
}
function Xc() {
  const s = new self.Blob([`var exports={};var module={exports:exports};function define(f){f()};define.amd=true;(${__HLS_WORKER_BUNDLE__.toString()})(true);`], {
    type: "text/javascript"
  }), e = self.URL.createObjectURL(s);
  return {
    worker: new self.Worker(e),
    objectURL: e
  };
}
function Qc(s) {
  const e = new self.URL(s, self.location.href).href;
  return {
    worker: new self.Worker(e),
    scriptURL: e
  };
}
function Be(s = "", e = 9e4) {
  return {
    type: s,
    id: -1,
    pid: -1,
    inputTimeScale: e,
    sequenceNumber: -1,
    samples: [],
    dropped: 0
  };
}
class Gs {
  constructor() {
    this._audioTrack = void 0, this._id3Track = void 0, this.frameIndex = 0, this.cachedData = null, this.basePTS = null, this.initPTS = null, this.lastPTS = null;
  }
  resetInitSegment(e, t, i, n) {
    this._id3Track = {
      type: "id3",
      id: 3,
      pid: -1,
      inputTimeScale: 9e4,
      sequenceNumber: 0,
      samples: [],
      dropped: 0
    };
  }
  resetTimeStamp(e) {
    this.initPTS = e, this.resetContiguity();
  }
  resetContiguity() {
    this.basePTS = null, this.lastPTS = null, this.frameIndex = 0;
  }
  canParse(e, t) {
    return !1;
  }
  appendFrame(e, t, i) {
  }
  // feed incoming data to the front of the parsing pipeline
  demux(e, t) {
    this.cachedData && (e = ke(this.cachedData, e), this.cachedData = null);
    let i = kt(e, 0), n = i ? i.length : 0, r;
    const a = this._audioTrack, o = this._id3Track, l = i ? Fs(i) : void 0, c = e.length;
    for ((this.basePTS === null || this.frameIndex === 0 && U(l)) && (this.basePTS = Jc(l, t, this.initPTS), this.lastPTS = this.basePTS), this.lastPTS === null && (this.lastPTS = this.basePTS), i && i.length > 0 && o.samples.push({
      pts: this.lastPTS,
      dts: this.lastPTS,
      data: i,
      type: Fe.audioId3,
      duration: Number.POSITIVE_INFINITY
    }); n < c; ) {
      if (this.canParse(e, n)) {
        const h = this.appendFrame(a, e, n);
        h ? (this.frameIndex++, this.lastPTS = h.sample.pts, n += h.length, r = n) : n = c;
      } else El(e, n) ? (i = kt(e, n), o.samples.push({
        pts: this.lastPTS,
        dts: this.lastPTS,
        data: i,
        type: Fe.audioId3,
        duration: Number.POSITIVE_INFINITY
      }), n += i.length, r = n) : n++;
      if (n === c && r !== c) {
        const h = lt(e, r);
        this.cachedData ? this.cachedData = ke(this.cachedData, h) : this.cachedData = h;
      }
    }
    return {
      audioTrack: a,
      videoTrack: Be(),
      id3Track: o,
      textTrack: Be()
    };
  }
  demuxSampleAes(e, t, i) {
    return Promise.reject(new Error(`[${this}] This demuxer does not support Sample-AES decryption`));
  }
  flush(e) {
    const t = this.cachedData;
    return t && (this.cachedData = null, this.demux(t, 0)), {
      audioTrack: this._audioTrack,
      videoTrack: Be(),
      id3Track: this._id3Track,
      textTrack: Be()
    };
  }
  destroy() {
  }
}
const Jc = (s, e, t) => {
  if (U(s))
    return s * 90;
  const i = t ? t.baseTime * 9e4 / t.timescale : 0;
  return e * 9e4 + i;
};
function Zc(s, e, t, i) {
  let n, r, a, o;
  const l = navigator.userAgent.toLowerCase(), c = i, h = [96e3, 88200, 64e3, 48e3, 44100, 32e3, 24e3, 22050, 16e3, 12e3, 11025, 8e3, 7350];
  n = ((e[t + 2] & 192) >>> 6) + 1;
  const u = (e[t + 2] & 60) >>> 2;
  if (u > h.length - 1) {
    const d = new Error(`invalid ADTS sampling index:${u}`);
    s.emit(p.ERROR, p.ERROR, {
      type: V.MEDIA_ERROR,
      details: I.FRAG_PARSING_ERROR,
      fatal: !0,
      error: d,
      reason: d.message
    });
    return;
  }
  return a = (e[t + 2] & 1) << 2, a |= (e[t + 3] & 192) >>> 6, S.log(`manifest codec:${i}, ADTS type:${n}, samplingIndex:${u}`), /firefox/i.test(l) ? u >= 6 ? (n = 5, o = new Array(4), r = u - 3) : (n = 2, o = new Array(2), r = u) : l.indexOf("android") !== -1 ? (n = 2, o = new Array(2), r = u) : (n = 5, o = new Array(4), i && (i.indexOf("mp4a.40.29") !== -1 || i.indexOf("mp4a.40.5") !== -1) || !i && u >= 6 ? r = u - 3 : ((i && i.indexOf("mp4a.40.2") !== -1 && (u >= 6 && a === 1 || /vivaldi/i.test(l)) || !i && a === 1) && (n = 2, o = new Array(2)), r = u)), o[0] = n << 3, o[0] |= (u & 14) >> 1, o[1] |= (u & 1) << 7, o[1] |= a << 3, n === 5 && (o[1] |= (r & 14) >> 1, o[2] = (r & 1) << 7, o[2] |= 8, o[3] = 0), {
    config: o,
    samplerate: h[u],
    channelCount: a,
    codec: "mp4a.40." + n,
    manifestCodec: c
  };
}
function la(s, e) {
  return s[e] === 255 && (s[e + 1] & 246) === 240;
}
function ca(s, e) {
  return s[e + 1] & 1 ? 7 : 9;
}
function Hs(s, e) {
  return (s[e + 3] & 3) << 11 | s[e + 4] << 3 | (s[e + 5] & 224) >>> 5;
}
function eh(s, e) {
  return e + 5 < s.length;
}
function Si(s, e) {
  return e + 1 < s.length && la(s, e);
}
function th(s, e) {
  return eh(s, e) && la(s, e) && Hs(s, e) <= s.length - e;
}
function ih(s, e) {
  if (Si(s, e)) {
    const t = ca(s, e);
    if (e + t >= s.length)
      return !1;
    const i = Hs(s, e);
    if (i <= t)
      return !1;
    const n = e + i;
    return n === s.length || Si(s, n);
  }
  return !1;
}
function ha(s, e, t, i, n) {
  if (!s.samplerate) {
    const r = Zc(e, t, i, n);
    if (!r)
      return;
    s.config = r.config, s.samplerate = r.samplerate, s.channelCount = r.channelCount, s.codec = r.codec, s.manifestCodec = r.manifestCodec, S.log(`parsed codec:${s.codec}, rate:${r.samplerate}, channels:${r.channelCount}`);
  }
}
function ua(s) {
  return 1024 * 9e4 / s;
}
function sh(s, e) {
  const t = ca(s, e);
  if (e + t <= s.length) {
    const i = Hs(s, e) - t;
    if (i > 0)
      return {
        headerLength: t,
        frameLength: i
      };
  }
}
function da(s, e, t, i, n) {
  const r = ua(s.samplerate), a = i + n * r, o = sh(e, t);
  let l;
  if (o) {
    const {
      frameLength: u,
      headerLength: d
    } = o, g = d + u, f = Math.max(0, t + g - e.length);
    f ? (l = new Uint8Array(g - d), l.set(e.subarray(t + d, e.length), 0)) : l = e.subarray(t + d, t + g);
    const m = {
      unit: l,
      pts: a
    };
    return f || s.samples.push(m), {
      sample: m,
      length: g,
      missing: f
    };
  }
  const c = e.length - t;
  return l = new Uint8Array(c), l.set(e.subarray(t, e.length), 0), {
    sample: {
      unit: l,
      pts: a
    },
    length: c,
    missing: -1
  };
}
let jt = null;
const nh = [32, 64, 96, 128, 160, 192, 224, 256, 288, 320, 352, 384, 416, 448, 32, 48, 56, 64, 80, 96, 112, 128, 160, 192, 224, 256, 320, 384, 32, 40, 48, 56, 64, 80, 96, 112, 128, 160, 192, 224, 256, 320, 32, 48, 56, 64, 80, 96, 112, 128, 144, 160, 176, 192, 224, 256, 8, 16, 24, 32, 40, 48, 56, 64, 80, 96, 112, 128, 144, 160], rh = [44100, 48e3, 32e3, 22050, 24e3, 16e3, 11025, 12e3, 8e3], ah = [
  // MPEG 2.5
  [
    0,
    // Reserved
    72,
    // Layer3
    144,
    // Layer2
    12
    // Layer1
  ],
  // Reserved
  [
    0,
    // Reserved
    0,
    // Layer3
    0,
    // Layer2
    0
    // Layer1
  ],
  // MPEG 2
  [
    0,
    // Reserved
    72,
    // Layer3
    144,
    // Layer2
    12
    // Layer1
  ],
  // MPEG 1
  [
    0,
    // Reserved
    144,
    // Layer3
    144,
    // Layer2
    12
    // Layer1
  ]
], oh = [
  0,
  // Reserved
  1,
  // Layer3
  1,
  // Layer2
  4
  // Layer1
];
function fa(s, e, t, i, n) {
  if (t + 24 > e.length)
    return;
  const r = ga(e, t);
  if (r && t + r.frameLength <= e.length) {
    const a = r.samplesPerFrame * 9e4 / r.sampleRate, o = i + n * a, l = {
      unit: e.subarray(t, t + r.frameLength),
      pts: o,
      dts: o
    };
    return s.config = [], s.channelCount = r.channelCount, s.samplerate = r.sampleRate, s.samples.push(l), {
      sample: l,
      length: r.frameLength,
      missing: 0
    };
  }
}
function ga(s, e) {
  const t = s[e + 1] >> 3 & 3, i = s[e + 1] >> 1 & 3, n = s[e + 2] >> 4 & 15, r = s[e + 2] >> 2 & 3;
  if (t !== 1 && n !== 0 && n !== 15 && r !== 3) {
    const a = s[e + 2] >> 1 & 1, o = s[e + 3] >> 6, l = t === 3 ? 3 - i : i === 3 ? 3 : 4, c = nh[l * 14 + n - 1] * 1e3, u = rh[(t === 3 ? 0 : t === 2 ? 1 : 2) * 3 + r], d = o === 3 ? 1 : 2, g = ah[t][i], f = oh[i], m = g * 8 * f, y = Math.floor(g * c / u + a) * f;
    if (jt === null) {
      const v = (navigator.userAgent || "").match(/Chrome\/(\d+)/i);
      jt = v ? parseInt(v[1]) : 0;
    }
    return !!jt && jt <= 87 && i === 2 && c >= 224e3 && o === 0 && (s[e + 3] = s[e + 3] | 128), {
      sampleRate: u,
      channelCount: d,
      frameLength: y,
      samplesPerFrame: m
    };
  }
}
function Ks(s, e) {
  return s[e] === 255 && (s[e + 1] & 224) === 224 && (s[e + 1] & 6) !== 0;
}
function ma(s, e) {
  return e + 1 < s.length && Ks(s, e);
}
function lh(s, e) {
  return Ks(s, e) && 4 <= s.length - e;
}
function pa(s, e) {
  if (e + 1 < s.length && Ks(s, e)) {
    const i = ga(s, e);
    let n = 4;
    i != null && i.frameLength && (n = i.frameLength);
    const r = e + n;
    return r === s.length || ma(s, r);
  }
  return !1;
}
class ch extends Gs {
  constructor(e, t) {
    super(), this.observer = void 0, this.config = void 0, this.observer = e, this.config = t;
  }
  resetInitSegment(e, t, i, n) {
    super.resetInitSegment(e, t, i, n), this._audioTrack = {
      container: "audio/adts",
      type: "audio",
      id: 2,
      pid: -1,
      sequenceNumber: 0,
      segmentCodec: "aac",
      samples: [],
      manifestCodec: t,
      duration: n,
      inputTimeScale: 9e4,
      dropped: 0
    };
  }
  // Source for probe info - https://wiki.multimedia.cx/index.php?title=ADTS
  static probe(e) {
    if (!e)
      return !1;
    const t = kt(e, 0);
    let i = (t == null ? void 0 : t.length) || 0;
    if (pa(e, i))
      return !1;
    for (let n = e.length; i < n; i++)
      if (ih(e, i))
        return S.log("ADTS sync word found !"), !0;
    return !1;
  }
  canParse(e, t) {
    return th(e, t);
  }
  appendFrame(e, t, i) {
    ha(e, this.observer, t, i, e.manifestCodec);
    const n = da(e, t, i, this.basePTS, this.frameIndex);
    if (n && n.missing === 0)
      return n;
  }
}
const hh = /\/emsg[-/]ID3/i;
class uh {
  constructor(e, t) {
    this.remainderData = null, this.timeOffset = 0, this.config = void 0, this.videoTrack = void 0, this.audioTrack = void 0, this.id3Track = void 0, this.txtTrack = void 0, this.config = t;
  }
  resetTimeStamp() {
  }
  resetInitSegment(e, t, i, n) {
    const r = this.videoTrack = Be("video", 1), a = this.audioTrack = Be("audio", 1), o = this.txtTrack = Be("text", 1);
    if (this.id3Track = Be("id3", 1), this.timeOffset = 0, !(e != null && e.byteLength))
      return;
    const l = Yr(e);
    if (l.video) {
      const {
        id: c,
        timescale: h,
        codec: u
      } = l.video;
      r.id = c, r.timescale = o.timescale = h, r.codec = u;
    }
    if (l.audio) {
      const {
        id: c,
        timescale: h,
        codec: u
      } = l.audio;
      a.id = c, a.timescale = h, a.codec = u;
    }
    o.id = Kr.text, r.sampleDuration = 0, r.duration = a.duration = n;
  }
  resetContiguity() {
    this.remainderData = null;
  }
  static probe(e) {
    return wl(e);
  }
  demux(e, t) {
    this.timeOffset = t;
    let i = e;
    const n = this.videoTrack, r = this.txtTrack;
    if (this.config.progressive) {
      this.remainderData && (i = ke(this.remainderData, e));
      const o = Ml(i);
      this.remainderData = o.remainder, n.samples = o.valid || new Uint8Array();
    } else
      n.samples = i;
    const a = this.extractID3Track(n, t);
    return r.samples = fn(t, n), {
      videoTrack: n,
      audioTrack: this.audioTrack,
      id3Track: a,
      textTrack: this.txtTrack
    };
  }
  flush() {
    const e = this.timeOffset, t = this.videoTrack, i = this.txtTrack;
    t.samples = this.remainderData || new Uint8Array(), this.remainderData = null;
    const n = this.extractID3Track(t, this.timeOffset);
    return i.samples = fn(e, t), {
      videoTrack: t,
      audioTrack: Be(),
      id3Track: n,
      textTrack: Be()
    };
  }
  extractID3Track(e, t) {
    const i = this.id3Track;
    if (e.samples.length) {
      const n = z(e.samples, ["emsg"]);
      n && n.forEach((r) => {
        const a = Bl(r);
        if (hh.test(a.schemeIdUri)) {
          const o = U(a.presentationTime) ? a.presentationTime / a.timeScale : t + a.presentationTimeDelta / a.timeScale;
          let l = a.eventDuration === 4294967295 ? Number.POSITIVE_INFINITY : a.eventDuration / a.timeScale;
          l <= 1e-3 && (l = Number.POSITIVE_INFINITY);
          const c = a.payload;
          i.samples.push({
            data: c,
            len: c.byteLength,
            dts: o,
            pts: o,
            type: Fe.emsg,
            duration: l
          });
        }
      });
    }
    return i;
  }
  demuxSampleAes(e, t, i) {
    return Promise.reject(new Error("The MP4 demuxer does not support SAMPLE-AES decryption"));
  }
  destroy() {
  }
}
const ya = (s, e) => {
  let t = 0, i = 5;
  e += i;
  const n = new Uint32Array(1), r = new Uint32Array(1), a = new Uint8Array(1);
  for (; i > 0; ) {
    a[0] = s[e];
    const o = Math.min(i, 8), l = 8 - o;
    r[0] = 4278190080 >>> 24 + l << l, n[0] = (a[0] & r[0]) >> l, t = t ? t << o | n[0] : n[0], e += 1, i -= o;
  }
  return t;
};
class dh extends Gs {
  constructor(e) {
    super(), this.observer = void 0, this.observer = e;
  }
  resetInitSegment(e, t, i, n) {
    super.resetInitSegment(e, t, i, n), this._audioTrack = {
      container: "audio/ac-3",
      type: "audio",
      id: 2,
      pid: -1,
      sequenceNumber: 0,
      segmentCodec: "ac3",
      samples: [],
      manifestCodec: t,
      duration: n,
      inputTimeScale: 9e4,
      dropped: 0
    };
  }
  canParse(e, t) {
    return t + 64 < e.length;
  }
  appendFrame(e, t, i) {
    const n = Ta(e, t, i, this.basePTS, this.frameIndex);
    if (n !== -1)
      return {
        sample: e.samples[e.samples.length - 1],
        length: n,
        missing: 0
      };
  }
  static probe(e) {
    if (!e)
      return !1;
    const t = kt(e, 0);
    if (!t)
      return !1;
    const i = t.length;
    return e[i] === 11 && e[i + 1] === 119 && Fs(t) !== void 0 && // check the bsid to confirm ac-3
    ya(e, i) < 16;
  }
}
function Ta(s, e, t, i, n) {
  if (t + 8 > e.length || e[t] !== 11 || e[t + 1] !== 119)
    return -1;
  const r = e[t + 4] >> 6;
  if (r >= 3)
    return -1;
  const o = [48e3, 44100, 32e3][r], l = e[t + 4] & 63, h = [64, 69, 96, 64, 70, 96, 80, 87, 120, 80, 88, 120, 96, 104, 144, 96, 105, 144, 112, 121, 168, 112, 122, 168, 128, 139, 192, 128, 140, 192, 160, 174, 240, 160, 175, 240, 192, 208, 288, 192, 209, 288, 224, 243, 336, 224, 244, 336, 256, 278, 384, 256, 279, 384, 320, 348, 480, 320, 349, 480, 384, 417, 576, 384, 418, 576, 448, 487, 672, 448, 488, 672, 512, 557, 768, 512, 558, 768, 640, 696, 960, 640, 697, 960, 768, 835, 1152, 768, 836, 1152, 896, 975, 1344, 896, 976, 1344, 1024, 1114, 1536, 1024, 1115, 1536, 1152, 1253, 1728, 1152, 1254, 1728, 1280, 1393, 1920, 1280, 1394, 1920][l * 3 + r] * 2;
  if (t + h > e.length)
    return -1;
  const u = e[t + 6] >> 5;
  let d = 0;
  u === 2 ? d += 2 : (u & 1 && u !== 1 && (d += 2), u & 4 && (d += 2));
  const g = (e[t + 6] << 8 | e[t + 7]) >> 12 - d & 1, m = [2, 1, 2, 3, 3, 4, 4, 5][u] + g, y = e[t + 5] >> 3, T = e[t + 5] & 7, b = new Uint8Array([r << 6 | y << 1 | T >> 2, (T & 3) << 6 | u << 3 | g << 2 | l >> 4, l << 4 & 224]), v = 1536 / o * 9e4, A = i + n * v, x = e.subarray(t, t + h);
  return s.config = b, s.channelCount = m, s.samplerate = o, s.samples.push({
    unit: x,
    pts: A
  }), h;
}
class fh {
  constructor() {
    this.VideoSample = null;
  }
  createVideoSample(e, t, i, n) {
    return {
      key: e,
      frame: !1,
      pts: t,
      dts: i,
      units: [],
      debug: n,
      length: 0
    };
  }
  getLastNalUnit(e) {
    var t;
    let i = this.VideoSample, n;
    if ((!i || i.units.length === 0) && (i = e[e.length - 1]), (t = i) != null && t.units) {
      const r = i.units;
      n = r[r.length - 1];
    }
    return n;
  }
  pushAccessUnit(e, t) {
    if (e.units.length && e.frame) {
      if (e.pts === void 0) {
        const i = t.samples, n = i.length;
        if (n) {
          const r = i[n - 1];
          e.pts = r.pts, e.dts = r.dts;
        } else {
          t.dropped++;
          return;
        }
      }
      t.samples.push(e);
    }
    e.debug.length && S.log(e.pts + "/" + e.dts + ":" + e.debug);
  }
}
class Gn {
  constructor(e) {
    this.data = void 0, this.bytesAvailable = void 0, this.word = void 0, this.bitsAvailable = void 0, this.data = e, this.bytesAvailable = e.byteLength, this.word = 0, this.bitsAvailable = 0;
  }
  // ():void
  loadWord() {
    const e = this.data, t = this.bytesAvailable, i = e.byteLength - t, n = new Uint8Array(4), r = Math.min(4, t);
    if (r === 0)
      throw new Error("no bytes available");
    n.set(e.subarray(i, i + r)), this.word = new DataView(n.buffer).getUint32(0), this.bitsAvailable = r * 8, this.bytesAvailable -= r;
  }
  // (count:int):void
  skipBits(e) {
    let t;
    e = Math.min(e, this.bytesAvailable * 8 + this.bitsAvailable), this.bitsAvailable > e ? (this.word <<= e, this.bitsAvailable -= e) : (e -= this.bitsAvailable, t = e >> 3, e -= t << 3, this.bytesAvailable -= t, this.loadWord(), this.word <<= e, this.bitsAvailable -= e);
  }
  // (size:int):uint
  readBits(e) {
    let t = Math.min(this.bitsAvailable, e);
    const i = this.word >>> 32 - t;
    if (e > 32 && S.error("Cannot read more than 32 bits at a time"), this.bitsAvailable -= t, this.bitsAvailable > 0)
      this.word <<= t;
    else if (this.bytesAvailable > 0)
      this.loadWord();
    else
      throw new Error("no bits available");
    return t = e - t, t > 0 && this.bitsAvailable ? i << t | this.readBits(t) : i;
  }
  // ():uint
  skipLZ() {
    let e;
    for (e = 0; e < this.bitsAvailable; ++e)
      if ((this.word & 2147483648 >>> e) !== 0)
        return this.word <<= e, this.bitsAvailable -= e, e;
    return this.loadWord(), e + this.skipLZ();
  }
  // ():void
  skipUEG() {
    this.skipBits(1 + this.skipLZ());
  }
  // ():void
  skipEG() {
    this.skipBits(1 + this.skipLZ());
  }
  // ():uint
  readUEG() {
    const e = this.skipLZ();
    return this.readBits(e + 1) - 1;
  }
  // ():int
  readEG() {
    const e = this.readUEG();
    return 1 & e ? 1 + e >>> 1 : -1 * (e >>> 1);
  }
  // Some convenience functions
  // :Boolean
  readBoolean() {
    return this.readBits(1) === 1;
  }
  // ():int
  readUByte() {
    return this.readBits(8);
  }
  // ():int
  readUShort() {
    return this.readBits(16);
  }
  // ():int
  readUInt() {
    return this.readBits(32);
  }
  /**
   * Advance the ExpGolomb decoder past a scaling list. The scaling
   * list is optionally transmitted as part of a sequence parameter
   * set and is not relevant to transmuxing.
   * @param count the number of entries in this scaling list
   * @see Recommendation ITU-T H.264, Section 7.3.2.1.1.1
   */
  skipScalingList(e) {
    let t = 8, i = 8, n;
    for (let r = 0; r < e; r++)
      i !== 0 && (n = this.readEG(), i = (t + n + 256) % 256), t = i === 0 ? t : i;
  }
  /**
   * Read a sequence parameter set and return some interesting video
   * properties. A sequence parameter set is the H264 metadata that
   * describes the properties of upcoming video frames.
   * @returns an object with configuration parsed from the
   * sequence parameter set, including the dimensions of the
   * associated video frames.
   */
  readSPS() {
    let e = 0, t = 0, i = 0, n = 0, r, a, o;
    const l = this.readUByte.bind(this), c = this.readBits.bind(this), h = this.readUEG.bind(this), u = this.readBoolean.bind(this), d = this.skipBits.bind(this), g = this.skipEG.bind(this), f = this.skipUEG.bind(this), m = this.skipScalingList.bind(this);
    l();
    const y = l();
    if (c(5), d(3), l(), f(), y === 100 || y === 110 || y === 122 || y === 244 || y === 44 || y === 83 || y === 86 || y === 118 || y === 128) {
      const w = h();
      if (w === 3 && d(1), f(), f(), d(1), u())
        for (a = w !== 3 ? 8 : 12, o = 0; o < a; o++)
          u() && (o < 6 ? m(16) : m(64));
    }
    f();
    const T = h();
    if (T === 0)
      h();
    else if (T === 1)
      for (d(1), g(), g(), r = h(), o = 0; o < r; o++)
        g();
    f(), d(1);
    const b = h(), v = h(), A = c(1);
    A === 0 && d(1), d(1), u() && (e = h(), t = h(), i = h(), n = h());
    let x = [1, 1];
    if (u() && u())
      switch (l()) {
        case 1:
          x = [1, 1];
          break;
        case 2:
          x = [12, 11];
          break;
        case 3:
          x = [10, 11];
          break;
        case 4:
          x = [16, 11];
          break;
        case 5:
          x = [40, 33];
          break;
        case 6:
          x = [24, 11];
          break;
        case 7:
          x = [20, 11];
          break;
        case 8:
          x = [32, 11];
          break;
        case 9:
          x = [80, 33];
          break;
        case 10:
          x = [18, 11];
          break;
        case 11:
          x = [15, 11];
          break;
        case 12:
          x = [64, 33];
          break;
        case 13:
          x = [160, 99];
          break;
        case 14:
          x = [4, 3];
          break;
        case 15:
          x = [3, 2];
          break;
        case 16:
          x = [2, 1];
          break;
        case 255: {
          x = [l() << 8 | l(), l() << 8 | l()];
          break;
        }
      }
    return {
      width: Math.ceil((b + 1) * 16 - e * 2 - t * 2),
      height: (2 - A) * (v + 1) * 16 - (A ? 2 : 4) * (i + n),
      pixelRatio: x
    };
  }
  readSliceType() {
    return this.readUByte(), this.readUEG(), this.readUEG();
  }
}
class gh extends fh {
  parseAVCPES(e, t, i, n, r) {
    const a = this.parseAVCNALu(e, i.data);
    let o = this.VideoSample, l, c = !1;
    i.data = null, o && a.length && !e.audFound && (this.pushAccessUnit(o, e), o = this.VideoSample = this.createVideoSample(!1, i.pts, i.dts, "")), a.forEach((h) => {
      var u;
      switch (h.type) {
        // NDR
        case 1: {
          let m = !1;
          l = !0;
          const y = h.data;
          if (c && y.length > 4) {
            const T = new Gn(y).readSliceType();
            (T === 2 || T === 4 || T === 7 || T === 9) && (m = !0);
          }
          if (m) {
            var d;
            (d = o) != null && d.frame && !o.key && (this.pushAccessUnit(o, e), o = this.VideoSample = null);
          }
          o || (o = this.VideoSample = this.createVideoSample(!0, i.pts, i.dts, "")), o.frame = !0, o.key = m;
          break;
        }
        case 5:
          l = !0, (u = o) != null && u.frame && !o.key && (this.pushAccessUnit(o, e), o = this.VideoSample = null), o || (o = this.VideoSample = this.createVideoSample(!0, i.pts, i.dts, "")), o.key = !0, o.frame = !0;
          break;
        // SEI
        case 6: {
          l = !0, qr(h.data, 1, i.pts, t.samples);
          break;
        }
        case 7: {
          var g, f;
          l = !0, c = !0;
          const m = h.data, T = new Gn(m).readSPS();
          if (!e.sps || e.width !== T.width || e.height !== T.height || ((g = e.pixelRatio) == null ? void 0 : g[0]) !== T.pixelRatio[0] || ((f = e.pixelRatio) == null ? void 0 : f[1]) !== T.pixelRatio[1]) {
            e.width = T.width, e.height = T.height, e.pixelRatio = T.pixelRatio, e.sps = [m], e.duration = r;
            const b = m.subarray(1, 4);
            let v = "avc1.";
            for (let A = 0; A < 3; A++) {
              let x = b[A].toString(16);
              x.length < 2 && (x = "0" + x), v += x;
            }
            e.codec = v;
          }
          break;
        }
        // PPS
        case 8:
          l = !0, e.pps = [h.data];
          break;
        // AUD
        case 9:
          l = !0, e.audFound = !0, o && this.pushAccessUnit(o, e), o = this.VideoSample = this.createVideoSample(!1, i.pts, i.dts, "");
          break;
        // Filler Data
        case 12:
          l = !0;
          break;
        default:
          l = !1, o && (o.debug += "unknown NAL " + h.type + " ");
          break;
      }
      o && l && o.units.push(h);
    }), n && o && (this.pushAccessUnit(o, e), this.VideoSample = null);
  }
  parseAVCNALu(e, t) {
    const i = t.byteLength;
    let n = e.naluState || 0;
    const r = n, a = [];
    let o = 0, l, c, h, u = -1, d = 0;
    for (n === -1 && (u = 0, d = t[0] & 31, n = 0, o = 1); o < i; ) {
      if (l = t[o++], !n) {
        n = l ? 0 : 1;
        continue;
      }
      if (n === 1) {
        n = l ? 0 : 2;
        continue;
      }
      if (!l)
        n = 3;
      else if (l === 1) {
        if (c = o - n - 1, u >= 0) {
          const g = {
            data: t.subarray(u, c),
            type: d
          };
          a.push(g);
        } else {
          const g = this.getLastNalUnit(e.samples);
          g && (r && o <= 4 - r && g.state && (g.data = g.data.subarray(0, g.data.byteLength - r)), c > 0 && (g.data = ke(g.data, t.subarray(0, c)), g.state = 0));
        }
        o < i ? (h = t[o] & 31, u = o, d = h, n = 0) : n = -1;
      } else
        n = 0;
    }
    if (u >= 0 && n >= 0) {
      const g = {
        data: t.subarray(u, i),
        type: d,
        state: n
      };
      a.push(g);
    }
    if (a.length === 0) {
      const g = this.getLastNalUnit(e.samples);
      g && (g.data = ke(g.data, t));
    }
    return e.naluState = n, a;
  }
}
class mh {
  constructor(e, t, i) {
    this.keyData = void 0, this.decrypter = void 0, this.keyData = i, this.decrypter = new Bs(t, {
      removePKCS7Padding: !1
    });
  }
  decryptBuffer(e) {
    return this.decrypter.decrypt(e, this.keyData.key.buffer, this.keyData.iv.buffer);
  }
  // AAC - encrypt all full 16 bytes blocks starting from offset 16
  decryptAacSample(e, t, i) {
    const n = e[t].unit;
    if (n.length <= 16)
      return;
    const r = n.subarray(16, n.length - n.length % 16), a = r.buffer.slice(r.byteOffset, r.byteOffset + r.length);
    this.decryptBuffer(a).then((o) => {
      const l = new Uint8Array(o);
      n.set(l, 16), this.decrypter.isSync() || this.decryptAacSamples(e, t + 1, i);
    });
  }
  decryptAacSamples(e, t, i) {
    for (; ; t++) {
      if (t >= e.length) {
        i();
        return;
      }
      if (!(e[t].unit.length < 32) && (this.decryptAacSample(e, t, i), !this.decrypter.isSync()))
        return;
    }
  }
  // AVC - encrypt one 16 bytes block out of ten, starting from offset 32
  getAvcEncryptedData(e) {
    const t = Math.floor((e.length - 48) / 160) * 16 + 16, i = new Int8Array(t);
    let n = 0;
    for (let r = 32; r < e.length - 16; r += 160, n += 16)
      i.set(e.subarray(r, r + 16), n);
    return i;
  }
  getAvcDecryptedUnit(e, t) {
    const i = new Uint8Array(t);
    let n = 0;
    for (let r = 32; r < e.length - 16; r += 160, n += 16)
      e.set(i.subarray(n, n + 16), r);
    return e;
  }
  decryptAvcSample(e, t, i, n, r) {
    const a = zr(r.data), o = this.getAvcEncryptedData(a);
    this.decryptBuffer(o.buffer).then((l) => {
      r.data = this.getAvcDecryptedUnit(a, l), this.decrypter.isSync() || this.decryptAvcSamples(e, t, i + 1, n);
    });
  }
  decryptAvcSamples(e, t, i, n) {
    if (e instanceof Uint8Array)
      throw new Error("Cannot decrypt samples of type Uint8Array");
    for (; ; t++, i = 0) {
      if (t >= e.length) {
        n();
        return;
      }
      const r = e[t].units;
      for (; !(i >= r.length); i++) {
        const a = r[i];
        if (!(a.data.length <= 48 || a.type !== 1 && a.type !== 5) && (this.decryptAvcSample(e, t, i, n, a), !this.decrypter.isSync()))
          return;
      }
    }
  }
}
const ye = 188;
class Je {
  constructor(e, t, i) {
    this.observer = void 0, this.config = void 0, this.typeSupported = void 0, this.sampleAes = null, this.pmtParsed = !1, this.audioCodec = void 0, this.videoCodec = void 0, this._duration = 0, this._pmtId = -1, this._videoTrack = void 0, this._audioTrack = void 0, this._id3Track = void 0, this._txtTrack = void 0, this.aacOverFlow = null, this.remainderData = null, this.videoParser = void 0, this.observer = e, this.config = t, this.typeSupported = i, this.videoParser = new gh();
  }
  static probe(e) {
    const t = Je.syncOffset(e);
    return t > 0 && S.warn(`MPEG2-TS detected but first sync word found @ offset ${t}`), t !== -1;
  }
  static syncOffset(e) {
    const t = e.length;
    let i = Math.min(ye * 5, t - ye) + 1, n = 0;
    for (; n < i; ) {
      let r = !1, a = -1, o = 0;
      for (let l = n; l < t; l += ye)
        if (e[l] === 71 && (t - l === ye || e[l + ye] === 71)) {
          if (o++, a === -1 && (a = l, a !== 0 && (i = Math.min(a + ye * 99, e.length - ye) + 1)), r || (r = vs(e, l) === 0), r && o > 1 && (a === 0 && o > 2 || l + ye > i))
            return a;
        } else {
          if (o)
            return -1;
          break;
        }
      n++;
    }
    return -1;
  }
  /**
   * Creates a track model internal to demuxer used to drive remuxing input
   */
  static createTrack(e, t) {
    return {
      container: e === "video" || e === "audio" ? "video/mp2t" : void 0,
      type: e,
      id: Kr[e],
      pid: -1,
      inputTimeScale: 9e4,
      sequenceNumber: 0,
      samples: [],
      dropped: 0,
      duration: e === "audio" ? t : void 0
    };
  }
  /**
   * Initializes a new init segment on the demuxer/remuxer interface. Needed for discontinuities/track-switches (or at stream start)
   * Resets all internal track instances of the demuxer.
   */
  resetInitSegment(e, t, i, n) {
    this.pmtParsed = !1, this._pmtId = -1, this._videoTrack = Je.createTrack("video"), this._audioTrack = Je.createTrack("audio", n), this._id3Track = Je.createTrack("id3"), this._txtTrack = Je.createTrack("text"), this._audioTrack.segmentCodec = "aac", this.aacOverFlow = null, this.remainderData = null, this.audioCodec = t, this.videoCodec = i, this._duration = n;
  }
  resetTimeStamp() {
  }
  resetContiguity() {
    const {
      _audioTrack: e,
      _videoTrack: t,
      _id3Track: i
    } = this;
    e && (e.pesData = null), t && (t.pesData = null), i && (i.pesData = null), this.aacOverFlow = null, this.remainderData = null;
  }
  demux(e, t, i = !1, n = !1) {
    i || (this.sampleAes = null);
    let r;
    const a = this._videoTrack, o = this._audioTrack, l = this._id3Track, c = this._txtTrack;
    let h = a.pid, u = a.pesData, d = o.pid, g = l.pid, f = o.pesData, m = l.pesData, y = null, T = this.pmtParsed, b = this._pmtId, v = e.length;
    if (this.remainderData && (e = ke(this.remainderData, e), v = e.length, this.remainderData = null), v < ye && !n)
      return this.remainderData = e, {
        audioTrack: o,
        videoTrack: a,
        id3Track: l,
        textTrack: c
      };
    const A = Math.max(0, Je.syncOffset(e));
    v -= (v - A) % ye, v < e.byteLength && !n && (this.remainderData = new Uint8Array(e.buffer, v, e.buffer.byteLength - v));
    let x = 0;
    for (let R = A; R < v; R += ye)
      if (e[R] === 71) {
        const k = !!(e[R + 1] & 64), _ = vs(e, R), C = (e[R + 3] & 48) >> 4;
        let P;
        if (C > 1) {
          if (P = R + 5 + e[R + 4], P === R + ye)
            continue;
        } else
          P = R + 4;
        switch (_) {
          case h:
            k && (u && (r = ft(u)) && this.videoParser.parseAVCPES(a, c, r, !1, this._duration), u = {
              data: [],
              size: 0
            }), u && (u.data.push(e.subarray(P, R + ye)), u.size += R + ye - P);
            break;
          case d:
            if (k) {
              if (f && (r = ft(f)))
                switch (o.segmentCodec) {
                  case "aac":
                    this.parseAACPES(o, r);
                    break;
                  case "mp3":
                    this.parseMPEGPES(o, r);
                    break;
                  case "ac3":
                    this.parseAC3PES(o, r);
                    break;
                }
              f = {
                data: [],
                size: 0
              };
            }
            f && (f.data.push(e.subarray(P, R + ye)), f.size += R + ye - P);
            break;
          case g:
            k && (m && (r = ft(m)) && this.parseID3PES(l, r), m = {
              data: [],
              size: 0
            }), m && (m.data.push(e.subarray(P, R + ye)), m.size += R + ye - P);
            break;
          case 0:
            k && (P += e[P] + 1), b = this._pmtId = ph(e, P);
            break;
          case b: {
            k && (P += e[P] + 1);
            const q = yh(e, P, this.typeSupported, i, this.observer);
            h = q.videoPid, h > 0 && (a.pid = h, a.segmentCodec = q.segmentVideoCodec), d = q.audioPid, d > 0 && (o.pid = d, o.segmentCodec = q.segmentAudioCodec), g = q.id3Pid, g > 0 && (l.pid = g), y !== null && !T && (S.warn(`MPEG-TS PMT found at ${R} after unknown PID '${y}'. Backtracking to sync byte @${A} to parse all TS packets.`), y = null, R = A - 188), T = this.pmtParsed = !0;
            break;
          }
          case 17:
          case 8191:
            break;
          default:
            y = _;
            break;
        }
      } else
        x++;
    x > 0 && Ai(this.observer, new Error(`Found ${x} TS packet/s that do not start with 0x47`)), a.pesData = u, o.pesData = f, l.pesData = m;
    const w = {
      audioTrack: o,
      videoTrack: a,
      id3Track: l,
      textTrack: c
    };
    return n && this.extractRemainingSamples(w), w;
  }
  flush() {
    const {
      remainderData: e
    } = this;
    this.remainderData = null;
    let t;
    return e ? t = this.demux(e, -1, !1, !0) : t = {
      videoTrack: this._videoTrack,
      audioTrack: this._audioTrack,
      id3Track: this._id3Track,
      textTrack: this._txtTrack
    }, this.extractRemainingSamples(t), this.sampleAes ? this.decrypt(t, this.sampleAes) : t;
  }
  extractRemainingSamples(e) {
    const {
      audioTrack: t,
      videoTrack: i,
      id3Track: n,
      textTrack: r
    } = e, a = i.pesData, o = t.pesData, l = n.pesData;
    let c;
    if (a && (c = ft(a)) ? (this.videoParser.parseAVCPES(i, r, c, !0, this._duration), i.pesData = null) : i.pesData = a, o && (c = ft(o))) {
      switch (t.segmentCodec) {
        case "aac":
          this.parseAACPES(t, c);
          break;
        case "mp3":
          this.parseMPEGPES(t, c);
          break;
        case "ac3":
          this.parseAC3PES(t, c);
          break;
      }
      t.pesData = null;
    } else
      o != null && o.size && S.log("last AAC PES packet truncated,might overlap between fragments"), t.pesData = o;
    l && (c = ft(l)) ? (this.parseID3PES(n, c), n.pesData = null) : n.pesData = l;
  }
  demuxSampleAes(e, t, i) {
    const n = this.demux(e, i, !0, !this.config.progressive), r = this.sampleAes = new mh(this.observer, this.config, t);
    return this.decrypt(n, r);
  }
  decrypt(e, t) {
    return new Promise((i) => {
      const {
        audioTrack: n,
        videoTrack: r
      } = e;
      n.samples && n.segmentCodec === "aac" ? t.decryptAacSamples(n.samples, 0, () => {
        r.samples ? t.decryptAvcSamples(r.samples, 0, 0, () => {
          i(e);
        }) : i(e);
      }) : r.samples && t.decryptAvcSamples(r.samples, 0, 0, () => {
        i(e);
      });
    });
  }
  destroy() {
    this._duration = 0;
  }
  parseAACPES(e, t) {
    let i = 0;
    const n = this.aacOverFlow;
    let r = t.data;
    if (n) {
      this.aacOverFlow = null;
      const u = n.missing, d = n.sample.unit.byteLength;
      if (u === -1)
        r = ke(n.sample.unit, r);
      else {
        const g = d - u;
        n.sample.unit.set(r.subarray(0, u), g), e.samples.push(n.sample), i = n.missing;
      }
    }
    let a, o;
    for (a = i, o = r.length; a < o - 1 && !Si(r, a); a++)
      ;
    if (a !== i) {
      let u;
      const d = a < o - 1;
      if (d ? u = `AAC PES did not start with ADTS header,offset:${a}` : u = "No ADTS header found in AAC PES", Ai(this.observer, new Error(u), d), !d)
        return;
    }
    ha(e, this.observer, r, a, this.audioCodec);
    let l;
    if (t.pts !== void 0)
      l = t.pts;
    else if (n) {
      const u = ua(e.samplerate);
      l = n.sample.pts + u;
    } else {
      S.warn("[tsdemuxer]: AAC PES unknown PTS");
      return;
    }
    let c = 0, h;
    for (; a < o; )
      if (h = da(e, r, a, l, c), a += h.length, h.missing) {
        this.aacOverFlow = h;
        break;
      } else
        for (c++; a < o - 1 && !Si(r, a); a++)
          ;
  }
  parseMPEGPES(e, t) {
    const i = t.data, n = i.length;
    let r = 0, a = 0;
    const o = t.pts;
    if (o === void 0) {
      S.warn("[tsdemuxer]: MPEG PES unknown PTS");
      return;
    }
    for (; a < n; )
      if (ma(i, a)) {
        const l = fa(e, i, a, o, r);
        if (l)
          a += l.length, r++;
        else
          break;
      } else
        a++;
  }
  parseAC3PES(e, t) {
    {
      const i = t.data, n = t.pts;
      if (n === void 0) {
        S.warn("[tsdemuxer]: AC3 PES unknown PTS");
        return;
      }
      const r = i.length;
      let a = 0, o = 0, l;
      for (; o < r && (l = Ta(e, i, o, n, a++)) > 0; )
        o += l;
    }
  }
  parseID3PES(e, t) {
    if (t.pts === void 0) {
      S.warn("[tsdemuxer]: ID3 PES unknown PTS");
      return;
    }
    const i = fe({}, t, {
      type: this._videoTrack ? Fe.emsg : Fe.audioId3,
      duration: Number.POSITIVE_INFINITY
    });
    e.samples.push(i);
  }
}
function vs(s, e) {
  return ((s[e + 1] & 31) << 8) + s[e + 2];
}
function ph(s, e) {
  return (s[e + 10] & 31) << 8 | s[e + 11];
}
function yh(s, e, t, i, n) {
  const r = {
    audioPid: -1,
    videoPid: -1,
    id3Pid: -1,
    segmentVideoCodec: "avc",
    segmentAudioCodec: "aac"
  }, a = (s[e + 1] & 15) << 8 | s[e + 2], o = e + 3 + a - 4, l = (s[e + 10] & 15) << 8 | s[e + 11];
  for (e += 12 + l; e < o; ) {
    const c = vs(s, e), h = (s[e + 3] & 15) << 8 | s[e + 4];
    switch (s[e]) {
      case 207:
        if (!i) {
          qi("ADTS AAC");
          break;
        }
      /* falls through */
      case 15:
        r.audioPid === -1 && (r.audioPid = c);
        break;
      // Packetized metadata (ID3)
      case 21:
        r.id3Pid === -1 && (r.id3Pid = c);
        break;
      case 219:
        if (!i) {
          qi("H.264");
          break;
        }
      /* falls through */
      case 27:
        r.videoPid === -1 && (r.videoPid = c, r.segmentVideoCodec = "avc");
        break;
      // ISO/IEC 11172-3 (MPEG-1 audio)
      // or ISO/IEC 13818-3 (MPEG-2 halved sample rate audio)
      case 3:
      case 4:
        !t.mpeg && !t.mp3 ? S.log("MPEG audio found, not supported in this browser") : r.audioPid === -1 && (r.audioPid = c, r.segmentAudioCodec = "mp3");
        break;
      case 193:
        if (!i) {
          qi("AC-3");
          break;
        }
      /* falls through */
      case 129:
        t.ac3 ? r.audioPid === -1 && (r.audioPid = c, r.segmentAudioCodec = "ac3") : S.log("AC-3 audio found, not supported in this browser");
        break;
      case 6:
        if (r.audioPid === -1 && h > 0) {
          let u = e + 5, d = h;
          for (; d > 2; ) {
            switch (s[u]) {
              case 106:
                t.ac3 !== !0 ? S.log("AC-3 audio found, not supported in this browser for now") : (r.audioPid = c, r.segmentAudioCodec = "ac3");
                break;
            }
            const f = s[u + 1] + 2;
            u += f, d -= f;
          }
        }
        break;
      case 194:
      // SAMPLE-AES EC3
      /* falls through */
      case 135:
        return Ai(n, new Error("Unsupported EC-3 in M2TS found")), r;
      case 36:
        return Ai(n, new Error("Unsupported HEVC in M2TS found")), r;
    }
    e += h + 5;
  }
  return r;
}
function Ai(s, e, t) {
  S.warn(`parsing error: ${e.message}`), s.emit(p.ERROR, p.ERROR, {
    type: V.MEDIA_ERROR,
    details: I.FRAG_PARSING_ERROR,
    fatal: !1,
    levelRetry: t,
    error: e,
    reason: e.message
  });
}
function qi(s) {
  S.log(`${s} with AES-128-CBC encryption found in unencrypted stream`);
}
function ft(s) {
  let e = 0, t, i, n, r, a;
  const o = s.data;
  if (!s || s.size === 0)
    return null;
  for (; o[0].length < 19 && o.length > 1; )
    o[0] = ke(o[0], o[1]), o.splice(1, 1);
  if (t = o[0], (t[0] << 16) + (t[1] << 8) + t[2] === 1) {
    if (i = (t[4] << 8) + t[5], i && i > s.size - 6)
      return null;
    const c = t[7];
    c & 192 && (r = (t[9] & 14) * 536870912 + // 1 << 29
    (t[10] & 255) * 4194304 + // 1 << 22
    (t[11] & 254) * 16384 + // 1 << 14
    (t[12] & 255) * 128 + // 1 << 7
    (t[13] & 254) / 2, c & 64 ? (a = (t[14] & 14) * 536870912 + // 1 << 29
    (t[15] & 255) * 4194304 + // 1 << 22
    (t[16] & 254) * 16384 + // 1 << 14
    (t[17] & 255) * 128 + // 1 << 7
    (t[18] & 254) / 2, r - a > 60 * 9e4 && (S.warn(`${Math.round((r - a) / 9e4)}s delta between PTS and DTS, align them`), r = a)) : a = r), n = t[8];
    let h = n + 9;
    if (s.size <= h)
      return null;
    s.size -= h;
    const u = new Uint8Array(s.size);
    for (let d = 0, g = o.length; d < g; d++) {
      t = o[d];
      let f = t.byteLength;
      if (h)
        if (h > f) {
          h -= f;
          continue;
        } else
          t = t.subarray(h), f -= h, h = 0;
      u.set(t, e), e += f;
    }
    return i && (i -= n + 3), {
      data: u,
      pts: r,
      dts: a,
      len: i
    };
  }
  return null;
}
class Th extends Gs {
  resetInitSegment(e, t, i, n) {
    super.resetInitSegment(e, t, i, n), this._audioTrack = {
      container: "audio/mpeg",
      type: "audio",
      id: 2,
      pid: -1,
      sequenceNumber: 0,
      segmentCodec: "mp3",
      samples: [],
      manifestCodec: t,
      duration: n,
      inputTimeScale: 9e4,
      dropped: 0
    };
  }
  static probe(e) {
    if (!e)
      return !1;
    const t = kt(e, 0);
    let i = (t == null ? void 0 : t.length) || 0;
    if (t && e[i] === 11 && e[i + 1] === 119 && Fs(t) !== void 0 && // check the bsid to confirm ac-3 or ec-3 (not mp3)
    ya(e, i) <= 16)
      return !1;
    for (let n = e.length; i < n; i++)
      if (pa(e, i))
        return S.log("MPEG Audio sync word found !"), !0;
    return !1;
  }
  canParse(e, t) {
    return lh(e, t);
  }
  appendFrame(e, t, i) {
    if (this.basePTS !== null)
      return fa(e, t, i, this.basePTS, this.frameIndex);
  }
}
class Hn {
  static getSilentFrame(e, t) {
    switch (e) {
      case "mp4a.40.2":
        if (t === 1)
          return new Uint8Array([0, 200, 0, 128, 35, 128]);
        if (t === 2)
          return new Uint8Array([33, 0, 73, 144, 2, 25, 0, 35, 128]);
        if (t === 3)
          return new Uint8Array([0, 200, 0, 128, 32, 132, 1, 38, 64, 8, 100, 0, 142]);
        if (t === 4)
          return new Uint8Array([0, 200, 0, 128, 32, 132, 1, 38, 64, 8, 100, 0, 128, 44, 128, 8, 2, 56]);
        if (t === 5)
          return new Uint8Array([0, 200, 0, 128, 32, 132, 1, 38, 64, 8, 100, 0, 130, 48, 4, 153, 0, 33, 144, 2, 56]);
        if (t === 6)
          return new Uint8Array([0, 200, 0, 128, 32, 132, 1, 38, 64, 8, 100, 0, 130, 48, 4, 153, 0, 33, 144, 2, 0, 178, 0, 32, 8, 224]);
        break;
      // handle HE-AAC below (mp4a.40.5 / mp4a.40.29)
      default:
        if (t === 1)
          return new Uint8Array([1, 64, 34, 128, 163, 78, 230, 128, 186, 8, 0, 0, 0, 28, 6, 241, 193, 10, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 94]);
        if (t === 2)
          return new Uint8Array([1, 64, 34, 128, 163, 94, 230, 128, 186, 8, 0, 0, 0, 0, 149, 0, 6, 241, 161, 10, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 94]);
        if (t === 3)
          return new Uint8Array([1, 64, 34, 128, 163, 94, 230, 128, 186, 8, 0, 0, 0, 0, 149, 0, 6, 241, 161, 10, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 94]);
        break;
    }
  }
}
const Qe = Math.pow(2, 32) - 1;
class L {
  static init() {
    L.types = {
      avc1: [],
      // codingname
      avcC: [],
      btrt: [],
      dinf: [],
      dref: [],
      esds: [],
      ftyp: [],
      hdlr: [],
      mdat: [],
      mdhd: [],
      mdia: [],
      mfhd: [],
      minf: [],
      moof: [],
      moov: [],
      mp4a: [],
      ".mp3": [],
      dac3: [],
      "ac-3": [],
      mvex: [],
      mvhd: [],
      pasp: [],
      sdtp: [],
      stbl: [],
      stco: [],
      stsc: [],
      stsd: [],
      stsz: [],
      stts: [],
      tfdt: [],
      tfhd: [],
      traf: [],
      trak: [],
      trun: [],
      trex: [],
      tkhd: [],
      vmhd: [],
      smhd: []
    };
    let e;
    for (e in L.types)
      L.types.hasOwnProperty(e) && (L.types[e] = [e.charCodeAt(0), e.charCodeAt(1), e.charCodeAt(2), e.charCodeAt(3)]);
    const t = new Uint8Array([
      0,
      // version 0
      0,
      0,
      0,
      // flags
      0,
      0,
      0,
      0,
      // pre_defined
      118,
      105,
      100,
      101,
      // handler_type: 'vide'
      0,
      0,
      0,
      0,
      // reserved
      0,
      0,
      0,
      0,
      // reserved
      0,
      0,
      0,
      0,
      // reserved
      86,
      105,
      100,
      101,
      111,
      72,
      97,
      110,
      100,
      108,
      101,
      114,
      0
      // name: 'VideoHandler'
    ]), i = new Uint8Array([
      0,
      // version 0
      0,
      0,
      0,
      // flags
      0,
      0,
      0,
      0,
      // pre_defined
      115,
      111,
      117,
      110,
      // handler_type: 'soun'
      0,
      0,
      0,
      0,
      // reserved
      0,
      0,
      0,
      0,
      // reserved
      0,
      0,
      0,
      0,
      // reserved
      83,
      111,
      117,
      110,
      100,
      72,
      97,
      110,
      100,
      108,
      101,
      114,
      0
      // name: 'SoundHandler'
    ]);
    L.HDLR_TYPES = {
      video: t,
      audio: i
    };
    const n = new Uint8Array([
      0,
      // version 0
      0,
      0,
      0,
      // flags
      0,
      0,
      0,
      1,
      // entry_count
      0,
      0,
      0,
      12,
      // entry_size
      117,
      114,
      108,
      32,
      // 'url' type
      0,
      // version 0
      0,
      0,
      1
      // entry_flags
    ]), r = new Uint8Array([
      0,
      // version
      0,
      0,
      0,
      // flags
      0,
      0,
      0,
      0
      // entry_count
    ]);
    L.STTS = L.STSC = L.STCO = r, L.STSZ = new Uint8Array([
      0,
      // version
      0,
      0,
      0,
      // flags
      0,
      0,
      0,
      0,
      // sample_size
      0,
      0,
      0,
      0
      // sample_count
    ]), L.VMHD = new Uint8Array([
      0,
      // version
      0,
      0,
      1,
      // flags
      0,
      0,
      // graphicsmode
      0,
      0,
      0,
      0,
      0,
      0
      // opcolor
    ]), L.SMHD = new Uint8Array([
      0,
      // version
      0,
      0,
      0,
      // flags
      0,
      0,
      // balance
      0,
      0
      // reserved
    ]), L.STSD = new Uint8Array([
      0,
      // version 0
      0,
      0,
      0,
      // flags
      0,
      0,
      0,
      1
    ]);
    const a = new Uint8Array([105, 115, 111, 109]), o = new Uint8Array([97, 118, 99, 49]), l = new Uint8Array([0, 0, 0, 1]);
    L.FTYP = L.box(L.types.ftyp, a, l, a, o), L.DINF = L.box(L.types.dinf, L.box(L.types.dref, n));
  }
  static box(e, ...t) {
    let i = 8, n = t.length;
    const r = n;
    for (; n--; )
      i += t[n].byteLength;
    const a = new Uint8Array(i);
    for (a[0] = i >> 24 & 255, a[1] = i >> 16 & 255, a[2] = i >> 8 & 255, a[3] = i & 255, a.set(e, 4), n = 0, i = 8; n < r; n++)
      a.set(t[n], i), i += t[n].byteLength;
    return a;
  }
  static hdlr(e) {
    return L.box(L.types.hdlr, L.HDLR_TYPES[e]);
  }
  static mdat(e) {
    return L.box(L.types.mdat, e);
  }
  static mdhd(e, t) {
    t *= e;
    const i = Math.floor(t / (Qe + 1)), n = Math.floor(t % (Qe + 1));
    return L.box(L.types.mdhd, new Uint8Array([
      1,
      // version 1
      0,
      0,
      0,
      // flags
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      2,
      // creation_time
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      3,
      // modification_time
      e >> 24 & 255,
      e >> 16 & 255,
      e >> 8 & 255,
      e & 255,
      // timescale
      i >> 24,
      i >> 16 & 255,
      i >> 8 & 255,
      i & 255,
      n >> 24,
      n >> 16 & 255,
      n >> 8 & 255,
      n & 255,
      85,
      196,
      // 'und' language (undetermined)
      0,
      0
    ]));
  }
  static mdia(e) {
    return L.box(L.types.mdia, L.mdhd(e.timescale, e.duration), L.hdlr(e.type), L.minf(e));
  }
  static mfhd(e) {
    return L.box(L.types.mfhd, new Uint8Array([
      0,
      0,
      0,
      0,
      // flags
      e >> 24,
      e >> 16 & 255,
      e >> 8 & 255,
      e & 255
      // sequence_number
    ]));
  }
  static minf(e) {
    return e.type === "audio" ? L.box(L.types.minf, L.box(L.types.smhd, L.SMHD), L.DINF, L.stbl(e)) : L.box(L.types.minf, L.box(L.types.vmhd, L.VMHD), L.DINF, L.stbl(e));
  }
  static moof(e, t, i) {
    return L.box(L.types.moof, L.mfhd(e), L.traf(i, t));
  }
  static moov(e) {
    let t = e.length;
    const i = [];
    for (; t--; )
      i[t] = L.trak(e[t]);
    return L.box.apply(null, [L.types.moov, L.mvhd(e[0].timescale, e[0].duration)].concat(i).concat(L.mvex(e)));
  }
  static mvex(e) {
    let t = e.length;
    const i = [];
    for (; t--; )
      i[t] = L.trex(e[t]);
    return L.box.apply(null, [L.types.mvex, ...i]);
  }
  static mvhd(e, t) {
    t *= e;
    const i = Math.floor(t / (Qe + 1)), n = Math.floor(t % (Qe + 1)), r = new Uint8Array([
      1,
      // version 1
      0,
      0,
      0,
      // flags
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      2,
      // creation_time
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      3,
      // modification_time
      e >> 24 & 255,
      e >> 16 & 255,
      e >> 8 & 255,
      e & 255,
      // timescale
      i >> 24,
      i >> 16 & 255,
      i >> 8 & 255,
      i & 255,
      n >> 24,
      n >> 16 & 255,
      n >> 8 & 255,
      n & 255,
      0,
      1,
      0,
      0,
      // 1.0 rate
      1,
      0,
      // 1.0 volume
      0,
      0,
      // reserved
      0,
      0,
      0,
      0,
      // reserved
      0,
      0,
      0,
      0,
      // reserved
      0,
      1,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      1,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      64,
      0,
      0,
      0,
      // transformation: unity matrix
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      // pre_defined
      255,
      255,
      255,
      255
      // next_track_ID
    ]);
    return L.box(L.types.mvhd, r);
  }
  static sdtp(e) {
    const t = e.samples || [], i = new Uint8Array(4 + t.length);
    let n, r;
    for (n = 0; n < t.length; n++)
      r = t[n].flags, i[n + 4] = r.dependsOn << 4 | r.isDependedOn << 2 | r.hasRedundancy;
    return L.box(L.types.sdtp, i);
  }
  static stbl(e) {
    return L.box(L.types.stbl, L.stsd(e), L.box(L.types.stts, L.STTS), L.box(L.types.stsc, L.STSC), L.box(L.types.stsz, L.STSZ), L.box(L.types.stco, L.STCO));
  }
  static avc1(e) {
    let t = [], i = [], n, r, a;
    for (n = 0; n < e.sps.length; n++)
      r = e.sps[n], a = r.byteLength, t.push(a >>> 8 & 255), t.push(a & 255), t = t.concat(Array.prototype.slice.call(r));
    for (n = 0; n < e.pps.length; n++)
      r = e.pps[n], a = r.byteLength, i.push(a >>> 8 & 255), i.push(a & 255), i = i.concat(Array.prototype.slice.call(r));
    const o = L.box(L.types.avcC, new Uint8Array([
      1,
      // version
      t[3],
      // profile
      t[4],
      // profile compat
      t[5],
      // level
      255,
      // lengthSizeMinusOne, hard-coded to 4 bytes
      224 | e.sps.length
      // 3bit reserved (111) + numOfSequenceParameterSets
    ].concat(t).concat([
      e.pps.length
      // numOfPictureParameterSets
    ]).concat(i))), l = e.width, c = e.height, h = e.pixelRatio[0], u = e.pixelRatio[1];
    return L.box(
      L.types.avc1,
      new Uint8Array([
        0,
        0,
        0,
        // reserved
        0,
        0,
        0,
        // reserved
        0,
        1,
        // data_reference_index
        0,
        0,
        // pre_defined
        0,
        0,
        // reserved
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        // pre_defined
        l >> 8 & 255,
        l & 255,
        // width
        c >> 8 & 255,
        c & 255,
        // height
        0,
        72,
        0,
        0,
        // horizresolution
        0,
        72,
        0,
        0,
        // vertresolution
        0,
        0,
        0,
        0,
        // reserved
        0,
        1,
        // frame_count
        18,
        100,
        97,
        105,
        108,
        // dailymotion/hls.js
        121,
        109,
        111,
        116,
        105,
        111,
        110,
        47,
        104,
        108,
        115,
        46,
        106,
        115,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        // compressorname
        0,
        24,
        // depth = 24
        17,
        17
      ]),
      // pre_defined = -1
      o,
      L.box(L.types.btrt, new Uint8Array([
        0,
        28,
        156,
        128,
        // bufferSizeDB
        0,
        45,
        198,
        192,
        // maxBitrate
        0,
        45,
        198,
        192
      ])),
      // avgBitrate
      L.box(L.types.pasp, new Uint8Array([
        h >> 24,
        // hSpacing
        h >> 16 & 255,
        h >> 8 & 255,
        h & 255,
        u >> 24,
        // vSpacing
        u >> 16 & 255,
        u >> 8 & 255,
        u & 255
      ]))
    );
  }
  static esds(e) {
    const t = e.config.length;
    return new Uint8Array([
      0,
      // version 0
      0,
      0,
      0,
      // flags
      3,
      // descriptor_type
      23 + t,
      // length
      0,
      1,
      // es_id
      0,
      // stream_priority
      4,
      // descriptor_type
      15 + t,
      // length
      64,
      // codec : mpeg4_audio
      21,
      // stream_type
      0,
      0,
      0,
      // buffer_size
      0,
      0,
      0,
      0,
      // maxBitrate
      0,
      0,
      0,
      0,
      // avgBitrate
      5
      // descriptor_type
    ].concat([t]).concat(e.config).concat([6, 1, 2]));
  }
  static audioStsd(e) {
    const t = e.samplerate;
    return new Uint8Array([
      0,
      0,
      0,
      // reserved
      0,
      0,
      0,
      // reserved
      0,
      1,
      // data_reference_index
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      // reserved
      0,
      e.channelCount,
      // channelcount
      0,
      16,
      // sampleSize:16bits
      0,
      0,
      0,
      0,
      // reserved2
      t >> 8 & 255,
      t & 255,
      //
      0,
      0
    ]);
  }
  static mp4a(e) {
    return L.box(L.types.mp4a, L.audioStsd(e), L.box(L.types.esds, L.esds(e)));
  }
  static mp3(e) {
    return L.box(L.types[".mp3"], L.audioStsd(e));
  }
  static ac3(e) {
    return L.box(L.types["ac-3"], L.audioStsd(e), L.box(L.types.dac3, e.config));
  }
  static stsd(e) {
    return e.type === "audio" ? e.segmentCodec === "mp3" && e.codec === "mp3" ? L.box(L.types.stsd, L.STSD, L.mp3(e)) : e.segmentCodec === "ac3" ? L.box(L.types.stsd, L.STSD, L.ac3(e)) : L.box(L.types.stsd, L.STSD, L.mp4a(e)) : L.box(L.types.stsd, L.STSD, L.avc1(e));
  }
  static tkhd(e) {
    const t = e.id, i = e.duration * e.timescale, n = e.width, r = e.height, a = Math.floor(i / (Qe + 1)), o = Math.floor(i % (Qe + 1));
    return L.box(L.types.tkhd, new Uint8Array([
      1,
      // version 1
      0,
      0,
      7,
      // flags
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      2,
      // creation_time
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      3,
      // modification_time
      t >> 24 & 255,
      t >> 16 & 255,
      t >> 8 & 255,
      t & 255,
      // track_ID
      0,
      0,
      0,
      0,
      // reserved
      a >> 24,
      a >> 16 & 255,
      a >> 8 & 255,
      a & 255,
      o >> 24,
      o >> 16 & 255,
      o >> 8 & 255,
      o & 255,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      // reserved
      0,
      0,
      // layer
      0,
      0,
      // alternate_group
      0,
      0,
      // non-audio track volume
      0,
      0,
      // reserved
      0,
      1,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      1,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      64,
      0,
      0,
      0,
      // transformation: unity matrix
      n >> 8 & 255,
      n & 255,
      0,
      0,
      // width
      r >> 8 & 255,
      r & 255,
      0,
      0
      // height
    ]));
  }
  static traf(e, t) {
    const i = L.sdtp(e), n = e.id, r = Math.floor(t / (Qe + 1)), a = Math.floor(t % (Qe + 1));
    return L.box(
      L.types.traf,
      L.box(L.types.tfhd, new Uint8Array([
        0,
        // version 0
        0,
        0,
        0,
        // flags
        n >> 24,
        n >> 16 & 255,
        n >> 8 & 255,
        n & 255
        // track_ID
      ])),
      L.box(L.types.tfdt, new Uint8Array([
        1,
        // version 1
        0,
        0,
        0,
        // flags
        r >> 24,
        r >> 16 & 255,
        r >> 8 & 255,
        r & 255,
        a >> 24,
        a >> 16 & 255,
        a >> 8 & 255,
        a & 255
      ])),
      L.trun(e, i.length + 16 + // tfhd
      20 + // tfdt
      8 + // traf header
      16 + // mfhd
      8 + // moof header
      8),
      // mdat header
      i
    );
  }
  /**
   * Generate a track box.
   * @param track a track definition
   */
  static trak(e) {
    return e.duration = e.duration || 4294967295, L.box(L.types.trak, L.tkhd(e), L.mdia(e));
  }
  static trex(e) {
    const t = e.id;
    return L.box(L.types.trex, new Uint8Array([
      0,
      // version 0
      0,
      0,
      0,
      // flags
      t >> 24,
      t >> 16 & 255,
      t >> 8 & 255,
      t & 255,
      // track_ID
      0,
      0,
      0,
      1,
      // default_sample_description_index
      0,
      0,
      0,
      0,
      // default_sample_duration
      0,
      0,
      0,
      0,
      // default_sample_size
      0,
      1,
      0,
      1
      // default_sample_flags
    ]));
  }
  static trun(e, t) {
    const i = e.samples || [], n = i.length, r = 12 + 16 * n, a = new Uint8Array(r);
    let o, l, c, h, u, d;
    for (t += 8 + r, a.set([
      e.type === "video" ? 1 : 0,
      // version 1 for video with signed-int sample_composition_time_offset
      0,
      15,
      1,
      // flags
      n >>> 24 & 255,
      n >>> 16 & 255,
      n >>> 8 & 255,
      n & 255,
      // sample_count
      t >>> 24 & 255,
      t >>> 16 & 255,
      t >>> 8 & 255,
      t & 255
      // data_offset
    ], 0), o = 0; o < n; o++)
      l = i[o], c = l.duration, h = l.size, u = l.flags, d = l.cts, a.set([
        c >>> 24 & 255,
        c >>> 16 & 255,
        c >>> 8 & 255,
        c & 255,
        // sample_duration
        h >>> 24 & 255,
        h >>> 16 & 255,
        h >>> 8 & 255,
        h & 255,
        // sample_size
        u.isLeading << 2 | u.dependsOn,
        u.isDependedOn << 6 | u.hasRedundancy << 4 | u.paddingValue << 1 | u.isNonSync,
        u.degradPrio & 61440,
        u.degradPrio & 15,
        // sample_flags
        d >>> 24 & 255,
        d >>> 16 & 255,
        d >>> 8 & 255,
        d & 255
        // sample_composition_time_offset
      ], 12 + 16 * o);
    return L.box(L.types.trun, a);
  }
  static initSegment(e) {
    L.types || L.init();
    const t = L.moov(e);
    return ke(L.FTYP, t);
  }
}
L.types = void 0;
L.HDLR_TYPES = void 0;
L.STTS = void 0;
L.STSC = void 0;
L.STCO = void 0;
L.STSZ = void 0;
L.VMHD = void 0;
L.SMHD = void 0;
L.STSD = void 0;
L.FTYP = void 0;
L.DINF = void 0;
const Ea = 9e4;
function Vs(s, e, t = 1, i = !1) {
  const n = s * e * t;
  return i ? Math.round(n) : n;
}
function Eh(s, e, t = 1, i = !1) {
  return Vs(s, e, 1 / t, i);
}
function Lt(s, e = !1) {
  return Vs(s, 1e3, 1 / Ea, e);
}
function vh(s, e = 1) {
  return Vs(s, Ea, 1 / e);
}
const bh = 10 * 1e3, Kn = 1024, xh = 1152, Sh = 1536;
let gt = null, zi = null;
class ri {
  constructor(e, t, i, n = "") {
    if (this.observer = void 0, this.config = void 0, this.typeSupported = void 0, this.ISGenerated = !1, this._initPTS = null, this._initDTS = null, this.nextAvcDts = null, this.nextAudioPts = null, this.videoSampleDuration = null, this.isAudioContiguous = !1, this.isVideoContiguous = !1, this.videoTrackConfig = void 0, this.observer = e, this.config = t, this.typeSupported = i, this.ISGenerated = !1, gt === null) {
      const a = (navigator.userAgent || "").match(/Chrome\/(\d+)/i);
      gt = a ? parseInt(a[1]) : 0;
    }
    if (zi === null) {
      const r = navigator.userAgent.match(/Safari\/(\d+)/i);
      zi = r ? parseInt(r[1]) : 0;
    }
  }
  destroy() {
    this.config = this.videoTrackConfig = this._initPTS = this._initDTS = null;
  }
  resetTimeStamp(e) {
    S.log("[mp4-remuxer]: initPTS & initDTS reset"), this._initPTS = this._initDTS = e;
  }
  resetNextTimestamp() {
    S.log("[mp4-remuxer]: reset next timestamp"), this.isVideoContiguous = !1, this.isAudioContiguous = !1;
  }
  resetInitSegment() {
    S.log("[mp4-remuxer]: ISGenerated flag reset"), this.ISGenerated = !1, this.videoTrackConfig = void 0;
  }
  getVideoStartPts(e) {
    let t = !1;
    const i = e[0].pts, n = e.reduce((r, a) => {
      let o = a.pts, l = o - r;
      return l < -4294967296 && (t = !0, o = De(o, i), l = o - r), l > 0 ? r : o;
    }, i);
    return t && S.debug("PTS rollover detected"), n;
  }
  remux(e, t, i, n, r, a, o, l) {
    let c, h, u, d, g, f, m = r, y = r;
    const T = e.pid > -1, b = t.pid > -1, v = t.samples.length, A = e.samples.length > 0, x = o && v > 0 || v > 1;
    if ((!T || A) && (!b || x) || this.ISGenerated || o) {
      if (this.ISGenerated) {
        var R, k, _, C;
        const j = this.videoTrackConfig;
        j && (t.width !== j.width || t.height !== j.height || ((R = t.pixelRatio) == null ? void 0 : R[0]) !== ((k = j.pixelRatio) == null ? void 0 : k[0]) || ((_ = t.pixelRatio) == null ? void 0 : _[1]) !== ((C = j.pixelRatio) == null ? void 0 : C[1])) && this.resetInitSegment();
      } else
        u = this.generateIS(e, t, r, a);
      const P = this.isVideoContiguous;
      let q = -1, M;
      if (x && (q = Ah(t.samples), !P && this.config.forceKeyFrameOnDiscontinuity))
        if (f = !0, q > 0) {
          S.warn(`[mp4-remuxer]: Dropped ${q} out of ${v} video samples due to a missing keyframe`);
          const j = this.getVideoStartPts(t.samples);
          t.samples = t.samples.slice(q), t.dropped += q, y += (t.samples[0].pts - j) / t.inputTimeScale, M = y;
        } else q === -1 && (S.warn(`[mp4-remuxer]: No keyframe found out of ${v} video samples`), f = !1);
      if (this.ISGenerated) {
        if (A && x) {
          const j = this.getVideoStartPts(t.samples), H = (De(e.samples[0].pts, j) - j) / t.inputTimeScale;
          m += Math.max(0, H), y += Math.max(0, -H);
        }
        if (A) {
          if (e.samplerate || (S.warn("[mp4-remuxer]: regenerate InitSegment as audio detected"), u = this.generateIS(e, t, r, a)), h = this.remuxAudio(e, m, this.isAudioContiguous, a, b || x || l === G.AUDIO ? y : void 0), x) {
            const j = h ? h.endPTS - h.startPTS : 0;
            t.inputTimeScale || (S.warn("[mp4-remuxer]: regenerate InitSegment as video detected"), u = this.generateIS(e, t, r, a)), c = this.remuxVideo(t, y, P, j);
          }
        } else x && (c = this.remuxVideo(t, y, P, 0));
        c && (c.firstKeyFrame = q, c.independent = q !== -1, c.firstKeyFramePTS = M);
      }
    }
    return this.ISGenerated && this._initPTS && this._initDTS && (i.samples.length && (g = va(i, r, this._initPTS, this._initDTS)), n.samples.length && (d = ba(n, r, this._initPTS))), {
      audio: h,
      video: c,
      initSegment: u,
      independent: f,
      text: d,
      id3: g
    };
  }
  generateIS(e, t, i, n) {
    const r = e.samples, a = t.samples, o = this.typeSupported, l = {}, c = this._initPTS;
    let h = !c || n, u = "audio/mp4", d, g, f;
    if (h && (d = g = 1 / 0), e.config && r.length) {
      switch (e.timescale = e.samplerate, e.segmentCodec) {
        case "mp3":
          o.mpeg ? (u = "audio/mpeg", e.codec = "") : o.mp3 && (e.codec = "mp3");
          break;
        case "ac3":
          e.codec = "ac-3";
          break;
      }
      l.audio = {
        id: "audio",
        container: u,
        codec: e.codec,
        initSegment: e.segmentCodec === "mp3" && o.mpeg ? new Uint8Array(0) : L.initSegment([e]),
        metadata: {
          channelCount: e.channelCount
        }
      }, h && (f = e.inputTimeScale, !c || f !== c.timescale ? d = g = r[0].pts - Math.round(f * i) : h = !1);
    }
    if (t.sps && t.pps && a.length) {
      if (t.timescale = t.inputTimeScale, l.video = {
        id: "main",
        container: "video/mp4",
        codec: t.codec,
        initSegment: L.initSegment([t]),
        metadata: {
          width: t.width,
          height: t.height
        }
      }, h)
        if (f = t.inputTimeScale, !c || f !== c.timescale) {
          const m = this.getVideoStartPts(a), y = Math.round(f * i);
          g = Math.min(g, De(a[0].dts, m) - y), d = Math.min(d, m - y);
        } else
          h = !1;
      this.videoTrackConfig = {
        width: t.width,
        height: t.height,
        pixelRatio: t.pixelRatio
      };
    }
    if (Object.keys(l).length)
      return this.ISGenerated = !0, h ? (this._initPTS = {
        baseTime: d,
        timescale: f
      }, this._initDTS = {
        baseTime: g,
        timescale: f
      }) : d = f = void 0, {
        tracks: l,
        initPTS: d,
        timescale: f
      };
  }
  remuxVideo(e, t, i, n) {
    const r = e.inputTimeScale, a = e.samples, o = [], l = a.length, c = this._initPTS;
    let h = this.nextAvcDts, u = 8, d = this.videoSampleDuration, g, f, m = Number.POSITIVE_INFINITY, y = Number.NEGATIVE_INFINITY, T = !1;
    if (!i || h === null) {
      const B = t * r, N = a[0].pts - De(a[0].dts, a[0].pts);
      gt && h !== null && Math.abs(B - N - h) < 15e3 ? i = !0 : h = B - N;
    }
    const b = c.baseTime * r / c.timescale;
    for (let B = 0; B < l; B++) {
      const N = a[B];
      N.pts = De(N.pts - b, h), N.dts = De(N.dts - b, h), N.dts < a[B > 0 ? B - 1 : B].dts && (T = !0);
    }
    T && a.sort(function(B, N) {
      const te = B.dts - N.dts, X = B.pts - N.pts;
      return te || X;
    }), g = a[0].dts, f = a[a.length - 1].dts;
    const v = f - g, A = v ? Math.round(v / (l - 1)) : d || e.inputTimeScale / 30;
    if (i) {
      const B = g - h, N = B > A, te = B < -1;
      if ((N || te) && (N ? S.warn(`AVC: ${Lt(B, !0)} ms (${B}dts) hole between fragments detected at ${t.toFixed(3)}`) : S.warn(`AVC: ${Lt(-B, !0)} ms (${B}dts) overlapping between fragments detected at ${t.toFixed(3)}`), !te || h >= a[0].pts || gt)) {
        g = h;
        const X = a[0].pts - B;
        if (N)
          a[0].dts = g, a[0].pts = X;
        else
          for (let ne = 0; ne < a.length && !(a[ne].dts > X); ne++)
            a[ne].dts -= B, a[ne].pts -= B;
        S.log(`Video: Initial PTS/DTS adjusted: ${Lt(X, !0)}/${Lt(g, !0)}, delta: ${Lt(B, !0)} ms`);
      }
    }
    g = Math.max(0, g);
    let x = 0, w = 0, R = g;
    for (let B = 0; B < l; B++) {
      const N = a[B], te = N.units, X = te.length;
      let ne = 0;
      for (let de = 0; de < X; de++)
        ne += te[de].data.length;
      w += ne, x += X, N.length = ne, N.dts < R ? (N.dts = R, R += A / 4 | 0 || 1) : R = N.dts, m = Math.min(N.pts, m), y = Math.max(N.pts, y);
    }
    f = a[l - 1].dts;
    const k = w + 4 * x + 8;
    let _;
    try {
      _ = new Uint8Array(k);
    } catch (B) {
      this.observer.emit(p.ERROR, p.ERROR, {
        type: V.MUX_ERROR,
        details: I.REMUX_ALLOC_ERROR,
        fatal: !1,
        error: B,
        bytes: k,
        reason: `fail allocating video mdat ${k}`
      });
      return;
    }
    const C = new DataView(_.buffer);
    C.setUint32(0, k), _.set(L.types.mdat, 4);
    let P = !1, q = Number.POSITIVE_INFINITY, M = Number.POSITIVE_INFINITY, j = Number.NEGATIVE_INFINITY, Y = Number.NEGATIVE_INFINITY;
    for (let B = 0; B < l; B++) {
      const N = a[B], te = N.units;
      let X = 0;
      for (let pe = 0, xe = te.length; pe < xe; pe++) {
        const we = te[pe], xt = we.data, Di = we.data.byteLength;
        C.setUint32(u, Di), u += 4, _.set(xt, u), u += Di, X += 4 + Di;
      }
      let ne;
      if (B < l - 1)
        d = a[B + 1].dts - N.dts, ne = a[B + 1].pts - N.pts;
      else {
        const pe = this.config, xe = B > 0 ? N.dts - a[B - 1].dts : A;
        if (ne = B > 0 ? N.pts - a[B - 1].pts : A, pe.stretchShortVideoTrack && this.nextAudioPts !== null) {
          const we = Math.floor(pe.maxBufferHole * r), xt = (n ? m + n * r : this.nextAudioPts) - N.pts;
          xt > we ? (d = xt - xe, d < 0 ? d = xe : P = !0, S.log(`[mp4-remuxer]: It is approximately ${xt / 90} ms to the next segment; using duration ${d / 90} ms for the last video frame.`)) : d = xe;
        } else
          d = xe;
      }
      const de = Math.round(N.pts - N.dts);
      q = Math.min(q, d), j = Math.max(j, d), M = Math.min(M, ne), Y = Math.max(Y, ne), o.push(new Vn(N.key, d, X, de));
    }
    if (o.length) {
      if (gt) {
        if (gt < 70) {
          const B = o[0].flags;
          B.dependsOn = 2, B.isNonSync = 0;
        }
      } else if (zi && Y - M < j - q && A / j < 0.025 && o[0].cts === 0) {
        S.warn("Found irregular gaps in sample duration. Using PTS instead of DTS to determine MP4 sample duration.");
        let B = g;
        for (let N = 0, te = o.length; N < te; N++) {
          const X = B + o[N].duration, ne = B + o[N].cts;
          if (N < te - 1) {
            const de = X + o[N + 1].cts;
            o[N].duration = de - ne;
          } else
            o[N].duration = N ? o[N - 1].duration : A;
          o[N].cts = 0, B = X;
        }
      }
    }
    d = P || !d ? A : d, this.nextAvcDts = h = f + d, this.videoSampleDuration = d, this.isVideoContiguous = !0;
    const ae = {
      data1: L.moof(e.sequenceNumber++, g, fe({}, e, {
        samples: o
      })),
      data2: _,
      startPTS: m / r,
      endPTS: (y + d) / r,
      startDTS: g / r,
      endDTS: h / r,
      type: "video",
      hasAudio: !1,
      hasVideo: !0,
      nb: o.length,
      dropped: e.dropped
    };
    return e.samples = [], e.dropped = 0, ae;
  }
  getSamplesPerFrame(e) {
    switch (e.segmentCodec) {
      case "mp3":
        return xh;
      case "ac3":
        return Sh;
      default:
        return Kn;
    }
  }
  remuxAudio(e, t, i, n, r) {
    const a = e.inputTimeScale, o = e.samplerate ? e.samplerate : a, l = a / o, c = this.getSamplesPerFrame(e), h = c * l, u = this._initPTS, d = e.segmentCodec === "mp3" && this.typeSupported.mpeg, g = [], f = r !== void 0;
    let m = e.samples, y = d ? 0 : 8, T = this.nextAudioPts || -1;
    const b = t * a, v = u.baseTime * a / u.timescale;
    if (this.isAudioContiguous = i = i || m.length && T > 0 && (n && Math.abs(b - T) < 9e3 || Math.abs(De(m[0].pts - v, b) - T) < 20 * h), m.forEach(function(H) {
      H.pts = De(H.pts - v, b);
    }), !i || T < 0) {
      if (m = m.filter((H) => H.pts >= 0), !m.length)
        return;
      r === 0 ? T = 0 : n && !f ? T = Math.max(0, b) : T = m[0].pts;
    }
    if (e.segmentCodec === "aac") {
      const H = this.config.maxAudioFramesDrift;
      for (let Z = 0, ae = T; Z < m.length; Z++) {
        const B = m[Z], N = B.pts, te = N - ae, X = Math.abs(1e3 * te / a);
        if (te <= -H * h && f)
          Z === 0 && (S.warn(`Audio frame @ ${(N / a).toFixed(3)}s overlaps nextAudioPts by ${Math.round(1e3 * te / a)} ms.`), this.nextAudioPts = T = ae = N);
        else if (te >= H * h && X < bh && f) {
          let ne = Math.round(te / h);
          ae = N - ne * h, ae < 0 && (ne--, ae += h), Z === 0 && (this.nextAudioPts = T = ae), S.warn(`[mp4-remuxer]: Injecting ${ne} audio frame @ ${(ae / a).toFixed(3)}s due to ${Math.round(1e3 * te / a)} ms gap.`);
          for (let de = 0; de < ne; de++) {
            const pe = Math.max(ae, 0);
            let xe = Hn.getSilentFrame(e.manifestCodec || e.codec, e.channelCount);
            xe || (S.log("[mp4-remuxer]: Unable to get silent frame for given audio codec; duplicating last frame instead."), xe = B.unit.subarray()), m.splice(Z, 0, {
              unit: xe,
              pts: pe
            }), ae += h, Z++;
          }
        }
        B.pts = ae, ae += h;
      }
    }
    let A = null, x = null, w, R = 0, k = m.length;
    for (; k--; )
      R += m[k].unit.byteLength;
    for (let H = 0, Z = m.length; H < Z; H++) {
      const ae = m[H], B = ae.unit;
      let N = ae.pts;
      if (x !== null) {
        const X = g[H - 1];
        X.duration = Math.round((N - x) / l);
      } else if (i && e.segmentCodec === "aac" && (N = T), A = N, R > 0) {
        R += y;
        try {
          w = new Uint8Array(R);
        } catch (X) {
          this.observer.emit(p.ERROR, p.ERROR, {
            type: V.MUX_ERROR,
            details: I.REMUX_ALLOC_ERROR,
            fatal: !1,
            error: X,
            bytes: R,
            reason: `fail allocating audio mdat ${R}`
          });
          return;
        }
        d || (new DataView(w.buffer).setUint32(0, R), w.set(L.types.mdat, 4));
      } else
        return;
      w.set(B, y);
      const te = B.byteLength;
      y += te, g.push(new Vn(!0, c, te, 0)), x = N;
    }
    const _ = g.length;
    if (!_)
      return;
    const C = g[g.length - 1];
    this.nextAudioPts = T = x + l * C.duration;
    const P = d ? new Uint8Array(0) : L.moof(e.sequenceNumber++, A / l, fe({}, e, {
      samples: g
    }));
    e.samples = [];
    const q = A / a, M = T / a, Y = {
      data1: P,
      data2: w,
      startPTS: q,
      endPTS: M,
      startDTS: q,
      endDTS: M,
      type: "audio",
      hasAudio: !0,
      hasVideo: !1,
      nb: _
    };
    return this.isAudioContiguous = !0, Y;
  }
  remuxEmptyAudio(e, t, i, n) {
    const r = e.inputTimeScale, a = e.samplerate ? e.samplerate : r, o = r / a, l = this.nextAudioPts, c = this._initDTS, h = c.baseTime * 9e4 / c.timescale, u = (l !== null ? l : n.startDTS * r) + h, d = n.endDTS * r + h, g = o * Kn, f = Math.ceil((d - u) / g), m = Hn.getSilentFrame(e.manifestCodec || e.codec, e.channelCount);
    if (S.warn("[mp4-remuxer]: remux empty Audio"), !m) {
      S.trace("[mp4-remuxer]: Unable to remuxEmptyAudio since we were unable to get a silent frame for given audio codec");
      return;
    }
    const y = [];
    for (let T = 0; T < f; T++) {
      const b = u + T * g;
      y.push({
        unit: m,
        pts: b,
        dts: b
      });
    }
    return e.samples = y, this.remuxAudio(e, t, i, !1);
  }
}
function De(s, e) {
  let t;
  if (e === null)
    return s;
  for (e < s ? t = -8589934592 : t = 8589934592; Math.abs(s - e) > 4294967296; )
    s += t;
  return s;
}
function Ah(s) {
  for (let e = 0; e < s.length; e++)
    if (s[e].key)
      return e;
  return -1;
}
function va(s, e, t, i) {
  const n = s.samples.length;
  if (!n)
    return;
  const r = s.inputTimeScale;
  for (let o = 0; o < n; o++) {
    const l = s.samples[o];
    l.pts = De(l.pts - t.baseTime * r / t.timescale, e * r) / r, l.dts = De(l.dts - i.baseTime * r / i.timescale, e * r) / r;
  }
  const a = s.samples;
  return s.samples = [], {
    samples: a
  };
}
function ba(s, e, t) {
  const i = s.samples.length;
  if (!i)
    return;
  const n = s.inputTimeScale;
  for (let a = 0; a < i; a++) {
    const o = s.samples[a];
    o.pts = De(o.pts - t.baseTime * n / t.timescale, e * n) / n;
  }
  s.samples.sort((a, o) => a.pts - o.pts);
  const r = s.samples;
  return s.samples = [], {
    samples: r
  };
}
class Vn {
  constructor(e, t, i, n) {
    this.size = void 0, this.duration = void 0, this.cts = void 0, this.flags = void 0, this.duration = t, this.size = i, this.cts = n, this.flags = {
      isLeading: 0,
      isDependedOn: 0,
      hasRedundancy: 0,
      degradPrio: 0,
      dependsOn: e ? 2 : 1,
      isNonSync: e ? 0 : 1
    };
  }
}
class Lh {
  constructor() {
    this.emitInitSegment = !1, this.audioCodec = void 0, this.videoCodec = void 0, this.initData = void 0, this.initPTS = null, this.initTracks = void 0, this.lastEndTime = null;
  }
  destroy() {
  }
  resetTimeStamp(e) {
    this.initPTS = e, this.lastEndTime = null;
  }
  resetNextTimestamp() {
    this.lastEndTime = null;
  }
  resetInitSegment(e, t, i, n) {
    this.audioCodec = t, this.videoCodec = i, this.generateInitSegment(kl(e, n)), this.emitInitSegment = !0;
  }
  generateInitSegment(e) {
    let {
      audioCodec: t,
      videoCodec: i
    } = this;
    if (!(e != null && e.byteLength)) {
      this.initTracks = void 0, this.initData = void 0;
      return;
    }
    const n = this.initData = Yr(e);
    n.audio && (t = Wn(n.audio, re.AUDIO)), n.video && (i = Wn(n.video, re.VIDEO));
    const r = {};
    n.audio && n.video ? r.audiovideo = {
      container: "video/mp4",
      codec: t + "," + i,
      initSegment: e,
      id: "main"
    } : n.audio ? r.audio = {
      container: "audio/mp4",
      codec: t,
      initSegment: e,
      id: "audio"
    } : n.video ? r.video = {
      container: "video/mp4",
      codec: i,
      initSegment: e,
      id: "main"
    } : S.warn("[passthrough-remuxer.ts]: initSegment does not contain moov or trak boxes."), this.initTracks = r;
  }
  remux(e, t, i, n, r, a) {
    var o, l;
    let {
      initPTS: c,
      lastEndTime: h
    } = this;
    const u = {
      audio: void 0,
      video: void 0,
      text: n,
      id3: i,
      initSegment: void 0
    };
    U(h) || (h = this.lastEndTime = r || 0);
    const d = t.samples;
    if (!(d != null && d.length))
      return u;
    const g = {
      initPTS: void 0,
      timescale: 1
    };
    let f = this.initData;
    if ((o = f) != null && o.length || (this.generateInitSegment(d), f = this.initData), !((l = f) != null && l.length))
      return S.warn("[passthrough-remuxer.ts]: Failed to generate initSegment."), u;
    this.emitInitSegment && (g.tracks = this.initTracks, this.emitInitSegment = !1);
    const m = _l(d, f), y = Pl(f, d), T = y === null ? r : y;
    (Rh(c, T, r, m) || g.timescale !== c.timescale && a) && (g.initPTS = T - r, c && c.timescale === 1 && S.warn(`Adjusting initPTS by ${g.initPTS - c.baseTime}`), this.initPTS = c = {
      baseTime: g.initPTS,
      timescale: 1
    });
    const b = e ? T - c.baseTime / c.timescale : h, v = b + m;
    Fl(f, d, c.baseTime / c.timescale), m > 0 ? this.lastEndTime = v : (S.warn("Duration parsed from mp4 should be greater than zero"), this.resetNextTimestamp());
    const A = !!f.audio, x = !!f.video;
    let w = "";
    A && (w += "audio"), x && (w += "video");
    const R = {
      data1: d,
      startPTS: b,
      startDTS: b,
      endPTS: v,
      endDTS: v,
      type: w,
      hasAudio: A,
      hasVideo: x,
      nb: 1,
      dropped: 0
    };
    return u.audio = R.type === "audio" ? R : void 0, u.video = R.type !== "audio" ? R : void 0, u.initSegment = g, u.id3 = va(i, r, c, c), n.samples.length && (u.text = ba(n, r, c)), u;
  }
}
function Rh(s, e, t, i) {
  if (s === null)
    return !0;
  const n = Math.max(i, 1), r = e - s.baseTime / s.timescale;
  return Math.abs(r - t) > n;
}
function Wn(s, e) {
  const t = s == null ? void 0 : s.codec;
  if (t && t.length > 4)
    return t;
  if (e === re.AUDIO) {
    if (t === "ec-3" || t === "ac-3" || t === "alac")
      return t;
    if (t === "fLaC" || t === "Opus")
      return yi(t, !1);
    const i = "mp4a.40.5";
    return S.info(`Parsed audio codec "${t}" or audio object type not handled. Using "${i}"`), i;
  }
  return S.warn(`Unhandled video codec "${t}"`), t === "hvc1" || t === "hev1" ? "hvc1.1.6.L120.90" : t === "av01" ? "av01.0.04M.08" : "avc1.42e01e";
}
let qe;
try {
  qe = self.performance.now.bind(self.performance);
} catch (s) {
  S.debug("Unable to use Performance API on this environment"), qe = Et == null ? void 0 : Et.Date.now;
}
const ai = [{
  demux: uh,
  remux: Lh
}, {
  demux: Je,
  remux: ri
}, {
  demux: ch,
  remux: ri
}, {
  demux: Th,
  remux: ri
}];
ai.splice(2, 0, {
  demux: dh,
  remux: ri
});
class Yn {
  constructor(e, t, i, n, r) {
    this.async = !1, this.observer = void 0, this.typeSupported = void 0, this.config = void 0, this.vendor = void 0, this.id = void 0, this.demuxer = void 0, this.remuxer = void 0, this.decrypter = void 0, this.probe = void 0, this.decryptionPromise = null, this.transmuxConfig = void 0, this.currentTransmuxState = void 0, this.observer = e, this.typeSupported = t, this.config = i, this.vendor = n, this.id = r;
  }
  configure(e) {
    this.transmuxConfig = e, this.decrypter && this.decrypter.reset();
  }
  push(e, t, i, n) {
    const r = i.transmuxing;
    r.executeStart = qe();
    let a = new Uint8Array(e);
    const {
      currentTransmuxState: o,
      transmuxConfig: l
    } = this;
    n && (this.currentTransmuxState = n);
    const {
      contiguous: c,
      discontinuity: h,
      trackSwitch: u,
      accurateTimeOffset: d,
      timeOffset: g,
      initSegmentChange: f
    } = n || o, {
      audioCodec: m,
      videoCodec: y,
      defaultInitPts: T,
      duration: b,
      initSegmentData: v
    } = l, A = Ih(a, t);
    if (A && A.method === "AES-128") {
      const k = this.getDecrypter();
      if (k.isSync()) {
        let _ = k.softwareDecrypt(a, A.key.buffer, A.iv.buffer);
        if (i.part > -1 && (_ = k.flush()), !_)
          return r.executeEnd = qe(), Xi(i);
        a = new Uint8Array(_);
      } else
        return this.decryptionPromise = k.webCryptoDecrypt(a, A.key.buffer, A.iv.buffer).then((_) => {
          const C = this.push(_, null, i);
          return this.decryptionPromise = null, C;
        }), this.decryptionPromise;
    }
    const x = this.needsProbing(h, u);
    if (x) {
      const k = this.configureTransmuxer(a);
      if (k)
        return S.warn(`[transmuxer] ${k.message}`), this.observer.emit(p.ERROR, p.ERROR, {
          type: V.MEDIA_ERROR,
          details: I.FRAG_PARSING_ERROR,
          fatal: !1,
          error: k,
          reason: k.message
        }), r.executeEnd = qe(), Xi(i);
    }
    (h || u || f || x) && this.resetInitSegment(v, m, y, b, t), (h || f || x) && this.resetInitialTimestamp(T), c || this.resetContiguity();
    const w = this.transmux(a, A, g, d, i), R = this.currentTransmuxState;
    return R.contiguous = !0, R.discontinuity = !1, R.trackSwitch = !1, r.executeEnd = qe(), w;
  }
  // Due to data caching, flush calls can produce more than one TransmuxerResult (hence the Array type)
  flush(e) {
    const t = e.transmuxing;
    t.executeStart = qe();
    const {
      decrypter: i,
      currentTransmuxState: n,
      decryptionPromise: r
    } = this;
    if (r)
      return r.then(() => this.flush(e));
    const a = [], {
      timeOffset: o
    } = n;
    if (i) {
      const u = i.flush();
      u && a.push(this.push(u, null, e));
    }
    const {
      demuxer: l,
      remuxer: c
    } = this;
    if (!l || !c)
      return t.executeEnd = qe(), [Xi(e)];
    const h = l.flush(o);
    return oi(h) ? h.then((u) => (this.flushRemux(a, u, e), a)) : (this.flushRemux(a, h, e), a);
  }
  flushRemux(e, t, i) {
    const {
      audioTrack: n,
      videoTrack: r,
      id3Track: a,
      textTrack: o
    } = t, {
      accurateTimeOffset: l,
      timeOffset: c
    } = this.currentTransmuxState;
    S.log(`[transmuxer.ts]: Flushed fragment ${i.sn}${i.part > -1 ? " p: " + i.part : ""} of level ${i.level}`);
    const h = this.remuxer.remux(n, r, a, o, c, l, !0, this.id);
    e.push({
      remuxResult: h,
      chunkMeta: i
    }), i.transmuxing.executeEnd = qe();
  }
  resetInitialTimestamp(e) {
    const {
      demuxer: t,
      remuxer: i
    } = this;
    !t || !i || (t.resetTimeStamp(e), i.resetTimeStamp(e));
  }
  resetContiguity() {
    const {
      demuxer: e,
      remuxer: t
    } = this;
    !e || !t || (e.resetContiguity(), t.resetNextTimestamp());
  }
  resetInitSegment(e, t, i, n, r) {
    const {
      demuxer: a,
      remuxer: o
    } = this;
    !a || !o || (a.resetInitSegment(e, t, i, n), o.resetInitSegment(e, t, i, r));
  }
  destroy() {
    this.demuxer && (this.demuxer.destroy(), this.demuxer = void 0), this.remuxer && (this.remuxer.destroy(), this.remuxer = void 0);
  }
  transmux(e, t, i, n, r) {
    let a;
    return t && t.method === "SAMPLE-AES" ? a = this.transmuxSampleAes(e, t, i, n, r) : a = this.transmuxUnencrypted(e, i, n, r), a;
  }
  transmuxUnencrypted(e, t, i, n) {
    const {
      audioTrack: r,
      videoTrack: a,
      id3Track: o,
      textTrack: l
    } = this.demuxer.demux(e, t, !1, !this.config.progressive);
    return {
      remuxResult: this.remuxer.remux(r, a, o, l, t, i, !1, this.id),
      chunkMeta: n
    };
  }
  transmuxSampleAes(e, t, i, n, r) {
    return this.demuxer.demuxSampleAes(e, t, i).then((a) => ({
      remuxResult: this.remuxer.remux(a.audioTrack, a.videoTrack, a.id3Track, a.textTrack, i, n, !1, this.id),
      chunkMeta: r
    }));
  }
  configureTransmuxer(e) {
    const {
      config: t,
      observer: i,
      typeSupported: n,
      vendor: r
    } = this;
    let a;
    for (let d = 0, g = ai.length; d < g; d++) {
      var o;
      if ((o = ai[d].demux) != null && o.probe(e)) {
        a = ai[d];
        break;
      }
    }
    if (!a)
      return new Error("Failed to find demuxer by probing fragment data");
    const l = this.demuxer, c = this.remuxer, h = a.remux, u = a.demux;
    (!c || !(c instanceof h)) && (this.remuxer = new h(i, t, n, r)), (!l || !(l instanceof u)) && (this.demuxer = new u(i, t, n), this.probe = u.probe);
  }
  needsProbing(e, t) {
    return !this.demuxer || !this.remuxer || e || t;
  }
  getDecrypter() {
    let e = this.decrypter;
    return e || (e = this.decrypter = new Bs(this.config)), e;
  }
}
function Ih(s, e) {
  let t = null;
  return s.byteLength > 0 && (e == null ? void 0 : e.key) != null && e.iv !== null && e.method != null && (t = e), t;
}
const Xi = (s) => ({
  remuxResult: {},
  chunkMeta: s
});
function oi(s) {
  return "then" in s && s.then instanceof Function;
}
class wh {
  constructor(e, t, i, n, r) {
    this.audioCodec = void 0, this.videoCodec = void 0, this.initSegmentData = void 0, this.duration = void 0, this.defaultInitPts = void 0, this.audioCodec = e, this.videoCodec = t, this.initSegmentData = i, this.duration = n, this.defaultInitPts = r || null;
  }
}
class Ch {
  constructor(e, t, i, n, r, a) {
    this.discontinuity = void 0, this.contiguous = void 0, this.accurateTimeOffset = void 0, this.trackSwitch = void 0, this.timeOffset = void 0, this.initSegmentChange = void 0, this.discontinuity = e, this.contiguous = t, this.accurateTimeOffset = i, this.trackSwitch = n, this.timeOffset = r, this.initSegmentChange = a;
  }
}
var xa = { exports: {} };
(function(s) {
  var e = Object.prototype.hasOwnProperty, t = "~";
  function i() {
  }
  Object.create && (i.prototype = /* @__PURE__ */ Object.create(null), new i().__proto__ || (t = !1));
  function n(l, c, h) {
    this.fn = l, this.context = c, this.once = h || !1;
  }
  function r(l, c, h, u, d) {
    if (typeof h != "function")
      throw new TypeError("The listener must be a function");
    var g = new n(h, u || l, d), f = t ? t + c : c;
    return l._events[f] ? l._events[f].fn ? l._events[f] = [l._events[f], g] : l._events[f].push(g) : (l._events[f] = g, l._eventsCount++), l;
  }
  function a(l, c) {
    --l._eventsCount === 0 ? l._events = new i() : delete l._events[c];
  }
  function o() {
    this._events = new i(), this._eventsCount = 0;
  }
  o.prototype.eventNames = function() {
    var c = [], h, u;
    if (this._eventsCount === 0) return c;
    for (u in h = this._events)
      e.call(h, u) && c.push(t ? u.slice(1) : u);
    return Object.getOwnPropertySymbols ? c.concat(Object.getOwnPropertySymbols(h)) : c;
  }, o.prototype.listeners = function(c) {
    var h = t ? t + c : c, u = this._events[h];
    if (!u) return [];
    if (u.fn) return [u.fn];
    for (var d = 0, g = u.length, f = new Array(g); d < g; d++)
      f[d] = u[d].fn;
    return f;
  }, o.prototype.listenerCount = function(c) {
    var h = t ? t + c : c, u = this._events[h];
    return u ? u.fn ? 1 : u.length : 0;
  }, o.prototype.emit = function(c, h, u, d, g, f) {
    var m = t ? t + c : c;
    if (!this._events[m]) return !1;
    var y = this._events[m], T = arguments.length, b, v;
    if (y.fn) {
      switch (y.once && this.removeListener(c, y.fn, void 0, !0), T) {
        case 1:
          return y.fn.call(y.context), !0;
        case 2:
          return y.fn.call(y.context, h), !0;
        case 3:
          return y.fn.call(y.context, h, u), !0;
        case 4:
          return y.fn.call(y.context, h, u, d), !0;
        case 5:
          return y.fn.call(y.context, h, u, d, g), !0;
        case 6:
          return y.fn.call(y.context, h, u, d, g, f), !0;
      }
      for (v = 1, b = new Array(T - 1); v < T; v++)
        b[v - 1] = arguments[v];
      y.fn.apply(y.context, b);
    } else {
      var A = y.length, x;
      for (v = 0; v < A; v++)
        switch (y[v].once && this.removeListener(c, y[v].fn, void 0, !0), T) {
          case 1:
            y[v].fn.call(y[v].context);
            break;
          case 2:
            y[v].fn.call(y[v].context, h);
            break;
          case 3:
            y[v].fn.call(y[v].context, h, u);
            break;
          case 4:
            y[v].fn.call(y[v].context, h, u, d);
            break;
          default:
            if (!b) for (x = 1, b = new Array(T - 1); x < T; x++)
              b[x - 1] = arguments[x];
            y[v].fn.apply(y[v].context, b);
        }
    }
    return !0;
  }, o.prototype.on = function(c, h, u) {
    return r(this, c, h, u, !1);
  }, o.prototype.once = function(c, h, u) {
    return r(this, c, h, u, !0);
  }, o.prototype.removeListener = function(c, h, u, d) {
    var g = t ? t + c : c;
    if (!this._events[g]) return this;
    if (!h)
      return a(this, g), this;
    var f = this._events[g];
    if (f.fn)
      f.fn === h && (!d || f.once) && (!u || f.context === u) && a(this, g);
    else {
      for (var m = 0, y = [], T = f.length; m < T; m++)
        (f[m].fn !== h || d && !f[m].once || u && f[m].context !== u) && y.push(f[m]);
      y.length ? this._events[g] = y.length === 1 ? y[0] : y : a(this, g);
    }
    return this;
  }, o.prototype.removeAllListeners = function(c) {
    var h;
    return c ? (h = t ? t + c : c, this._events[h] && a(this, h)) : (this._events = new i(), this._eventsCount = 0), this;
  }, o.prototype.off = o.prototype.removeListener, o.prototype.addListener = o.prototype.on, o.prefixed = t, o.EventEmitter = o, s.exports = o;
})(xa);
var Dh = xa.exports, Ws = /* @__PURE__ */ Zo(Dh);
class Sa {
  constructor(e, t, i, n) {
    this.error = null, this.hls = void 0, this.id = void 0, this.observer = void 0, this.frag = null, this.part = null, this.useWorker = void 0, this.workerContext = null, this.onwmsg = void 0, this.transmuxer = null, this.onTransmuxComplete = void 0, this.onFlush = void 0;
    const r = e.config;
    this.hls = e, this.id = t, this.useWorker = !!r.enableWorker, this.onTransmuxComplete = i, this.onFlush = n;
    const a = (c, h) => {
      h = h || {}, h.frag = this.frag, h.id = this.id, c === p.ERROR && (this.error = h.error), this.hls.trigger(c, h);
    };
    this.observer = new Ws(), this.observer.on(p.FRAG_DECRYPTED, a), this.observer.on(p.ERROR, a);
    const o = ht(r.preferManagedMediaSource) || {
      isTypeSupported: () => !1
    }, l = {
      mpeg: o.isTypeSupported("audio/mpeg"),
      mp3: o.isTypeSupported('audio/mp4; codecs="mp3"'),
      ac3: o.isTypeSupported('audio/mp4; codecs="ac-3"')
    };
    if (this.useWorker && typeof Worker != "undefined" && (r.workerPath || zc())) {
      try {
        r.workerPath ? (S.log(`loading Web Worker ${r.workerPath} for "${t}"`), this.workerContext = Qc(r.workerPath)) : (S.log(`injecting Web Worker for "${t}"`), this.workerContext = Xc()), this.onwmsg = (u) => this.onWorkerMessage(u);
        const {
          worker: h
        } = this.workerContext;
        h.addEventListener("message", this.onwmsg), h.onerror = (u) => {
          const d = new Error(`${u.message}  (${u.filename}:${u.lineno})`);
          r.enableWorker = !1, S.warn(`Error in "${t}" Web Worker, fallback to inline`), this.hls.trigger(p.ERROR, {
            type: V.OTHER_ERROR,
            details: I.INTERNAL_EXCEPTION,
            fatal: !1,
            event: "demuxerWorker",
            error: d
          });
        }, h.postMessage({
          cmd: "init",
          typeSupported: l,
          vendor: "",
          id: t,
          config: JSON.stringify(r)
        });
      } catch (h) {
        S.warn(`Error setting up "${t}" Web Worker, fallback to inline`, h), this.resetWorker(), this.error = null, this.transmuxer = new Yn(this.observer, l, r, "", t);
      }
      return;
    }
    this.transmuxer = new Yn(this.observer, l, r, "", t);
  }
  resetWorker() {
    if (this.workerContext) {
      const {
        worker: e,
        objectURL: t
      } = this.workerContext;
      t && self.URL.revokeObjectURL(t), e.removeEventListener("message", this.onwmsg), e.onerror = null, e.terminate(), this.workerContext = null;
    }
  }
  destroy() {
    if (this.workerContext)
      this.resetWorker(), this.onwmsg = void 0;
    else {
      const t = this.transmuxer;
      t && (t.destroy(), this.transmuxer = null);
    }
    const e = this.observer;
    e && e.removeAllListeners(), this.frag = null, this.observer = null, this.hls = null;
  }
  push(e, t, i, n, r, a, o, l, c, h) {
    var u, d;
    c.transmuxing.start = self.performance.now();
    const {
      transmuxer: g
    } = this, f = a ? a.start : r.start, m = r.decryptdata, y = this.frag, T = !(y && r.cc === y.cc), b = !(y && c.level === y.level), v = y ? c.sn - y.sn : -1, A = this.part ? c.part - this.part.index : -1, x = v === 0 && c.id > 1 && c.id === (y == null ? void 0 : y.stats.chunkCount), w = !b && (v === 1 || v === 0 && (A === 1 || x && A <= 0)), R = self.performance.now();
    (b || v || r.stats.parsing.start === 0) && (r.stats.parsing.start = R), a && (A || !w) && (a.stats.parsing.start = R);
    const k = !(y && ((u = r.initSegment) == null ? void 0 : u.url) === ((d = y.initSegment) == null ? void 0 : d.url)), _ = new Ch(T, w, l, b, f, k);
    if (!w || T || k) {
      S.log(`[transmuxer-interface, ${r.type}]: Starting new transmux session for sn: ${c.sn} p: ${c.part} level: ${c.level} id: ${c.id}
        discontinuity: ${T}
        trackSwitch: ${b}
        contiguous: ${w}
        accurateTimeOffset: ${l}
        timeOffset: ${f}
        initSegmentChange: ${k}`);
      const C = new wh(i, n, t, o, h);
      this.configureTransmuxer(C);
    }
    if (this.frag = r, this.part = a, this.workerContext)
      this.workerContext.worker.postMessage({
        cmd: "demux",
        data: e,
        decryptdata: m,
        chunkMeta: c,
        state: _
      }, e instanceof ArrayBuffer ? [e] : []);
    else if (g) {
      const C = g.push(e, m, c, _);
      oi(C) ? (g.async = !0, C.then((P) => {
        this.handleTransmuxComplete(P);
      }).catch((P) => {
        this.transmuxerError(P, c, "transmuxer-interface push error");
      })) : (g.async = !1, this.handleTransmuxComplete(C));
    }
  }
  flush(e) {
    e.transmuxing.start = self.performance.now();
    const {
      transmuxer: t
    } = this;
    if (this.workerContext)
      this.workerContext.worker.postMessage({
        cmd: "flush",
        chunkMeta: e
      });
    else if (t) {
      let i = t.flush(e);
      oi(i) || t.async ? (oi(i) || (i = Promise.resolve(i)), i.then((r) => {
        this.handleFlushResult(r, e);
      }).catch((r) => {
        this.transmuxerError(r, e, "transmuxer-interface flush error");
      })) : this.handleFlushResult(i, e);
    }
  }
  transmuxerError(e, t, i) {
    this.hls && (this.error = e, this.hls.trigger(p.ERROR, {
      type: V.MEDIA_ERROR,
      details: I.FRAG_PARSING_ERROR,
      chunkMeta: t,
      frag: this.frag || void 0,
      fatal: !1,
      error: e,
      err: e,
      reason: i
    }));
  }
  handleFlushResult(e, t) {
    e.forEach((i) => {
      this.handleTransmuxComplete(i);
    }), this.onFlush(t);
  }
  onWorkerMessage(e) {
    const t = e.data;
    if (!(t != null && t.event)) {
      S.warn(`worker message received with no ${t ? "event name" : "data"}`);
      return;
    }
    const i = this.hls;
    if (this.hls)
      switch (t.event) {
        case "init": {
          var n;
          const r = (n = this.workerContext) == null ? void 0 : n.objectURL;
          r && self.URL.revokeObjectURL(r);
          break;
        }
        case "transmuxComplete": {
          this.handleTransmuxComplete(t.data);
          break;
        }
        case "flush": {
          this.onFlush(t.data);
          break;
        }
        // pass logs from the worker thread to the main logger
        case "workerLog":
          S[t.data.logType] && S[t.data.logType](t.data.message);
          break;
        default: {
          t.data = t.data || {}, t.data.frag = this.frag, t.data.id = this.id, i.trigger(t.event, t.data);
          break;
        }
      }
  }
  configureTransmuxer(e) {
    const {
      transmuxer: t
    } = this;
    this.workerContext ? this.workerContext.worker.postMessage({
      cmd: "configure",
      config: e
    }) : t && t.configure(e);
  }
  handleTransmuxComplete(e) {
    e.chunkMeta.transmuxing.end = self.performance.now(), this.onTransmuxComplete(e);
  }
}
const jn = 100;
class kh extends $s {
  constructor(e, t, i) {
    super(e, t, i, "[audio-stream-controller]", G.AUDIO), this.videoBuffer = null, this.videoTrackCC = -1, this.waitingVideoCC = -1, this.bufferedTrack = null, this.switchingTrack = null, this.trackId = -1, this.waitingData = null, this.mainDetails = null, this.flushing = !1, this.bufferFlushed = !1, this.cachedTrackLoadedData = null, this._registerListeners();
  }
  onHandlerDestroying() {
    this._unregisterListeners(), super.onHandlerDestroying(), this.mainDetails = null, this.bufferedTrack = null, this.switchingTrack = null;
  }
  _registerListeners() {
    const {
      hls: e
    } = this;
    e.on(p.MEDIA_ATTACHED, this.onMediaAttached, this), e.on(p.MEDIA_DETACHING, this.onMediaDetaching, this), e.on(p.MANIFEST_LOADING, this.onManifestLoading, this), e.on(p.LEVEL_LOADED, this.onLevelLoaded, this), e.on(p.AUDIO_TRACKS_UPDATED, this.onAudioTracksUpdated, this), e.on(p.AUDIO_TRACK_SWITCHING, this.onAudioTrackSwitching, this), e.on(p.AUDIO_TRACK_LOADED, this.onAudioTrackLoaded, this), e.on(p.ERROR, this.onError, this), e.on(p.BUFFER_RESET, this.onBufferReset, this), e.on(p.BUFFER_CREATED, this.onBufferCreated, this), e.on(p.BUFFER_FLUSHING, this.onBufferFlushing, this), e.on(p.BUFFER_FLUSHED, this.onBufferFlushed, this), e.on(p.INIT_PTS_FOUND, this.onInitPtsFound, this), e.on(p.FRAG_BUFFERED, this.onFragBuffered, this);
  }
  _unregisterListeners() {
    const {
      hls: e
    } = this;
    e.off(p.MEDIA_ATTACHED, this.onMediaAttached, this), e.off(p.MEDIA_DETACHING, this.onMediaDetaching, this), e.off(p.MANIFEST_LOADING, this.onManifestLoading, this), e.off(p.LEVEL_LOADED, this.onLevelLoaded, this), e.off(p.AUDIO_TRACKS_UPDATED, this.onAudioTracksUpdated, this), e.off(p.AUDIO_TRACK_SWITCHING, this.onAudioTrackSwitching, this), e.off(p.AUDIO_TRACK_LOADED, this.onAudioTrackLoaded, this), e.off(p.ERROR, this.onError, this), e.off(p.BUFFER_RESET, this.onBufferReset, this), e.off(p.BUFFER_CREATED, this.onBufferCreated, this), e.off(p.BUFFER_FLUSHING, this.onBufferFlushing, this), e.off(p.BUFFER_FLUSHED, this.onBufferFlushed, this), e.off(p.INIT_PTS_FOUND, this.onInitPtsFound, this), e.off(p.FRAG_BUFFERED, this.onFragBuffered, this);
  }
  // INIT_PTS_FOUND is triggered when the video track parsed in the stream-controller has a new PTS value
  onInitPtsFound(e, {
    frag: t,
    id: i,
    initPTS: n,
    timescale: r
  }) {
    if (i === "main") {
      const a = t.cc;
      this.initPTS[t.cc] = {
        baseTime: n,
        timescale: r
      }, this.log(`InitPTS for cc: ${a} found from main: ${n}`), this.videoTrackCC = a, this.state === D.WAITING_INIT_PTS && this.tick();
    }
  }
  startLoad(e) {
    if (!this.levels) {
      this.startPosition = e, this.state = D.STOPPED;
      return;
    }
    const t = this.lastCurrentTime;
    this.stopLoad(), this.setInterval(jn), t > 0 && e === -1 ? (this.log(`Override startPosition with lastCurrentTime @${t.toFixed(3)}`), e = t, this.state = D.IDLE) : (this.loadedmetadata = !1, this.state = D.WAITING_TRACK), this.nextLoadPosition = this.startPosition = this.lastCurrentTime = e, this.tick();
  }
  doTick() {
    switch (this.state) {
      case D.IDLE:
        this.doTickIdle();
        break;
      case D.WAITING_TRACK: {
        var e;
        const {
          levels: i,
          trackId: n
        } = this, r = i == null || (e = i[n]) == null ? void 0 : e.details;
        if (r) {
          if (this.waitForCdnTuneIn(r))
            break;
          this.state = D.WAITING_INIT_PTS;
        }
        break;
      }
      case D.FRAG_LOADING_WAITING_RETRY: {
        var t;
        const i = performance.now(), n = this.retryDate;
        if (!n || i >= n || (t = this.media) != null && t.seeking) {
          const {
            levels: r,
            trackId: a
          } = this;
          this.log("RetryDate reached, switch back to IDLE state"), this.resetStartWhenNotLoaded((r == null ? void 0 : r[a]) || null), this.state = D.IDLE;
        }
        break;
      }
      case D.WAITING_INIT_PTS: {
        const i = this.waitingData;
        if (i) {
          const {
            frag: n,
            part: r,
            cache: a,
            complete: o
          } = i;
          if (this.initPTS[n.cc] !== void 0) {
            this.waitingData = null, this.waitingVideoCC = -1, this.state = D.FRAG_LOADING;
            const l = a.flush(), c = {
              frag: n,
              part: r,
              payload: l,
              networkDetails: null
            };
            this._handleFragmentLoadProgress(c), o && super._handleFragmentLoadComplete(c);
          } else if (this.videoTrackCC !== this.waitingVideoCC)
            this.log(`Waiting fragment cc (${n.cc}) cancelled because video is at cc ${this.videoTrackCC}`), this.clearWaitingFragment();
          else {
            const l = this.getLoadPosition(), c = le.bufferInfo(this.mediaBuffer, l, this.config.maxBufferHole);
            Es(c.end, this.config.maxFragLookUpTolerance, n) < 0 && (this.log(`Waiting fragment cc (${n.cc}) @ ${n.start} cancelled because another fragment at ${c.end} is needed`), this.clearWaitingFragment());
          }
        } else
          this.state = D.IDLE;
      }
    }
    this.onTickEnd();
  }
  clearWaitingFragment() {
    const e = this.waitingData;
    e && (this.fragmentTracker.removeFragment(e.frag), this.waitingData = null, this.waitingVideoCC = -1, this.state = D.IDLE);
  }
  resetLoadingState() {
    this.clearWaitingFragment(), super.resetLoadingState();
  }
  onTickEnd() {
    const {
      media: e
    } = this;
    e != null && e.readyState && (this.lastCurrentTime = e.currentTime);
  }
  doTickIdle() {
    const {
      hls: e,
      levels: t,
      media: i,
      trackId: n
    } = this, r = e.config;
    if (!this.buffering || !i && (this.startFragRequested || !r.startFragPrefetch) || !(t != null && t[n]))
      return;
    const a = t[n], o = a.details;
    if (!o || o.live && this.levelLastLoaded !== a || this.waitForCdnTuneIn(o)) {
      this.state = D.WAITING_TRACK;
      return;
    }
    const l = this.mediaBuffer ? this.mediaBuffer : this.media;
    this.bufferFlushed && l && (this.bufferFlushed = !1, this.afterBufferFlushed(l, re.AUDIO, G.AUDIO));
    const c = this.getFwdBufferInfo(l, G.AUDIO);
    if (c === null)
      return;
    if (!this.switchingTrack && this._streamEnded(c, o)) {
      e.trigger(p.BUFFER_EOS, {
        type: "audio"
      }), this.state = D.ENDED;
      return;
    }
    const h = this.getFwdBufferInfo(this.videoBuffer ? this.videoBuffer : this.media, G.MAIN), u = c.len, d = this.getMaxBufferLength(h == null ? void 0 : h.len), g = o.fragments, f = g[0].start, m = this.getLoadPosition(), y = this.flushing ? m : c.end;
    if (this.switchingTrack && i) {
      const A = m;
      o.PTSKnown && A < f && (c.end > f || c.nextStart) && (this.log("Alt audio track ahead of main track, seek to start of alt audio track"), i.currentTime = f + 0.05);
    }
    if (u >= d && !this.switchingTrack && y < g[g.length - 1].start)
      return;
    let T = this.getNextFragment(y, o), b = !1;
    if (T && this.isLoopLoading(T, y) && (b = !!T.gap, T = this.getNextFragmentLoopLoading(T, o, c, G.MAIN, d)), !T) {
      this.bufferFlushed = !0;
      return;
    }
    const v = h && T.start > h.end + o.targetduration;
    if (v || // Or wait for main buffer after buffing some audio
    !(h != null && h.len) && c.len) {
      const A = this.getAppendedFrag(T.start, G.MAIN);
      if (A === null || (b || (b = !!A.gap || !!v && h.len === 0), v && !b || b && c.nextStart && c.nextStart < A.end))
        return;
    }
    this.loadFragment(T, a, y);
  }
  getMaxBufferLength(e) {
    const t = super.getMaxBufferLength();
    return e ? Math.min(Math.max(t, e), this.config.maxMaxBufferLength) : t;
  }
  onMediaDetaching() {
    this.videoBuffer = null, this.bufferFlushed = this.flushing = !1, super.onMediaDetaching();
  }
  onAudioTracksUpdated(e, {
    audioTracks: t
  }) {
    this.resetTransmuxer(), this.levels = t.map((i) => new vt(i));
  }
  onAudioTrackSwitching(e, t) {
    const i = !!t.url;
    this.trackId = t.id;
    const {
      fragCurrent: n
    } = this;
    n && (n.abortRequests(), this.removeUnbufferedFrags(n.start)), this.resetLoadingState(), i ? this.setInterval(jn) : this.resetTransmuxer(), i ? (this.switchingTrack = t, this.state = D.IDLE, this.flushAudioIfNeeded(t)) : (this.switchingTrack = null, this.bufferedTrack = t, this.state = D.STOPPED), this.tick();
  }
  onManifestLoading() {
    this.fragmentTracker.removeAllFragments(), this.startPosition = this.lastCurrentTime = 0, this.bufferFlushed = this.flushing = !1, this.levels = this.mainDetails = this.waitingData = this.bufferedTrack = this.cachedTrackLoadedData = this.switchingTrack = null, this.startFragRequested = !1, this.trackId = this.videoTrackCC = this.waitingVideoCC = -1;
  }
  onLevelLoaded(e, t) {
    this.mainDetails = t.details, this.cachedTrackLoadedData !== null && (this.hls.trigger(p.AUDIO_TRACK_LOADED, this.cachedTrackLoadedData), this.cachedTrackLoadedData = null);
  }
  onAudioTrackLoaded(e, t) {
    var i;
    if (this.mainDetails == null) {
      this.cachedTrackLoadedData = t;
      return;
    }
    const {
      levels: n
    } = this, {
      details: r,
      id: a
    } = t;
    if (!n) {
      this.warn(`Audio tracks were reset while loading level ${a}`);
      return;
    }
    this.log(`Audio track ${a} loaded [${r.startSN},${r.endSN}]${r.lastPartSn ? `[part-${r.lastPartSn}-${r.lastPartIndex}]` : ""},duration:${r.totalduration}`);
    const o = n[a];
    let l = 0;
    if (r.live || (i = o.details) != null && i.live) {
      this.checkLiveUpdate(r);
      const h = this.mainDetails;
      if (r.deltaUpdateFailed || !h)
        return;
      if (!o.details && r.hasProgramDateTime && h.hasProgramDateTime)
        xi(r, h), l = r.fragments[0].start;
      else {
        var c;
        l = this.alignPlaylists(r, o.details, (c = this.levelLastLoaded) == null ? void 0 : c.details);
      }
    }
    o.details = r, this.levelLastLoaded = o, !this.startFragRequested && (this.mainDetails || !r.live) && this.setStartPosition(this.mainDetails || r, l), this.state === D.WAITING_TRACK && !this.waitForCdnTuneIn(r) && (this.state = D.IDLE), this.tick();
  }
  _handleFragmentLoadProgress(e) {
    var t;
    const {
      frag: i,
      part: n,
      payload: r
    } = e, {
      config: a,
      trackId: o,
      levels: l
    } = this;
    if (!l) {
      this.warn(`Audio tracks were reset while fragment load was in progress. Fragment ${i.sn} of level ${i.level} will not be buffered`);
      return;
    }
    const c = l[o];
    if (!c) {
      this.warn("Audio track is undefined on fragment load progress");
      return;
    }
    const h = c.details;
    if (!h) {
      this.warn("Audio track details undefined on fragment load progress"), this.removeUnbufferedFrags(i.start);
      return;
    }
    const u = a.defaultAudioCodec || c.audioCodec || "mp4a.40.2";
    let d = this.transmuxer;
    d || (d = this.transmuxer = new Sa(this.hls, G.AUDIO, this._handleTransmuxComplete.bind(this), this._handleTransmuxerFlush.bind(this)));
    const g = this.initPTS[i.cc], f = (t = i.initSegment) == null ? void 0 : t.data;
    if (g !== void 0) {
      const y = n ? n.index : -1, T = y !== -1, b = new Us(i.level, i.sn, i.stats.chunkCount, r.byteLength, y, T);
      d.push(r, f, u, "", i, n, h.totalduration, !1, b, g);
    } else {
      this.log(`Unknown video PTS for cc ${i.cc}, waiting for video PTS before demuxing audio frag ${i.sn} of [${h.startSN} ,${h.endSN}],track ${o}`);
      const {
        cache: m
      } = this.waitingData = this.waitingData || {
        frag: i,
        part: n,
        cache: new oa(),
        complete: !1
      };
      m.push(new Uint8Array(r)), this.waitingVideoCC = this.videoTrackCC, this.state = D.WAITING_INIT_PTS;
    }
  }
  _handleFragmentLoadComplete(e) {
    if (this.waitingData) {
      this.waitingData.complete = !0;
      return;
    }
    super._handleFragmentLoadComplete(e);
  }
  onBufferReset() {
    this.mediaBuffer = this.videoBuffer = null, this.loadedmetadata = !1;
  }
  onBufferCreated(e, t) {
    const i = t.tracks.audio;
    i && (this.mediaBuffer = i.buffer || null), t.tracks.video && (this.videoBuffer = t.tracks.video.buffer || null);
  }
  onFragBuffered(e, t) {
    const {
      frag: i,
      part: n
    } = t;
    if (i.type !== G.AUDIO) {
      if (!this.loadedmetadata && i.type === G.MAIN) {
        const r = this.videoBuffer || this.media;
        r && le.getBuffered(r).length && (this.loadedmetadata = !0);
      }
      return;
    }
    if (this.fragContextChanged(i)) {
      this.warn(`Fragment ${i.sn}${n ? " p: " + n.index : ""} of level ${i.level} finished buffering, but was aborted. state: ${this.state}, audioSwitch: ${this.switchingTrack ? this.switchingTrack.name : "false"}`);
      return;
    }
    if (i.sn !== "initSegment") {
      this.fragPrevious = i;
      const r = this.switchingTrack;
      r && (this.bufferedTrack = r, this.switchingTrack = null, this.hls.trigger(p.AUDIO_TRACK_SWITCHED, be({}, r)));
    }
    this.fragBufferedComplete(i, n);
  }
  onError(e, t) {
    var i;
    if (t.fatal) {
      this.state = D.ERROR;
      return;
    }
    switch (t.details) {
      case I.FRAG_GAP:
      case I.FRAG_PARSING_ERROR:
      case I.FRAG_DECRYPT_ERROR:
      case I.FRAG_LOAD_ERROR:
      case I.FRAG_LOAD_TIMEOUT:
      case I.KEY_LOAD_ERROR:
      case I.KEY_LOAD_TIMEOUT:
        this.onFragmentOrKeyLoadError(G.AUDIO, t);
        break;
      case I.AUDIO_TRACK_LOAD_ERROR:
      case I.AUDIO_TRACK_LOAD_TIMEOUT:
      case I.LEVEL_PARSING_ERROR:
        !t.levelRetry && this.state === D.WAITING_TRACK && ((i = t.context) == null ? void 0 : i.type) === Q.AUDIO_TRACK && (this.state = D.IDLE);
        break;
      case I.BUFFER_APPEND_ERROR:
      case I.BUFFER_FULL_ERROR:
        if (!t.parent || t.parent !== "audio")
          return;
        if (t.details === I.BUFFER_APPEND_ERROR) {
          this.resetLoadingState();
          return;
        }
        this.reduceLengthAndFlushBuffer(t) && (this.bufferedTrack = null, super.flushMainBuffer(0, Number.POSITIVE_INFINITY, "audio"));
        break;
      case I.INTERNAL_EXCEPTION:
        this.recoverWorkerError(t);
        break;
    }
  }
  onBufferFlushing(e, {
    type: t
  }) {
    t !== re.VIDEO && (this.flushing = !0);
  }
  onBufferFlushed(e, {
    type: t
  }) {
    if (t !== re.VIDEO) {
      this.flushing = !1, this.bufferFlushed = !0, this.state === D.ENDED && (this.state = D.IDLE);
      const i = this.mediaBuffer || this.media;
      i && (this.afterBufferFlushed(i, t, G.AUDIO), this.tick());
    }
  }
  _handleTransmuxComplete(e) {
    var t;
    const i = "audio", {
      hls: n
    } = this, {
      remuxResult: r,
      chunkMeta: a
    } = e, o = this.getCurrentContext(a);
    if (!o) {
      this.resetWhenMissingContext(a);
      return;
    }
    const {
      frag: l,
      part: c,
      level: h
    } = o, {
      details: u
    } = h, {
      audio: d,
      text: g,
      id3: f,
      initSegment: m
    } = r;
    if (this.fragContextChanged(l) || !u) {
      this.fragmentTracker.removeFragment(l);
      return;
    }
    if (this.state = D.PARSING, this.switchingTrack && d && this.completeAudioSwitch(this.switchingTrack), m != null && m.tracks) {
      const y = l.initSegment || l;
      this._bufferInitSegment(h, m.tracks, y, a), n.trigger(p.FRAG_PARSING_INIT_SEGMENT, {
        frag: y,
        id: i,
        tracks: m.tracks
      });
    }
    if (d) {
      const {
        startPTS: y,
        endPTS: T,
        startDTS: b,
        endDTS: v
      } = d;
      c && (c.elementaryStreams[re.AUDIO] = {
        startPTS: y,
        endPTS: T,
        startDTS: b,
        endDTS: v
      }), l.setElementaryStreamInfo(re.AUDIO, y, T, b, v), this.bufferFragmentData(d, l, c, a);
    }
    if (f != null && (t = f.samples) != null && t.length) {
      const y = fe({
        id: i,
        frag: l,
        details: u
      }, f);
      n.trigger(p.FRAG_PARSING_METADATA, y);
    }
    if (g) {
      const y = fe({
        id: i,
        frag: l,
        details: u
      }, g);
      n.trigger(p.FRAG_PARSING_USERDATA, y);
    }
  }
  _bufferInitSegment(e, t, i, n) {
    if (this.state !== D.PARSING)
      return;
    t.video && delete t.video;
    const r = t.audio;
    if (!r)
      return;
    r.id = "audio";
    const a = e.audioCodec;
    this.log(`Init audio buffer, container:${r.container}, codecs[level/parsed]=[${a}/${r.codec}]`), a && a.split(",").length === 1 && (r.levelCodec = a), this.hls.trigger(p.BUFFER_CODECS, t);
    const o = r.initSegment;
    if (o != null && o.byteLength) {
      const l = {
        type: "audio",
        frag: i,
        part: null,
        chunkMeta: n,
        parent: i.type,
        data: o
      };
      this.hls.trigger(p.BUFFER_APPENDING, l);
    }
    this.tickImmediate();
  }
  loadFragment(e, t, i) {
    const n = this.fragmentTracker.getState(e);
    if (this.fragCurrent = e, this.switchingTrack || n === ve.NOT_LOADED || n === ve.PARTIAL) {
      var r;
      if (e.sn === "initSegment")
        this._loadInitSegment(e, t);
      else if ((r = t.details) != null && r.live && !this.initPTS[e.cc]) {
        this.log(`Waiting for video PTS in continuity counter ${e.cc} of live stream before loading audio fragment ${e.sn} of level ${this.trackId}`), this.state = D.WAITING_INIT_PTS;
        const a = this.mainDetails;
        a && a.fragments[0].start !== t.details.fragments[0].start && xi(t.details, a);
      } else
        this.startFragRequested = !0, super.loadFragment(e, t, i);
    } else
      this.clearTrackerIfNeeded(e);
  }
  flushAudioIfNeeded(e) {
    if (this.media && this.bufferedTrack) {
      const {
        name: t,
        lang: i,
        assocLang: n,
        characteristics: r,
        audioCodec: a,
        channels: o
      } = this.bufferedTrack;
      ct({
        name: t,
        lang: i,
        assocLang: n,
        characteristics: r,
        audioCodec: a,
        channels: o
      }, e, rt) || (this.log("Switching audio track : flushing all audio"), super.flushMainBuffer(0, Number.POSITIVE_INFINITY, "audio"), this.bufferedTrack = null);
    }
  }
  completeAudioSwitch(e) {
    const {
      hls: t
    } = this;
    this.flushAudioIfNeeded(e), this.bufferedTrack = e, this.switchingTrack = null, t.trigger(p.AUDIO_TRACK_SWITCHED, be({}, e));
  }
}
function Aa(s, e) {
  if (s.length !== e.length)
    return !1;
  for (let t = 0; t < s.length; t++)
    if (!Ot(s[t].attrs, e[t].attrs))
      return !1;
  return !0;
}
function Ot(s, e, t) {
  const i = s["STABLE-RENDITION-ID"];
  return i && !t ? i === e["STABLE-RENDITION-ID"] : !(t || ["LANGUAGE", "NAME", "CHARACTERISTICS", "AUTOSELECT", "DEFAULT", "FORCED", "ASSOC-LANGUAGE"]).some((n) => s[n] !== e[n]);
}
function bs(s, e) {
  return e.label.toLowerCase() === s.name.toLowerCase() && (!e.language || e.language.toLowerCase() === (s.lang || "").toLowerCase());
}
class Ph extends Ns {
  constructor(e) {
    super(e, "[audio-track-controller]"), this.tracks = [], this.groupIds = null, this.tracksInGroup = [], this.trackId = -1, this.currentTrack = null, this.selectDefaultTrack = !0, this.registerListeners();
  }
  registerListeners() {
    const {
      hls: e
    } = this;
    e.on(p.MANIFEST_LOADING, this.onManifestLoading, this), e.on(p.MANIFEST_PARSED, this.onManifestParsed, this), e.on(p.LEVEL_LOADING, this.onLevelLoading, this), e.on(p.LEVEL_SWITCHING, this.onLevelSwitching, this), e.on(p.AUDIO_TRACK_LOADED, this.onAudioTrackLoaded, this), e.on(p.ERROR, this.onError, this);
  }
  unregisterListeners() {
    const {
      hls: e
    } = this;
    e.off(p.MANIFEST_LOADING, this.onManifestLoading, this), e.off(p.MANIFEST_PARSED, this.onManifestParsed, this), e.off(p.LEVEL_LOADING, this.onLevelLoading, this), e.off(p.LEVEL_SWITCHING, this.onLevelSwitching, this), e.off(p.AUDIO_TRACK_LOADED, this.onAudioTrackLoaded, this), e.off(p.ERROR, this.onError, this);
  }
  destroy() {
    this.unregisterListeners(), this.tracks.length = 0, this.tracksInGroup.length = 0, this.currentTrack = null, super.destroy();
  }
  onManifestLoading() {
    this.tracks = [], this.tracksInGroup = [], this.groupIds = null, this.currentTrack = null, this.trackId = -1, this.selectDefaultTrack = !0;
  }
  onManifestParsed(e, t) {
    this.tracks = t.audioTracks || [];
  }
  onAudioTrackLoaded(e, t) {
    const {
      id: i,
      groupId: n,
      details: r
    } = t, a = this.tracksInGroup[i];
    if (!a || a.groupId !== n) {
      this.warn(`Audio track with id:${i} and group:${n} not found in active group ${a == null ? void 0 : a.groupId}`);
      return;
    }
    const o = a.details;
    a.details = t.details, this.log(`Audio track ${i} "${a.name}" lang:${a.lang} group:${n} loaded [${r.startSN}-${r.endSN}]`), i === this.trackId && this.playlistLoaded(i, t, o);
  }
  onLevelLoading(e, t) {
    this.switchLevel(t.level);
  }
  onLevelSwitching(e, t) {
    this.switchLevel(t.level);
  }
  switchLevel(e) {
    const t = this.hls.levels[e];
    if (!t)
      return;
    const i = t.audioGroups || null, n = this.groupIds;
    let r = this.currentTrack;
    if (!i || (n == null ? void 0 : n.length) !== (i == null ? void 0 : i.length) || i != null && i.some((o) => (n == null ? void 0 : n.indexOf(o)) === -1)) {
      this.groupIds = i, this.trackId = -1, this.currentTrack = null;
      const o = this.tracks.filter((d) => !i || i.indexOf(d.groupId) !== -1);
      if (o.length)
        this.selectDefaultTrack && !o.some((d) => d.default) && (this.selectDefaultTrack = !1), o.forEach((d, g) => {
          d.id = g;
        });
      else if (!r && !this.tracksInGroup.length)
        return;
      this.tracksInGroup = o;
      const l = this.hls.config.audioPreference;
      if (!r && l) {
        const d = He(l, o, rt);
        if (d > -1)
          r = o[d];
        else {
          const g = He(l, this.tracks);
          r = this.tracks[g];
        }
      }
      let c = this.findTrackId(r);
      c === -1 && r && (c = this.findTrackId(null));
      const h = {
        audioTracks: o
      };
      this.log(`Updating audio tracks, ${o.length} track(s) found in group(s): ${i == null ? void 0 : i.join(",")}`), this.hls.trigger(p.AUDIO_TRACKS_UPDATED, h);
      const u = this.trackId;
      if (c !== -1 && u === -1)
        this.setAudioTrack(c);
      else if (o.length && u === -1) {
        var a;
        const d = new Error(`No audio track selected for current audio group-ID(s): ${(a = this.groupIds) == null ? void 0 : a.join(",")} track count: ${o.length}`);
        this.warn(d.message), this.hls.trigger(p.ERROR, {
          type: V.MEDIA_ERROR,
          details: I.AUDIO_TRACK_LOAD_ERROR,
          fatal: !0,
          error: d
        });
      }
    } else this.shouldReloadPlaylist(r) && this.setAudioTrack(this.trackId);
  }
  onError(e, t) {
    t.fatal || !t.context || t.context.type === Q.AUDIO_TRACK && t.context.id === this.trackId && (!this.groupIds || this.groupIds.indexOf(t.context.groupId) !== -1) && (this.requestScheduled = -1, this.checkRetry(t));
  }
  get allAudioTracks() {
    return this.tracks;
  }
  get audioTracks() {
    return this.tracksInGroup;
  }
  get audioTrack() {
    return this.trackId;
  }
  set audioTrack(e) {
    this.selectDefaultTrack = !1, this.setAudioTrack(e);
  }
  setAudioOption(e) {
    const t = this.hls;
    if (t.config.audioPreference = e, e) {
      const i = this.allAudioTracks;
      if (this.selectDefaultTrack = !1, i.length) {
        const n = this.currentTrack;
        if (n && ct(e, n, rt))
          return n;
        const r = He(e, this.tracksInGroup, rt);
        if (r > -1) {
          const a = this.tracksInGroup[r];
          return this.setAudioTrack(r), a;
        } else if (n) {
          let a = t.loadLevel;
          a === -1 && (a = t.firstAutoLevel);
          const o = Pc(e, t.levels, i, a, rt);
          if (o === -1)
            return null;
          t.nextLoadLevel = o;
        }
        if (e.channels || e.audioCodec) {
          const a = He(e, i);
          if (a > -1)
            return i[a];
        }
      }
    }
    return null;
  }
  setAudioTrack(e) {
    const t = this.tracksInGroup;
    if (e < 0 || e >= t.length) {
      this.warn(`Invalid audio track id: ${e}`);
      return;
    }
    this.clearTimer(), this.selectDefaultTrack = !1;
    const i = this.currentTrack, n = t[e], r = n.details && !n.details.live;
    if (e === this.trackId && n === i && r || (this.log(`Switching to audio-track ${e} "${n.name}" lang:${n.lang} group:${n.groupId} channels:${n.channels}`), this.trackId = e, this.currentTrack = n, this.hls.trigger(p.AUDIO_TRACK_SWITCHING, be({}, n)), r))
      return;
    const a = this.switchParams(n.url, i == null ? void 0 : i.details, n.details);
    this.loadPlaylist(a);
  }
  findTrackId(e) {
    const t = this.tracksInGroup;
    for (let i = 0; i < t.length; i++) {
      const n = t[i];
      if (!(this.selectDefaultTrack && !n.default) && (!e || ct(e, n, rt)))
        return i;
    }
    if (e) {
      const {
        name: i,
        lang: n,
        assocLang: r,
        characteristics: a,
        audioCodec: o,
        channels: l
      } = e;
      for (let c = 0; c < t.length; c++) {
        const h = t[c];
        if (ct({
          name: i,
          lang: n,
          assocLang: r,
          characteristics: a,
          audioCodec: o,
          channels: l
        }, h, rt))
          return c;
      }
      for (let c = 0; c < t.length; c++) {
        const h = t[c];
        if (Ot(e.attrs, h.attrs, ["LANGUAGE", "ASSOC-LANGUAGE", "CHARACTERISTICS"]))
          return c;
      }
      for (let c = 0; c < t.length; c++) {
        const h = t[c];
        if (Ot(e.attrs, h.attrs, ["LANGUAGE"]))
          return c;
      }
    }
    return -1;
  }
  loadPlaylist(e) {
    const t = this.currentTrack;
    if (this.shouldLoadPlaylist(t) && t) {
      super.loadPlaylist();
      const i = t.id, n = t.groupId;
      let r = t.url;
      if (e)
        try {
          r = e.addDirectives(r);
        } catch (a) {
          this.warn(`Could not construct new URL with HLS Delivery Directives: ${a}`);
        }
      this.log(`loading audio-track playlist ${i} "${t.name}" lang:${t.lang} group:${n}`), this.clearTimer(), this.hls.trigger(p.AUDIO_TRACK_LOADING, {
        url: r,
        id: i,
        groupId: n,
        deliveryDirectives: e || null
      });
    }
  }
}
const qn = 500;
class _h extends $s {
  constructor(e, t, i) {
    super(e, t, i, "[subtitle-stream-controller]", G.SUBTITLE), this.currentTrackId = -1, this.tracksBuffered = [], this.mainDetails = null, this._registerListeners();
  }
  onHandlerDestroying() {
    this._unregisterListeners(), super.onHandlerDestroying(), this.mainDetails = null;
  }
  _registerListeners() {
    const {
      hls: e
    } = this;
    e.on(p.MEDIA_ATTACHED, this.onMediaAttached, this), e.on(p.MEDIA_DETACHING, this.onMediaDetaching, this), e.on(p.MANIFEST_LOADING, this.onManifestLoading, this), e.on(p.LEVEL_LOADED, this.onLevelLoaded, this), e.on(p.ERROR, this.onError, this), e.on(p.SUBTITLE_TRACKS_UPDATED, this.onSubtitleTracksUpdated, this), e.on(p.SUBTITLE_TRACK_SWITCH, this.onSubtitleTrackSwitch, this), e.on(p.SUBTITLE_TRACK_LOADED, this.onSubtitleTrackLoaded, this), e.on(p.SUBTITLE_FRAG_PROCESSED, this.onSubtitleFragProcessed, this), e.on(p.BUFFER_FLUSHING, this.onBufferFlushing, this), e.on(p.FRAG_BUFFERED, this.onFragBuffered, this);
  }
  _unregisterListeners() {
    const {
      hls: e
    } = this;
    e.off(p.MEDIA_ATTACHED, this.onMediaAttached, this), e.off(p.MEDIA_DETACHING, this.onMediaDetaching, this), e.off(p.MANIFEST_LOADING, this.onManifestLoading, this), e.off(p.LEVEL_LOADED, this.onLevelLoaded, this), e.off(p.ERROR, this.onError, this), e.off(p.SUBTITLE_TRACKS_UPDATED, this.onSubtitleTracksUpdated, this), e.off(p.SUBTITLE_TRACK_SWITCH, this.onSubtitleTrackSwitch, this), e.off(p.SUBTITLE_TRACK_LOADED, this.onSubtitleTrackLoaded, this), e.off(p.SUBTITLE_FRAG_PROCESSED, this.onSubtitleFragProcessed, this), e.off(p.BUFFER_FLUSHING, this.onBufferFlushing, this), e.off(p.FRAG_BUFFERED, this.onFragBuffered, this);
  }
  startLoad(e) {
    this.stopLoad(), this.state = D.IDLE, this.setInterval(qn), this.nextLoadPosition = this.startPosition = this.lastCurrentTime = e, this.tick();
  }
  onManifestLoading() {
    this.mainDetails = null, this.fragmentTracker.removeAllFragments();
  }
  onMediaDetaching() {
    this.tracksBuffered = [], super.onMediaDetaching();
  }
  onLevelLoaded(e, t) {
    this.mainDetails = t.details;
  }
  onSubtitleFragProcessed(e, t) {
    const {
      frag: i,
      success: n
    } = t;
    if (this.fragPrevious = i, this.state = D.IDLE, !n)
      return;
    const r = this.tracksBuffered[this.currentTrackId];
    if (!r)
      return;
    let a;
    const o = i.start;
    for (let c = 0; c < r.length; c++)
      if (o >= r[c].start && o <= r[c].end) {
        a = r[c];
        break;
      }
    const l = i.start + i.duration;
    a ? a.end = l : (a = {
      start: o,
      end: l
    }, r.push(a)), this.fragmentTracker.fragBuffered(i), this.fragBufferedComplete(i, null);
  }
  onBufferFlushing(e, t) {
    const {
      startOffset: i,
      endOffset: n
    } = t;
    if (i === 0 && n !== Number.POSITIVE_INFINITY) {
      const r = n - 1;
      if (r <= 0)
        return;
      t.endOffsetSubtitles = Math.max(0, r), this.tracksBuffered.forEach((a) => {
        for (let o = 0; o < a.length; ) {
          if (a[o].end <= r) {
            a.shift();
            continue;
          } else if (a[o].start < r)
            a[o].start = r;
          else
            break;
          o++;
        }
      }), this.fragmentTracker.removeFragmentsInRange(i, r, G.SUBTITLE);
    }
  }
  onFragBuffered(e, t) {
    if (!this.loadedmetadata && t.frag.type === G.MAIN) {
      var i;
      (i = this.media) != null && i.buffered.length && (this.loadedmetadata = !0);
    }
  }
  // If something goes wrong, proceed to next frag, if we were processing one.
  onError(e, t) {
    const i = t.frag;
    (i == null ? void 0 : i.type) === G.SUBTITLE && (t.details === I.FRAG_GAP && this.fragmentTracker.fragBuffered(i, !0), this.fragCurrent && this.fragCurrent.abortRequests(), this.state !== D.STOPPED && (this.state = D.IDLE));
  }
  // Got all new subtitle levels.
  onSubtitleTracksUpdated(e, {
    subtitleTracks: t
  }) {
    if (this.levels && Aa(this.levels, t)) {
      this.levels = t.map((i) => new vt(i));
      return;
    }
    this.tracksBuffered = [], this.levels = t.map((i) => {
      const n = new vt(i);
      return this.tracksBuffered[n.id] = [], n;
    }), this.fragmentTracker.removeFragmentsInRange(0, Number.POSITIVE_INFINITY, G.SUBTITLE), this.fragPrevious = null, this.mediaBuffer = null;
  }
  onSubtitleTrackSwitch(e, t) {
    var i;
    if (this.currentTrackId = t.id, !((i = this.levels) != null && i.length) || this.currentTrackId === -1) {
      this.clearInterval();
      return;
    }
    const n = this.levels[this.currentTrackId];
    n != null && n.details ? this.mediaBuffer = this.mediaBufferTimeRanges : this.mediaBuffer = null, n && this.setInterval(qn);
  }
  // Got a new set of subtitle fragments.
  onSubtitleTrackLoaded(e, t) {
    var i;
    const {
      currentTrackId: n,
      levels: r
    } = this, {
      details: a,
      id: o
    } = t;
    if (!r) {
      this.warn(`Subtitle tracks were reset while loading level ${o}`);
      return;
    }
    const l = r[o];
    if (o >= r.length || !l)
      return;
    this.log(`Subtitle track ${o} loaded [${a.startSN},${a.endSN}]${a.lastPartSn ? `[part-${a.lastPartSn}-${a.lastPartIndex}]` : ""},duration:${a.totalduration}`), this.mediaBuffer = this.mediaBufferTimeRanges;
    let c = 0;
    if (a.live || (i = l.details) != null && i.live) {
      const u = this.mainDetails;
      if (a.deltaUpdateFailed || !u)
        return;
      const d = u.fragments[0];
      if (!l.details)
        a.hasProgramDateTime && u.hasProgramDateTime ? (xi(a, u), c = a.fragments[0].start) : d && (c = d.start, Ts(a, c));
      else {
        var h;
        c = this.alignPlaylists(a, l.details, (h = this.levelLastLoaded) == null ? void 0 : h.details), c === 0 && d && (c = d.start, Ts(a, c));
      }
    }
    l.details = a, this.levelLastLoaded = l, o === n && (!this.startFragRequested && (this.mainDetails || !a.live) && this.setStartPosition(this.mainDetails || a, c), this.tick(), a.live && !this.fragCurrent && this.media && this.state === D.IDLE && (bi(null, a.fragments, this.media.currentTime, 0) || (this.warn("Subtitle playlist not aligned with playback"), l.details = void 0)));
  }
  _handleFragmentLoadComplete(e) {
    const {
      frag: t,
      payload: i
    } = e, n = t.decryptdata, r = this.hls;
    if (!this.fragContextChanged(t) && i && i.byteLength > 0 && n != null && n.key && n.iv && n.method === "AES-128") {
      const a = performance.now();
      this.decrypter.decrypt(new Uint8Array(i), n.key.buffer, n.iv.buffer).catch((o) => {
        throw r.trigger(p.ERROR, {
          type: V.MEDIA_ERROR,
          details: I.FRAG_DECRYPT_ERROR,
          fatal: !1,
          error: o,
          reason: o.message,
          frag: t
        }), o;
      }).then((o) => {
        const l = performance.now();
        r.trigger(p.FRAG_DECRYPTED, {
          frag: t,
          payload: o,
          stats: {
            tstart: a,
            tdecrypt: l
          }
        });
      }).catch((o) => {
        this.warn(`${o.name}: ${o.message}`), this.state = D.IDLE;
      });
    }
  }
  doTick() {
    if (!this.media) {
      this.state = D.IDLE;
      return;
    }
    if (this.state === D.IDLE) {
      const {
        currentTrackId: e,
        levels: t
      } = this, i = t == null ? void 0 : t[e];
      if (!i || !t.length || !i.details)
        return;
      const {
        config: n
      } = this, r = this.getLoadPosition(), a = le.bufferedInfo(this.tracksBuffered[this.currentTrackId] || [], r, n.maxBufferHole), {
        end: o,
        len: l
      } = a, c = this.getFwdBufferInfo(this.media, G.MAIN), h = i.details, u = this.getMaxBufferLength(c == null ? void 0 : c.len) + h.levelTargetDuration;
      if (l > u)
        return;
      const d = h.fragments, g = d.length, f = h.edge;
      let m = null;
      const y = this.fragPrevious;
      if (o < f) {
        const T = n.maxFragLookUpTolerance, b = o > f - T ? 0 : T;
        m = bi(y, d, Math.max(d[0].start, o), b), !m && y && y.start < d[0].start && (m = d[0]);
      } else
        m = d[g - 1];
      if (!m)
        return;
      if (m = this.mapToInitFragWhenRequired(m), m.sn !== "initSegment") {
        const T = m.sn - h.startSN, b = d[T - 1];
        b && b.cc === m.cc && this.fragmentTracker.getState(b) === ve.NOT_LOADED && (m = b);
      }
      this.fragmentTracker.getState(m) === ve.NOT_LOADED && this.loadFragment(m, i, o);
    }
  }
  getMaxBufferLength(e) {
    const t = super.getMaxBufferLength();
    return e ? Math.max(t, e) : t;
  }
  loadFragment(e, t, i) {
    this.fragCurrent = e, e.sn === "initSegment" ? this._loadInitSegment(e, t) : (this.startFragRequested = !0, super.loadFragment(e, t, i));
  }
  get mediaBufferTimeRanges() {
    return new Oh(this.tracksBuffered[this.currentTrackId] || []);
  }
}
class Oh {
  constructor(e) {
    this.buffered = void 0;
    const t = (i, n, r) => {
      if (n = n >>> 0, n > r - 1)
        throw new DOMException(`Failed to execute '${i}' on 'TimeRanges': The index provided (${n}) is greater than the maximum bound (${r})`);
      return e[n][i];
    };
    this.buffered = {
      get length() {
        return e.length;
      },
      end(i) {
        return t("end", i, e.length);
      },
      start(i) {
        return t("start", i, e.length);
      }
    };
  }
}
class Fh extends Ns {
  constructor(e) {
    super(e, "[subtitle-track-controller]"), this.media = null, this.tracks = [], this.groupIds = null, this.tracksInGroup = [], this.trackId = -1, this.currentTrack = null, this.selectDefaultTrack = !0, this.queuedDefaultTrack = -1, this.asyncPollTrackChange = () => this.pollTrackChange(0), this.useTextTrackPolling = !1, this.subtitlePollingInterval = -1, this._subtitleDisplay = !0, this.onTextTracksChanged = () => {
      if (this.useTextTrackPolling || self.clearInterval(this.subtitlePollingInterval), !this.media || !this.hls.config.renderTextTracksNatively)
        return;
      let t = null;
      const i = ii(this.media.textTracks);
      for (let r = 0; r < i.length; r++)
        if (i[r].mode === "hidden")
          t = i[r];
        else if (i[r].mode === "showing") {
          t = i[r];
          break;
        }
      const n = this.findTrackForTextTrack(t);
      this.subtitleTrack !== n && this.setSubtitleTrack(n);
    }, this.registerListeners();
  }
  destroy() {
    this.unregisterListeners(), this.tracks.length = 0, this.tracksInGroup.length = 0, this.currentTrack = null, this.onTextTracksChanged = this.asyncPollTrackChange = null, super.destroy();
  }
  get subtitleDisplay() {
    return this._subtitleDisplay;
  }
  set subtitleDisplay(e) {
    this._subtitleDisplay = e, this.trackId > -1 && this.toggleTrackModes();
  }
  registerListeners() {
    const {
      hls: e
    } = this;
    e.on(p.MEDIA_ATTACHED, this.onMediaAttached, this), e.on(p.MEDIA_DETACHING, this.onMediaDetaching, this), e.on(p.MANIFEST_LOADING, this.onManifestLoading, this), e.on(p.MANIFEST_PARSED, this.onManifestParsed, this), e.on(p.LEVEL_LOADING, this.onLevelLoading, this), e.on(p.LEVEL_SWITCHING, this.onLevelSwitching, this), e.on(p.SUBTITLE_TRACK_LOADED, this.onSubtitleTrackLoaded, this), e.on(p.ERROR, this.onError, this);
  }
  unregisterListeners() {
    const {
      hls: e
    } = this;
    e.off(p.MEDIA_ATTACHED, this.onMediaAttached, this), e.off(p.MEDIA_DETACHING, this.onMediaDetaching, this), e.off(p.MANIFEST_LOADING, this.onManifestLoading, this), e.off(p.MANIFEST_PARSED, this.onManifestParsed, this), e.off(p.LEVEL_LOADING, this.onLevelLoading, this), e.off(p.LEVEL_SWITCHING, this.onLevelSwitching, this), e.off(p.SUBTITLE_TRACK_LOADED, this.onSubtitleTrackLoaded, this), e.off(p.ERROR, this.onError, this);
  }
  // Listen for subtitle track change, then extract the current track ID.
  onMediaAttached(e, t) {
    this.media = t.media, this.media && (this.queuedDefaultTrack > -1 && (this.subtitleTrack = this.queuedDefaultTrack, this.queuedDefaultTrack = -1), this.useTextTrackPolling = !(this.media.textTracks && "onchange" in this.media.textTracks), this.useTextTrackPolling ? this.pollTrackChange(500) : this.media.textTracks.addEventListener("change", this.asyncPollTrackChange));
  }
  pollTrackChange(e) {
    self.clearInterval(this.subtitlePollingInterval), this.subtitlePollingInterval = self.setInterval(this.onTextTracksChanged, e);
  }
  onMediaDetaching() {
    if (!this.media)
      return;
    self.clearInterval(this.subtitlePollingInterval), this.useTextTrackPolling || this.media.textTracks.removeEventListener("change", this.asyncPollTrackChange), this.trackId > -1 && (this.queuedDefaultTrack = this.trackId), ii(this.media.textTracks).forEach((t) => {
      mt(t);
    }), this.subtitleTrack = -1, this.media = null;
  }
  onManifestLoading() {
    this.tracks = [], this.groupIds = null, this.tracksInGroup = [], this.trackId = -1, this.currentTrack = null, this.selectDefaultTrack = !0;
  }
  // Fired whenever a new manifest is loaded.
  onManifestParsed(e, t) {
    this.tracks = t.subtitleTracks;
  }
  onSubtitleTrackLoaded(e, t) {
    const {
      id: i,
      groupId: n,
      details: r
    } = t, a = this.tracksInGroup[i];
    if (!a || a.groupId !== n) {
      this.warn(`Subtitle track with id:${i} and group:${n} not found in active group ${a == null ? void 0 : a.groupId}`);
      return;
    }
    const o = a.details;
    a.details = t.details, this.log(`Subtitle track ${i} "${a.name}" lang:${a.lang} group:${n} loaded [${r.startSN}-${r.endSN}]`), i === this.trackId && this.playlistLoaded(i, t, o);
  }
  onLevelLoading(e, t) {
    this.switchLevel(t.level);
  }
  onLevelSwitching(e, t) {
    this.switchLevel(t.level);
  }
  switchLevel(e) {
    const t = this.hls.levels[e];
    if (!t)
      return;
    const i = t.subtitleGroups || null, n = this.groupIds;
    let r = this.currentTrack;
    if (!i || (n == null ? void 0 : n.length) !== (i == null ? void 0 : i.length) || i != null && i.some((a) => (n == null ? void 0 : n.indexOf(a)) === -1)) {
      this.groupIds = i, this.trackId = -1, this.currentTrack = null;
      const a = this.tracks.filter((h) => !i || i.indexOf(h.groupId) !== -1);
      if (a.length)
        this.selectDefaultTrack && !a.some((h) => h.default) && (this.selectDefaultTrack = !1), a.forEach((h, u) => {
          h.id = u;
        });
      else if (!r && !this.tracksInGroup.length)
        return;
      this.tracksInGroup = a;
      const o = this.hls.config.subtitlePreference;
      if (!r && o) {
        this.selectDefaultTrack = !1;
        const h = He(o, a);
        if (h > -1)
          r = a[h];
        else {
          const u = He(o, this.tracks);
          r = this.tracks[u];
        }
      }
      let l = this.findTrackId(r);
      l === -1 && r && (l = this.findTrackId(null));
      const c = {
        subtitleTracks: a
      };
      this.log(`Updating subtitle tracks, ${a.length} track(s) found in "${i == null ? void 0 : i.join(",")}" group-id`), this.hls.trigger(p.SUBTITLE_TRACKS_UPDATED, c), l !== -1 && this.trackId === -1 && this.setSubtitleTrack(l);
    } else this.shouldReloadPlaylist(r) && this.setSubtitleTrack(this.trackId);
  }
  findTrackId(e) {
    const t = this.tracksInGroup, i = this.selectDefaultTrack;
    for (let n = 0; n < t.length; n++) {
      const r = t[n];
      if (!(i && !r.default || !i && !e) && (!e || ct(r, e)))
        return n;
    }
    if (e) {
      for (let n = 0; n < t.length; n++) {
        const r = t[n];
        if (Ot(e.attrs, r.attrs, ["LANGUAGE", "ASSOC-LANGUAGE", "CHARACTERISTICS"]))
          return n;
      }
      for (let n = 0; n < t.length; n++) {
        const r = t[n];
        if (Ot(e.attrs, r.attrs, ["LANGUAGE"]))
          return n;
      }
    }
    return -1;
  }
  findTrackForTextTrack(e) {
    if (e) {
      const t = this.tracksInGroup;
      for (let i = 0; i < t.length; i++) {
        const n = t[i];
        if (bs(n, e))
          return i;
      }
    }
    return -1;
  }
  onError(e, t) {
    t.fatal || !t.context || t.context.type === Q.SUBTITLE_TRACK && t.context.id === this.trackId && (!this.groupIds || this.groupIds.indexOf(t.context.groupId) !== -1) && this.checkRetry(t);
  }
  get allSubtitleTracks() {
    return this.tracks;
  }
  /** get alternate subtitle tracks list from playlist **/
  get subtitleTracks() {
    return this.tracksInGroup;
  }
  /** get/set index of the selected subtitle track (based on index in subtitle track lists) **/
  get subtitleTrack() {
    return this.trackId;
  }
  set subtitleTrack(e) {
    this.selectDefaultTrack = !1, this.setSubtitleTrack(e);
  }
  setSubtitleOption(e) {
    if (this.hls.config.subtitlePreference = e, e) {
      const t = this.allSubtitleTracks;
      if (this.selectDefaultTrack = !1, t.length) {
        const i = this.currentTrack;
        if (i && ct(e, i))
          return i;
        const n = He(e, this.tracksInGroup);
        if (n > -1) {
          const r = this.tracksInGroup[n];
          return this.setSubtitleTrack(n), r;
        } else {
          if (i)
            return null;
          {
            const r = He(e, t);
            if (r > -1)
              return t[r];
          }
        }
      }
    }
    return null;
  }
  loadPlaylist(e) {
    super.loadPlaylist();
    const t = this.currentTrack;
    if (this.shouldLoadPlaylist(t) && t) {
      const i = t.id, n = t.groupId;
      let r = t.url;
      if (e)
        try {
          r = e.addDirectives(r);
        } catch (a) {
          this.warn(`Could not construct new URL with HLS Delivery Directives: ${a}`);
        }
      this.log(`Loading subtitle playlist for id ${i}`), this.hls.trigger(p.SUBTITLE_TRACK_LOADING, {
        url: r,
        id: i,
        groupId: n,
        deliveryDirectives: e || null
      });
    }
  }
  /**
   * Disables the old subtitleTrack and sets current mode on the next subtitleTrack.
   * This operates on the DOM textTracks.
   * A value of -1 will disable all subtitle tracks.
   */
  toggleTrackModes() {
    const {
      media: e
    } = this;
    if (!e)
      return;
    const t = ii(e.textTracks), i = this.currentTrack;
    let n;
    if (i && (n = t.filter((r) => bs(i, r))[0], n || this.warn(`Unable to find subtitle TextTrack with name "${i.name}" and language "${i.lang}"`)), [].slice.call(t).forEach((r) => {
      r.mode !== "disabled" && r !== n && (r.mode = "disabled");
    }), n) {
      const r = this.subtitleDisplay ? "showing" : "hidden";
      n.mode !== r && (n.mode = r);
    }
  }
  /**
   * This method is responsible for validating the subtitle index and periodically reloading if live.
   * Dispatches the SUBTITLE_TRACK_SWITCH event, which instructs the subtitle-stream-controller to load the selected track.
   */
  setSubtitleTrack(e) {
    const t = this.tracksInGroup;
    if (!this.media) {
      this.queuedDefaultTrack = e;
      return;
    }
    if (e < -1 || e >= t.length || !U(e)) {
      this.warn(`Invalid subtitle track id: ${e}`);
      return;
    }
    this.clearTimer(), this.selectDefaultTrack = !1;
    const i = this.currentTrack, n = t[e] || null;
    if (this.trackId = e, this.currentTrack = n, this.toggleTrackModes(), !n) {
      this.hls.trigger(p.SUBTITLE_TRACK_SWITCH, {
        id: e
      });
      return;
    }
    const r = !!n.details && !n.details.live;
    if (e === this.trackId && n === i && r)
      return;
    this.log(`Switching to subtitle-track ${e}` + (n ? ` "${n.name}" lang:${n.lang} group:${n.groupId}` : ""));
    const {
      id: a,
      groupId: o = "",
      name: l,
      type: c,
      url: h
    } = n;
    this.hls.trigger(p.SUBTITLE_TRACK_SWITCH, {
      id: a,
      groupId: o,
      name: l,
      type: c,
      url: h
    });
    const u = this.switchParams(n.url, i == null ? void 0 : i.details, n.details);
    this.loadPlaylist(u);
  }
}
class Mh {
  constructor(e) {
    this.buffers = void 0, this.queues = {
      video: [],
      audio: [],
      audiovideo: []
    }, this.buffers = e;
  }
  append(e, t, i) {
    const n = this.queues[t];
    n.push(e), n.length === 1 && !i && this.executeNext(t);
  }
  insertAbort(e, t) {
    this.queues[t].unshift(e), this.executeNext(t);
  }
  appendBlocker(e) {
    let t;
    const i = new Promise((r) => {
      t = r;
    }), n = {
      execute: t,
      onStart: () => {
      },
      onComplete: () => {
      },
      onError: () => {
      }
    };
    return this.append(n, e), i;
  }
  executeNext(e) {
    const t = this.queues[e];
    if (t.length) {
      const i = t[0];
      try {
        i.execute();
      } catch (n) {
        S.warn(`[buffer-operation-queue]: Exception executing "${e}" SourceBuffer operation: ${n}`), i.onError(n);
        const r = this.buffers[e];
        r != null && r.updating || this.shiftAndExecuteNext(e);
      }
    }
  }
  shiftAndExecuteNext(e) {
    this.queues[e].shift(), this.executeNext(e);
  }
  current(e) {
    return this.queues[e][0];
  }
}
const zn = /(avc[1234]|hvc1|hev1|dvh[1e]|vp09|av01)(?:\.[^.,]+)+/;
class Nh {
  constructor(e) {
    this.details = null, this._objectUrl = null, this.operationQueue = void 0, this.listeners = void 0, this.hls = void 0, this.bufferCodecEventsExpected = 0, this._bufferCodecEventsTotal = 0, this.media = null, this.mediaSource = null, this.lastMpegAudioChunk = null, this.appendSource = void 0, this.appendErrors = {
      audio: 0,
      video: 0,
      audiovideo: 0
    }, this.tracks = {}, this.pendingTracks = {}, this.sourceBuffer = void 0, this.log = void 0, this.warn = void 0, this.error = void 0, this._onEndStreaming = (i) => {
      this.hls && this.hls.pauseBuffering();
    }, this._onStartStreaming = (i) => {
      this.hls && this.hls.resumeBuffering();
    }, this._onMediaSourceOpen = () => {
      const {
        media: i,
        mediaSource: n
      } = this;
      this.log("Media source opened"), i && (i.removeEventListener("emptied", this._onMediaEmptied), this.updateMediaElementDuration(), this.hls.trigger(p.MEDIA_ATTACHED, {
        media: i,
        mediaSource: n
      })), n && n.removeEventListener("sourceopen", this._onMediaSourceOpen), this.checkPendingTracks();
    }, this._onMediaSourceClose = () => {
      this.log("Media source closed");
    }, this._onMediaSourceEnded = () => {
      this.log("Media source ended");
    }, this._onMediaEmptied = () => {
      const {
        mediaSrc: i,
        _objectUrl: n
      } = this;
      i !== n && S.error(`Media element src was set while attaching MediaSource (${n} > ${i})`);
    }, this.hls = e;
    const t = "[buffer-controller]";
    this.appendSource = Yl(ht(e.config.preferManagedMediaSource)), this.log = S.log.bind(S, t), this.warn = S.warn.bind(S, t), this.error = S.error.bind(S, t), this._initSourceBuffer(), this.registerListeners();
  }
  hasSourceTypes() {
    return this.getSourceBufferTypes().length > 0 || Object.keys(this.pendingTracks).length > 0;
  }
  destroy() {
    this.unregisterListeners(), this.details = null, this.lastMpegAudioChunk = null, this.hls = null;
  }
  registerListeners() {
    const {
      hls: e
    } = this;
    e.on(p.MEDIA_ATTACHING, this.onMediaAttaching, this), e.on(p.MEDIA_DETACHING, this.onMediaDetaching, this), e.on(p.MANIFEST_LOADING, this.onManifestLoading, this), e.on(p.MANIFEST_PARSED, this.onManifestParsed, this), e.on(p.BUFFER_RESET, this.onBufferReset, this), e.on(p.BUFFER_APPENDING, this.onBufferAppending, this), e.on(p.BUFFER_CODECS, this.onBufferCodecs, this), e.on(p.BUFFER_EOS, this.onBufferEos, this), e.on(p.BUFFER_FLUSHING, this.onBufferFlushing, this), e.on(p.LEVEL_UPDATED, this.onLevelUpdated, this), e.on(p.FRAG_PARSED, this.onFragParsed, this), e.on(p.FRAG_CHANGED, this.onFragChanged, this);
  }
  unregisterListeners() {
    const {
      hls: e
    } = this;
    e.off(p.MEDIA_ATTACHING, this.onMediaAttaching, this), e.off(p.MEDIA_DETACHING, this.onMediaDetaching, this), e.off(p.MANIFEST_LOADING, this.onManifestLoading, this), e.off(p.MANIFEST_PARSED, this.onManifestParsed, this), e.off(p.BUFFER_RESET, this.onBufferReset, this), e.off(p.BUFFER_APPENDING, this.onBufferAppending, this), e.off(p.BUFFER_CODECS, this.onBufferCodecs, this), e.off(p.BUFFER_EOS, this.onBufferEos, this), e.off(p.BUFFER_FLUSHING, this.onBufferFlushing, this), e.off(p.LEVEL_UPDATED, this.onLevelUpdated, this), e.off(p.FRAG_PARSED, this.onFragParsed, this), e.off(p.FRAG_CHANGED, this.onFragChanged, this);
  }
  _initSourceBuffer() {
    this.sourceBuffer = {}, this.operationQueue = new Mh(this.sourceBuffer), this.listeners = {
      audio: [],
      video: [],
      audiovideo: []
    }, this.appendErrors = {
      audio: 0,
      video: 0,
      audiovideo: 0
    }, this.lastMpegAudioChunk = null;
  }
  onManifestLoading() {
    this.bufferCodecEventsExpected = this._bufferCodecEventsTotal = 0, this.details = null;
  }
  onManifestParsed(e, t) {
    let i = 2;
    (t.audio && !t.video || !t.altAudio) && (i = 1), this.bufferCodecEventsExpected = this._bufferCodecEventsTotal = i, this.log(`${this.bufferCodecEventsExpected} bufferCodec event(s) expected`);
  }
  onMediaAttaching(e, t) {
    const i = this.media = t.media, n = ht(this.appendSource);
    if (i && n) {
      var r;
      const a = this.mediaSource = new n();
      this.log(`created media source: ${(r = a.constructor) == null ? void 0 : r.name}`), a.addEventListener("sourceopen", this._onMediaSourceOpen), a.addEventListener("sourceended", this._onMediaSourceEnded), a.addEventListener("sourceclose", this._onMediaSourceClose), this.appendSource && (a.addEventListener("startstreaming", this._onStartStreaming), a.addEventListener("endstreaming", this._onEndStreaming));
      const o = this._objectUrl = self.URL.createObjectURL(a);
      if (this.appendSource)
        try {
          i.removeAttribute("src");
          const l = self.ManagedMediaSource;
          i.disableRemotePlayback = i.disableRemotePlayback || l && a instanceof l, Xn(i), Uh(i, o), i.load();
        } catch (l) {
          i.src = o;
        }
      else
        i.src = o;
      i.addEventListener("emptied", this._onMediaEmptied);
    }
  }
  onMediaDetaching() {
    const {
      media: e,
      mediaSource: t,
      _objectUrl: i
    } = this;
    if (t) {
      if (this.log("media source detaching"), t.readyState === "open")
        try {
          t.endOfStream();
        } catch (n) {
          this.warn(`onMediaDetaching: ${n.message} while calling endOfStream`);
        }
      this.onBufferReset(), t.removeEventListener("sourceopen", this._onMediaSourceOpen), t.removeEventListener("sourceended", this._onMediaSourceEnded), t.removeEventListener("sourceclose", this._onMediaSourceClose), this.appendSource && (t.removeEventListener("startstreaming", this._onStartStreaming), t.removeEventListener("endstreaming", this._onEndStreaming)), e && (e.removeEventListener("emptied", this._onMediaEmptied), i && self.URL.revokeObjectURL(i), this.mediaSrc === i ? (e.removeAttribute("src"), this.appendSource && Xn(e), e.load()) : this.warn("media|source.src was changed by a third party - skip cleanup")), this.mediaSource = null, this.media = null, this._objectUrl = null, this.bufferCodecEventsExpected = this._bufferCodecEventsTotal, this.pendingTracks = {}, this.tracks = {};
    }
    this.hls.trigger(p.MEDIA_DETACHED, void 0);
  }
  onBufferReset() {
    this.getSourceBufferTypes().forEach((e) => {
      this.resetBuffer(e);
    }), this._initSourceBuffer(), this.hls.resumeBuffering();
  }
  resetBuffer(e) {
    const t = this.sourceBuffer[e];
    try {
      if (t) {
        var i;
        this.removeBufferListeners(e), this.sourceBuffer[e] = void 0, (i = this.mediaSource) != null && i.sourceBuffers.length && this.mediaSource.removeSourceBuffer(t);
      }
    } catch (n) {
      this.warn(`onBufferReset ${e}`, n);
    }
  }
  onBufferCodecs(e, t) {
    const i = this.getSourceBufferTypes().length, n = Object.keys(t);
    if (n.forEach((a) => {
      if (i) {
        const l = this.tracks[a];
        if (l && typeof l.buffer.changeType == "function") {
          var o;
          const {
            id: c,
            codec: h,
            levelCodec: u,
            container: d,
            metadata: g
          } = t[a], f = yn(l.codec, l.levelCodec), m = f == null ? void 0 : f.replace(zn, "$1");
          let y = yn(h, u);
          const T = (o = y) == null ? void 0 : o.replace(zn, "$1");
          if (y && m !== T) {
            a.slice(0, 5) === "audio" && (y = yi(y, this.appendSource));
            const b = `${d};codecs=${y}`;
            this.appendChangeType(a, b), this.log(`switching codec ${f} to ${y}`), this.tracks[a] = {
              buffer: l.buffer,
              codec: h,
              container: d,
              levelCodec: u,
              metadata: g,
              id: c
            };
          }
        }
      } else
        this.pendingTracks[a] = t[a];
    }), i)
      return;
    const r = Math.max(this.bufferCodecEventsExpected - 1, 0);
    this.bufferCodecEventsExpected !== r && (this.log(`${r} bufferCodec event(s) expected ${n.join(",")}`), this.bufferCodecEventsExpected = r), this.mediaSource && this.mediaSource.readyState === "open" && this.checkPendingTracks();
  }
  appendChangeType(e, t) {
    const {
      operationQueue: i
    } = this, n = {
      execute: () => {
        const r = this.sourceBuffer[e];
        r && (this.log(`changing ${e} sourceBuffer type to ${t}`), r.changeType(t)), i.shiftAndExecuteNext(e);
      },
      onStart: () => {
      },
      onComplete: () => {
      },
      onError: (r) => {
        this.warn(`Failed to change ${e} SourceBuffer type`, r);
      }
    };
    i.append(n, e, !!this.pendingTracks[e]);
  }
  onBufferAppending(e, t) {
    const {
      hls: i,
      operationQueue: n,
      tracks: r
    } = this, {
      data: a,
      type: o,
      frag: l,
      part: c,
      chunkMeta: h
    } = t, u = h.buffering[o], d = self.performance.now();
    u.start = d;
    const g = l.stats.buffering, f = c ? c.stats.buffering : null;
    g.start === 0 && (g.start = d), f && f.start === 0 && (f.start = d);
    const m = r.audio;
    let y = !1;
    o === "audio" && (m == null ? void 0 : m.container) === "audio/mpeg" && (y = !this.lastMpegAudioChunk || h.id === 1 || this.lastMpegAudioChunk.sn !== h.sn, this.lastMpegAudioChunk = h);
    const T = l.start, b = {
      execute: () => {
        if (u.executeStart = self.performance.now(), y) {
          const v = this.sourceBuffer[o];
          if (v) {
            const A = T - v.timestampOffset;
            Math.abs(A) >= 0.1 && (this.log(`Updating audio SourceBuffer timestampOffset to ${T} (delta: ${A}) sn: ${l.sn})`), v.timestampOffset = T);
          }
        }
        this.appendExecutor(a, o);
      },
      onStart: () => {
      },
      onComplete: () => {
        const v = self.performance.now();
        u.executeEnd = u.end = v, g.first === 0 && (g.first = v), f && f.first === 0 && (f.first = v);
        const {
          sourceBuffer: A
        } = this, x = {};
        for (const w in A)
          x[w] = le.getBuffered(A[w]);
        this.appendErrors[o] = 0, o === "audio" || o === "video" ? this.appendErrors.audiovideo = 0 : (this.appendErrors.audio = 0, this.appendErrors.video = 0), this.hls.trigger(p.BUFFER_APPENDED, {
          type: o,
          frag: l,
          part: c,
          chunkMeta: h,
          parent: l.type,
          timeRanges: x
        });
      },
      onError: (v) => {
        const A = {
          type: V.MEDIA_ERROR,
          parent: l.type,
          details: I.BUFFER_APPEND_ERROR,
          sourceBufferName: o,
          frag: l,
          part: c,
          chunkMeta: h,
          error: v,
          err: v,
          fatal: !1
        };
        if (v.code === DOMException.QUOTA_EXCEEDED_ERR)
          A.details = I.BUFFER_FULL_ERROR;
        else {
          const x = ++this.appendErrors[o];
          A.details = I.BUFFER_APPEND_ERROR, this.warn(`Failed ${x}/${i.config.appendErrorMaxRetry} times to append segment in "${o}" sourceBuffer`), x >= i.config.appendErrorMaxRetry && (A.fatal = !0);
        }
        i.trigger(p.ERROR, A);
      }
    };
    n.append(b, o, !!this.pendingTracks[o]);
  }
  onBufferFlushing(e, t) {
    const {
      operationQueue: i
    } = this, n = (r) => ({
      execute: this.removeExecutor.bind(this, r, t.startOffset, t.endOffset),
      onStart: () => {
      },
      onComplete: () => {
        this.hls.trigger(p.BUFFER_FLUSHED, {
          type: r
        });
      },
      onError: (a) => {
        this.warn(`Failed to remove from ${r} SourceBuffer`, a);
      }
    });
    t.type ? i.append(n(t.type), t.type) : this.getSourceBufferTypes().forEach((r) => {
      i.append(n(r), r);
    });
  }
  onFragParsed(e, t) {
    const {
      frag: i,
      part: n
    } = t, r = [], a = n ? n.elementaryStreams : i.elementaryStreams;
    a[re.AUDIOVIDEO] ? r.push("audiovideo") : (a[re.AUDIO] && r.push("audio"), a[re.VIDEO] && r.push("video"));
    const o = () => {
      const l = self.performance.now();
      i.stats.buffering.end = l, n && (n.stats.buffering.end = l);
      const c = n ? n.stats : i.stats;
      this.hls.trigger(p.FRAG_BUFFERED, {
        frag: i,
        part: n,
        stats: c,
        id: i.type
      });
    };
    r.length === 0 && this.warn(`Fragments must have at least one ElementaryStreamType set. type: ${i.type} level: ${i.level} sn: ${i.sn}`), this.blockBuffers(o, r);
  }
  onFragChanged(e, t) {
    this.trimBuffers();
  }
  // on BUFFER_EOS mark matching sourcebuffer(s) as ended and trigger checkEos()
  // an undefined data.type will mark all buffers as EOS.
  onBufferEos(e, t) {
    this.getSourceBufferTypes().reduce((n, r) => {
      const a = this.sourceBuffer[r];
      return a && (!t.type || t.type === r) && (a.ending = !0, a.ended || (a.ended = !0, this.log(`${r} sourceBuffer now EOS`))), n && !!(!a || a.ended);
    }, !0) && (this.log("Queueing mediaSource.endOfStream()"), this.blockBuffers(() => {
      this.getSourceBufferTypes().forEach((r) => {
        const a = this.sourceBuffer[r];
        a && (a.ending = !1);
      });
      const {
        mediaSource: n
      } = this;
      if (!n || n.readyState !== "open") {
        n && this.log(`Could not call mediaSource.endOfStream(). mediaSource.readyState: ${n.readyState}`);
        return;
      }
      this.log("Calling mediaSource.endOfStream()"), n.endOfStream();
    }));
  }
  onLevelUpdated(e, {
    details: t
  }) {
    t.fragments.length && (this.details = t, this.getSourceBufferTypes().length ? this.blockBuffers(this.updateMediaElementDuration.bind(this)) : this.updateMediaElementDuration());
  }
  trimBuffers() {
    const {
      hls: e,
      details: t,
      media: i
    } = this;
    if (!i || t === null || !this.getSourceBufferTypes().length)
      return;
    const r = e.config, a = i.currentTime, o = t.levelTargetDuration, l = t.live && r.liveBackBufferLength !== null ? r.liveBackBufferLength : r.backBufferLength;
    if (U(l) && l > 0) {
      const c = Math.max(l, o), h = Math.floor(a / o) * o - c;
      this.flushBackBuffer(a, o, h);
    }
    if (U(r.frontBufferFlushThreshold) && r.frontBufferFlushThreshold > 0) {
      const c = Math.max(r.maxBufferLength, r.frontBufferFlushThreshold), h = Math.max(c, o), u = Math.floor(a / o) * o + h;
      this.flushFrontBuffer(a, o, u);
    }
  }
  flushBackBuffer(e, t, i) {
    const {
      details: n,
      sourceBuffer: r
    } = this;
    this.getSourceBufferTypes().forEach((o) => {
      const l = r[o];
      if (l) {
        const c = le.getBuffered(l);
        if (c.length > 0 && i > c.start(0)) {
          if (this.hls.trigger(p.BACK_BUFFER_REACHED, {
            bufferEnd: i
          }), n != null && n.live)
            this.hls.trigger(p.LIVE_BACK_BUFFER_REACHED, {
              bufferEnd: i
            });
          else if (l.ended && c.end(c.length - 1) - e < t * 2) {
            this.log(`Cannot flush ${o} back buffer while SourceBuffer is in ended state`);
            return;
          }
          this.hls.trigger(p.BUFFER_FLUSHING, {
            startOffset: 0,
            endOffset: i,
            type: o
          });
        }
      }
    });
  }
  flushFrontBuffer(e, t, i) {
    const {
      sourceBuffer: n
    } = this;
    this.getSourceBufferTypes().forEach((a) => {
      const o = n[a];
      if (o) {
        const l = le.getBuffered(o), c = l.length;
        if (c < 2)
          return;
        const h = l.start(c - 1), u = l.end(c - 1);
        if (i > h || e >= h && e <= u)
          return;
        if (o.ended && e - u < 2 * t) {
          this.log(`Cannot flush ${a} front buffer while SourceBuffer is in ended state`);
          return;
        }
        this.hls.trigger(p.BUFFER_FLUSHING, {
          startOffset: h,
          endOffset: 1 / 0,
          type: a
        });
      }
    });
  }
  /**
   * Update Media Source duration to current level duration or override to Infinity if configuration parameter
   * 'liveDurationInfinity` is set to `true`
   * More details: https://github.com/video-dev/hls.js/issues/355
   */
  updateMediaElementDuration() {
    if (!this.details || !this.media || !this.mediaSource || this.mediaSource.readyState !== "open")
      return;
    const {
      details: e,
      hls: t,
      media: i,
      mediaSource: n
    } = this, r = e.fragments[0].start + e.totalduration, a = i.duration, o = U(n.duration) ? n.duration : 0;
    e.live && t.config.liveDurationInfinity ? (n.duration = 1 / 0, this.updateSeekableRange(e)) : (r > o && r > a || !U(a)) && (this.log(`Updating Media Source duration to ${r.toFixed(3)}`), n.duration = r);
  }
  updateSeekableRange(e) {
    const t = this.mediaSource, i = e.fragments;
    if (i.length && e.live && t != null && t.setLiveSeekableRange) {
      const r = Math.max(0, i[0].start), a = Math.max(r, r + e.totalduration);
      this.log(`Media Source duration is set to ${t.duration}. Setting seekable range to ${r}-${a}.`), t.setLiveSeekableRange(r, a);
    }
  }
  checkPendingTracks() {
    const {
      bufferCodecEventsExpected: e,
      operationQueue: t,
      pendingTracks: i
    } = this, n = Object.keys(i).length;
    if (n && (!e || n === 2 || "audiovideo" in i)) {
      this.createSourceBuffers(i), this.pendingTracks = {};
      const r = this.getSourceBufferTypes();
      if (r.length)
        this.hls.trigger(p.BUFFER_CREATED, {
          tracks: this.tracks
        }), r.forEach((a) => {
          t.executeNext(a);
        });
      else {
        const a = new Error("could not create source buffer for media codec(s)");
        this.hls.trigger(p.ERROR, {
          type: V.MEDIA_ERROR,
          details: I.BUFFER_INCOMPATIBLE_CODECS_ERROR,
          fatal: !0,
          error: a,
          reason: a.message
        });
      }
    }
  }
  createSourceBuffers(e) {
    const {
      sourceBuffer: t,
      mediaSource: i
    } = this;
    if (!i)
      throw Error("createSourceBuffers called when mediaSource was null");
    for (const r in e)
      if (!t[r]) {
        var n;
        const a = e[r];
        if (!a)
          throw Error(`source buffer exists for track ${r}, however track does not`);
        let o = ((n = a.levelCodec) == null ? void 0 : n.indexOf(",")) === -1 ? a.levelCodec : a.codec;
        o && r.slice(0, 5) === "audio" && (o = yi(o, this.appendSource));
        const l = `${a.container};codecs=${o}`;
        this.log(`creating sourceBuffer(${l})`);
        try {
          const c = t[r] = i.addSourceBuffer(l), h = r;
          this.addBufferListener(h, "updatestart", this._onSBUpdateStart), this.addBufferListener(h, "updateend", this._onSBUpdateEnd), this.addBufferListener(h, "error", this._onSBUpdateError), this.appendSource && this.addBufferListener(h, "bufferedchange", (u, d) => {
            const g = d.removedRanges;
            g != null && g.length && this.hls.trigger(p.BUFFER_FLUSHED, {
              type: r
            });
          }), this.tracks[r] = {
            buffer: c,
            codec: o,
            container: a.container,
            levelCodec: a.levelCodec,
            metadata: a.metadata,
            id: a.id
          };
        } catch (c) {
          this.error(`error while trying to add sourceBuffer: ${c.message}`), this.hls.trigger(p.ERROR, {
            type: V.MEDIA_ERROR,
            details: I.BUFFER_ADD_CODEC_ERROR,
            fatal: !1,
            error: c,
            sourceBufferName: r,
            mimeType: l
          });
        }
      }
  }
  get mediaSrc() {
    var e, t;
    const i = ((e = this.media) == null || (t = e.querySelector) == null ? void 0 : t.call(e, "source")) || this.media;
    return i == null ? void 0 : i.src;
  }
  _onSBUpdateStart(e) {
    const {
      operationQueue: t
    } = this;
    t.current(e).onStart();
  }
  _onSBUpdateEnd(e) {
    var t;
    if (((t = this.mediaSource) == null ? void 0 : t.readyState) === "closed") {
      this.resetBuffer(e);
      return;
    }
    const {
      operationQueue: i
    } = this;
    i.current(e).onComplete(), i.shiftAndExecuteNext(e);
  }
  _onSBUpdateError(e, t) {
    var i;
    const n = new Error(`${e} SourceBuffer error. MediaSource readyState: ${(i = this.mediaSource) == null ? void 0 : i.readyState}`);
    this.error(`${n}`, t), this.hls.trigger(p.ERROR, {
      type: V.MEDIA_ERROR,
      details: I.BUFFER_APPENDING_ERROR,
      sourceBufferName: e,
      error: n,
      fatal: !1
    });
    const r = this.operationQueue.current(e);
    r && r.onError(n);
  }
  // This method must result in an updateend event; if remove is not called, _onSBUpdateEnd must be called manually
  removeExecutor(e, t, i) {
    const {
      media: n,
      mediaSource: r,
      operationQueue: a,
      sourceBuffer: o
    } = this, l = o[e];
    if (!n || !r || !l) {
      this.warn(`Attempting to remove from the ${e} SourceBuffer, but it does not exist`), a.shiftAndExecuteNext(e);
      return;
    }
    const c = U(n.duration) ? n.duration : 1 / 0, h = U(r.duration) ? r.duration : 1 / 0, u = Math.max(0, t), d = Math.min(i, c, h);
    d > u && (!l.ending || l.ended) ? (l.ended = !1, this.log(`Removing [${u},${d}] from the ${e} SourceBuffer`), l.remove(u, d)) : a.shiftAndExecuteNext(e);
  }
  // This method must result in an updateend event; if append is not called, _onSBUpdateEnd must be called manually
  appendExecutor(e, t) {
    const i = this.sourceBuffer[t];
    if (!i) {
      if (!this.pendingTracks[t])
        throw new Error(`Attempting to append to the ${t} SourceBuffer, but it does not exist`);
      return;
    }
    i.ended = !1, i.appendBuffer(e);
  }
  // Enqueues an operation to each SourceBuffer queue which, upon execution, resolves a promise. When all promises
  // resolve, the onUnblocked function is executed. Functions calling this method do not need to unblock the queue
  // upon completion, since we already do it here
  blockBuffers(e, t = this.getSourceBufferTypes()) {
    if (!t.length) {
      this.log("Blocking operation requested, but no SourceBuffers exist"), Promise.resolve().then(e);
      return;
    }
    const {
      operationQueue: i
    } = this, n = t.map((r) => i.appendBlocker(r));
    Promise.all(n).then(() => {
      e(), t.forEach((r) => {
        const a = this.sourceBuffer[r];
        a != null && a.updating || i.shiftAndExecuteNext(r);
      });
    });
  }
  getSourceBufferTypes() {
    return Object.keys(this.sourceBuffer);
  }
  addBufferListener(e, t, i) {
    const n = this.sourceBuffer[e];
    if (!n)
      return;
    const r = i.bind(this, e);
    this.listeners[e].push({
      event: t,
      listener: r
    }), n.addEventListener(t, r);
  }
  removeBufferListeners(e) {
    const t = this.sourceBuffer[e];
    t && this.listeners[e].forEach((i) => {
      t.removeEventListener(i.event, i.listener);
    });
  }
}
function Xn(s) {
  const e = s.querySelectorAll("source");
  [].slice.call(e).forEach((t) => {
    s.removeChild(t);
  });
}
function Uh(s, e) {
  const t = self.document.createElement("source");
  t.type = "video/mp4", t.src = e, s.appendChild(t);
}
const Bh = {
  42: 225,
  // lowercase a, acute accent
  92: 233,
  // lowercase e, acute accent
  94: 237,
  // lowercase i, acute accent
  95: 243,
  // lowercase o, acute accent
  96: 250,
  // lowercase u, acute accent
  123: 231,
  // lowercase c with cedilla
  124: 247,
  // division symbol
  125: 209,
  // uppercase N tilde
  126: 241,
  // lowercase n tilde
  127: 9608,
  // Full block
  // THIS BLOCK INCLUDES THE 16 EXTENDED (TWO-BYTE) LINE 21 CHARACTERS
  // THAT COME FROM HI BYTE=0x11 AND LOW BETWEEN 0x30 AND 0x3F
  // THIS MEANS THAT \x50 MUST BE ADDED TO THE VALUES
  128: 174,
  // Registered symbol (R)
  129: 176,
  // degree sign
  130: 189,
  // 1/2 symbol
  131: 191,
  // Inverted (open) question mark
  132: 8482,
  // Trademark symbol (TM)
  133: 162,
  // Cents symbol
  134: 163,
  // Pounds sterling
  135: 9834,
  // Music 8'th note
  136: 224,
  // lowercase a, grave accent
  137: 32,
  // transparent space (regular)
  138: 232,
  // lowercase e, grave accent
  139: 226,
  // lowercase a, circumflex accent
  140: 234,
  // lowercase e, circumflex accent
  141: 238,
  // lowercase i, circumflex accent
  142: 244,
  // lowercase o, circumflex accent
  143: 251,
  // lowercase u, circumflex accent
  // THIS BLOCK INCLUDES THE 32 EXTENDED (TWO-BYTE) LINE 21 CHARACTERS
  // THAT COME FROM HI BYTE=0x12 AND LOW BETWEEN 0x20 AND 0x3F
  144: 193,
  // capital letter A with acute
  145: 201,
  // capital letter E with acute
  146: 211,
  // capital letter O with acute
  147: 218,
  // capital letter U with acute
  148: 220,
  // capital letter U with diaresis
  149: 252,
  // lowercase letter U with diaeresis
  150: 8216,
  // opening single quote
  151: 161,
  // inverted exclamation mark
  152: 42,
  // asterisk
  153: 8217,
  // closing single quote
  154: 9473,
  // box drawings heavy horizontal
  155: 169,
  // copyright sign
  156: 8480,
  // Service mark
  157: 8226,
  // (round) bullet
  158: 8220,
  // Left double quotation mark
  159: 8221,
  // Right double quotation mark
  160: 192,
  // uppercase A, grave accent
  161: 194,
  // uppercase A, circumflex
  162: 199,
  // uppercase C with cedilla
  163: 200,
  // uppercase E, grave accent
  164: 202,
  // uppercase E, circumflex
  165: 203,
  // capital letter E with diaresis
  166: 235,
  // lowercase letter e with diaresis
  167: 206,
  // uppercase I, circumflex
  168: 207,
  // uppercase I, with diaresis
  169: 239,
  // lowercase i, with diaresis
  170: 212,
  // uppercase O, circumflex
  171: 217,
  // uppercase U, grave accent
  172: 249,
  // lowercase u, grave accent
  173: 219,
  // uppercase U, circumflex
  174: 171,
  // left-pointing double angle quotation mark
  175: 187,
  // right-pointing double angle quotation mark
  // THIS BLOCK INCLUDES THE 32 EXTENDED (TWO-BYTE) LINE 21 CHARACTERS
  // THAT COME FROM HI BYTE=0x13 AND LOW BETWEEN 0x20 AND 0x3F
  176: 195,
  // Uppercase A, tilde
  177: 227,
  // Lowercase a, tilde
  178: 205,
  // Uppercase I, acute accent
  179: 204,
  // Uppercase I, grave accent
  180: 236,
  // Lowercase i, grave accent
  181: 210,
  // Uppercase O, grave accent
  182: 242,
  // Lowercase o, grave accent
  183: 213,
  // Uppercase O, tilde
  184: 245,
  // Lowercase o, tilde
  185: 123,
  // Open curly brace
  186: 125,
  // Closing curly brace
  187: 92,
  // Backslash
  188: 94,
  // Caret
  189: 95,
  // Underscore
  190: 124,
  // Pipe (vertical line)
  191: 8764,
  // Tilde operator
  192: 196,
  // Uppercase A, umlaut
  193: 228,
  // Lowercase A, umlaut
  194: 214,
  // Uppercase O, umlaut
  195: 246,
  // Lowercase o, umlaut
  196: 223,
  // Esszett (sharp S)
  197: 165,
  // Yen symbol
  198: 164,
  // Generic currency sign
  199: 9475,
  // Box drawings heavy vertical
  200: 197,
  // Uppercase A, ring
  201: 229,
  // Lowercase A, ring
  202: 216,
  // Uppercase O, stroke
  203: 248,
  // Lowercase o, strok
  204: 9487,
  // Box drawings heavy down and right
  205: 9491,
  // Box drawings heavy down and left
  206: 9495,
  // Box drawings heavy up and right
  207: 9499
  // Box drawings heavy up and left
}, La = (s) => String.fromCharCode(Bh[s] || s), Oe = 15, Ye = 100, $h = {
  17: 1,
  18: 3,
  21: 5,
  22: 7,
  23: 9,
  16: 11,
  19: 12,
  20: 14
}, Gh = {
  17: 2,
  18: 4,
  21: 6,
  22: 8,
  23: 10,
  19: 13,
  20: 15
}, Hh = {
  25: 1,
  26: 3,
  29: 5,
  30: 7,
  31: 9,
  24: 11,
  27: 12,
  28: 14
}, Kh = {
  25: 2,
  26: 4,
  29: 6,
  30: 8,
  31: 10,
  27: 13,
  28: 15
}, Vh = ["white", "green", "blue", "cyan", "red", "yellow", "magenta", "black", "transparent"];
class Wh {
  constructor() {
    this.time = null, this.verboseLevel = 0;
  }
  log(e, t) {
    if (this.verboseLevel >= e) {
      const i = typeof t == "function" ? t() : t;
      S.log(`${this.time} [${e}] ${i}`);
    }
  }
}
const st = function(e) {
  const t = [];
  for (let i = 0; i < e.length; i++)
    t.push(e[i].toString(16));
  return t;
};
class Ra {
  constructor() {
    this.foreground = "white", this.underline = !1, this.italics = !1, this.background = "black", this.flash = !1;
  }
  reset() {
    this.foreground = "white", this.underline = !1, this.italics = !1, this.background = "black", this.flash = !1;
  }
  setStyles(e) {
    const t = ["foreground", "underline", "italics", "background", "flash"];
    for (let i = 0; i < t.length; i++) {
      const n = t[i];
      e.hasOwnProperty(n) && (this[n] = e[n]);
    }
  }
  isDefault() {
    return this.foreground === "white" && !this.underline && !this.italics && this.background === "black" && !this.flash;
  }
  equals(e) {
    return this.foreground === e.foreground && this.underline === e.underline && this.italics === e.italics && this.background === e.background && this.flash === e.flash;
  }
  copy(e) {
    this.foreground = e.foreground, this.underline = e.underline, this.italics = e.italics, this.background = e.background, this.flash = e.flash;
  }
  toString() {
    return "color=" + this.foreground + ", underline=" + this.underline + ", italics=" + this.italics + ", background=" + this.background + ", flash=" + this.flash;
  }
}
class Yh {
  constructor() {
    this.uchar = " ", this.penState = new Ra();
  }
  reset() {
    this.uchar = " ", this.penState.reset();
  }
  setChar(e, t) {
    this.uchar = e, this.penState.copy(t);
  }
  setPenState(e) {
    this.penState.copy(e);
  }
  equals(e) {
    return this.uchar === e.uchar && this.penState.equals(e.penState);
  }
  copy(e) {
    this.uchar = e.uchar, this.penState.copy(e.penState);
  }
  isEmpty() {
    return this.uchar === " " && this.penState.isDefault();
  }
}
class jh {
  constructor(e) {
    this.chars = [], this.pos = 0, this.currPenState = new Ra(), this.cueStartTime = null, this.logger = void 0;
    for (let t = 0; t < Ye; t++)
      this.chars.push(new Yh());
    this.logger = e;
  }
  equals(e) {
    for (let t = 0; t < Ye; t++)
      if (!this.chars[t].equals(e.chars[t]))
        return !1;
    return !0;
  }
  copy(e) {
    for (let t = 0; t < Ye; t++)
      this.chars[t].copy(e.chars[t]);
  }
  isEmpty() {
    let e = !0;
    for (let t = 0; t < Ye; t++)
      if (!this.chars[t].isEmpty()) {
        e = !1;
        break;
      }
    return e;
  }
  /**
   *  Set the cursor to a valid column.
   */
  setCursor(e) {
    this.pos !== e && (this.pos = e), this.pos < 0 ? (this.logger.log(3, "Negative cursor position " + this.pos), this.pos = 0) : this.pos > Ye && (this.logger.log(3, "Too large cursor position " + this.pos), this.pos = Ye);
  }
  /**
   * Move the cursor relative to current position.
   */
  moveCursor(e) {
    const t = this.pos + e;
    if (e > 1)
      for (let i = this.pos + 1; i < t + 1; i++)
        this.chars[i].setPenState(this.currPenState);
    this.setCursor(t);
  }
  /**
   * Backspace, move one step back and clear character.
   */
  backSpace() {
    this.moveCursor(-1), this.chars[this.pos].setChar(" ", this.currPenState);
  }
  insertChar(e) {
    e >= 144 && this.backSpace();
    const t = La(e);
    if (this.pos >= Ye) {
      this.logger.log(0, () => "Cannot insert " + e.toString(16) + " (" + t + ") at position " + this.pos + ". Skipping it!");
      return;
    }
    this.chars[this.pos].setChar(t, this.currPenState), this.moveCursor(1);
  }
  clearFromPos(e) {
    let t;
    for (t = e; t < Ye; t++)
      this.chars[t].reset();
  }
  clear() {
    this.clearFromPos(0), this.pos = 0, this.currPenState.reset();
  }
  clearToEndOfRow() {
    this.clearFromPos(this.pos);
  }
  getTextString() {
    const e = [];
    let t = !0;
    for (let i = 0; i < Ye; i++) {
      const n = this.chars[i].uchar;
      n !== " " && (t = !1), e.push(n);
    }
    return t ? "" : e.join("");
  }
  setPenStyles(e) {
    this.currPenState.setStyles(e), this.chars[this.pos].setPenState(this.currPenState);
  }
}
class Qi {
  constructor(e) {
    this.rows = [], this.currRow = Oe - 1, this.nrRollUpRows = null, this.lastOutputScreen = null, this.logger = void 0;
    for (let t = 0; t < Oe; t++)
      this.rows.push(new jh(e));
    this.logger = e;
  }
  reset() {
    for (let e = 0; e < Oe; e++)
      this.rows[e].clear();
    this.currRow = Oe - 1;
  }
  equals(e) {
    let t = !0;
    for (let i = 0; i < Oe; i++)
      if (!this.rows[i].equals(e.rows[i])) {
        t = !1;
        break;
      }
    return t;
  }
  copy(e) {
    for (let t = 0; t < Oe; t++)
      this.rows[t].copy(e.rows[t]);
  }
  isEmpty() {
    let e = !0;
    for (let t = 0; t < Oe; t++)
      if (!this.rows[t].isEmpty()) {
        e = !1;
        break;
      }
    return e;
  }
  backSpace() {
    this.rows[this.currRow].backSpace();
  }
  clearToEndOfRow() {
    this.rows[this.currRow].clearToEndOfRow();
  }
  /**
   * Insert a character (without styling) in the current row.
   */
  insertChar(e) {
    this.rows[this.currRow].insertChar(e);
  }
  setPen(e) {
    this.rows[this.currRow].setPenStyles(e);
  }
  moveCursor(e) {
    this.rows[this.currRow].moveCursor(e);
  }
  setCursor(e) {
    this.logger.log(2, "setCursor: " + e), this.rows[this.currRow].setCursor(e);
  }
  setPAC(e) {
    this.logger.log(2, () => "pacData = " + JSON.stringify(e));
    let t = e.row - 1;
    if (this.nrRollUpRows && t < this.nrRollUpRows - 1 && (t = this.nrRollUpRows - 1), this.nrRollUpRows && this.currRow !== t) {
      for (let o = 0; o < Oe; o++)
        this.rows[o].clear();
      const r = this.currRow + 1 - this.nrRollUpRows, a = this.lastOutputScreen;
      if (a) {
        const o = a.rows[r].cueStartTime, l = this.logger.time;
        if (o !== null && l !== null && o < l)
          for (let c = 0; c < this.nrRollUpRows; c++)
            this.rows[t - this.nrRollUpRows + c + 1].copy(a.rows[r + c]);
      }
    }
    this.currRow = t;
    const i = this.rows[this.currRow];
    if (e.indent !== null) {
      const r = e.indent, a = Math.max(r - 1, 0);
      i.setCursor(e.indent), e.color = i.chars[a].penState.foreground;
    }
    const n = {
      foreground: e.color,
      underline: e.underline,
      italics: e.italics,
      background: "black",
      flash: !1
    };
    this.setPen(n);
  }
  /**
   * Set background/extra foreground, but first do back_space, and then insert space (backwards compatibility).
   */
  setBkgData(e) {
    this.logger.log(2, () => "bkgData = " + JSON.stringify(e)), this.backSpace(), this.setPen(e), this.insertChar(32);
  }
  setRollUpRows(e) {
    this.nrRollUpRows = e;
  }
  rollUp() {
    if (this.nrRollUpRows === null) {
      this.logger.log(3, "roll_up but nrRollUpRows not set yet");
      return;
    }
    this.logger.log(1, () => this.getDisplayText());
    const e = this.currRow + 1 - this.nrRollUpRows, t = this.rows.splice(e, 1)[0];
    t.clear(), this.rows.splice(this.currRow, 0, t), this.logger.log(2, "Rolling up");
  }
  /**
   * Get all non-empty rows with as unicode text.
   */
  getDisplayText(e) {
    e = e || !1;
    const t = [];
    let i = "", n = -1;
    for (let r = 0; r < Oe; r++) {
      const a = this.rows[r].getTextString();
      a && (n = r + 1, e ? t.push("Row " + n + ": '" + a + "'") : t.push(a.trim()));
    }
    return t.length > 0 && (e ? i = "[" + t.join(" | ") + "]" : i = t.join(`
`)), i;
  }
  getTextAndFormat() {
    return this.rows;
  }
}
class Qn {
  constructor(e, t, i) {
    this.chNr = void 0, this.outputFilter = void 0, this.mode = void 0, this.verbose = void 0, this.displayedMemory = void 0, this.nonDisplayedMemory = void 0, this.lastOutputScreen = void 0, this.currRollUpRow = void 0, this.writeScreen = void 0, this.cueStartTime = void 0, this.logger = void 0, this.chNr = e, this.outputFilter = t, this.mode = null, this.verbose = 0, this.displayedMemory = new Qi(i), this.nonDisplayedMemory = new Qi(i), this.lastOutputScreen = new Qi(i), this.currRollUpRow = this.displayedMemory.rows[Oe - 1], this.writeScreen = this.displayedMemory, this.mode = null, this.cueStartTime = null, this.logger = i;
  }
  reset() {
    this.mode = null, this.displayedMemory.reset(), this.nonDisplayedMemory.reset(), this.lastOutputScreen.reset(), this.outputFilter.reset(), this.currRollUpRow = this.displayedMemory.rows[Oe - 1], this.writeScreen = this.displayedMemory, this.mode = null, this.cueStartTime = null;
  }
  getHandler() {
    return this.outputFilter;
  }
  setHandler(e) {
    this.outputFilter = e;
  }
  setPAC(e) {
    this.writeScreen.setPAC(e);
  }
  setBkgData(e) {
    this.writeScreen.setBkgData(e);
  }
  setMode(e) {
    e !== this.mode && (this.mode = e, this.logger.log(2, () => "MODE=" + e), this.mode === "MODE_POP-ON" ? this.writeScreen = this.nonDisplayedMemory : (this.writeScreen = this.displayedMemory, this.writeScreen.reset()), this.mode !== "MODE_ROLL-UP" && (this.displayedMemory.nrRollUpRows = null, this.nonDisplayedMemory.nrRollUpRows = null), this.mode = e);
  }
  insertChars(e) {
    for (let i = 0; i < e.length; i++)
      this.writeScreen.insertChar(e[i]);
    const t = this.writeScreen === this.displayedMemory ? "DISP" : "NON_DISP";
    this.logger.log(2, () => t + ": " + this.writeScreen.getDisplayText(!0)), (this.mode === "MODE_PAINT-ON" || this.mode === "MODE_ROLL-UP") && (this.logger.log(1, () => "DISPLAYED: " + this.displayedMemory.getDisplayText(!0)), this.outputDataUpdate());
  }
  ccRCL() {
    this.logger.log(2, "RCL - Resume Caption Loading"), this.setMode("MODE_POP-ON");
  }
  ccBS() {
    this.logger.log(2, "BS - BackSpace"), this.mode !== "MODE_TEXT" && (this.writeScreen.backSpace(), this.writeScreen === this.displayedMemory && this.outputDataUpdate());
  }
  ccAOF() {
  }
  ccAON() {
  }
  ccDER() {
    this.logger.log(2, "DER- Delete to End of Row"), this.writeScreen.clearToEndOfRow(), this.outputDataUpdate();
  }
  ccRU(e) {
    this.logger.log(2, "RU(" + e + ") - Roll Up"), this.writeScreen = this.displayedMemory, this.setMode("MODE_ROLL-UP"), this.writeScreen.setRollUpRows(e);
  }
  ccFON() {
    this.logger.log(2, "FON - Flash On"), this.writeScreen.setPen({
      flash: !0
    });
  }
  ccRDC() {
    this.logger.log(2, "RDC - Resume Direct Captioning"), this.setMode("MODE_PAINT-ON");
  }
  ccTR() {
    this.logger.log(2, "TR"), this.setMode("MODE_TEXT");
  }
  ccRTD() {
    this.logger.log(2, "RTD"), this.setMode("MODE_TEXT");
  }
  ccEDM() {
    this.logger.log(2, "EDM - Erase Displayed Memory"), this.displayedMemory.reset(), this.outputDataUpdate(!0);
  }
  ccCR() {
    this.logger.log(2, "CR - Carriage Return"), this.writeScreen.rollUp(), this.outputDataUpdate(!0);
  }
  ccENM() {
    this.logger.log(2, "ENM - Erase Non-displayed Memory"), this.nonDisplayedMemory.reset();
  }
  ccEOC() {
    if (this.logger.log(2, "EOC - End Of Caption"), this.mode === "MODE_POP-ON") {
      const e = this.displayedMemory;
      this.displayedMemory = this.nonDisplayedMemory, this.nonDisplayedMemory = e, this.writeScreen = this.nonDisplayedMemory, this.logger.log(1, () => "DISP: " + this.displayedMemory.getDisplayText());
    }
    this.outputDataUpdate(!0);
  }
  ccTO(e) {
    this.logger.log(2, "TO(" + e + ") - Tab Offset"), this.writeScreen.moveCursor(e);
  }
  ccMIDROW(e) {
    const t = {
      flash: !1
    };
    if (t.underline = e % 2 === 1, t.italics = e >= 46, t.italics)
      t.foreground = "white";
    else {
      const i = Math.floor(e / 2) - 16, n = ["white", "green", "blue", "cyan", "red", "yellow", "magenta"];
      t.foreground = n[i];
    }
    this.logger.log(2, "MIDROW: " + JSON.stringify(t)), this.writeScreen.setPen(t);
  }
  outputDataUpdate(e = !1) {
    const t = this.logger.time;
    t !== null && this.outputFilter && (this.cueStartTime === null && !this.displayedMemory.isEmpty() ? this.cueStartTime = t : this.displayedMemory.equals(this.lastOutputScreen) || (this.outputFilter.newCue(this.cueStartTime, t, this.lastOutputScreen), e && this.outputFilter.dispatchCue && this.outputFilter.dispatchCue(), this.cueStartTime = this.displayedMemory.isEmpty() ? null : t), this.lastOutputScreen.copy(this.displayedMemory));
  }
  cueSplitAtTime(e) {
    this.outputFilter && (this.displayedMemory.isEmpty() || (this.outputFilter.newCue && this.outputFilter.newCue(this.cueStartTime, e, this.displayedMemory), this.cueStartTime = e));
  }
}
class Jn {
  constructor(e, t, i) {
    this.channels = void 0, this.currentChannel = 0, this.cmdHistory = zh(), this.logger = void 0;
    const n = this.logger = new Wh();
    this.channels = [null, new Qn(e, t, n), new Qn(e + 1, i, n)];
  }
  getHandler(e) {
    return this.channels[e].getHandler();
  }
  setHandler(e, t) {
    this.channels[e].setHandler(t);
  }
  /**
   * Add data for time t in forms of list of bytes (unsigned ints). The bytes are treated as pairs.
   */
  addData(e, t) {
    this.logger.time = e;
    for (let i = 0; i < t.length; i += 2) {
      const n = t[i] & 127, r = t[i + 1] & 127;
      let a = !1, o = null;
      if (n === 0 && r === 0)
        continue;
      this.logger.log(3, () => "[" + st([t[i], t[i + 1]]) + "] -> (" + st([n, r]) + ")");
      const l = this.cmdHistory;
      if (n >= 16 && n <= 31) {
        if (qh(n, r, l)) {
          qt(null, null, l), this.logger.log(3, () => "Repeated command (" + st([n, r]) + ") is dropped");
          continue;
        }
        qt(n, r, this.cmdHistory), a = this.parseCmd(n, r), a || (a = this.parseMidrow(n, r)), a || (a = this.parsePAC(n, r)), a || (a = this.parseBackgroundAttributes(n, r));
      } else
        qt(null, null, l);
      if (!a && (o = this.parseChars(n, r), o)) {
        const h = this.currentChannel;
        h && h > 0 ? this.channels[h].insertChars(o) : this.logger.log(2, "No channel found yet. TEXT-MODE?");
      }
      !a && !o && this.logger.log(2, () => "Couldn't parse cleaned data " + st([n, r]) + " orig: " + st([t[i], t[i + 1]]));
    }
  }
  /**
   * Parse Command.
   * @returns True if a command was found
   */
  parseCmd(e, t) {
    const i = (e === 20 || e === 28 || e === 21 || e === 29) && t >= 32 && t <= 47, n = (e === 23 || e === 31) && t >= 33 && t <= 35;
    if (!(i || n))
      return !1;
    const r = e === 20 || e === 21 || e === 23 ? 1 : 2, a = this.channels[r];
    return e === 20 || e === 21 || e === 28 || e === 29 ? t === 32 ? a.ccRCL() : t === 33 ? a.ccBS() : t === 34 ? a.ccAOF() : t === 35 ? a.ccAON() : t === 36 ? a.ccDER() : t === 37 ? a.ccRU(2) : t === 38 ? a.ccRU(3) : t === 39 ? a.ccRU(4) : t === 40 ? a.ccFON() : t === 41 ? a.ccRDC() : t === 42 ? a.ccTR() : t === 43 ? a.ccRTD() : t === 44 ? a.ccEDM() : t === 45 ? a.ccCR() : t === 46 ? a.ccENM() : t === 47 && a.ccEOC() : a.ccTO(t - 32), this.currentChannel = r, !0;
  }
  /**
   * Parse midrow styling command
   */
  parseMidrow(e, t) {
    let i = 0;
    if ((e === 17 || e === 25) && t >= 32 && t <= 47) {
      if (e === 17 ? i = 1 : i = 2, i !== this.currentChannel)
        return this.logger.log(0, "Mismatch channel in midrow parsing"), !1;
      const n = this.channels[i];
      return n ? (n.ccMIDROW(t), this.logger.log(3, () => "MIDROW (" + st([e, t]) + ")"), !0) : !1;
    }
    return !1;
  }
  /**
   * Parse Preable Access Codes (Table 53).
   * @returns {Boolean} Tells if PAC found
   */
  parsePAC(e, t) {
    let i;
    const n = (e >= 17 && e <= 23 || e >= 25 && e <= 31) && t >= 64 && t <= 127, r = (e === 16 || e === 24) && t >= 64 && t <= 95;
    if (!(n || r))
      return !1;
    const a = e <= 23 ? 1 : 2;
    t >= 64 && t <= 95 ? i = a === 1 ? $h[e] : Hh[e] : i = a === 1 ? Gh[e] : Kh[e];
    const o = this.channels[a];
    return o ? (o.setPAC(this.interpretPAC(i, t)), this.currentChannel = a, !0) : !1;
  }
  /**
   * Interpret the second byte of the pac, and return the information.
   * @returns pacData with style parameters
   */
  interpretPAC(e, t) {
    let i;
    const n = {
      color: null,
      italics: !1,
      indent: null,
      underline: !1,
      row: e
    };
    return t > 95 ? i = t - 96 : i = t - 64, n.underline = (i & 1) === 1, i <= 13 ? n.color = ["white", "green", "blue", "cyan", "red", "yellow", "magenta", "white"][Math.floor(i / 2)] : i <= 15 ? (n.italics = !0, n.color = "white") : n.indent = Math.floor((i - 16) / 2) * 4, n;
  }
  /**
   * Parse characters.
   * @returns An array with 1 to 2 codes corresponding to chars, if found. null otherwise.
   */
  parseChars(e, t) {
    let i, n = null, r = null;
    if (e >= 25 ? (i = 2, r = e - 8) : (i = 1, r = e), r >= 17 && r <= 19) {
      let a;
      r === 17 ? a = t + 80 : r === 18 ? a = t + 112 : a = t + 144, this.logger.log(2, () => "Special char '" + La(a) + "' in channel " + i), n = [a];
    } else e >= 32 && e <= 127 && (n = t === 0 ? [e] : [e, t]);
    return n && this.logger.log(3, () => "Char codes =  " + st(n).join(",")), n;
  }
  /**
   * Parse extended background attributes as well as new foreground color black.
   * @returns True if background attributes are found
   */
  parseBackgroundAttributes(e, t) {
    const i = (e === 16 || e === 24) && t >= 32 && t <= 47, n = (e === 23 || e === 31) && t >= 45 && t <= 47;
    if (!(i || n))
      return !1;
    let r;
    const a = {};
    e === 16 || e === 24 ? (r = Math.floor((t - 32) / 2), a.background = Vh[r], t % 2 === 1 && (a.background = a.background + "_semi")) : t === 45 ? a.background = "transparent" : (a.foreground = "black", t === 47 && (a.underline = !0));
    const o = e <= 23 ? 1 : 2;
    return this.channels[o].setBkgData(a), !0;
  }
  /**
   * Reset state of parser and its channels.
   */
  reset() {
    for (let e = 0; e < Object.keys(this.channels).length; e++) {
      const t = this.channels[e];
      t && t.reset();
    }
    qt(null, null, this.cmdHistory);
  }
  /**
   * Trigger the generation of a cue, and the start of a new one if displayScreens are not empty.
   */
  cueSplitAtTime(e) {
    for (let t = 0; t < this.channels.length; t++) {
      const i = this.channels[t];
      i && i.cueSplitAtTime(e);
    }
  }
}
function qt(s, e, t) {
  t.a = s, t.b = e;
}
function qh(s, e, t) {
  return t.a === s && t.b === e;
}
function zh() {
  return {
    a: null,
    b: null
  };
}
class zt {
  constructor(e, t) {
    this.timelineController = void 0, this.cueRanges = [], this.trackName = void 0, this.startTime = null, this.endTime = null, this.screen = null, this.timelineController = e, this.trackName = t;
  }
  dispatchCue() {
    this.startTime !== null && (this.timelineController.addCues(this.trackName, this.startTime, this.endTime, this.screen, this.cueRanges), this.startTime = null);
  }
  newCue(e, t, i) {
    (this.startTime === null || this.startTime > e) && (this.startTime = e), this.endTime = t, this.screen = i, this.timelineController.createCaptionsTrack(this.trackName);
  }
  reset() {
    this.cueRanges = [], this.startTime = null;
  }
}
var Ys = function() {
  if (Et != null && Et.VTTCue)
    return self.VTTCue;
  const s = ["", "lr", "rl"], e = ["start", "middle", "end", "left", "right"];
  function t(o, l) {
    if (typeof l != "string" || !Array.isArray(o))
      return !1;
    const c = l.toLowerCase();
    return ~o.indexOf(c) ? c : !1;
  }
  function i(o) {
    return t(s, o);
  }
  function n(o) {
    return t(e, o);
  }
  function r(o, ...l) {
    let c = 1;
    for (; c < arguments.length; c++) {
      const h = arguments[c];
      for (const u in h)
        o[u] = h[u];
    }
    return o;
  }
  function a(o, l, c) {
    const h = this, u = {
      enumerable: !0
    };
    h.hasBeenReset = !1;
    let d = "", g = !1, f = o, m = l, y = c, T = null, b = "", v = !0, A = "auto", x = "start", w = 50, R = "middle", k = 50, _ = "middle";
    Object.defineProperty(h, "id", r({}, u, {
      get: function() {
        return d;
      },
      set: function(C) {
        d = "" + C;
      }
    })), Object.defineProperty(h, "pauseOnExit", r({}, u, {
      get: function() {
        return g;
      },
      set: function(C) {
        g = !!C;
      }
    })), Object.defineProperty(h, "startTime", r({}, u, {
      get: function() {
        return f;
      },
      set: function(C) {
        if (typeof C != "number")
          throw new TypeError("Start time must be set to a number.");
        f = C, this.hasBeenReset = !0;
      }
    })), Object.defineProperty(h, "endTime", r({}, u, {
      get: function() {
        return m;
      },
      set: function(C) {
        if (typeof C != "number")
          throw new TypeError("End time must be set to a number.");
        m = C, this.hasBeenReset = !0;
      }
    })), Object.defineProperty(h, "text", r({}, u, {
      get: function() {
        return y;
      },
      set: function(C) {
        y = "" + C, this.hasBeenReset = !0;
      }
    })), Object.defineProperty(h, "region", r({}, u, {
      get: function() {
        return T;
      },
      set: function(C) {
        T = C, this.hasBeenReset = !0;
      }
    })), Object.defineProperty(h, "vertical", r({}, u, {
      get: function() {
        return b;
      },
      set: function(C) {
        const P = i(C);
        if (P === !1)
          throw new SyntaxError("An invalid or illegal string was specified.");
        b = P, this.hasBeenReset = !0;
      }
    })), Object.defineProperty(h, "snapToLines", r({}, u, {
      get: function() {
        return v;
      },
      set: function(C) {
        v = !!C, this.hasBeenReset = !0;
      }
    })), Object.defineProperty(h, "line", r({}, u, {
      get: function() {
        return A;
      },
      set: function(C) {
        if (typeof C != "number" && C !== "auto")
          throw new SyntaxError("An invalid number or illegal string was specified.");
        A = C, this.hasBeenReset = !0;
      }
    })), Object.defineProperty(h, "lineAlign", r({}, u, {
      get: function() {
        return x;
      },
      set: function(C) {
        const P = n(C);
        if (!P)
          throw new SyntaxError("An invalid or illegal string was specified.");
        x = P, this.hasBeenReset = !0;
      }
    })), Object.defineProperty(h, "position", r({}, u, {
      get: function() {
        return w;
      },
      set: function(C) {
        if (C < 0 || C > 100)
          throw new Error("Position must be between 0 and 100.");
        w = C, this.hasBeenReset = !0;
      }
    })), Object.defineProperty(h, "positionAlign", r({}, u, {
      get: function() {
        return R;
      },
      set: function(C) {
        const P = n(C);
        if (!P)
          throw new SyntaxError("An invalid or illegal string was specified.");
        R = P, this.hasBeenReset = !0;
      }
    })), Object.defineProperty(h, "size", r({}, u, {
      get: function() {
        return k;
      },
      set: function(C) {
        if (C < 0 || C > 100)
          throw new Error("Size must be between 0 and 100.");
        k = C, this.hasBeenReset = !0;
      }
    })), Object.defineProperty(h, "align", r({}, u, {
      get: function() {
        return _;
      },
      set: function(C) {
        const P = n(C);
        if (!P)
          throw new SyntaxError("An invalid or illegal string was specified.");
        _ = P, this.hasBeenReset = !0;
      }
    })), h.displayState = void 0;
  }
  return a.prototype.getCueAsHTML = function() {
    return self.WebVTT.convertCueToDOMTree(self, this.text);
  }, a;
}();
class Xh {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  decode(e, t) {
    if (!e)
      return "";
    if (typeof e != "string")
      throw new Error("Error - expected string data.");
    return decodeURIComponent(encodeURIComponent(e));
  }
}
function Ia(s) {
  function e(i, n, r, a) {
    return (i | 0) * 3600 + (n | 0) * 60 + (r | 0) + parseFloat(a || 0);
  }
  const t = s.match(/^(?:(\d+):)?(\d{2}):(\d{2})(\.\d+)?/);
  return t ? parseFloat(t[2]) > 59 ? e(t[2], t[3], 0, t[4]) : e(t[1], t[2], t[3], t[4]) : null;
}
class Qh {
  constructor() {
    this.values = /* @__PURE__ */ Object.create(null);
  }
  // Only accept the first assignment to any key.
  set(e, t) {
    !this.get(e) && t !== "" && (this.values[e] = t);
  }
  // Return the value for a key, or a default value.
  // If 'defaultKey' is passed then 'dflt' is assumed to be an object with
  // a number of possible default values as properties where 'defaultKey' is
  // the key of the property that will be chosen; otherwise it's assumed to be
  // a single value.
  get(e, t, i) {
    return i ? this.has(e) ? this.values[e] : t[i] : this.has(e) ? this.values[e] : t;
  }
  // Check whether we have a value for a key.
  has(e) {
    return e in this.values;
  }
  // Accept a setting if its one of the given alternatives.
  alt(e, t, i) {
    for (let n = 0; n < i.length; ++n)
      if (t === i[n]) {
        this.set(e, t);
        break;
      }
  }
  // Accept a setting if its a valid (signed) integer.
  integer(e, t) {
    /^-?\d+$/.test(t) && this.set(e, parseInt(t, 10));
  }
  // Accept a setting if its a valid percentage.
  percent(e, t) {
    if (/^([\d]{1,3})(\.[\d]*)?%$/.test(t)) {
      const i = parseFloat(t);
      if (i >= 0 && i <= 100)
        return this.set(e, i), !0;
    }
    return !1;
  }
}
function wa(s, e, t, i) {
  const n = i ? s.split(i) : [s];
  for (const r in n) {
    if (typeof n[r] != "string")
      continue;
    const a = n[r].split(t);
    if (a.length !== 2)
      continue;
    const o = a[0], l = a[1];
    e(o, l);
  }
}
const xs = new Ys(0, 0, ""), Xt = xs.align === "middle" ? "middle" : "center";
function Jh(s, e, t) {
  const i = s;
  function n() {
    const o = Ia(s);
    if (o === null)
      throw new Error("Malformed timestamp: " + i);
    return s = s.replace(/^[^\sa-zA-Z-]+/, ""), o;
  }
  function r(o, l) {
    const c = new Qh();
    wa(o, function(d, g) {
      let f;
      switch (d) {
        case "region":
          for (let m = t.length - 1; m >= 0; m--)
            if (t[m].id === g) {
              c.set(d, t[m].region);
              break;
            }
          break;
        case "vertical":
          c.alt(d, g, ["rl", "lr"]);
          break;
        case "line":
          f = g.split(","), c.integer(d, f[0]), c.percent(d, f[0]) && c.set("snapToLines", !1), c.alt(d, f[0], ["auto"]), f.length === 2 && c.alt("lineAlign", f[1], ["start", Xt, "end"]);
          break;
        case "position":
          f = g.split(","), c.percent(d, f[0]), f.length === 2 && c.alt("positionAlign", f[1], ["start", Xt, "end", "line-left", "line-right", "auto"]);
          break;
        case "size":
          c.percent(d, g);
          break;
        case "align":
          c.alt(d, g, ["start", Xt, "end", "left", "right"]);
          break;
      }
    }, /:/, /\s/), l.region = c.get("region", null), l.vertical = c.get("vertical", "");
    let h = c.get("line", "auto");
    h === "auto" && xs.line === -1 && (h = -1), l.line = h, l.lineAlign = c.get("lineAlign", "start"), l.snapToLines = c.get("snapToLines", !0), l.size = c.get("size", 100), l.align = c.get("align", Xt);
    let u = c.get("position", "auto");
    u === "auto" && xs.position === 50 && (u = l.align === "start" || l.align === "left" ? 0 : l.align === "end" || l.align === "right" ? 100 : 50), l.position = u;
  }
  function a() {
    s = s.replace(/^\s+/, "");
  }
  if (a(), e.startTime = n(), a(), s.slice(0, 3) !== "-->")
    throw new Error("Malformed time stamp (time stamps must be separated by '-->'): " + i);
  s = s.slice(3), a(), e.endTime = n(), a(), r(s, e);
}
function Ca(s) {
  return s.replace(/<br(?: \/)?>/gi, `
`);
}
class Zh {
  constructor() {
    this.state = "INITIAL", this.buffer = "", this.decoder = new Xh(), this.regionList = [], this.cue = null, this.oncue = void 0, this.onparsingerror = void 0, this.onflush = void 0;
  }
  parse(e) {
    const t = this;
    e && (t.buffer += t.decoder.decode(e, {
      stream: !0
    }));
    function i() {
      let r = t.buffer, a = 0;
      for (r = Ca(r); a < r.length && r[a] !== "\r" && r[a] !== `
`; )
        ++a;
      const o = r.slice(0, a);
      return r[a] === "\r" && ++a, r[a] === `
` && ++a, t.buffer = r.slice(a), o;
    }
    function n(r) {
      wa(r, function(a, o) {
      }, /:/);
    }
    try {
      let r = "";
      if (t.state === "INITIAL") {
        if (!/\r\n|\n/.test(t.buffer))
          return this;
        r = i();
        const o = r.match(/^(ï»¿)?WEBVTT([ \t].*)?$/);
        if (!(o != null && o[0]))
          throw new Error("Malformed WebVTT signature.");
        t.state = "HEADER";
      }
      let a = !1;
      for (; t.buffer; ) {
        if (!/\r\n|\n/.test(t.buffer))
          return this;
        switch (a ? a = !1 : r = i(), t.state) {
          case "HEADER":
            /:/.test(r) ? n(r) : r || (t.state = "ID");
            continue;
          case "NOTE":
            r || (t.state = "ID");
            continue;
          case "ID":
            if (/^NOTE($|[ \t])/.test(r)) {
              t.state = "NOTE";
              break;
            }
            if (!r)
              continue;
            if (t.cue = new Ys(0, 0, ""), t.state = "CUE", r.indexOf("-->") === -1) {
              t.cue.id = r;
              continue;
            }
          // Process line as start of a cue.
          /* falls through */
          case "CUE":
            if (!t.cue) {
              t.state = "BADCUE";
              continue;
            }
            try {
              Jh(r, t.cue, t.regionList);
            } catch (o) {
              t.cue = null, t.state = "BADCUE";
              continue;
            }
            t.state = "CUETEXT";
            continue;
          case "CUETEXT":
            {
              const o = r.indexOf("-->") !== -1;
              if (!r || o && (a = !0)) {
                t.oncue && t.cue && t.oncue(t.cue), t.cue = null, t.state = "ID";
                continue;
              }
              if (t.cue === null)
                continue;
              t.cue.text && (t.cue.text += `
`), t.cue.text += r;
            }
            continue;
          case "BADCUE":
            r || (t.state = "ID");
        }
      }
    } catch (r) {
      t.state === "CUETEXT" && t.cue && t.oncue && t.oncue(t.cue), t.cue = null, t.state = t.state === "INITIAL" ? "BADWEBVTT" : "BADCUE";
    }
    return this;
  }
  flush() {
    const e = this;
    try {
      if ((e.cue || e.state === "HEADER") && (e.buffer += `

`, e.parse()), e.state === "INITIAL" || e.state === "BADWEBVTT")
        throw new Error("Malformed WebVTT signature.");
    } catch (t) {
      e.onparsingerror && e.onparsingerror(t);
    }
    return e.onflush && e.onflush(), this;
  }
}
const eu = /\r\n|\n\r|\n|\r/g, Ji = function(e, t, i = 0) {
  return e.slice(i, i + t.length) === t;
}, tu = function(e) {
  let t = parseInt(e.slice(-3));
  const i = parseInt(e.slice(-6, -4)), n = parseInt(e.slice(-9, -7)), r = e.length > 9 ? parseInt(e.substring(0, e.indexOf(":"))) : 0;
  if (!U(t) || !U(i) || !U(n) || !U(r))
    throw Error(`Malformed X-TIMESTAMP-MAP: Local:${e}`);
  return t += 1e3 * i, t += 60 * 1e3 * n, t += 60 * 60 * 1e3 * r, t;
}, Zi = function(e) {
  let t = 5381, i = e.length;
  for (; i; )
    t = t * 33 ^ e.charCodeAt(--i);
  return (t >>> 0).toString();
};
function js(s, e, t) {
  return Zi(s.toString()) + Zi(e.toString()) + Zi(t);
}
const iu = function(e, t, i) {
  let n = e[t], r = e[n.prevCC];
  if (!r || !r.new && n.new) {
    e.ccOffset = e.presentationOffset = n.start, n.new = !1;
    return;
  }
  for (; (a = r) != null && a.new; ) {
    var a;
    e.ccOffset += n.start - r.start, n.new = !1, n = r, r = e[n.prevCC];
  }
  e.presentationOffset = i;
};
function su(s, e, t, i, n, r, a) {
  const o = new Zh(), l = Ke(new Uint8Array(s)).trim().replace(eu, `
`).split(`
`), c = [], h = e ? vh(e.baseTime, e.timescale) : 0;
  let u = "00:00.000", d = 0, g = 0, f, m = !0;
  o.oncue = function(y) {
    const T = t[i];
    let b = t.ccOffset;
    const v = (d - h) / 9e4;
    if (T != null && T.new && (g !== void 0 ? b = t.ccOffset = T.start : iu(t, i, v)), v) {
      if (!e) {
        f = new Error("Missing initPTS for VTT MPEGTS");
        return;
      }
      b = v - t.presentationOffset;
    }
    const A = y.endTime - y.startTime, x = De((y.startTime + b - g) * 9e4, n * 9e4) / 9e4;
    y.startTime = Math.max(x, 0), y.endTime = Math.max(x + A, 0);
    const w = y.text.trim();
    y.text = decodeURIComponent(encodeURIComponent(w)), y.id || (y.id = js(y.startTime, y.endTime, w)), y.endTime > 0 && c.push(y);
  }, o.onparsingerror = function(y) {
    f = y;
  }, o.onflush = function() {
    if (f) {
      a(f);
      return;
    }
    r(c);
  }, l.forEach((y) => {
    if (m)
      if (Ji(y, "X-TIMESTAMP-MAP=")) {
        m = !1, y.slice(16).split(",").forEach((T) => {
          Ji(T, "LOCAL:") ? u = T.slice(6) : Ji(T, "MPEGTS:") && (d = parseInt(T.slice(7)));
        });
        try {
          g = tu(u) / 1e3;
        } catch (T) {
          f = T;
        }
        return;
      } else y === "" && (m = !1);
    o.parse(y + `
`);
  }), o.flush();
}
const es = "stpp.ttml.im1t", Da = /^(\d{2,}):(\d{2}):(\d{2}):(\d{2})\.?(\d+)?$/, ka = /^(\d*(?:\.\d*)?)(h|m|s|ms|f|t)$/, nu = {
  left: "start",
  center: "center",
  right: "end",
  start: "start",
  end: "end"
};
function Zn(s, e, t, i) {
  const n = z(new Uint8Array(s), ["mdat"]);
  if (n.length === 0) {
    i(new Error("Could not parse IMSC1 mdat"));
    return;
  }
  const r = n.map((o) => Ke(o)), a = Eh(e.baseTime, 1, e.timescale);
  try {
    r.forEach((o) => t(ru(o, a)));
  } catch (o) {
    i(o);
  }
}
function ru(s, e) {
  const n = new DOMParser().parseFromString(s, "text/xml").getElementsByTagName("tt")[0];
  if (!n)
    throw new Error("Invalid ttml");
  const r = {
    frameRate: 30,
    subFrameRate: 1,
    frameRateMultiplier: 0,
    tickRate: 0
  }, a = Object.keys(r).reduce((u, d) => (u[d] = n.getAttribute(`ttp:${d}`) || r[d], u), {}), o = n.getAttribute("xml:space") !== "preserve", l = er(ts(n, "styling", "style")), c = er(ts(n, "layout", "region")), h = ts(n, "body", "[begin]");
  return [].map.call(h, (u) => {
    const d = Pa(u, o);
    if (!d || !u.hasAttribute("begin"))
      return null;
    const g = ss(u.getAttribute("begin"), a), f = ss(u.getAttribute("dur"), a);
    let m = ss(u.getAttribute("end"), a);
    if (g === null)
      throw tr(u);
    if (m === null) {
      if (f === null)
        throw tr(u);
      m = g + f;
    }
    const y = new Ys(g - e, m - e, d);
    y.id = js(y.startTime, y.endTime, y.text);
    const T = c[u.getAttribute("region")], b = l[u.getAttribute("style")], v = au(T, b, l), {
      textAlign: A
    } = v;
    if (A) {
      const x = nu[A];
      x && (y.lineAlign = x), y.align = A;
    }
    return fe(y, v), y;
  }).filter((u) => u !== null);
}
function ts(s, e, t) {
  const i = s.getElementsByTagName(e)[0];
  return i ? [].slice.call(i.querySelectorAll(t)) : [];
}
function er(s) {
  return s.reduce((e, t) => {
    const i = t.getAttribute("xml:id");
    return i && (e[i] = t), e;
  }, {});
}
function Pa(s, e) {
  return [].slice.call(s.childNodes).reduce((t, i, n) => {
    var r;
    return i.nodeName === "br" && n ? t + `
` : (r = i.childNodes) != null && r.length ? Pa(i, e) : e ? t + i.textContent.trim().replace(/\s+/g, " ") : t + i.textContent;
  }, "");
}
function au(s, e, t) {
  const i = "http://www.w3.org/ns/ttml#styling";
  let n = null;
  const r = [
    "displayAlign",
    "textAlign",
    "color",
    "backgroundColor",
    "fontSize",
    "fontFamily"
    // 'fontWeight',
    // 'lineHeight',
    // 'wrapOption',
    // 'fontStyle',
    // 'direction',
    // 'writingMode'
  ], a = s != null && s.hasAttribute("style") ? s.getAttribute("style") : null;
  return a && t.hasOwnProperty(a) && (n = t[a]), r.reduce((o, l) => {
    const c = is(e, i, l) || is(s, i, l) || is(n, i, l);
    return c && (o[l] = c), o;
  }, {});
}
function is(s, e, t) {
  return s && s.hasAttributeNS(e, t) ? s.getAttributeNS(e, t) : null;
}
function tr(s) {
  return new Error(`Could not parse ttml timestamp ${s}`);
}
function ss(s, e) {
  if (!s)
    return null;
  let t = Ia(s);
  return t === null && (Da.test(s) ? t = ou(s, e) : ka.test(s) && (t = lu(s, e))), t;
}
function ou(s, e) {
  const t = Da.exec(s), i = (t[4] | 0) + (t[5] | 0) / e.subFrameRate;
  return (t[1] | 0) * 3600 + (t[2] | 0) * 60 + (t[3] | 0) + i / e.frameRate;
}
function lu(s, e) {
  const t = ka.exec(s), i = Number(t[1]);
  switch (t[2]) {
    case "h":
      return i * 3600;
    case "m":
      return i * 60;
    case "ms":
      return i * 1e3;
    case "f":
      return i / e.frameRate;
    case "t":
      return i / e.tickRate;
  }
  return i;
}
class cu {
  constructor(e) {
    this.hls = void 0, this.media = null, this.config = void 0, this.enabled = !0, this.Cues = void 0, this.textTracks = [], this.tracks = [], this.initPTS = [], this.unparsedVttFrags = [], this.captionsTracks = {}, this.nonNativeCaptionsTracks = {}, this.cea608Parser1 = void 0, this.cea608Parser2 = void 0, this.lastCc = -1, this.lastSn = -1, this.lastPartIndex = -1, this.prevCC = -1, this.vttCCs = sr(), this.captionsProperties = void 0, this.hls = e, this.config = e.config, this.Cues = e.config.cueHandler, this.captionsProperties = {
      textTrack1: {
        label: this.config.captionsTextTrack1Label,
        languageCode: this.config.captionsTextTrack1LanguageCode
      },
      textTrack2: {
        label: this.config.captionsTextTrack2Label,
        languageCode: this.config.captionsTextTrack2LanguageCode
      },
      textTrack3: {
        label: this.config.captionsTextTrack3Label,
        languageCode: this.config.captionsTextTrack3LanguageCode
      },
      textTrack4: {
        label: this.config.captionsTextTrack4Label,
        languageCode: this.config.captionsTextTrack4LanguageCode
      }
    }, e.on(p.MEDIA_ATTACHING, this.onMediaAttaching, this), e.on(p.MEDIA_DETACHING, this.onMediaDetaching, this), e.on(p.MANIFEST_LOADING, this.onManifestLoading, this), e.on(p.MANIFEST_LOADED, this.onManifestLoaded, this), e.on(p.SUBTITLE_TRACKS_UPDATED, this.onSubtitleTracksUpdated, this), e.on(p.FRAG_LOADING, this.onFragLoading, this), e.on(p.FRAG_LOADED, this.onFragLoaded, this), e.on(p.FRAG_PARSING_USERDATA, this.onFragParsingUserdata, this), e.on(p.FRAG_DECRYPTED, this.onFragDecrypted, this), e.on(p.INIT_PTS_FOUND, this.onInitPtsFound, this), e.on(p.SUBTITLE_TRACKS_CLEARED, this.onSubtitleTracksCleared, this), e.on(p.BUFFER_FLUSHING, this.onBufferFlushing, this);
  }
  destroy() {
    const {
      hls: e
    } = this;
    e.off(p.MEDIA_ATTACHING, this.onMediaAttaching, this), e.off(p.MEDIA_DETACHING, this.onMediaDetaching, this), e.off(p.MANIFEST_LOADING, this.onManifestLoading, this), e.off(p.MANIFEST_LOADED, this.onManifestLoaded, this), e.off(p.SUBTITLE_TRACKS_UPDATED, this.onSubtitleTracksUpdated, this), e.off(p.FRAG_LOADING, this.onFragLoading, this), e.off(p.FRAG_LOADED, this.onFragLoaded, this), e.off(p.FRAG_PARSING_USERDATA, this.onFragParsingUserdata, this), e.off(p.FRAG_DECRYPTED, this.onFragDecrypted, this), e.off(p.INIT_PTS_FOUND, this.onInitPtsFound, this), e.off(p.SUBTITLE_TRACKS_CLEARED, this.onSubtitleTracksCleared, this), e.off(p.BUFFER_FLUSHING, this.onBufferFlushing, this), this.hls = this.config = null, this.cea608Parser1 = this.cea608Parser2 = void 0;
  }
  initCea608Parsers() {
    if (this.config.enableCEA708Captions && (!this.cea608Parser1 || !this.cea608Parser2)) {
      const e = new zt(this, "textTrack1"), t = new zt(this, "textTrack2"), i = new zt(this, "textTrack3"), n = new zt(this, "textTrack4");
      this.cea608Parser1 = new Jn(1, e, t), this.cea608Parser2 = new Jn(3, i, n);
    }
  }
  addCues(e, t, i, n, r) {
    let a = !1;
    for (let o = r.length; o--; ) {
      const l = r[o], c = hu(l[0], l[1], t, i);
      if (c >= 0 && (l[0] = Math.min(l[0], t), l[1] = Math.max(l[1], i), a = !0, c / (i - t) > 0.5))
        return;
    }
    if (a || r.push([t, i]), this.config.renderTextTracksNatively) {
      const o = this.captionsTracks[e];
      this.Cues.newCue(o, t, i, n);
    } else {
      const o = this.Cues.newCue(null, t, i, n);
      this.hls.trigger(p.CUES_PARSED, {
        type: "captions",
        cues: o,
        track: e
      });
    }
  }
  // Triggered when an initial PTS is found; used for synchronisation of WebVTT.
  onInitPtsFound(e, {
    frag: t,
    id: i,
    initPTS: n,
    timescale: r
  }) {
    const {
      unparsedVttFrags: a
    } = this;
    i === "main" && (this.initPTS[t.cc] = {
      baseTime: n,
      timescale: r
    }), a.length && (this.unparsedVttFrags = [], a.forEach((o) => {
      this.onFragLoaded(p.FRAG_LOADED, o);
    }));
  }
  getExistingTrack(e, t) {
    const {
      media: i
    } = this;
    if (i)
      for (let n = 0; n < i.textTracks.length; n++) {
        const r = i.textTracks[n];
        if (ir(r, {
          name: e,
          lang: t
        }))
          return r;
      }
    return null;
  }
  createCaptionsTrack(e) {
    this.config.renderTextTracksNatively ? this.createNativeTrack(e) : this.createNonNativeTrack(e);
  }
  createNativeTrack(e) {
    if (this.captionsTracks[e])
      return;
    const {
      captionsProperties: t,
      captionsTracks: i,
      media: n
    } = this, {
      label: r,
      languageCode: a
    } = t[e], o = this.getExistingTrack(r, a);
    if (o)
      i[e] = o, mt(i[e]), Jr(i[e], n);
    else {
      const l = this.createTextTrack("captions", r, a);
      l && (l[e] = !0, i[e] = l);
    }
  }
  createNonNativeTrack(e) {
    if (this.nonNativeCaptionsTracks[e])
      return;
    const t = this.captionsProperties[e];
    if (!t)
      return;
    const i = t.label, n = {
      _id: e,
      label: i,
      kind: "captions",
      default: t.media ? !!t.media.default : !1,
      closedCaptions: t.media
    };
    this.nonNativeCaptionsTracks[e] = n, this.hls.trigger(p.NON_NATIVE_TEXT_TRACKS_FOUND, {
      tracks: [n]
    });
  }
  createTextTrack(e, t, i) {
    const n = this.media;
    if (n)
      return n.addTextTrack(e, t, i);
  }
  onMediaAttaching(e, t) {
    this.media = t.media, this._cleanTracks();
  }
  onMediaDetaching() {
    const {
      captionsTracks: e
    } = this;
    Object.keys(e).forEach((t) => {
      mt(e[t]), delete e[t];
    }), this.nonNativeCaptionsTracks = {};
  }
  onManifestLoading() {
    this.lastCc = -1, this.lastSn = -1, this.lastPartIndex = -1, this.prevCC = -1, this.vttCCs = sr(), this._cleanTracks(), this.tracks = [], this.captionsTracks = {}, this.nonNativeCaptionsTracks = {}, this.textTracks = [], this.unparsedVttFrags = [], this.initPTS = [], this.cea608Parser1 && this.cea608Parser2 && (this.cea608Parser1.reset(), this.cea608Parser2.reset());
  }
  _cleanTracks() {
    const {
      media: e
    } = this;
    if (!e)
      return;
    const t = e.textTracks;
    if (t)
      for (let i = 0; i < t.length; i++)
        mt(t[i]);
  }
  onSubtitleTracksUpdated(e, t) {
    const i = t.subtitleTracks || [], n = i.some((r) => r.textCodec === es);
    if (this.config.enableWebVTT || n && this.config.enableIMSC1) {
      if (Aa(this.tracks, i)) {
        this.tracks = i;
        return;
      }
      if (this.textTracks = [], this.tracks = i, this.config.renderTextTracksNatively) {
        const a = this.media, o = a ? ii(a.textTracks) : null;
        if (this.tracks.forEach((l, c) => {
          let h;
          if (o) {
            let u = null;
            for (let d = 0; d < o.length; d++)
              if (o[d] && ir(o[d], l)) {
                u = o[d], o[d] = null;
                break;
              }
            u && (h = u);
          }
          if (h)
            mt(h);
          else {
            const u = _a(l);
            h = this.createTextTrack(u, l.name, l.lang), h && (h.mode = "disabled");
          }
          h && this.textTracks.push(h);
        }), o != null && o.length) {
          const l = o.filter((c) => c !== null).map((c) => c.label);
          l.length && S.warn(`Media element contains unused subtitle tracks: ${l.join(", ")}. Replace media element for each source to clear TextTracks and captions menu.`);
        }
      } else if (this.tracks.length) {
        const a = this.tracks.map((o) => ({
          label: o.name,
          kind: o.type.toLowerCase(),
          default: o.default,
          subtitleTrack: o
        }));
        this.hls.trigger(p.NON_NATIVE_TEXT_TRACKS_FOUND, {
          tracks: a
        });
      }
    }
  }
  onManifestLoaded(e, t) {
    this.config.enableCEA708Captions && t.captions && t.captions.forEach((i) => {
      const n = /(?:CC|SERVICE)([1-4])/.exec(i.instreamId);
      if (!n)
        return;
      const r = `textTrack${n[1]}`, a = this.captionsProperties[r];
      a && (a.label = i.name, i.lang && (a.languageCode = i.lang), a.media = i);
    });
  }
  closedCaptionsForLevel(e) {
    const t = this.hls.levels[e.level];
    return t == null ? void 0 : t.attrs["CLOSED-CAPTIONS"];
  }
  onFragLoading(e, t) {
    if (this.enabled && t.frag.type === G.MAIN) {
      var i, n;
      const {
        cea608Parser1: r,
        cea608Parser2: a,
        lastSn: o
      } = this, {
        cc: l,
        sn: c
      } = t.frag, h = (i = (n = t.part) == null ? void 0 : n.index) != null ? i : -1;
      r && a && (c !== o + 1 || c === o && h !== this.lastPartIndex + 1 || l !== this.lastCc) && (r.reset(), a.reset()), this.lastCc = l, this.lastSn = c, this.lastPartIndex = h;
    }
  }
  onFragLoaded(e, t) {
    const {
      frag: i,
      payload: n
    } = t;
    if (i.type === G.SUBTITLE)
      if (n.byteLength) {
        const r = i.decryptdata, a = "stats" in t;
        if (r == null || !r.encrypted || a) {
          const o = this.tracks[i.level], l = this.vttCCs;
          l[i.cc] || (l[i.cc] = {
            start: i.start,
            prevCC: this.prevCC,
            new: !0
          }, this.prevCC = i.cc), o && o.textCodec === es ? this._parseIMSC1(i, n) : this._parseVTTs(t);
        }
      } else
        this.hls.trigger(p.SUBTITLE_FRAG_PROCESSED, {
          success: !1,
          frag: i,
          error: new Error("Empty subtitle payload")
        });
  }
  _parseIMSC1(e, t) {
    const i = this.hls;
    Zn(t, this.initPTS[e.cc], (n) => {
      this._appendCues(n, e.level), i.trigger(p.SUBTITLE_FRAG_PROCESSED, {
        success: !0,
        frag: e
      });
    }, (n) => {
      S.log(`Failed to parse IMSC1: ${n}`), i.trigger(p.SUBTITLE_FRAG_PROCESSED, {
        success: !1,
        frag: e,
        error: n
      });
    });
  }
  _parseVTTs(e) {
    var t;
    const {
      frag: i,
      payload: n
    } = e, {
      initPTS: r,
      unparsedVttFrags: a
    } = this, o = r.length - 1;
    if (!r[i.cc] && o === -1) {
      a.push(e);
      return;
    }
    const l = this.hls, c = (t = i.initSegment) != null && t.data ? ke(i.initSegment.data, new Uint8Array(n)) : n;
    su(c, this.initPTS[i.cc], this.vttCCs, i.cc, i.start, (h) => {
      this._appendCues(h, i.level), l.trigger(p.SUBTITLE_FRAG_PROCESSED, {
        success: !0,
        frag: i
      });
    }, (h) => {
      const u = h.message === "Missing initPTS for VTT MPEGTS";
      u ? a.push(e) : this._fallbackToIMSC1(i, n), S.log(`Failed to parse VTT cue: ${h}`), !(u && o > i.cc) && l.trigger(p.SUBTITLE_FRAG_PROCESSED, {
        success: !1,
        frag: i,
        error: h
      });
    });
  }
  _fallbackToIMSC1(e, t) {
    const i = this.tracks[e.level];
    i.textCodec || Zn(t, this.initPTS[e.cc], () => {
      i.textCodec = es, this._parseIMSC1(e, t);
    }, () => {
      i.textCodec = "wvtt";
    });
  }
  _appendCues(e, t) {
    const i = this.hls;
    if (this.config.renderTextTracksNatively) {
      const n = this.textTracks[t];
      if (!n || n.mode === "disabled")
        return;
      e.forEach((r) => Zr(n, r));
    } else {
      const n = this.tracks[t];
      if (!n)
        return;
      const r = n.default ? "default" : "subtitles" + t;
      i.trigger(p.CUES_PARSED, {
        type: "subtitles",
        cues: e,
        track: r
      });
    }
  }
  onFragDecrypted(e, t) {
    const {
      frag: i
    } = t;
    i.type === G.SUBTITLE && this.onFragLoaded(p.FRAG_LOADED, t);
  }
  onSubtitleTracksCleared() {
    this.tracks = [], this.captionsTracks = {};
  }
  onFragParsingUserdata(e, t) {
    this.initCea608Parsers();
    const {
      cea608Parser1: i,
      cea608Parser2: n
    } = this;
    if (!this.enabled || !i || !n)
      return;
    const {
      frag: r,
      samples: a
    } = t;
    if (!(r.type === G.MAIN && this.closedCaptionsForLevel(r) === "NONE"))
      for (let o = 0; o < a.length; o++) {
        const l = a[o].bytes;
        if (l) {
          const c = this.extractCea608Data(l);
          i.addData(a[o].pts, c[0]), n.addData(a[o].pts, c[1]);
        }
      }
  }
  onBufferFlushing(e, {
    startOffset: t,
    endOffset: i,
    endOffsetSubtitles: n,
    type: r
  }) {
    const {
      media: a
    } = this;
    if (!(!a || a.currentTime < i)) {
      if (!r || r === "video") {
        const {
          captionsTracks: o
        } = this;
        Object.keys(o).forEach((l) => ms(o[l], t, i));
      }
      if (this.config.renderTextTracksNatively && t === 0 && n !== void 0) {
        const {
          textTracks: o
        } = this;
        Object.keys(o).forEach((l) => ms(o[l], t, n));
      }
    }
  }
  extractCea608Data(e) {
    const t = [[], []], i = e[0] & 31;
    let n = 2;
    for (let r = 0; r < i; r++) {
      const a = e[n++], o = 127 & e[n++], l = 127 & e[n++];
      if (o === 0 && l === 0)
        continue;
      if ((4 & a) !== 0) {
        const h = 3 & a;
        (h === 0 || h === 1) && (t[h].push(o), t[h].push(l));
      }
    }
    return t;
  }
}
function _a(s) {
  return s.characteristics && /transcribes-spoken-dialog/gi.test(s.characteristics) && /describes-music-and-sound/gi.test(s.characteristics) ? "captions" : "subtitles";
}
function ir(s, e) {
  return !!s && s.kind === _a(e) && bs(e, s);
}
function hu(s, e, t, i) {
  return Math.min(e, i) - Math.max(s, t);
}
function sr() {
  return {
    ccOffset: 0,
    presentationOffset: 0,
    0: {
      start: 0,
      prevCC: -1,
      new: !0
    }
  };
}
class qs {
  constructor(e) {
    this.hls = void 0, this.autoLevelCapping = void 0, this.firstLevel = void 0, this.media = void 0, this.restrictedLevels = void 0, this.timer = void 0, this.clientRect = void 0, this.streamController = void 0, this.hls = e, this.autoLevelCapping = Number.POSITIVE_INFINITY, this.firstLevel = -1, this.media = null, this.restrictedLevels = [], this.timer = void 0, this.clientRect = null, this.registerListeners();
  }
  setStreamController(e) {
    this.streamController = e;
  }
  destroy() {
    this.hls && this.unregisterListener(), this.timer && this.stopCapping(), this.media = null, this.clientRect = null, this.hls = this.streamController = null;
  }
  registerListeners() {
    const {
      hls: e
    } = this;
    e.on(p.FPS_DROP_LEVEL_CAPPING, this.onFpsDropLevelCapping, this), e.on(p.MEDIA_ATTACHING, this.onMediaAttaching, this), e.on(p.MANIFEST_PARSED, this.onManifestParsed, this), e.on(p.LEVELS_UPDATED, this.onLevelsUpdated, this), e.on(p.BUFFER_CODECS, this.onBufferCodecs, this), e.on(p.MEDIA_DETACHING, this.onMediaDetaching, this);
  }
  unregisterListener() {
    const {
      hls: e
    } = this;
    e.off(p.FPS_DROP_LEVEL_CAPPING, this.onFpsDropLevelCapping, this), e.off(p.MEDIA_ATTACHING, this.onMediaAttaching, this), e.off(p.MANIFEST_PARSED, this.onManifestParsed, this), e.off(p.LEVELS_UPDATED, this.onLevelsUpdated, this), e.off(p.BUFFER_CODECS, this.onBufferCodecs, this), e.off(p.MEDIA_DETACHING, this.onMediaDetaching, this);
  }
  onFpsDropLevelCapping(e, t) {
    const i = this.hls.levels[t.droppedLevel];
    this.isLevelAllowed(i) && this.restrictedLevels.push({
      bitrate: i.bitrate,
      height: i.height,
      width: i.width
    });
  }
  onMediaAttaching(e, t) {
    this.media = t.media instanceof HTMLVideoElement ? t.media : null, this.clientRect = null, this.timer && this.hls.levels.length && this.detectPlayerSize();
  }
  onManifestParsed(e, t) {
    const i = this.hls;
    this.restrictedLevels = [], this.firstLevel = t.firstLevel, i.config.capLevelToPlayerSize && t.video && this.startCapping();
  }
  onLevelsUpdated(e, t) {
    this.timer && U(this.autoLevelCapping) && this.detectPlayerSize();
  }
  // Only activate capping when playing a video stream; otherwise, multi-bitrate audio-only streams will be restricted
  // to the first level
  onBufferCodecs(e, t) {
    this.hls.config.capLevelToPlayerSize && t.video && this.startCapping();
  }
  onMediaDetaching() {
    this.stopCapping();
  }
  detectPlayerSize() {
    if (this.media) {
      if (this.mediaHeight <= 0 || this.mediaWidth <= 0) {
        this.clientRect = null;
        return;
      }
      const e = this.hls.levels;
      if (e.length) {
        const t = this.hls, i = this.getMaxLevel(e.length - 1);
        i !== this.autoLevelCapping && S.log(`Setting autoLevelCapping to ${i}: ${e[i].height}p@${e[i].bitrate} for media ${this.mediaWidth}x${this.mediaHeight}`), t.autoLevelCapping = i, t.autoLevelCapping > this.autoLevelCapping && this.streamController && this.streamController.nextLevelSwitch(), this.autoLevelCapping = t.autoLevelCapping;
      }
    }
  }
  /*
   * returns level should be the one with the dimensions equal or greater than the media (player) dimensions (so the video will be downscaled)
   */
  getMaxLevel(e) {
    const t = this.hls.levels;
    if (!t.length)
      return -1;
    const i = t.filter((n, r) => this.isLevelAllowed(n) && r <= e);
    return this.clientRect = null, qs.getMaxLevelByMediaSize(i, this.mediaWidth, this.mediaHeight);
  }
  startCapping() {
    this.timer || (this.autoLevelCapping = Number.POSITIVE_INFINITY, self.clearInterval(this.timer), this.timer = self.setInterval(this.detectPlayerSize.bind(this), 1e3), this.detectPlayerSize());
  }
  stopCapping() {
    this.restrictedLevels = [], this.firstLevel = -1, this.autoLevelCapping = Number.POSITIVE_INFINITY, this.timer && (self.clearInterval(this.timer), this.timer = void 0);
  }
  getDimensions() {
    if (this.clientRect)
      return this.clientRect;
    const e = this.media, t = {
      width: 0,
      height: 0
    };
    if (e) {
      const i = e.getBoundingClientRect();
      t.width = i.width, t.height = i.height, !t.width && !t.height && (t.width = i.right - i.left || e.width || 0, t.height = i.bottom - i.top || e.height || 0);
    }
    return this.clientRect = t, t;
  }
  get mediaWidth() {
    return this.getDimensions().width * this.contentScaleFactor;
  }
  get mediaHeight() {
    return this.getDimensions().height * this.contentScaleFactor;
  }
  get contentScaleFactor() {
    let e = 1;
    if (!this.hls.config.ignoreDevicePixelRatio)
      try {
        e = self.devicePixelRatio;
      } catch (t) {
      }
    return e;
  }
  isLevelAllowed(e) {
    return !this.restrictedLevels.some((i) => e.bitrate === i.bitrate && e.width === i.width && e.height === i.height);
  }
  static getMaxLevelByMediaSize(e, t, i) {
    if (!(e != null && e.length))
      return -1;
    const n = (o, l) => l ? o.width !== l.width || o.height !== l.height : !0;
    let r = e.length - 1;
    const a = Math.max(t, i);
    for (let o = 0; o < e.length; o += 1) {
      const l = e[o];
      if ((l.width >= a || l.height >= a) && n(l, e[o + 1])) {
        r = o;
        break;
      }
    }
    return r;
  }
}
class uu {
  constructor(e) {
    this.hls = void 0, this.isVideoPlaybackQualityAvailable = !1, this.timer = void 0, this.media = null, this.lastTime = void 0, this.lastDroppedFrames = 0, this.lastDecodedFrames = 0, this.streamController = void 0, this.hls = e, this.registerListeners();
  }
  setStreamController(e) {
    this.streamController = e;
  }
  registerListeners() {
    this.hls.on(p.MEDIA_ATTACHING, this.onMediaAttaching, this);
  }
  unregisterListeners() {
    this.hls.off(p.MEDIA_ATTACHING, this.onMediaAttaching, this);
  }
  destroy() {
    this.timer && clearInterval(this.timer), this.unregisterListeners(), this.isVideoPlaybackQualityAvailable = !1, this.media = null;
  }
  onMediaAttaching(e, t) {
    const i = this.hls.config;
    if (i.capLevelOnFPSDrop) {
      const n = t.media instanceof self.HTMLVideoElement ? t.media : null;
      this.media = n, n && typeof n.getVideoPlaybackQuality == "function" && (this.isVideoPlaybackQualityAvailable = !0), self.clearInterval(this.timer), this.timer = self.setInterval(this.checkFPSInterval.bind(this), i.fpsDroppedMonitoringPeriod);
    }
  }
  checkFPS(e, t, i) {
    const n = performance.now();
    if (t) {
      if (this.lastTime) {
        const r = n - this.lastTime, a = i - this.lastDroppedFrames, o = t - this.lastDecodedFrames, l = 1e3 * a / r, c = this.hls;
        if (c.trigger(p.FPS_DROP, {
          currentDropped: a,
          currentDecoded: o,
          totalDroppedFrames: i
        }), l > 0 && a > c.config.fpsDroppedMonitoringThreshold * o) {
          let h = c.currentLevel;
          S.warn("drop FPS ratio greater than max allowed value for currentLevel: " + h), h > 0 && (c.autoLevelCapping === -1 || c.autoLevelCapping >= h) && (h = h - 1, c.trigger(p.FPS_DROP_LEVEL_CAPPING, {
            level: h,
            droppedLevel: c.currentLevel
          }), c.autoLevelCapping = h, this.streamController.nextLevelSwitch());
        }
      }
      this.lastTime = n, this.lastDroppedFrames = i, this.lastDecodedFrames = t;
    }
  }
  checkFPSInterval() {
    const e = this.media;
    if (e)
      if (this.isVideoPlaybackQualityAvailable) {
        const t = e.getVideoPlaybackQuality();
        this.checkFPS(e, t.totalVideoFrames, t.droppedVideoFrames);
      } else
        this.checkFPS(e, e.webkitDecodedFrameCount, e.webkitDroppedFrameCount);
  }
}
const Qt = "[eme]";
class yt {
  constructor(e) {
    this.hls = void 0, this.config = void 0, this.media = null, this.keyFormatPromise = null, this.keySystemAccessPromises = {}, this._requestLicenseFailureCount = 0, this.mediaKeySessions = [], this.keyIdToKeySessionPromise = {}, this.setMediaKeysQueue = yt.CDMCleanupPromise ? [yt.CDMCleanupPromise] : [], this.debug = S.debug.bind(S, Qt), this.log = S.log.bind(S, Qt), this.warn = S.warn.bind(S, Qt), this.error = S.error.bind(S, Qt), this.onMediaEncrypted = (t) => {
      const {
        initDataType: i,
        initData: n
      } = t, r = `"${t.type}" event: init data type: "${i}"`;
      if (this.debug(r), n !== null) {
        if (!this.keyFormatPromise) {
          let a = Object.keys(this.keySystemAccessPromises);
          a.length || (a = Gt(this.config));
          const o = a.map(Bi).filter((l) => !!l);
          this.keyFormatPromise = this.getKeyFormatPromise(o);
        }
        this.keyFormatPromise.then((a) => {
          const o = Ni(a);
          let l, c;
          if (i === "sinf") {
            if (o !== se.FAIRPLAY) {
              this.warn(`Ignoring unexpected "${t.type}" event with init data type: "${i}" for selected key-system ${o}`);
              return;
            }
            const f = me(new Uint8Array(n));
            try {
              const m = _s(JSON.parse(f).sinf), y = jr(m);
              if (!y)
                throw new Error("'schm' box missing or not cbcs/cenc with schi > tenc");
              l = y.subarray(8, 24), c = se.FAIRPLAY;
            } catch (m) {
              this.warn(`${r} Failed to parse sinf: ${m}`);
              return;
            }
          } else {
            if (o !== se.WIDEVINE && o !== se.PLAYREADY) {
              this.warn(`Ignoring unexpected "${t.type}" event with init data type: "${i}" for selected key-system ${o}`);
              return;
            }
            const f = Hl(n), m = f.filter((T) => !!T.systemId && Ui(T.systemId) === o);
            m.length > 1 && this.warn(`${r} Using first of ${m.length} pssh found for selected key-system ${o}`);
            const y = m[0];
            if (!y) {
              f.length === 0 || f.some((T) => !T.systemId) ? this.warn(`${r} contains incomplete or invalid pssh data`) : this.log(`ignoring ${r} for ${f.map((T) => Ui(T.systemId)).join(",")} pssh data in favor of playlist keys`);
              return;
            }
            if (c = Ui(y.systemId), y.version === 0 && y.data)
              if (c === se.WIDEVINE) {
                const T = y.data.length - 22;
                l = y.data.subarray(T, T + 16);
              } else c === se.PLAYREADY && (l = Br(y.data));
          }
          if (!c || !l) {
            this.log(`Unable to handle ${r} with key-system ${o}`);
            return;
          }
          const h = Ue.hexDump(l), {
            keyIdToKeySessionPromise: u,
            mediaKeySessions: d
          } = this;
          let g = u[h];
          for (let f = 0; f < d.length; f++) {
            const m = d[f], y = m.decryptdata;
            if (!y.keyId)
              continue;
            const T = Ue.hexDump(y.keyId);
            if (h === T || y.uri.replace(/-/g, "").indexOf(h) !== -1) {
              if (g = u[T], y.pssh)
                break;
              delete u[T], y.pssh = new Uint8Array(n), y.keyId = l, g = u[h] = g.then(() => this.generateRequestWithPreferredKeySession(m, i, n, "encrypted-event-key-match")), g.catch((b) => this.handleError(b));
              break;
            }
          }
          if (!g) {
            if (c !== o) {
              this.log(`Ignoring "${r}" with ${c} init data for selected key-system ${o}`);
              return;
            }
            g = u[h] = this.getKeySystemSelectionPromise([c]).then(({
              keySystem: f,
              mediaKeys: m
            }) => {
              var y;
              this.throwIfDestroyed();
              const T = new Pt("ISO-23001-7", h, (y = Bi(f)) != null ? y : "");
              return T.pssh = new Uint8Array(n), T.keyId = l, this.attemptSetMediaKeys(f, m).then(() => {
                this.throwIfDestroyed();
                const b = this.createMediaKeySessionContext({
                  decryptdata: T,
                  keySystem: f,
                  mediaKeys: m
                });
                return this.generateRequestWithPreferredKeySession(b, i, n, "encrypted-event-no-match");
              });
            }), g.catch((f) => this.handleError(f));
          }
        });
      }
    }, this.onWaitingForKey = (t) => {
      this.log(`"${t.type}" event`);
    }, this.hls = e, this.config = e.config, this.registerListeners();
  }
  destroy() {
    this.unregisterListeners(), this.onMediaDetached();
    const e = this.config;
    e.requestMediaKeySystemAccessFunc = null, e.licenseXhrSetup = e.licenseResponseCallback = void 0, e.drmSystems = e.drmSystemOptions = {}, this.hls = this.config = this.keyIdToKeySessionPromise = null, this.onMediaEncrypted = this.onWaitingForKey = null;
  }
  registerListeners() {
    this.hls.on(p.MEDIA_ATTACHED, this.onMediaAttached, this), this.hls.on(p.MEDIA_DETACHED, this.onMediaDetached, this), this.hls.on(p.MANIFEST_LOADING, this.onManifestLoading, this), this.hls.on(p.MANIFEST_LOADED, this.onManifestLoaded, this);
  }
  unregisterListeners() {
    this.hls.off(p.MEDIA_ATTACHED, this.onMediaAttached, this), this.hls.off(p.MEDIA_DETACHED, this.onMediaDetached, this), this.hls.off(p.MANIFEST_LOADING, this.onManifestLoading, this), this.hls.off(p.MANIFEST_LOADED, this.onManifestLoaded, this);
  }
  getLicenseServerUrl(e) {
    const {
      drmSystems: t,
      widevineLicenseUrl: i
    } = this.config, n = t[e];
    if (n)
      return n.licenseUrl;
    if (e === se.WIDEVINE && i)
      return i;
  }
  getLicenseServerUrlOrThrow(e) {
    const t = this.getLicenseServerUrl(e);
    if (t === void 0)
      throw new Error(`no license server URL configured for key-system "${e}"`);
    return t;
  }
  getServerCertificateUrl(e) {
    const {
      drmSystems: t
    } = this.config, i = t[e];
    if (i)
      return i.serverCertificateUrl;
    this.log(`No Server Certificate in config.drmSystems["${e}"]`);
  }
  attemptKeySystemAccess(e) {
    const t = this.hls.levels, i = (a, o, l) => !!a && l.indexOf(a) === o, n = t.map((a) => a.audioCodec).filter(i), r = t.map((a) => a.videoCodec).filter(i);
    return n.length + r.length === 0 && r.push("avc1.42e01e"), new Promise((a, o) => {
      const l = (c) => {
        const h = c.shift();
        this.getMediaKeysPromise(h, n, r).then((u) => a({
          keySystem: h,
          mediaKeys: u
        })).catch((u) => {
          c.length ? l(c) : u instanceof Ce ? o(u) : o(new Ce({
            type: V.KEY_SYSTEM_ERROR,
            details: I.KEY_SYSTEM_NO_ACCESS,
            error: u,
            fatal: !0
          }, u.message));
        });
      };
      l(e);
    });
  }
  requestMediaKeySystemAccess(e, t) {
    const {
      requestMediaKeySystemAccessFunc: i
    } = this.config;
    if (typeof i != "function") {
      let n = `Configured requestMediaKeySystemAccess is not a function ${i}`;
      return Ur === null && self.location.protocol === "http:" && (n = `navigator.requestMediaKeySystemAccess is not available over insecure protocol ${location.protocol}`), Promise.reject(new Error(n));
    }
    return i(e, t);
  }
  getMediaKeysPromise(e, t, i) {
    const n = yl(e, t, i, this.config.drmSystemOptions), r = this.keySystemAccessPromises[e];
    let a = r == null ? void 0 : r.keySystemAccess;
    if (!a) {
      this.log(`Requesting encrypted media "${e}" key-system access with config: ${JSON.stringify(n)}`), a = this.requestMediaKeySystemAccess(e, n);
      const o = this.keySystemAccessPromises[e] = {
        keySystemAccess: a
      };
      return a.catch((l) => {
        this.log(`Failed to obtain access to key-system "${e}": ${l}`);
      }), a.then((l) => {
        this.log(`Access for key-system "${l.keySystem}" obtained`);
        const c = this.fetchServerCertificate(e);
        return this.log(`Create media-keys for "${e}"`), o.mediaKeys = l.createMediaKeys().then((h) => (this.log(`Media-keys created for "${e}"`), c.then((u) => u ? this.setMediaKeysServerCertificate(h, e, u) : h))), o.mediaKeys.catch((h) => {
          this.error(`Failed to create media-keys for "${e}"}: ${h}`);
        }), o.mediaKeys;
      });
    }
    return a.then(() => r.mediaKeys);
  }
  createMediaKeySessionContext({
    decryptdata: e,
    keySystem: t,
    mediaKeys: i
  }) {
    this.log(`Creating key-system session "${t}" keyId: ${Ue.hexDump(e.keyId || [])}`);
    const n = i.createSession(), r = {
      decryptdata: e,
      keySystem: t,
      mediaKeys: i,
      mediaKeysSession: n,
      keyStatus: "status-pending"
    };
    return this.mediaKeySessions.push(r), r;
  }
  renewKeySession(e) {
    const t = e.decryptdata;
    if (t.pssh) {
      const i = this.createMediaKeySessionContext(e), n = this.getKeyIdString(t), r = "cenc";
      this.keyIdToKeySessionPromise[n] = this.generateRequestWithPreferredKeySession(i, r, t.pssh, "expired");
    } else
      this.warn("Could not renew expired session. Missing pssh initData.");
    this.removeSession(e);
  }
  getKeyIdString(e) {
    if (!e)
      throw new Error("Could not read keyId of undefined decryptdata");
    if (e.keyId === null)
      throw new Error("keyId is null");
    return Ue.hexDump(e.keyId);
  }
  updateKeySession(e, t) {
    var i;
    const n = e.mediaKeysSession;
    return this.log(`Updating key-session "${n.sessionId}" for keyID ${Ue.hexDump(((i = e.decryptdata) == null ? void 0 : i.keyId) || [])}
      } (data length: ${t && t.byteLength})`), n.update(t);
  }
  selectKeySystemFormat(e) {
    const t = Object.keys(e.levelkeys || {});
    return this.keyFormatPromise || (this.log(`Selecting key-system from fragment (sn: ${e.sn} ${e.type}: ${e.level}) key formats ${t.join(", ")}`), this.keyFormatPromise = this.getKeyFormatPromise(t)), this.keyFormatPromise;
  }
  getKeyFormatPromise(e) {
    return new Promise((t, i) => {
      const n = Gt(this.config), r = e.map(Ni).filter((a) => !!a && n.indexOf(a) !== -1);
      return this.getKeySystemSelectionPromise(r).then(({
        keySystem: a
      }) => {
        const o = Bi(a);
        o ? t(o) : i(new Error(`Unable to find format for key-system "${a}"`));
      }).catch(i);
    });
  }
  loadKey(e) {
    const t = e.keyInfo.decryptdata, i = this.getKeyIdString(t), n = `(keyId: ${i} format: "${t.keyFormat}" method: ${t.method} uri: ${t.uri})`;
    this.log(`Starting session for key ${n}`);
    let r = this.keyIdToKeySessionPromise[i];
    return r || (r = this.keyIdToKeySessionPromise[i] = this.getKeySystemForKeyPromise(t).then(({
      keySystem: a,
      mediaKeys: o
    }) => (this.throwIfDestroyed(), this.log(`Handle encrypted media sn: ${e.frag.sn} ${e.frag.type}: ${e.frag.level} using key ${n}`), this.attemptSetMediaKeys(a, o).then(() => {
      this.throwIfDestroyed();
      const l = this.createMediaKeySessionContext({
        keySystem: a,
        mediaKeys: o,
        decryptdata: t
      });
      return this.generateRequestWithPreferredKeySession(l, "cenc", t.pssh, "playlist-key");
    }))), r.catch((a) => this.handleError(a))), r;
  }
  throwIfDestroyed(e = "Invalid state") {
    if (!this.hls)
      throw new Error("invalid state");
  }
  handleError(e) {
    this.hls && (this.error(e.message), e instanceof Ce ? this.hls.trigger(p.ERROR, e.data) : this.hls.trigger(p.ERROR, {
      type: V.KEY_SYSTEM_ERROR,
      details: I.KEY_SYSTEM_NO_KEYS,
      error: e,
      fatal: !0
    }));
  }
  getKeySystemForKeyPromise(e) {
    const t = this.getKeyIdString(e), i = this.keyIdToKeySessionPromise[t];
    if (!i) {
      const n = Ni(e.keyFormat), r = n ? [n] : Gt(this.config);
      return this.attemptKeySystemAccess(r);
    }
    return i;
  }
  getKeySystemSelectionPromise(e) {
    if (e.length || (e = Gt(this.config)), e.length === 0)
      throw new Ce({
        type: V.KEY_SYSTEM_ERROR,
        details: I.KEY_SYSTEM_NO_CONFIGURED_LICENSE,
        fatal: !0
      }, `Missing key-system license configuration options ${JSON.stringify({
        drmSystems: this.config.drmSystems
      })}`);
    return this.attemptKeySystemAccess(e);
  }
  attemptSetMediaKeys(e, t) {
    const i = this.setMediaKeysQueue.slice();
    this.log(`Setting media-keys for "${e}"`);
    const n = Promise.all(i).then(() => {
      if (!this.media)
        throw new Error("Attempted to set mediaKeys without media element attached");
      return this.media.setMediaKeys(t);
    });
    return this.setMediaKeysQueue.push(n), n.then(() => {
      this.log(`Media-keys set for "${e}"`), i.push(n), this.setMediaKeysQueue = this.setMediaKeysQueue.filter((r) => i.indexOf(r) === -1);
    });
  }
  generateRequestWithPreferredKeySession(e, t, i, n) {
    var r, a;
    const o = (r = this.config.drmSystems) == null || (a = r[e.keySystem]) == null ? void 0 : a.generateRequest;
    if (o)
      try {
        const f = o.call(this.hls, t, i, e);
        if (!f)
          throw new Error("Invalid response from configured generateRequest filter");
        t = f.initDataType, i = e.decryptdata.pssh = f.initData ? new Uint8Array(f.initData) : null;
      } catch (f) {
        var l;
        if (this.warn(f.message), (l = this.hls) != null && l.config.debug)
          throw f;
      }
    if (i === null)
      return this.log(`Skipping key-session request for "${n}" (no initData)`), Promise.resolve(e);
    const c = this.getKeyIdString(e.decryptdata);
    this.log(`Generating key-session request for "${n}": ${c} (init data type: ${t} length: ${i ? i.byteLength : null})`);
    const h = new Ws(), u = e._onmessage = (f) => {
      const m = e.mediaKeysSession;
      if (!m) {
        h.emit("error", new Error("invalid state"));
        return;
      }
      const {
        messageType: y,
        message: T
      } = f;
      this.log(`"${y}" message event for session "${m.sessionId}" message size: ${T.byteLength}`), y === "license-request" || y === "license-renewal" ? this.renewLicense(e, T).catch((b) => {
        this.handleError(b), h.emit("error", b);
      }) : y === "license-release" ? e.keySystem === se.FAIRPLAY && (this.updateKeySession(e, fs("acknowledged")), this.removeSession(e)) : this.warn(`unhandled media key message type "${y}"`);
    }, d = e._onkeystatuseschange = (f) => {
      if (!e.mediaKeysSession) {
        h.emit("error", new Error("invalid state"));
        return;
      }
      this.onKeyStatusChange(e);
      const y = e.keyStatus;
      h.emit("keyStatus", y), y === "expired" && (this.warn(`${e.keySystem} expired for key ${c}`), this.renewKeySession(e));
    };
    e.mediaKeysSession.addEventListener("message", u), e.mediaKeysSession.addEventListener("keystatuseschange", d);
    const g = new Promise((f, m) => {
      h.on("error", m), h.on("keyStatus", (y) => {
        y.startsWith("usable") ? f() : y === "output-restricted" ? m(new Ce({
          type: V.KEY_SYSTEM_ERROR,
          details: I.KEY_SYSTEM_STATUS_OUTPUT_RESTRICTED,
          fatal: !1
        }, "HDCP level output restricted")) : y === "internal-error" ? m(new Ce({
          type: V.KEY_SYSTEM_ERROR,
          details: I.KEY_SYSTEM_STATUS_INTERNAL_ERROR,
          fatal: !0
        }, `key status changed to "${y}"`)) : y === "expired" ? m(new Error("key expired while generating request")) : this.warn(`unhandled key status change "${y}"`);
      });
    });
    return e.mediaKeysSession.generateRequest(t, i).then(() => {
      var f;
      this.log(`Request generated for key-session "${(f = e.mediaKeysSession) == null ? void 0 : f.sessionId}" keyId: ${c}`);
    }).catch((f) => {
      throw new Ce({
        type: V.KEY_SYSTEM_ERROR,
        details: I.KEY_SYSTEM_NO_SESSION,
        error: f,
        fatal: !1
      }, `Error generating key-session request: ${f}`);
    }).then(() => g).catch((f) => {
      throw h.removeAllListeners(), this.removeSession(e), f;
    }).then(() => (h.removeAllListeners(), e));
  }
  onKeyStatusChange(e) {
    e.mediaKeysSession.keyStatuses.forEach((t, i) => {
      this.log(`key status change "${t}" for keyStatuses keyId: ${Ue.hexDump("buffer" in i ? new Uint8Array(i.buffer, i.byteOffset, i.byteLength) : new Uint8Array(i))} session keyId: ${Ue.hexDump(new Uint8Array(e.decryptdata.keyId || []))} uri: ${e.decryptdata.uri}`), e.keyStatus = t;
    });
  }
  fetchServerCertificate(e) {
    const t = this.config, i = t.loader, n = new i(t), r = this.getServerCertificateUrl(e);
    return r ? (this.log(`Fetching server certificate for "${e}"`), new Promise((a, o) => {
      const l = {
        responseType: "arraybuffer",
        url: r
      }, c = t.certLoadPolicy.default, h = {
        loadPolicy: c,
        timeout: c.maxLoadTimeMs,
        maxRetry: 0,
        retryDelay: 0,
        maxRetryDelay: 0
      }, u = {
        onSuccess: (d, g, f, m) => {
          a(d.data);
        },
        onError: (d, g, f, m) => {
          o(new Ce({
            type: V.KEY_SYSTEM_ERROR,
            details: I.KEY_SYSTEM_SERVER_CERTIFICATE_REQUEST_FAILED,
            fatal: !0,
            networkDetails: f,
            response: be({
              url: l.url,
              data: void 0
            }, d)
          }, `"${e}" certificate request failed (${r}). Status: ${d.code} (${d.text})`));
        },
        onTimeout: (d, g, f) => {
          o(new Ce({
            type: V.KEY_SYSTEM_ERROR,
            details: I.KEY_SYSTEM_SERVER_CERTIFICATE_REQUEST_FAILED,
            fatal: !0,
            networkDetails: f,
            response: {
              url: l.url,
              data: void 0
            }
          }, `"${e}" certificate request timed out (${r})`));
        },
        onAbort: (d, g, f) => {
          o(new Error("aborted"));
        }
      };
      n.load(l, h, u);
    })) : Promise.resolve();
  }
  setMediaKeysServerCertificate(e, t, i) {
    return new Promise((n, r) => {
      e.setServerCertificate(i).then((a) => {
        this.log(`setServerCertificate ${a ? "success" : "not supported by CDM"} (${i == null ? void 0 : i.byteLength}) on "${t}"`), n(e);
      }).catch((a) => {
        r(new Ce({
          type: V.KEY_SYSTEM_ERROR,
          details: I.KEY_SYSTEM_SERVER_CERTIFICATE_UPDATE_FAILED,
          error: a,
          fatal: !0
        }, a.message));
      });
    });
  }
  renewLicense(e, t) {
    return this.requestLicense(e, new Uint8Array(t)).then((i) => this.updateKeySession(e, new Uint8Array(i)).catch((n) => {
      throw new Ce({
        type: V.KEY_SYSTEM_ERROR,
        details: I.KEY_SYSTEM_SESSION_UPDATE_FAILED,
        error: n,
        fatal: !0
      }, n.message);
    }));
  }
  unpackPlayReadyKeyMessage(e, t) {
    const i = String.fromCharCode.apply(null, new Uint16Array(t.buffer));
    if (!i.includes("PlayReadyKeyMessage"))
      return e.setRequestHeader("Content-Type", "text/xml; charset=utf-8"), t;
    const n = new DOMParser().parseFromString(i, "application/xml"), r = n.querySelectorAll("HttpHeader");
    if (r.length > 0) {
      let h;
      for (let u = 0, d = r.length; u < d; u++) {
        var a, o;
        h = r[u];
        const g = (a = h.querySelector("name")) == null ? void 0 : a.textContent, f = (o = h.querySelector("value")) == null ? void 0 : o.textContent;
        g && f && e.setRequestHeader(g, f);
      }
    }
    const l = n.querySelector("Challenge"), c = l == null ? void 0 : l.textContent;
    if (!c)
      throw new Error("Cannot find <Challenge> in key message");
    return fs(atob(c));
  }
  setupLicenseXHR(e, t, i, n) {
    const r = this.config.licenseXhrSetup;
    return r ? Promise.resolve().then(() => {
      if (!i.decryptdata)
        throw new Error("Key removed");
      return r.call(this.hls, e, t, i, n);
    }).catch((a) => {
      if (!i.decryptdata)
        throw a;
      return e.open("POST", t, !0), r.call(this.hls, e, t, i, n);
    }).then((a) => (e.readyState || e.open("POST", t, !0), {
      xhr: e,
      licenseChallenge: a || n
    })) : (e.open("POST", t, !0), Promise.resolve({
      xhr: e,
      licenseChallenge: n
    }));
  }
  requestLicense(e, t) {
    const i = this.config.keyLoadPolicy.default;
    return new Promise((n, r) => {
      const a = this.getLicenseServerUrlOrThrow(e.keySystem);
      this.log(`Sending license request to URL: ${a}`);
      const o = new XMLHttpRequest();
      o.responseType = "arraybuffer", o.onreadystatechange = () => {
        if (!this.hls || !e.mediaKeysSession)
          return r(new Error("invalid state"));
        if (o.readyState === 4)
          if (o.status === 200) {
            this._requestLicenseFailureCount = 0;
            let l = o.response;
            this.log(`License received ${l instanceof ArrayBuffer ? l.byteLength : l}`);
            const c = this.config.licenseResponseCallback;
            if (c)
              try {
                l = c.call(this.hls, o, a, e);
              } catch (h) {
                this.error(h);
              }
            n(l);
          } else {
            const l = i.errorRetry, c = l ? l.maxNumRetry : 0;
            if (this._requestLicenseFailureCount++, this._requestLicenseFailureCount > c || o.status >= 400 && o.status < 500)
              r(new Ce({
                type: V.KEY_SYSTEM_ERROR,
                details: I.KEY_SYSTEM_LICENSE_REQUEST_FAILED,
                fatal: !0,
                networkDetails: o,
                response: {
                  url: a,
                  data: void 0,
                  code: o.status,
                  text: o.statusText
                }
              }, `License Request XHR failed (${a}). Status: ${o.status} (${o.statusText})`));
            else {
              const h = c - this._requestLicenseFailureCount + 1;
              this.warn(`Retrying license request, ${h} attempts left`), this.requestLicense(e, t).then(n, r);
            }
          }
      }, e.licenseXhr && e.licenseXhr.readyState !== XMLHttpRequest.DONE && e.licenseXhr.abort(), e.licenseXhr = o, this.setupLicenseXHR(o, a, e, t).then(({
        xhr: l,
        licenseChallenge: c
      }) => {
        e.keySystem == se.PLAYREADY && (c = this.unpackPlayReadyKeyMessage(l, c)), l.send(c);
      });
    });
  }
  onMediaAttached(e, t) {
    if (!this.config.emeEnabled)
      return;
    const i = t.media;
    this.media = i, i.removeEventListener("encrypted", this.onMediaEncrypted), i.removeEventListener("waitingforkey", this.onWaitingForKey), i.addEventListener("encrypted", this.onMediaEncrypted), i.addEventListener("waitingforkey", this.onWaitingForKey);
  }
  onMediaDetached() {
    const e = this.media, t = this.mediaKeySessions;
    e && (e.removeEventListener("encrypted", this.onMediaEncrypted), e.removeEventListener("waitingforkey", this.onWaitingForKey), this.media = null), this._requestLicenseFailureCount = 0, this.setMediaKeysQueue = [], this.mediaKeySessions = [], this.keyIdToKeySessionPromise = {}, Pt.clearKeyUriToKeyIdMap();
    const i = t.length;
    yt.CDMCleanupPromise = Promise.all(t.map((n) => this.removeSession(n)).concat(e == null ? void 0 : e.setMediaKeys(null).catch((n) => {
      this.log(`Could not clear media keys: ${n}`);
    }))).then(() => {
      i && (this.log("finished closing key sessions and clearing media keys"), t.length = 0);
    }).catch((n) => {
      this.log(`Could not close sessions and clear media keys: ${n}`);
    });
  }
  onManifestLoading() {
    this.keyFormatPromise = null;
  }
  onManifestLoaded(e, {
    sessionKeys: t
  }) {
    if (!(!t || !this.config.emeEnabled) && !this.keyFormatPromise) {
      const i = t.reduce((n, r) => (n.indexOf(r.keyFormat) === -1 && n.push(r.keyFormat), n), []);
      this.log(`Selecting key-system from session-keys ${i.join(", ")}`), this.keyFormatPromise = this.getKeyFormatPromise(i);
    }
  }
  removeSession(e) {
    const {
      mediaKeysSession: t,
      licenseXhr: i
    } = e;
    if (t) {
      this.log(`Remove licenses and keys and close session ${t.sessionId}`), e._onmessage && (t.removeEventListener("message", e._onmessage), e._onmessage = void 0), e._onkeystatuseschange && (t.removeEventListener("keystatuseschange", e._onkeystatuseschange), e._onkeystatuseschange = void 0), i && i.readyState !== XMLHttpRequest.DONE && i.abort(), e.mediaKeysSession = e.decryptdata = e.licenseXhr = void 0;
      const n = this.mediaKeySessions.indexOf(e);
      return n > -1 && this.mediaKeySessions.splice(n, 1), t.remove().catch((r) => {
        this.log(`Could not remove session: ${r}`);
      }).then(() => t.close()).catch((r) => {
        this.log(`Could not close session: ${r}`);
      });
    }
  }
}
yt.CDMCleanupPromise = void 0;
class Ce extends Error {
  constructor(e, t) {
    super(t), this.data = void 0, e.error || (e.error = new Error(t)), this.data = e, e.err = e.error;
  }
}
var Le;
(function(s) {
  s.MANIFEST = "m", s.AUDIO = "a", s.VIDEO = "v", s.MUXED = "av", s.INIT = "i", s.CAPTION = "c", s.TIMED_TEXT = "tt", s.KEY = "k", s.OTHER = "o";
})(Le || (Le = {}));
var Ss;
(function(s) {
  s.DASH = "d", s.HLS = "h", s.SMOOTH = "s", s.OTHER = "o";
})(Ss || (Ss = {}));
var ot;
(function(s) {
  s.OBJECT = "CMCD-Object", s.REQUEST = "CMCD-Request", s.SESSION = "CMCD-Session", s.STATUS = "CMCD-Status";
})(ot || (ot = {}));
const du = {
  [ot.OBJECT]: ["br", "d", "ot", "tb"],
  [ot.REQUEST]: ["bl", "dl", "mtp", "nor", "nrr", "su"],
  [ot.SESSION]: ["cid", "pr", "sf", "sid", "st", "v"],
  [ot.STATUS]: ["bs", "rtp"]
};
class bt {
  constructor(e, t) {
    this.value = void 0, this.params = void 0, Array.isArray(e) && (e = e.map((i) => i instanceof bt ? i : new bt(i))), this.value = e, this.params = t;
  }
}
class Oa {
  constructor(e) {
    this.description = void 0, this.description = e;
  }
}
const fu = "Dict";
function gu(s) {
  return Array.isArray(s) ? JSON.stringify(s) : s instanceof Map ? "Map{}" : s instanceof Set ? "Set{}" : typeof s == "object" ? JSON.stringify(s) : String(s);
}
function mu(s, e, t, i) {
  return new Error(`failed to ${s} "${gu(e)}" as ${t}`, {
    cause: i
  });
}
const nr = "Bare Item", pu = "Boolean", yu = "Byte Sequence", Tu = "Decimal", Eu = "Integer";
function vu(s) {
  return s < -999999999999999 || 999999999999999 < s;
}
const bu = /[\x00-\x1f\x7f]+/, xu = "Token", Su = "Key";
function Ve(s, e, t) {
  return mu("serialize", s, e, t);
}
function Au(s) {
  if (typeof s != "boolean")
    throw Ve(s, pu);
  return s ? "?1" : "?0";
}
function Lu(s) {
  return btoa(String.fromCharCode(...s));
}
function Ru(s) {
  if (ArrayBuffer.isView(s) === !1)
    throw Ve(s, yu);
  return `:${Lu(s)}:`;
}
function Fa(s) {
  if (vu(s))
    throw Ve(s, Eu);
  return s.toString();
}
function Iu(s) {
  return `@${Fa(s.getTime() / 1e3)}`;
}
function Ma(s, e) {
  if (s < 0)
    return -Ma(-s, e);
  const t = Math.pow(10, e);
  if (Math.abs(s * t % 1 - 0.5) < Number.EPSILON) {
    const n = Math.floor(s * t);
    return (n % 2 === 0 ? n : n + 1) / t;
  } else
    return Math.round(s * t) / t;
}
function wu(s) {
  const e = Ma(s, 3);
  if (Math.floor(Math.abs(e)).toString().length > 12)
    throw Ve(s, Tu);
  const t = e.toString();
  return t.includes(".") ? t : `${t}.0`;
}
const Cu = "String";
function Du(s) {
  if (bu.test(s))
    throw Ve(s, Cu);
  return `"${s.replace(/\\/g, "\\\\").replace(/"/g, '\\"')}"`;
}
function ku(s) {
  return s.description || s.toString().slice(7, -1);
}
function rr(s) {
  const e = ku(s);
  if (/^([a-zA-Z*])([!#$%&'*+\-.^_`|~\w:/]*)$/.test(e) === !1)
    throw Ve(e, xu);
  return e;
}
function As(s) {
  switch (typeof s) {
    case "number":
      if (!U(s))
        throw Ve(s, nr);
      return Number.isInteger(s) ? Fa(s) : wu(s);
    case "string":
      return Du(s);
    case "symbol":
      return rr(s);
    case "boolean":
      return Au(s);
    case "object":
      if (s instanceof Date)
        return Iu(s);
      if (s instanceof Uint8Array)
        return Ru(s);
      if (s instanceof Oa)
        return rr(s);
    default:
      throw Ve(s, nr);
  }
}
function Ls(s) {
  if (/^[a-z*][a-z0-9\-_.*]*$/.test(s) === !1)
    throw Ve(s, Su);
  return s;
}
function zs(s) {
  return s == null ? "" : Object.entries(s).map(([e, t]) => t === !0 ? `;${Ls(e)}` : `;${Ls(e)}=${As(t)}`).join("");
}
function Na(s) {
  return s instanceof bt ? `${As(s.value)}${zs(s.params)}` : As(s);
}
function Pu(s) {
  return `(${s.value.map(Na).join(" ")})${zs(s.params)}`;
}
function _u(s, e = {
  whitespace: !0
}) {
  if (typeof s != "object")
    throw Ve(s, fu);
  const t = s instanceof Map ? s.entries() : Object.entries(s), i = e != null && e.whitespace ? " " : "";
  return Array.from(t).map(([n, r]) => {
    r instanceof bt || (r = new bt(r));
    let a = Ls(n);
    return r.value === !0 ? a += zs(r.params) : (a += "=", Array.isArray(r.value) ? a += Pu(r) : a += Na(r)), a;
  }).join(`,${i}`);
}
function Ou(s, e) {
  return _u(s, e);
}
const Fu = (s) => s === "ot" || s === "sf" || s === "st", Mu = (s) => typeof s == "number" ? U(s) : s != null && s !== "" && s !== !1;
function Nu(s, e) {
  const t = new URL(s), i = new URL(e);
  if (t.origin !== i.origin)
    return s;
  const n = t.pathname.split("/").slice(1), r = i.pathname.split("/").slice(1, -1);
  for (; n[0] === r[0]; )
    n.shift(), r.shift();
  for (; r.length; )
    r.shift(), n.unshift("..");
  return n.join("/");
}
function Uu() {
  try {
    return crypto.randomUUID();
  } catch (s) {
    try {
      const e = URL.createObjectURL(new Blob()), t = e.toString();
      return URL.revokeObjectURL(e), t.slice(t.lastIndexOf("/") + 1);
    } catch (e) {
      let t = (/* @__PURE__ */ new Date()).getTime();
      return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (n) => {
        const r = (t + Math.random() * 16) % 16 | 0;
        return t = Math.floor(t / 16), (n == "x" ? r : r & 3 | 8).toString(16);
      });
    }
  }
}
const li = (s) => Math.round(s), Bu = (s, e) => (e != null && e.baseUrl && (s = Nu(s, e.baseUrl)), encodeURIComponent(s)), Jt = (s) => li(s / 100) * 100, $u = {
  /**
   * Bitrate (kbps) rounded integer
   */
  br: li,
  /**
   * Duration (milliseconds) rounded integer
   */
  d: li,
  /**
   * Buffer Length (milliseconds) rounded nearest 100ms
   */
  bl: Jt,
  /**
   * Deadline (milliseconds) rounded nearest 100ms
   */
  dl: Jt,
  /**
   * Measured Throughput (kbps) rounded nearest 100kbps
   */
  mtp: Jt,
  /**
   * Next Object Request URL encoded
   */
  nor: Bu,
  /**
   * Requested maximum throughput (kbps) rounded nearest 100kbps
   */
  rtp: Jt,
  /**
   * Top Bitrate (kbps) rounded integer
   */
  tb: li
};
function Gu(s, e) {
  const t = {};
  if (s == null || typeof s != "object")
    return t;
  const i = Object.keys(s).sort(), n = fe({}, $u, e == null ? void 0 : e.formatters), r = e == null ? void 0 : e.filter;
  return i.forEach((a) => {
    if (r != null && r(a))
      return;
    let o = s[a];
    const l = n[a];
    l && (o = l(o, e)), !(a === "v" && o === 1) && (a == "pr" && o === 1 || Mu(o) && (Fu(a) && typeof o == "string" && (o = new Oa(o)), t[a] = o));
  }), t;
}
function Ua(s, e = {}) {
  return s ? Ou(Gu(s, e), fe({
    whitespace: !1
  }, e)) : "";
}
function Hu(s, e = {}) {
  if (!s)
    return {};
  const t = Object.entries(s), i = Object.entries(du).concat(Object.entries((e == null ? void 0 : e.customHeaderMap) || {})), n = t.reduce((r, a) => {
    var o, l;
    const [c, h] = a, u = ((o = i.find((d) => d[1].includes(c))) == null ? void 0 : o[0]) || ot.REQUEST;
    return (l = r[u]) != null || (r[u] = {}), r[u][c] = h, r;
  }, {});
  return Object.entries(n).reduce((r, [a, o]) => (r[a] = Ua(o, e), r), {});
}
function Ku(s, e, t) {
  return fe(s, Hu(e, t));
}
const Vu = "CMCD";
function Wu(s, e = {}) {
  if (!s)
    return "";
  const t = Ua(s, e);
  return `${Vu}=${encodeURIComponent(t)}`;
}
const ar = /CMCD=[^&#]+/;
function Yu(s, e, t) {
  const i = Wu(e, t);
  if (!i)
    return s;
  if (ar.test(s))
    return s.replace(ar, i);
  const n = s.includes("?") ? "&" : "?";
  return `${s}${n}${i}`;
}
class ju {
  // eslint-disable-line no-restricted-globals
  constructor(e) {
    this.hls = void 0, this.config = void 0, this.media = void 0, this.sid = void 0, this.cid = void 0, this.useHeaders = !1, this.includeKeys = void 0, this.initialized = !1, this.starved = !1, this.buffering = !0, this.audioBuffer = void 0, this.videoBuffer = void 0, this.onWaiting = () => {
      this.initialized && (this.starved = !0), this.buffering = !0;
    }, this.onPlaying = () => {
      this.initialized || (this.initialized = !0), this.buffering = !1;
    }, this.applyPlaylistData = (n) => {
      try {
        this.apply(n, {
          ot: Le.MANIFEST,
          su: !this.initialized
        });
      } catch (r) {
        S.warn("Could not generate manifest CMCD data.", r);
      }
    }, this.applyFragmentData = (n) => {
      try {
        const r = n.frag, a = this.hls.levels[r.level], o = this.getObjectType(r), l = {
          d: r.duration * 1e3,
          ot: o
        };
        (o === Le.VIDEO || o === Le.AUDIO || o == Le.MUXED) && (l.br = a.bitrate / 1e3, l.tb = this.getTopBandwidth(o) / 1e3, l.bl = this.getBufferLength(o)), this.apply(n, l);
      } catch (r) {
        S.warn("Could not generate segment CMCD data.", r);
      }
    }, this.hls = e;
    const t = this.config = e.config, {
      cmcd: i
    } = t;
    i != null && (t.pLoader = this.createPlaylistLoader(), t.fLoader = this.createFragmentLoader(), this.sid = i.sessionId || Uu(), this.cid = i.contentId, this.useHeaders = i.useHeaders === !0, this.includeKeys = i.includeKeys, this.registerListeners());
  }
  registerListeners() {
    const e = this.hls;
    e.on(p.MEDIA_ATTACHED, this.onMediaAttached, this), e.on(p.MEDIA_DETACHED, this.onMediaDetached, this), e.on(p.BUFFER_CREATED, this.onBufferCreated, this);
  }
  unregisterListeners() {
    const e = this.hls;
    e.off(p.MEDIA_ATTACHED, this.onMediaAttached, this), e.off(p.MEDIA_DETACHED, this.onMediaDetached, this), e.off(p.BUFFER_CREATED, this.onBufferCreated, this);
  }
  destroy() {
    this.unregisterListeners(), this.onMediaDetached(), this.hls = this.config = this.audioBuffer = this.videoBuffer = null, this.onWaiting = this.onPlaying = null;
  }
  onMediaAttached(e, t) {
    this.media = t.media, this.media.addEventListener("waiting", this.onWaiting), this.media.addEventListener("playing", this.onPlaying);
  }
  onMediaDetached() {
    this.media && (this.media.removeEventListener("waiting", this.onWaiting), this.media.removeEventListener("playing", this.onPlaying), this.media = null);
  }
  onBufferCreated(e, t) {
    var i, n;
    this.audioBuffer = (i = t.tracks.audio) == null ? void 0 : i.buffer, this.videoBuffer = (n = t.tracks.video) == null ? void 0 : n.buffer;
  }
  /**
   * Create baseline CMCD data
   */
  createData() {
    var e;
    return {
      v: 1,
      sf: Ss.HLS,
      sid: this.sid,
      cid: this.cid,
      pr: (e = this.media) == null ? void 0 : e.playbackRate,
      mtp: this.hls.bandwidthEstimate / 1e3
    };
  }
  /**
   * Apply CMCD data to a request.
   */
  apply(e, t = {}) {
    fe(t, this.createData());
    const i = t.ot === Le.INIT || t.ot === Le.VIDEO || t.ot === Le.MUXED;
    this.starved && i && (t.bs = !0, t.su = !0, this.starved = !1), t.su == null && (t.su = this.buffering);
    const {
      includeKeys: n
    } = this;
    n && (t = Object.keys(t).reduce((r, a) => (n.includes(a) && (r[a] = t[a]), r), {})), this.useHeaders ? (e.headers || (e.headers = {}), Ku(e.headers, t)) : e.url = Yu(e.url, t);
  }
  /**
   * The CMCD object type.
   */
  getObjectType(e) {
    const {
      type: t
    } = e;
    if (t === "subtitle")
      return Le.TIMED_TEXT;
    if (e.sn === "initSegment")
      return Le.INIT;
    if (t === "audio")
      return Le.AUDIO;
    if (t === "main")
      return this.hls.audioTracks.length ? Le.VIDEO : Le.MUXED;
  }
  /**
   * Get the highest bitrate.
   */
  getTopBandwidth(e) {
    let t = 0, i;
    const n = this.hls;
    if (e === Le.AUDIO)
      i = n.audioTracks;
    else {
      const r = n.maxAutoLevel, a = r > -1 ? r + 1 : n.levels.length;
      i = n.levels.slice(0, a);
    }
    for (const r of i)
      r.bitrate > t && (t = r.bitrate);
    return t > 0 ? t : NaN;
  }
  /**
   * Get the buffer length for a media type in milliseconds
   */
  getBufferLength(e) {
    const t = this.hls.media, i = e === Le.AUDIO ? this.audioBuffer : this.videoBuffer;
    return !i || !t ? NaN : le.bufferInfo(i, t.currentTime, this.config.maxBufferHole).len * 1e3;
  }
  /**
   * Create a playlist loader
   */
  createPlaylistLoader() {
    const {
      pLoader: e
    } = this.config, t = this.applyPlaylistData, i = e || this.config.loader;
    return class {
      constructor(r) {
        this.loader = void 0, this.loader = new i(r);
      }
      get stats() {
        return this.loader.stats;
      }
      get context() {
        return this.loader.context;
      }
      destroy() {
        this.loader.destroy();
      }
      abort() {
        this.loader.abort();
      }
      load(r, a, o) {
        t(r), this.loader.load(r, a, o);
      }
    };
  }
  /**
   * Create a playlist loader
   */
  createFragmentLoader() {
    const {
      fLoader: e
    } = this.config, t = this.applyFragmentData, i = e || this.config.loader;
    return class {
      constructor(r) {
        this.loader = void 0, this.loader = new i(r);
      }
      get stats() {
        return this.loader.stats;
      }
      get context() {
        return this.loader.context;
      }
      destroy() {
        this.loader.destroy();
      }
      abort() {
        this.loader.abort();
      }
      load(r, a, o) {
        t(r), this.loader.load(r, a, o);
      }
    };
  }
}
const qu = 3e5;
class zu {
  constructor(e) {
    this.hls = void 0, this.log = void 0, this.loader = null, this.uri = null, this.pathwayId = ".", this.pathwayPriority = null, this.timeToLoad = 300, this.reloadTimer = -1, this.updated = 0, this.started = !1, this.enabled = !0, this.levels = null, this.audioTracks = null, this.subtitleTracks = null, this.penalizedPathways = {}, this.hls = e, this.log = S.log.bind(S, "[content-steering]:"), this.registerListeners();
  }
  registerListeners() {
    const e = this.hls;
    e.on(p.MANIFEST_LOADING, this.onManifestLoading, this), e.on(p.MANIFEST_LOADED, this.onManifestLoaded, this), e.on(p.MANIFEST_PARSED, this.onManifestParsed, this), e.on(p.ERROR, this.onError, this);
  }
  unregisterListeners() {
    const e = this.hls;
    e && (e.off(p.MANIFEST_LOADING, this.onManifestLoading, this), e.off(p.MANIFEST_LOADED, this.onManifestLoaded, this), e.off(p.MANIFEST_PARSED, this.onManifestParsed, this), e.off(p.ERROR, this.onError, this));
  }
  startLoad() {
    if (this.started = !0, this.clearTimeout(), this.enabled && this.uri) {
      if (this.updated) {
        const e = this.timeToLoad * 1e3 - (performance.now() - this.updated);
        if (e > 0) {
          this.scheduleRefresh(this.uri, e);
          return;
        }
      }
      this.loadSteeringManifest(this.uri);
    }
  }
  stopLoad() {
    this.started = !1, this.loader && (this.loader.destroy(), this.loader = null), this.clearTimeout();
  }
  clearTimeout() {
    this.reloadTimer !== -1 && (self.clearTimeout(this.reloadTimer), this.reloadTimer = -1);
  }
  destroy() {
    this.unregisterListeners(), this.stopLoad(), this.hls = null, this.levels = this.audioTracks = this.subtitleTracks = null;
  }
  removeLevel(e) {
    const t = this.levels;
    t && (this.levels = t.filter((i) => i !== e));
  }
  onManifestLoading() {
    this.stopLoad(), this.enabled = !0, this.timeToLoad = 300, this.updated = 0, this.uri = null, this.pathwayId = ".", this.levels = this.audioTracks = this.subtitleTracks = null;
  }
  onManifestLoaded(e, t) {
    const {
      contentSteering: i
    } = t;
    i !== null && (this.pathwayId = i.pathwayId, this.uri = i.uri, this.started && this.startLoad());
  }
  onManifestParsed(e, t) {
    this.audioTracks = t.audioTracks, this.subtitleTracks = t.subtitleTracks;
  }
  onError(e, t) {
    const {
      errorAction: i
    } = t;
    if ((i == null ? void 0 : i.action) === Se.SendAlternateToPenaltyBox && i.flags === Pe.MoveAllAlternatesMatchingHost) {
      const n = this.levels;
      let r = this.pathwayPriority, a = this.pathwayId;
      if (t.context) {
        const {
          groupId: o,
          pathwayId: l,
          type: c
        } = t.context;
        o && n ? a = this.getPathwayForGroupId(o, c, a) : l && (a = l);
      }
      a in this.penalizedPathways || (this.penalizedPathways[a] = performance.now()), !r && n && (r = n.reduce((o, l) => (o.indexOf(l.pathwayId) === -1 && o.push(l.pathwayId), o), [])), r && r.length > 1 && (this.updatePathwayPriority(r), i.resolved = this.pathwayId !== a), i.resolved || S.warn(`Could not resolve ${t.details} ("${t.error.message}") with content-steering for Pathway: ${a} levels: ${n && n.length} priorities: ${JSON.stringify(r)} penalized: ${JSON.stringify(this.penalizedPathways)}`);
    }
  }
  filterParsedLevels(e) {
    this.levels = e;
    let t = this.getLevelsForPathway(this.pathwayId);
    if (t.length === 0) {
      const i = e[0].pathwayId;
      this.log(`No levels found in Pathway ${this.pathwayId}. Setting initial Pathway to "${i}"`), t = this.getLevelsForPathway(i), this.pathwayId = i;
    }
    return t.length !== e.length && this.log(`Found ${t.length}/${e.length} levels in Pathway "${this.pathwayId}"`), t;
  }
  getLevelsForPathway(e) {
    return this.levels === null ? [] : this.levels.filter((t) => e === t.pathwayId);
  }
  updatePathwayPriority(e) {
    this.pathwayPriority = e;
    let t;
    const i = this.penalizedPathways, n = performance.now();
    Object.keys(i).forEach((r) => {
      n - i[r] > qu && delete i[r];
    });
    for (let r = 0; r < e.length; r++) {
      const a = e[r];
      if (a in i)
        continue;
      if (a === this.pathwayId)
        return;
      const o = this.hls.nextLoadLevel, l = this.hls.levels[o];
      if (t = this.getLevelsForPathway(a), t.length > 0) {
        this.log(`Setting Pathway to "${a}"`), this.pathwayId = a, sa(t), this.hls.trigger(p.LEVELS_UPDATED, {
          levels: t
        });
        const c = this.hls.levels[o];
        l && c && this.levels && (c.attrs["STABLE-VARIANT-ID"] !== l.attrs["STABLE-VARIANT-ID"] && c.bitrate !== l.bitrate && this.log(`Unstable Pathways change from bitrate ${l.bitrate} to ${c.bitrate}`), this.hls.nextLoadLevel = o);
        break;
      }
    }
  }
  getPathwayForGroupId(e, t, i) {
    const n = this.getLevelsForPathway(i).concat(this.levels || []);
    for (let r = 0; r < n.length; r++)
      if (t === Q.AUDIO_TRACK && n[r].hasAudioGroup(e) || t === Q.SUBTITLE_TRACK && n[r].hasSubtitleGroup(e))
        return n[r].pathwayId;
    return i;
  }
  clonePathways(e) {
    const t = this.levels;
    if (!t)
      return;
    const i = {}, n = {};
    e.forEach((r) => {
      const {
        ID: a,
        "BASE-ID": o,
        "URI-REPLACEMENT": l
      } = r;
      if (t.some((h) => h.pathwayId === a))
        return;
      const c = this.getLevelsForPathway(o).map((h) => {
        const u = new ce(h.attrs);
        u["PATHWAY-ID"] = a;
        const d = u.AUDIO && `${u.AUDIO}_clone_${a}`, g = u.SUBTITLES && `${u.SUBTITLES}_clone_${a}`;
        d && (i[u.AUDIO] = d, u.AUDIO = d), g && (n[u.SUBTITLES] = g, u.SUBTITLES = g);
        const f = Ba(h.uri, u["STABLE-VARIANT-ID"], "PER-VARIANT-URIS", l), m = new vt({
          attrs: u,
          audioCodec: h.audioCodec,
          bitrate: h.bitrate,
          height: h.height,
          name: h.name,
          url: f,
          videoCodec: h.videoCodec,
          width: h.width
        });
        if (h.audioGroups)
          for (let y = 1; y < h.audioGroups.length; y++)
            m.addGroupId("audio", `${h.audioGroups[y]}_clone_${a}`);
        if (h.subtitleGroups)
          for (let y = 1; y < h.subtitleGroups.length; y++)
            m.addGroupId("text", `${h.subtitleGroups[y]}_clone_${a}`);
        return m;
      });
      t.push(...c), or(this.audioTracks, i, l, a), or(this.subtitleTracks, n, l, a);
    });
  }
  loadSteeringManifest(e) {
    const t = this.hls.config, i = t.loader;
    this.loader && this.loader.destroy(), this.loader = new i(t);
    let n;
    try {
      n = new self.URL(e);
    } catch (h) {
      this.enabled = !1, this.log(`Failed to parse Steering Manifest URI: ${e}`);
      return;
    }
    if (n.protocol !== "data:") {
      const h = (this.hls.bandwidthEstimate || t.abrEwmaDefaultEstimate) | 0;
      n.searchParams.set("_HLS_pathway", this.pathwayId), n.searchParams.set("_HLS_throughput", "" + h);
    }
    const r = {
      responseType: "json",
      url: n.href
    }, a = t.steeringManifestLoadPolicy.default, o = a.errorRetry || a.timeoutRetry || {}, l = {
      loadPolicy: a,
      timeout: a.maxLoadTimeMs,
      maxRetry: o.maxNumRetry || 0,
      retryDelay: o.retryDelayMs || 0,
      maxRetryDelay: o.maxRetryDelayMs || 0
    }, c = {
      onSuccess: (h, u, d, g) => {
        this.log(`Loaded steering manifest: "${n}"`);
        const f = h.data;
        if (f.VERSION !== 1) {
          this.log(`Steering VERSION ${f.VERSION} not supported!`);
          return;
        }
        this.updated = performance.now(), this.timeToLoad = f.TTL;
        const {
          "RELOAD-URI": m,
          "PATHWAY-CLONES": y,
          "PATHWAY-PRIORITY": T
        } = f;
        if (m)
          try {
            this.uri = new self.URL(m, n).href;
          } catch (v) {
            this.enabled = !1, this.log(`Failed to parse Steering Manifest RELOAD-URI: ${m}`);
            return;
          }
        this.scheduleRefresh(this.uri || d.url), y && this.clonePathways(y);
        const b = {
          steeringManifest: f,
          url: n.toString()
        };
        this.hls.trigger(p.STEERING_MANIFEST_LOADED, b), T && this.updatePathwayPriority(T);
      },
      onError: (h, u, d, g) => {
        if (this.log(`Error loading steering manifest: ${h.code} ${h.text} (${u.url})`), this.stopLoad(), h.code === 410) {
          this.enabled = !1, this.log(`Steering manifest ${u.url} no longer available`);
          return;
        }
        let f = this.timeToLoad * 1e3;
        if (h.code === 429) {
          const m = this.loader;
          if (typeof (m == null ? void 0 : m.getResponseHeader) == "function") {
            const y = m.getResponseHeader("Retry-After");
            y && (f = parseFloat(y) * 1e3);
          }
          this.log(`Steering manifest ${u.url} rate limited`);
          return;
        }
        this.scheduleRefresh(this.uri || u.url, f);
      },
      onTimeout: (h, u, d) => {
        this.log(`Timeout loading steering manifest (${u.url})`), this.scheduleRefresh(this.uri || u.url);
      }
    };
    this.log(`Requesting steering manifest: ${n}`), this.loader.load(r, l, c);
  }
  scheduleRefresh(e, t = this.timeToLoad * 1e3) {
    this.clearTimeout(), this.reloadTimer = self.setTimeout(() => {
      var i;
      const n = (i = this.hls) == null ? void 0 : i.media;
      if (n && !n.ended) {
        this.loadSteeringManifest(e);
        return;
      }
      this.scheduleRefresh(e, this.timeToLoad * 1e3);
    }, t);
  }
}
function or(s, e, t, i) {
  s && Object.keys(e).forEach((n) => {
    const r = s.filter((a) => a.groupId === n).map((a) => {
      const o = fe({}, a);
      return o.details = void 0, o.attrs = new ce(o.attrs), o.url = o.attrs.URI = Ba(a.url, a.attrs["STABLE-RENDITION-ID"], "PER-RENDITION-URIS", t), o.groupId = o.attrs["GROUP-ID"] = e[n], o.attrs["PATHWAY-ID"] = i, o;
    });
    s.push(...r);
  });
}
function Ba(s, e, t, i) {
  const {
    HOST: n,
    PARAMS: r,
    [t]: a
  } = i;
  let o;
  e && (o = a == null ? void 0 : a[e], o && (s = o));
  const l = new self.URL(s);
  return n && !o && (l.host = n), r && Object.keys(r).sort().forEach((c) => {
    c && l.searchParams.set(c, r[c]);
  }), l.href;
}
const Xu = /^age:\s*[\d.]+\s*$/im;
class $a {
  constructor(e) {
    this.xhrSetup = void 0, this.requestTimeout = void 0, this.retryTimeout = void 0, this.retryDelay = void 0, this.config = null, this.callbacks = null, this.context = null, this.loader = null, this.stats = void 0, this.xhrSetup = e && e.xhrSetup || null, this.stats = new wi(), this.retryDelay = 0;
  }
  destroy() {
    this.callbacks = null, this.abortInternal(), this.loader = null, this.config = null, this.context = null, this.xhrSetup = null;
  }
  abortInternal() {
    const e = this.loader;
    self.clearTimeout(this.requestTimeout), self.clearTimeout(this.retryTimeout), e && (e.onreadystatechange = null, e.onprogress = null, e.readyState !== 4 && (this.stats.aborted = !0, e.abort()));
  }
  abort() {
    var e;
    this.abortInternal(), (e = this.callbacks) != null && e.onAbort && this.callbacks.onAbort(this.stats, this.context, this.loader);
  }
  load(e, t, i) {
    if (this.stats.loading.start)
      throw new Error("Loader can only be used once.");
    this.stats.loading.start = self.performance.now(), this.context = e, this.config = t, this.callbacks = i, this.loadInternal();
  }
  loadInternal() {
    const {
      config: e,
      context: t
    } = this;
    if (!e || !t)
      return;
    const i = this.loader = new self.XMLHttpRequest(), n = this.stats;
    n.loading.first = 0, n.loaded = 0, n.aborted = !1;
    const r = this.xhrSetup;
    r ? Promise.resolve().then(() => {
      if (!(this.loader !== i || this.stats.aborted))
        return r(i, t.url);
    }).catch((a) => {
      if (!(this.loader !== i || this.stats.aborted))
        return i.open("GET", t.url, !0), r(i, t.url);
    }).then(() => {
      this.loader !== i || this.stats.aborted || this.openAndSendXhr(i, t, e);
    }).catch((a) => {
      this.callbacks.onError({
        code: i.status,
        text: a.message
      }, t, i, n);
    }) : this.openAndSendXhr(i, t, e);
  }
  openAndSendXhr(e, t, i) {
    e.readyState || e.open("GET", t.url, !0);
    const n = t.headers, {
      maxTimeToFirstByteMs: r,
      maxLoadTimeMs: a
    } = i.loadPolicy;
    if (n)
      for (const o in n)
        e.setRequestHeader(o, n[o]);
    t.rangeEnd && e.setRequestHeader("Range", "bytes=" + t.rangeStart + "-" + (t.rangeEnd - 1)), e.onreadystatechange = this.readystatechange.bind(this), e.onprogress = this.loadprogress.bind(this), e.responseType = t.responseType, self.clearTimeout(this.requestTimeout), i.timeout = r && U(r) ? r : a, this.requestTimeout = self.setTimeout(this.loadtimeout.bind(this), i.timeout), e.send();
  }
  readystatechange() {
    const {
      context: e,
      loader: t,
      stats: i
    } = this;
    if (!e || !t)
      return;
    const n = t.readyState, r = this.config;
    if (!i.aborted && n >= 2 && (i.loading.first === 0 && (i.loading.first = Math.max(self.performance.now(), i.loading.start), r.timeout !== r.loadPolicy.maxLoadTimeMs && (self.clearTimeout(this.requestTimeout), r.timeout = r.loadPolicy.maxLoadTimeMs, this.requestTimeout = self.setTimeout(this.loadtimeout.bind(this), r.loadPolicy.maxLoadTimeMs - (i.loading.first - i.loading.start)))), n === 4)) {
      self.clearTimeout(this.requestTimeout), t.onreadystatechange = null, t.onprogress = null;
      const a = t.status, o = t.responseType === "text" ? t.responseText : null;
      if (a >= 200 && a < 300) {
        const u = o != null ? o : t.response;
        if (u != null) {
          i.loading.end = Math.max(self.performance.now(), i.loading.first);
          const d = t.responseType === "arraybuffer" ? u.byteLength : u.length;
          if (i.loaded = i.total = d, i.bwEstimate = i.total * 8e3 / (i.loading.end - i.loading.first), !this.callbacks)
            return;
          const g = this.callbacks.onProgress;
          if (g && g(i, e, u, t), !this.callbacks)
            return;
          const f = {
            url: t.responseURL,
            data: u,
            code: a
          };
          this.callbacks.onSuccess(f, i, e, t);
          return;
        }
      }
      const l = r.loadPolicy.errorRetry, c = i.retry, h = {
        url: e.url,
        data: void 0,
        code: a
      };
      vi(l, c, !1, h) ? this.retry(l) : (S.error(`${a} while loading ${e.url}`), this.callbacks.onError({
        code: a,
        text: t.statusText
      }, e, t, i));
    }
  }
  loadtimeout() {
    if (!this.config) return;
    const e = this.config.loadPolicy.timeoutRetry, t = this.stats.retry;
    if (vi(e, t, !0))
      this.retry(e);
    else {
      var i;
      S.warn(`timeout while loading ${(i = this.context) == null ? void 0 : i.url}`);
      const n = this.callbacks;
      n && (this.abortInternal(), n.onTimeout(this.stats, this.context, this.loader));
    }
  }
  retry(e) {
    const {
      context: t,
      stats: i
    } = this;
    this.retryDelay = Ms(e, i.retry), i.retry++, S.warn(`${status ? "HTTP Status " + status : "Timeout"} while loading ${t == null ? void 0 : t.url}, retrying ${i.retry}/${e.maxNumRetry} in ${this.retryDelay}ms`), this.abortInternal(), this.loader = null, self.clearTimeout(this.retryTimeout), this.retryTimeout = self.setTimeout(this.loadInternal.bind(this), this.retryDelay);
  }
  loadprogress(e) {
    const t = this.stats;
    t.loaded = e.loaded, e.lengthComputable && (t.total = e.total);
  }
  getCacheAge() {
    let e = null;
    if (this.loader && Xu.test(this.loader.getAllResponseHeaders())) {
      const t = this.loader.getResponseHeader("age");
      e = t ? parseFloat(t) : null;
    }
    return e;
  }
  getResponseHeader(e) {
    return this.loader && new RegExp(`^${e}:\\s*[\\d.]+\\s*$`, "im").test(this.loader.getAllResponseHeaders()) ? this.loader.getResponseHeader(e) : null;
  }
}
function Qu() {
  if (
    // @ts-ignore
    self.fetch && self.AbortController && self.ReadableStream && self.Request
  )
    try {
      return new self.ReadableStream({}), !0;
    } catch (s) {
    }
  return !1;
}
const Ju = /(\d+)-(\d+)\/(\d+)/;
class lr {
  constructor(e) {
    this.fetchSetup = void 0, this.requestTimeout = void 0, this.request = null, this.response = null, this.controller = void 0, this.context = null, this.config = null, this.callbacks = null, this.stats = void 0, this.loader = null, this.fetchSetup = e.fetchSetup || id, this.controller = new self.AbortController(), this.stats = new wi();
  }
  destroy() {
    this.loader = this.callbacks = this.context = this.config = this.request = null, this.abortInternal(), this.response = null, this.fetchSetup = this.controller = this.stats = null;
  }
  abortInternal() {
    this.controller && !this.stats.loading.end && (this.stats.aborted = !0, this.controller.abort());
  }
  abort() {
    var e;
    this.abortInternal(), (e = this.callbacks) != null && e.onAbort && this.callbacks.onAbort(this.stats, this.context, this.response);
  }
  load(e, t, i) {
    const n = this.stats;
    if (n.loading.start)
      throw new Error("Loader can only be used once.");
    n.loading.start = self.performance.now();
    const r = Zu(e, this.controller.signal), a = i.onProgress, o = e.responseType === "arraybuffer", l = o ? "byteLength" : "length", {
      maxTimeToFirstByteMs: c,
      maxLoadTimeMs: h
    } = t.loadPolicy;
    this.context = e, this.config = t, this.callbacks = i, this.request = this.fetchSetup(e, r), self.clearTimeout(this.requestTimeout), t.timeout = c && U(c) ? c : h, this.requestTimeout = self.setTimeout(() => {
      this.abortInternal(), i.onTimeout(n, e, this.response);
    }, t.timeout), self.fetch(this.request).then((u) => {
      this.response = this.loader = u;
      const d = Math.max(self.performance.now(), n.loading.start);
      if (self.clearTimeout(this.requestTimeout), t.timeout = h, this.requestTimeout = self.setTimeout(() => {
        this.abortInternal(), i.onTimeout(n, e, this.response);
      }, h - (d - n.loading.start)), !u.ok) {
        const {
          status: g,
          statusText: f
        } = u;
        throw new sd(f || "fetch, bad network response", g, u);
      }
      return n.loading.first = d, n.total = td(u.headers) || n.total, a && U(t.highWaterMark) ? this.loadProgressively(u, n, e, t.highWaterMark, a) : o ? u.arrayBuffer() : e.responseType === "json" ? u.json() : u.text();
    }).then((u) => {
      const d = this.response;
      if (!d)
        throw new Error("loader destroyed");
      self.clearTimeout(this.requestTimeout), n.loading.end = Math.max(self.performance.now(), n.loading.first);
      const g = u[l];
      g && (n.loaded = n.total = g);
      const f = {
        url: d.url,
        data: u,
        code: d.status
      };
      a && !U(t.highWaterMark) && a(n, e, u, d), i.onSuccess(f, n, e, d);
    }).catch((u) => {
      if (self.clearTimeout(this.requestTimeout), n.aborted)
        return;
      const d = u && u.code || 0, g = u ? u.message : null;
      i.onError({
        code: d,
        text: g
      }, e, u ? u.details : null, n);
    });
  }
  getCacheAge() {
    let e = null;
    if (this.response) {
      const t = this.response.headers.get("age");
      e = t ? parseFloat(t) : null;
    }
    return e;
  }
  getResponseHeader(e) {
    return this.response ? this.response.headers.get(e) : null;
  }
  loadProgressively(e, t, i, n = 0, r) {
    const a = new oa(), o = e.body.getReader(), l = () => o.read().then((c) => {
      if (c.done)
        return a.dataLength && r(t, i, a.flush(), e), Promise.resolve(new ArrayBuffer(0));
      const h = c.value, u = h.length;
      return t.loaded += u, u < n || a.dataLength ? (a.push(h), a.dataLength >= n && r(t, i, a.flush(), e)) : r(t, i, h, e), l();
    }).catch(() => Promise.reject());
    return l();
  }
}
function Zu(s, e) {
  const t = {
    method: "GET",
    mode: "cors",
    credentials: "same-origin",
    signal: e,
    headers: new self.Headers(fe({}, s.headers))
  };
  return s.rangeEnd && t.headers.set("Range", "bytes=" + s.rangeStart + "-" + String(s.rangeEnd - 1)), t;
}
function ed(s) {
  const e = Ju.exec(s);
  if (e)
    return parseInt(e[2]) - parseInt(e[1]) + 1;
}
function td(s) {
  const e = s.get("Content-Range");
  if (e) {
    const i = ed(e);
    if (U(i))
      return i;
  }
  const t = s.get("Content-Length");
  if (t)
    return parseInt(t);
}
function id(s, e) {
  return new self.Request(s.url, e);
}
class sd extends Error {
  constructor(e, t, i) {
    super(e), this.code = void 0, this.details = void 0, this.code = t, this.details = i;
  }
}
const nd = /\s/, rd = {
  newCue(s, e, t, i) {
    const n = [];
    let r, a, o, l, c;
    const h = self.VTTCue || self.TextTrackCue;
    for (let d = 0; d < i.rows.length; d++)
      if (r = i.rows[d], o = !0, l = 0, c = "", !r.isEmpty()) {
        var u;
        for (let m = 0; m < r.chars.length; m++)
          nd.test(r.chars[m].uchar) && o ? l++ : (c += r.chars[m].uchar, o = !1);
        r.cueStartTime = e, e === t && (t += 1e-4), l >= 16 ? l-- : l++;
        const g = Ca(c.trim()), f = js(e, t, g);
        s != null && (u = s.cues) != null && u.getCueById(f) || (a = new h(e, t, g), a.id = f, a.line = d + 1, a.align = "left", a.position = 10 + Math.min(80, Math.floor(l * 8 / 32) * 10), n.push(a));
      }
    return s && n.length && (n.sort((d, g) => d.line === "auto" || g.line === "auto" ? 0 : d.line > 8 && g.line > 8 ? g.line - d.line : d.line - g.line), n.forEach((d) => Zr(s, d))), n;
  }
}, ad = {
  maxTimeToFirstByteMs: 8e3,
  maxLoadTimeMs: 2e4,
  timeoutRetry: null,
  errorRetry: null
}, Ga = be(be({
  autoStartLoad: !0,
  // used by stream-controller
  startPosition: -1,
  // used by stream-controller
  defaultAudioCodec: void 0,
  // used by stream-controller
  debug: !1,
  // used by logger
  capLevelOnFPSDrop: !1,
  // used by fps-controller
  capLevelToPlayerSize: !1,
  // used by cap-level-controller
  ignoreDevicePixelRatio: !1,
  // used by cap-level-controller
  preferManagedMediaSource: !0,
  initialLiveManifestSize: 1,
  // used by stream-controller
  maxBufferLength: 30,
  // used by stream-controller
  backBufferLength: 1 / 0,
  // used by buffer-controller
  frontBufferFlushThreshold: 1 / 0,
  maxBufferSize: 60 * 1e3 * 1e3,
  // used by stream-controller
  maxBufferHole: 0.1,
  // used by stream-controller
  highBufferWatchdogPeriod: 2,
  // used by stream-controller
  nudgeOffset: 0.1,
  // used by stream-controller
  nudgeMaxRetry: 3,
  // used by stream-controller
  maxFragLookUpTolerance: 0.25,
  // used by stream-controller
  liveSyncDurationCount: 3,
  // used by latency-controller
  liveMaxLatencyDurationCount: 1 / 0,
  // used by latency-controller
  liveSyncDuration: void 0,
  // used by latency-controller
  liveMaxLatencyDuration: void 0,
  // used by latency-controller
  maxLiveSyncPlaybackRate: 1,
  // used by latency-controller
  liveDurationInfinity: !1,
  // used by buffer-controller
  /**
   * @deprecated use backBufferLength
   */
  liveBackBufferLength: null,
  // used by buffer-controller
  maxMaxBufferLength: 600,
  // used by stream-controller
  enableWorker: !0,
  // used by transmuxer
  workerPath: null,
  // used by transmuxer
  enableSoftwareAES: !0,
  // used by decrypter
  startLevel: void 0,
  // used by level-controller
  startFragPrefetch: !1,
  // used by stream-controller
  fpsDroppedMonitoringPeriod: 5e3,
  // used by fps-controller
  fpsDroppedMonitoringThreshold: 0.2,
  // used by fps-controller
  appendErrorMaxRetry: 3,
  // used by buffer-controller
  loader: $a,
  // loader: FetchLoader,
  fLoader: void 0,
  // used by fragment-loader
  pLoader: void 0,
  // used by playlist-loader
  xhrSetup: void 0,
  // used by xhr-loader
  licenseXhrSetup: void 0,
  // used by eme-controller
  licenseResponseCallback: void 0,
  // used by eme-controller
  abrController: _c,
  bufferController: Nh,
  capLevelController: qs,
  errorController: bc,
  fpsController: uu,
  stretchShortVideoTrack: !1,
  // used by mp4-remuxer
  maxAudioFramesDrift: 1,
  // used by mp4-remuxer
  forceKeyFrameOnDiscontinuity: !0,
  // used by ts-demuxer
  abrEwmaFastLive: 3,
  // used by abr-controller
  abrEwmaSlowLive: 9,
  // used by abr-controller
  abrEwmaFastVoD: 3,
  // used by abr-controller
  abrEwmaSlowVoD: 9,
  // used by abr-controller
  abrEwmaDefaultEstimate: 5e5,
  // 500 kbps  // used by abr-controller
  abrEwmaDefaultEstimateMax: 5e6,
  // 5 mbps
  abrBandWidthFactor: 0.95,
  // used by abr-controller
  abrBandWidthUpFactor: 0.7,
  // used by abr-controller
  abrMaxWithRealBitrate: !1,
  // used by abr-controller
  maxStarvationDelay: 4,
  // used by abr-controller
  maxLoadingDelay: 4,
  // used by abr-controller
  minAutoBitrate: 0,
  // used by hls
  emeEnabled: !1,
  // used by eme-controller
  widevineLicenseUrl: void 0,
  // used by eme-controller
  drmSystems: {},
  // used by eme-controller
  drmSystemOptions: {},
  // used by eme-controller
  requestMediaKeySystemAccessFunc: Ur,
  // used by eme-controller
  testBandwidth: !0,
  progressive: !1,
  lowLatencyMode: !0,
  cmcd: void 0,
  enableDateRangeMetadataCues: !0,
  enableEmsgMetadataCues: !0,
  enableID3MetadataCues: !0,
  useMediaCapabilities: !0,
  certLoadPolicy: {
    default: ad
  },
  keyLoadPolicy: {
    default: {
      maxTimeToFirstByteMs: 8e3,
      maxLoadTimeMs: 2e4,
      timeoutRetry: {
        maxNumRetry: 1,
        retryDelayMs: 1e3,
        maxRetryDelayMs: 2e4,
        backoff: "linear"
      },
      errorRetry: {
        maxNumRetry: 8,
        retryDelayMs: 1e3,
        maxRetryDelayMs: 2e4,
        backoff: "linear"
      }
    }
  },
  manifestLoadPolicy: {
    default: {
      maxTimeToFirstByteMs: 1 / 0,
      maxLoadTimeMs: 2e4,
      timeoutRetry: {
        maxNumRetry: 2,
        retryDelayMs: 0,
        maxRetryDelayMs: 0
      },
      errorRetry: {
        maxNumRetry: 1,
        retryDelayMs: 1e3,
        maxRetryDelayMs: 8e3
      }
    }
  },
  playlistLoadPolicy: {
    default: {
      maxTimeToFirstByteMs: 1e4,
      maxLoadTimeMs: 2e4,
      timeoutRetry: {
        maxNumRetry: 2,
        retryDelayMs: 0,
        maxRetryDelayMs: 0
      },
      errorRetry: {
        maxNumRetry: 2,
        retryDelayMs: 1e3,
        maxRetryDelayMs: 8e3
      }
    }
  },
  fragLoadPolicy: {
    default: {
      maxTimeToFirstByteMs: 1e4,
      maxLoadTimeMs: 12e4,
      timeoutRetry: {
        maxNumRetry: 4,
        retryDelayMs: 0,
        maxRetryDelayMs: 0
      },
      errorRetry: {
        maxNumRetry: 6,
        retryDelayMs: 1e3,
        maxRetryDelayMs: 8e3
      }
    }
  },
  steeringManifestLoadPolicy: {
    default: {
      maxTimeToFirstByteMs: 1e4,
      maxLoadTimeMs: 2e4,
      timeoutRetry: {
        maxNumRetry: 2,
        retryDelayMs: 0,
        maxRetryDelayMs: 0
      },
      errorRetry: {
        maxNumRetry: 1,
        retryDelayMs: 1e3,
        maxRetryDelayMs: 8e3
      }
    }
  },
  // These default settings are deprecated in favor of the above policies
  // and are maintained for backwards compatibility
  manifestLoadingTimeOut: 1e4,
  manifestLoadingMaxRetry: 1,
  manifestLoadingRetryDelay: 1e3,
  manifestLoadingMaxRetryTimeout: 64e3,
  levelLoadingTimeOut: 1e4,
  levelLoadingMaxRetry: 4,
  levelLoadingRetryDelay: 1e3,
  levelLoadingMaxRetryTimeout: 64e3,
  fragLoadingTimeOut: 2e4,
  fragLoadingMaxRetry: 6,
  fragLoadingRetryDelay: 1e3,
  fragLoadingMaxRetryTimeout: 64e3
}, od()), {}, {
  subtitleStreamController: _h,
  subtitleTrackController: Fh,
  timelineController: cu,
  audioStreamController: kh,
  audioTrackController: Ph,
  emeController: yt,
  cmcdController: ju,
  contentSteeringController: zu
});
function od() {
  return {
    cueHandler: rd,
    // used by timeline-controller
    enableWebVTT: !0,
    // used by timeline-controller
    enableIMSC1: !0,
    // used by timeline-controller
    enableCEA708Captions: !0,
    // used by timeline-controller
    captionsTextTrack1Label: "English",
    // used by timeline-controller
    captionsTextTrack1LanguageCode: "en",
    // used by timeline-controller
    captionsTextTrack2Label: "Spanish",
    // used by timeline-controller
    captionsTextTrack2LanguageCode: "es",
    // used by timeline-controller
    captionsTextTrack3Label: "Unknown CC",
    // used by timeline-controller
    captionsTextTrack3LanguageCode: "",
    // used by timeline-controller
    captionsTextTrack4Label: "Unknown CC",
    // used by timeline-controller
    captionsTextTrack4LanguageCode: "",
    // used by timeline-controller
    renderTextTracksNatively: !0
  };
}
function ld(s, e) {
  if ((e.liveSyncDurationCount || e.liveMaxLatencyDurationCount) && (e.liveSyncDuration || e.liveMaxLatencyDuration))
    throw new Error("Illegal hls.js config: don't mix up liveSyncDurationCount/liveMaxLatencyDurationCount and liveSyncDuration/liveMaxLatencyDuration");
  if (e.liveMaxLatencyDurationCount !== void 0 && (e.liveSyncDurationCount === void 0 || e.liveMaxLatencyDurationCount <= e.liveSyncDurationCount))
    throw new Error('Illegal hls.js config: "liveMaxLatencyDurationCount" must be greater than "liveSyncDurationCount"');
  if (e.liveMaxLatencyDuration !== void 0 && (e.liveSyncDuration === void 0 || e.liveMaxLatencyDuration <= e.liveSyncDuration))
    throw new Error('Illegal hls.js config: "liveMaxLatencyDuration" must be greater than "liveSyncDuration"');
  const t = Rs(s), i = ["manifest", "level", "frag"], n = ["TimeOut", "MaxRetry", "RetryDelay", "MaxRetryTimeout"];
  return i.forEach((r) => {
    const a = `${r === "level" ? "playlist" : r}LoadPolicy`, o = e[a] === void 0, l = [];
    n.forEach((c) => {
      const h = `${r}Loading${c}`, u = e[h];
      if (u !== void 0 && o) {
        l.push(h);
        const d = t[a].default;
        switch (e[a] = {
          default: d
        }, c) {
          case "TimeOut":
            d.maxLoadTimeMs = u, d.maxTimeToFirstByteMs = u;
            break;
          case "MaxRetry":
            d.errorRetry.maxNumRetry = u, d.timeoutRetry.maxNumRetry = u;
            break;
          case "RetryDelay":
            d.errorRetry.retryDelayMs = u, d.timeoutRetry.retryDelayMs = u;
            break;
          case "MaxRetryTimeout":
            d.errorRetry.maxRetryDelayMs = u, d.timeoutRetry.maxRetryDelayMs = u;
            break;
        }
      }
    }), l.length && S.warn(`hls.js config: "${l.join('", "')}" setting(s) are deprecated, use "${a}": ${JSON.stringify(e[a])}`);
  }), be(be({}, t), e);
}
function Rs(s) {
  return s && typeof s == "object" ? Array.isArray(s) ? s.map(Rs) : Object.keys(s).reduce((e, t) => (e[t] = Rs(s[t]), e), {}) : s;
}
function cd(s) {
  const e = s.loader;
  e !== lr && e !== $a ? (S.log("[config]: Custom loader detected, cannot enable progressive streaming"), s.progressive = !1) : Qu() && (s.loader = lr, s.progressive = !0, s.enableSoftwareAES = !0, S.log("[config]: Progressive streaming enabled, using FetchLoader"));
}
let ns;
class hd extends Ns {
  constructor(e, t) {
    super(e, "[level-controller]"), this._levels = [], this._firstLevel = -1, this._maxAutoLevel = -1, this._startLevel = void 0, this.currentLevel = null, this.currentLevelIndex = -1, this.manualLevelIndex = -1, this.steering = void 0, this.onParsedComplete = void 0, this.steering = t, this._registerListeners();
  }
  _registerListeners() {
    const {
      hls: e
    } = this;
    e.on(p.MANIFEST_LOADING, this.onManifestLoading, this), e.on(p.MANIFEST_LOADED, this.onManifestLoaded, this), e.on(p.LEVEL_LOADED, this.onLevelLoaded, this), e.on(p.LEVELS_UPDATED, this.onLevelsUpdated, this), e.on(p.FRAG_BUFFERED, this.onFragBuffered, this), e.on(p.ERROR, this.onError, this);
  }
  _unregisterListeners() {
    const {
      hls: e
    } = this;
    e.off(p.MANIFEST_LOADING, this.onManifestLoading, this), e.off(p.MANIFEST_LOADED, this.onManifestLoaded, this), e.off(p.LEVEL_LOADED, this.onLevelLoaded, this), e.off(p.LEVELS_UPDATED, this.onLevelsUpdated, this), e.off(p.FRAG_BUFFERED, this.onFragBuffered, this), e.off(p.ERROR, this.onError, this);
  }
  destroy() {
    this._unregisterListeners(), this.steering = null, this.resetLevels(), super.destroy();
  }
  stopLoad() {
    this._levels.forEach((t) => {
      t.loadError = 0, t.fragmentError = 0;
    }), super.stopLoad();
  }
  resetLevels() {
    this._startLevel = void 0, this.manualLevelIndex = -1, this.currentLevelIndex = -1, this.currentLevel = null, this._levels = [], this._maxAutoLevel = -1;
  }
  onManifestLoading(e, t) {
    this.resetLevels();
  }
  onManifestLoaded(e, t) {
    const i = this.hls.config.preferManagedMediaSource, n = [], r = {}, a = {};
    let o = !1, l = !1, c = !1;
    t.levels.forEach((h) => {
      var u, d;
      const g = h.attrs;
      let {
        audioCodec: f,
        videoCodec: m
      } = h;
      ((u = f) == null ? void 0 : u.indexOf("mp4a.40.34")) !== -1 && (ns || (ns = /chrome|firefox/i.test(navigator.userAgent)), ns && (h.audioCodec = f = void 0)), f && (h.audioCodec = f = yi(f, i)), ((d = m) == null ? void 0 : d.indexOf("avc1")) === 0 && (m = h.videoCodec = Xl(m));
      const {
        width: y,
        height: T,
        unknownCodecs: b
      } = h;
      if (o || (o = !!(y && T)), l || (l = !!m), c || (c = !!f), b != null && b.length || f && !Ki(f, "audio", i) || m && !Ki(m, "video", i))
        return;
      const {
        CODECS: v,
        "FRAME-RATE": A,
        "HDCP-LEVEL": x,
        "PATHWAY-ID": w,
        RESOLUTION: R,
        "VIDEO-RANGE": k
      } = g, C = `${`${w || "."}-`}${h.bitrate}-${R}-${A}-${v}-${k}-${x}`;
      if (r[C])
        if (r[C].uri !== h.url && !h.attrs["PATHWAY-ID"]) {
          const P = a[C] += 1;
          h.attrs["PATHWAY-ID"] = new Array(P + 1).join(".");
          const q = new vt(h);
          r[C] = q, n.push(q);
        } else
          r[C].addGroupId("audio", g.AUDIO), r[C].addGroupId("text", g.SUBTITLES);
      else {
        const P = new vt(h);
        r[C] = P, a[C] = 1, n.push(P);
      }
    }), this.filterAndSortMediaOptions(n, t, o, l, c);
  }
  filterAndSortMediaOptions(e, t, i, n, r) {
    let a = [], o = [], l = e;
    if ((i || n) && r && (l = l.filter(({
      videoCodec: f,
      videoRange: m,
      width: y,
      height: T
    }) => (!!f || !!(y && T)) && cc(m))), l.length === 0) {
      Promise.resolve().then(() => {
        if (this.hls) {
          t.levels.length && this.warn(`One or more CODECS in variant not supported: ${JSON.stringify(t.levels[0].attrs)}`);
          const f = new Error("no level with compatible codecs found in manifest");
          this.hls.trigger(p.ERROR, {
            type: V.MEDIA_ERROR,
            details: I.MANIFEST_INCOMPATIBLE_CODECS_ERROR,
            fatal: !0,
            url: t.url,
            error: f,
            reason: f.message
          });
        }
      });
      return;
    }
    if (t.audioTracks) {
      const {
        preferManagedMediaSource: f
      } = this.hls.config;
      a = t.audioTracks.filter((m) => !m.audioCodec || Ki(m.audioCodec, "audio", f)), cr(a);
    }
    t.subtitles && (o = t.subtitles, cr(o));
    const c = l.slice(0);
    l.sort((f, m) => {
      if (f.attrs["HDCP-LEVEL"] !== m.attrs["HDCP-LEVEL"])
        return (f.attrs["HDCP-LEVEL"] || "") > (m.attrs["HDCP-LEVEL"] || "") ? 1 : -1;
      if (i && f.height !== m.height)
        return f.height - m.height;
      if (f.frameRate !== m.frameRate)
        return f.frameRate - m.frameRate;
      if (f.videoRange !== m.videoRange)
        return Ti.indexOf(f.videoRange) - Ti.indexOf(m.videoRange);
      if (f.videoCodec !== m.videoCodec) {
        const y = pn(f.videoCodec), T = pn(m.videoCodec);
        if (y !== T)
          return T - y;
      }
      if (f.uri === m.uri && f.codecSet !== m.codecSet) {
        const y = pi(f.codecSet), T = pi(m.codecSet);
        if (y !== T)
          return T - y;
      }
      return f.averageBitrate !== m.averageBitrate ? f.averageBitrate - m.averageBitrate : 0;
    });
    let h = c[0];
    if (this.steering && (l = this.steering.filterParsedLevels(l), l.length !== c.length)) {
      for (let f = 0; f < c.length; f++)
        if (c[f].pathwayId === l[0].pathwayId) {
          h = c[f];
          break;
        }
    }
    this._levels = l;
    for (let f = 0; f < l.length; f++)
      if (l[f] === h) {
        var u;
        this._firstLevel = f;
        const m = h.bitrate, y = this.hls.bandwidthEstimate;
        if (this.log(`manifest loaded, ${l.length} level(s) found, first bitrate: ${m}`), ((u = this.hls.userConfig) == null ? void 0 : u.abrEwmaDefaultEstimate) === void 0) {
          const T = Math.min(m, this.hls.config.abrEwmaDefaultEstimateMax);
          T > y && y === Ga.abrEwmaDefaultEstimate && (this.hls.bandwidthEstimate = T);
        }
        break;
      }
    const d = r && !n, g = {
      levels: l,
      audioTracks: a,
      subtitleTracks: o,
      sessionData: t.sessionData,
      sessionKeys: t.sessionKeys,
      firstLevel: this._firstLevel,
      stats: t.stats,
      audio: r,
      video: n,
      altAudio: !d && a.some((f) => !!f.url)
    };
    this.hls.trigger(p.MANIFEST_PARSED, g), (this.hls.config.autoStartLoad || this.hls.forceStartLoad) && this.hls.startLoad(this.hls.config.startPosition);
  }
  get levels() {
    return this._levels.length === 0 ? null : this._levels;
  }
  get level() {
    return this.currentLevelIndex;
  }
  set level(e) {
    const t = this._levels;
    if (t.length === 0)
      return;
    if (e < 0 || e >= t.length) {
      const h = new Error("invalid level idx"), u = e < 0;
      if (this.hls.trigger(p.ERROR, {
        type: V.OTHER_ERROR,
        details: I.LEVEL_SWITCH_ERROR,
        level: e,
        fatal: u,
        error: h,
        reason: h.message
      }), u)
        return;
      e = Math.min(e, t.length - 1);
    }
    const i = this.currentLevelIndex, n = this.currentLevel, r = n ? n.attrs["PATHWAY-ID"] : void 0, a = t[e], o = a.attrs["PATHWAY-ID"];
    if (this.currentLevelIndex = e, this.currentLevel = a, i === e && a.details && n && r === o)
      return;
    this.log(`Switching to level ${e} (${a.height ? a.height + "p " : ""}${a.videoRange ? a.videoRange + " " : ""}${a.codecSet ? a.codecSet + " " : ""}@${a.bitrate})${o ? " with Pathway " + o : ""} from level ${i}${r ? " with Pathway " + r : ""}`);
    const l = {
      level: e,
      attrs: a.attrs,
      details: a.details,
      bitrate: a.bitrate,
      averageBitrate: a.averageBitrate,
      maxBitrate: a.maxBitrate,
      realBitrate: a.realBitrate,
      width: a.width,
      height: a.height,
      codecSet: a.codecSet,
      audioCodec: a.audioCodec,
      videoCodec: a.videoCodec,
      audioGroups: a.audioGroups,
      subtitleGroups: a.subtitleGroups,
      loaded: a.loaded,
      loadError: a.loadError,
      fragmentError: a.fragmentError,
      name: a.name,
      id: a.id,
      uri: a.uri,
      url: a.url,
      urlId: 0,
      audioGroupIds: a.audioGroupIds,
      textGroupIds: a.textGroupIds
    };
    this.hls.trigger(p.LEVEL_SWITCHING, l);
    const c = a.details;
    if (!c || c.live) {
      const h = this.switchParams(a.uri, n == null ? void 0 : n.details, c);
      this.loadPlaylist(h);
    }
  }
  get manualLevel() {
    return this.manualLevelIndex;
  }
  set manualLevel(e) {
    this.manualLevelIndex = e, this._startLevel === void 0 && (this._startLevel = e), e !== -1 && (this.level = e);
  }
  get firstLevel() {
    return this._firstLevel;
  }
  set firstLevel(e) {
    this._firstLevel = e;
  }
  get startLevel() {
    if (this._startLevel === void 0) {
      const e = this.hls.config.startLevel;
      return e !== void 0 ? e : this.hls.firstAutoLevel;
    }
    return this._startLevel;
  }
  set startLevel(e) {
    this._startLevel = e;
  }
  onError(e, t) {
    t.fatal || !t.context || t.context.type === Q.LEVEL && t.context.level === this.level && this.checkRetry(t);
  }
  // reset errors on the successful load of a fragment
  onFragBuffered(e, {
    frag: t
  }) {
    if (t !== void 0 && t.type === G.MAIN) {
      const i = t.elementaryStreams;
      if (!Object.keys(i).some((r) => !!i[r]))
        return;
      const n = this._levels[t.level];
      n != null && n.loadError && (this.log(`Resetting level error count of ${n.loadError} on frag buffered`), n.loadError = 0);
    }
  }
  onLevelLoaded(e, t) {
    var i;
    const {
      level: n,
      details: r
    } = t, a = this._levels[n];
    if (!a) {
      var o;
      this.warn(`Invalid level index ${n}`), (o = t.deliveryDirectives) != null && o.skip && (r.deltaUpdateFailed = !0);
      return;
    }
    n === this.currentLevelIndex ? (a.fragmentError === 0 && (a.loadError = 0), this.playlistLoaded(n, t, a.details)) : (i = t.deliveryDirectives) != null && i.skip && (r.deltaUpdateFailed = !0);
  }
  loadPlaylist(e) {
    super.loadPlaylist();
    const t = this.currentLevelIndex, i = this.currentLevel;
    if (i && this.shouldLoadPlaylist(i)) {
      let n = i.uri;
      if (e)
        try {
          n = e.addDirectives(n);
        } catch (a) {
          this.warn(`Could not construct new URL with HLS Delivery Directives: ${a}`);
        }
      const r = i.attrs["PATHWAY-ID"];
      this.log(`Loading level index ${t}${(e == null ? void 0 : e.msn) !== void 0 ? " at sn " + e.msn + " part " + e.part : ""} with${r ? " Pathway " + r : ""} ${n}`), this.clearTimer(), this.hls.trigger(p.LEVEL_LOADING, {
        url: n,
        level: t,
        pathwayId: i.attrs["PATHWAY-ID"],
        id: 0,
        // Deprecated Level urlId
        deliveryDirectives: e || null
      });
    }
  }
  get nextLoadLevel() {
    return this.manualLevelIndex !== -1 ? this.manualLevelIndex : this.hls.nextAutoLevel;
  }
  set nextLoadLevel(e) {
    this.level = e, this.manualLevelIndex === -1 && (this.hls.nextAutoLevel = e);
  }
  removeLevel(e) {
    var t;
    const i = this._levels.filter((n, r) => r !== e ? !0 : (this.steering && this.steering.removeLevel(n), n === this.currentLevel && (this.currentLevel = null, this.currentLevelIndex = -1, n.details && n.details.fragments.forEach((a) => a.level = -1)), !1));
    sa(i), this._levels = i, this.currentLevelIndex > -1 && (t = this.currentLevel) != null && t.details && (this.currentLevelIndex = this.currentLevel.details.fragments[0].level), this.hls.trigger(p.LEVELS_UPDATED, {
      levels: i
    });
  }
  onLevelsUpdated(e, {
    levels: t
  }) {
    this._levels = t;
  }
  checkMaxAutoUpdated() {
    const {
      autoLevelCapping: e,
      maxAutoLevel: t,
      maxHdcpLevel: i
    } = this.hls;
    this._maxAutoLevel !== t && (this._maxAutoLevel = t, this.hls.trigger(p.MAX_AUTO_LEVEL_UPDATED, {
      autoLevelCapping: e,
      levels: this.levels,
      maxAutoLevel: t,
      minAutoLevel: this.hls.minAutoLevel,
      maxHdcpLevel: i
    }));
  }
}
function cr(s) {
  const e = {};
  s.forEach((t) => {
    const i = t.groupId || "";
    t.id = e[i] = e[i] || 0, e[i]++;
  });
}
class ud {
  constructor(e) {
    this.config = void 0, this.keyUriToKeyInfo = {}, this.emeController = null, this.config = e;
  }
  abort(e) {
    for (const i in this.keyUriToKeyInfo) {
      const n = this.keyUriToKeyInfo[i].loader;
      if (n) {
        var t;
        if (e && e !== ((t = n.context) == null ? void 0 : t.frag.type))
          return;
        n.abort();
      }
    }
  }
  detach() {
    for (const e in this.keyUriToKeyInfo) {
      const t = this.keyUriToKeyInfo[e];
      (t.mediaKeySessionContext || t.decryptdata.isCommonEncryption) && delete this.keyUriToKeyInfo[e];
    }
  }
  destroy() {
    this.detach();
    for (const e in this.keyUriToKeyInfo) {
      const t = this.keyUriToKeyInfo[e].loader;
      t && t.destroy();
    }
    this.keyUriToKeyInfo = {};
  }
  createKeyLoadError(e, t = I.KEY_LOAD_ERROR, i, n, r) {
    return new je({
      type: V.NETWORK_ERROR,
      details: t,
      fatal: !1,
      frag: e,
      response: r,
      error: i,
      networkDetails: n
    });
  }
  loadClear(e, t) {
    if (this.emeController && this.config.emeEnabled) {
      const {
        sn: i,
        cc: n
      } = e;
      for (let r = 0; r < t.length; r++) {
        const a = t[r];
        if (n <= a.cc && (i === "initSegment" || a.sn === "initSegment" || i < a.sn)) {
          this.emeController.selectKeySystemFormat(a).then((o) => {
            a.setKeyFormat(o);
          });
          break;
        }
      }
    }
  }
  load(e) {
    return !e.decryptdata && e.encrypted && this.emeController && this.config.emeEnabled ? this.emeController.selectKeySystemFormat(e).then((t) => this.loadInternal(e, t)) : this.loadInternal(e);
  }
  loadInternal(e, t) {
    var i, n;
    t && e.setKeyFormat(t);
    const r = e.decryptdata;
    if (!r) {
      const c = new Error(t ? `Expected frag.decryptdata to be defined after setting format ${t}` : "Missing decryption data on fragment in onKeyLoading");
      return Promise.reject(this.createKeyLoadError(e, I.KEY_LOAD_ERROR, c));
    }
    const a = r.uri;
    if (!a)
      return Promise.reject(this.createKeyLoadError(e, I.KEY_LOAD_ERROR, new Error(`Invalid key URI: "${a}"`)));
    let o = this.keyUriToKeyInfo[a];
    if ((i = o) != null && i.decryptdata.key)
      return r.key = o.decryptdata.key, Promise.resolve({
        frag: e,
        keyInfo: o
      });
    if ((n = o) != null && n.keyLoadPromise) {
      var l;
      switch ((l = o.mediaKeySessionContext) == null ? void 0 : l.keyStatus) {
        case void 0:
        case "status-pending":
        case "usable":
        case "usable-in-future":
          return o.keyLoadPromise.then((c) => (r.key = c.keyInfo.decryptdata.key, {
            frag: e,
            keyInfo: o
          }));
      }
    }
    switch (o = this.keyUriToKeyInfo[a] = {
      decryptdata: r,
      keyLoadPromise: null,
      loader: null,
      mediaKeySessionContext: null
    }, r.method) {
      case "ISO-23001-7":
      case "SAMPLE-AES":
      case "SAMPLE-AES-CENC":
      case "SAMPLE-AES-CTR":
        return r.keyFormat === "identity" ? this.loadKeyHTTP(o, e) : this.loadKeyEME(o, e);
      case "AES-128":
        return this.loadKeyHTTP(o, e);
      default:
        return Promise.reject(this.createKeyLoadError(e, I.KEY_LOAD_ERROR, new Error(`Key supplied with unsupported METHOD: "${r.method}"`)));
    }
  }
  loadKeyEME(e, t) {
    const i = {
      frag: t,
      keyInfo: e
    };
    if (this.emeController && this.config.emeEnabled) {
      const n = this.emeController.loadKey(i);
      if (n)
        return (e.keyLoadPromise = n.then((r) => (e.mediaKeySessionContext = r, i))).catch((r) => {
          throw e.keyLoadPromise = null, r;
        });
    }
    return Promise.resolve(i);
  }
  loadKeyHTTP(e, t) {
    const i = this.config, n = i.loader, r = new n(i);
    return t.keyLoader = e.loader = r, e.keyLoadPromise = new Promise((a, o) => {
      const l = {
        keyInfo: e,
        frag: t,
        responseType: "arraybuffer",
        url: e.decryptdata.uri
      }, c = i.keyLoadPolicy.default, h = {
        loadPolicy: c,
        timeout: c.maxLoadTimeMs,
        maxRetry: 0,
        retryDelay: 0,
        maxRetryDelay: 0
      }, u = {
        onSuccess: (d, g, f, m) => {
          const {
            frag: y,
            keyInfo: T,
            url: b
          } = f;
          if (!y.decryptdata || T !== this.keyUriToKeyInfo[b])
            return o(this.createKeyLoadError(y, I.KEY_LOAD_ERROR, new Error("after key load, decryptdata unset or changed"), m));
          T.decryptdata.key = y.decryptdata.key = new Uint8Array(d.data), y.keyLoader = null, T.loader = null, a({
            frag: y,
            keyInfo: T
          });
        },
        onError: (d, g, f, m) => {
          this.resetLoader(g), o(this.createKeyLoadError(t, I.KEY_LOAD_ERROR, new Error(`HTTP Error ${d.code} loading key ${d.text}`), f, be({
            url: l.url,
            data: void 0
          }, d)));
        },
        onTimeout: (d, g, f) => {
          this.resetLoader(g), o(this.createKeyLoadError(t, I.KEY_LOAD_TIMEOUT, new Error("key loading timed out"), f));
        },
        onAbort: (d, g, f) => {
          this.resetLoader(g), o(this.createKeyLoadError(t, I.INTERNAL_ABORTED, new Error("key loading aborted"), f));
        }
      };
      r.load(l, h, u);
    });
  }
  resetLoader(e) {
    const {
      frag: t,
      keyInfo: i,
      url: n
    } = e, r = i.loader;
    t.keyLoader === r && (t.keyLoader = null, i.loader = null), delete this.keyUriToKeyInfo[n], r && r.destroy();
  }
}
function Ha() {
  return self.SourceBuffer || self.WebKitSourceBuffer;
}
function Ka() {
  if (!ht())
    return !1;
  const e = Ha();
  return !e || e.prototype && typeof e.prototype.appendBuffer == "function" && typeof e.prototype.remove == "function";
}
function dd() {
  if (!Ka())
    return !1;
  const s = ht();
  return typeof (s == null ? void 0 : s.isTypeSupported) == "function" && (["avc1.42E01E,mp4a.40.2", "av01.0.01M.08", "vp09.00.50.08"].some((e) => s.isTypeSupported(_t(e, "video"))) || ["mp4a.40.2", "fLaC"].some((e) => s.isTypeSupported(_t(e, "audio"))));
}
function fd() {
  var s;
  const e = Ha();
  return typeof (e == null || (s = e.prototype) == null ? void 0 : s.changeType) == "function";
}
const gd = 250, ci = 2, md = 0.1, pd = 0.05;
class yd {
  constructor(e, t, i, n) {
    this.config = void 0, this.media = null, this.fragmentTracker = void 0, this.hls = void 0, this.nudgeRetry = 0, this.stallReported = !1, this.stalled = null, this.moved = !1, this.seeking = !1, this.config = e, this.media = t, this.fragmentTracker = i, this.hls = n;
  }
  destroy() {
    this.media = null, this.hls = this.fragmentTracker = null;
  }
  /**
   * Checks if the playhead is stuck within a gap, and if so, attempts to free it.
   * A gap is an unbuffered range between two buffered ranges (or the start and the first buffered range).
   *
   * @param lastCurrentTime - Previously read playhead position
   */
  poll(e, t) {
    const {
      config: i,
      media: n,
      stalled: r
    } = this;
    if (n === null)
      return;
    const {
      currentTime: a,
      seeking: o
    } = n, l = this.seeking && !o, c = !this.seeking && o;
    if (this.seeking = o, a !== e) {
      if (this.moved = !0, o || (this.nudgeRetry = 0), r !== null) {
        if (this.stallReported) {
          const y = self.performance.now() - r;
          S.warn(`playback not stuck anymore @${a}, after ${Math.round(y)}ms`), this.stallReported = !1;
        }
        this.stalled = null;
      }
      return;
    }
    if (c || l) {
      this.stalled = null;
      return;
    }
    if (n.paused && !o || n.ended || n.playbackRate === 0 || !le.getBuffered(n).length) {
      this.nudgeRetry = 0;
      return;
    }
    const h = le.bufferInfo(n, a, 0), u = h.nextStart || 0;
    if (o) {
      const y = h.len > ci, T = !u || t && t.start <= a || u - a > ci && !this.fragmentTracker.getPartialFragment(a);
      if (y || T)
        return;
      this.moved = !1;
    }
    if (!this.moved && this.stalled !== null) {
      var d;
      if (!(h.len > 0) && !u)
        return;
      const T = Math.max(u, h.start || 0) - a, b = this.hls.levels ? this.hls.levels[this.hls.currentLevel] : null, A = (b == null || (d = b.details) == null ? void 0 : d.live) ? b.details.targetduration * 2 : ci, x = this.fragmentTracker.getPartialFragment(a);
      if (T > 0 && (T <= A || x)) {
        n.paused || this._trySkipBufferHole(x);
        return;
      }
    }
    const g = self.performance.now();
    if (r === null) {
      this.stalled = g;
      return;
    }
    const f = g - r;
    if (!o && f >= gd && (this._reportStall(h), !this.media))
      return;
    const m = le.bufferInfo(n, a, i.maxBufferHole);
    this._tryFixBufferStall(m, f);
  }
  /**
   * Detects and attempts to fix known buffer stalling issues.
   * @param bufferInfo - The properties of the current buffer.
   * @param stalledDurationMs - The amount of time Hls.js has been stalling for.
   * @private
   */
  _tryFixBufferStall(e, t) {
    const {
      config: i,
      fragmentTracker: n,
      media: r
    } = this;
    if (r === null)
      return;
    const a = r.currentTime, o = n.getPartialFragment(a);
    o && (this._trySkipBufferHole(o) || !this.media) || (e.len > i.maxBufferHole || e.nextStart && e.nextStart - a < i.maxBufferHole) && t > i.highBufferWatchdogPeriod * 1e3 && (S.warn("Trying to nudge playhead over buffer-hole"), this.stalled = null, this._tryNudgeBuffer());
  }
  /**
   * Triggers a BUFFER_STALLED_ERROR event, but only once per stall period.
   * @param bufferLen - The playhead distance from the end of the current buffer segment.
   * @private
   */
  _reportStall(e) {
    const {
      hls: t,
      media: i,
      stallReported: n
    } = this;
    if (!n && i) {
      this.stallReported = !0;
      const r = new Error(`Playback stalling at @${i.currentTime} due to low buffer (${JSON.stringify(e)})`);
      S.warn(r.message), t.trigger(p.ERROR, {
        type: V.MEDIA_ERROR,
        details: I.BUFFER_STALLED_ERROR,
        fatal: !1,
        error: r,
        buffer: e.len
      });
    }
  }
  /**
   * Attempts to fix buffer stalls by jumping over known gaps caused by partial fragments
   * @param partial - The partial fragment found at the current time (where playback is stalling).
   * @private
   */
  _trySkipBufferHole(e) {
    const {
      config: t,
      hls: i,
      media: n
    } = this;
    if (n === null)
      return 0;
    const r = n.currentTime, a = le.bufferInfo(n, r, 0), o = r < a.start ? a.start : a.nextStart;
    if (o) {
      const l = a.len <= t.maxBufferHole, c = a.len > 0 && a.len < 1 && n.readyState < 3, h = o - r;
      if (h > 0 && (l || c)) {
        if (h > t.maxBufferHole) {
          const {
            fragmentTracker: d
          } = this;
          let g = !1;
          if (r === 0) {
            const f = d.getAppendedFrag(0, G.MAIN);
            f && o < f.end && (g = !0);
          }
          if (!g) {
            const f = e || d.getAppendedFrag(r, G.MAIN);
            if (f) {
              let m = !1, y = f.end;
              for (; y < o; ) {
                const T = d.getPartialFragment(y);
                if (T)
                  y += T.duration;
                else {
                  m = !0;
                  break;
                }
              }
              if (m)
                return 0;
            }
          }
        }
        const u = Math.max(o + pd, r + md);
        if (S.warn(`skipping hole, adjusting currentTime from ${r} to ${u}`), this.moved = !0, this.stalled = null, n.currentTime = u, e && !e.gap) {
          const d = new Error(`fragment loaded with buffer holes, seeking from ${r} to ${u}`);
          i.trigger(p.ERROR, {
            type: V.MEDIA_ERROR,
            details: I.BUFFER_SEEK_OVER_HOLE,
            fatal: !1,
            error: d,
            reason: d.message,
            frag: e
          });
        }
        return u;
      }
    }
    return 0;
  }
  /**
   * Attempts to fix buffer stalls by advancing the mediaElement's current time by a small amount.
   * @private
   */
  _tryNudgeBuffer() {
    const {
      config: e,
      hls: t,
      media: i,
      nudgeRetry: n
    } = this;
    if (i === null)
      return;
    const r = i.currentTime;
    if (this.nudgeRetry++, n < e.nudgeMaxRetry) {
      const a = r + (n + 1) * e.nudgeOffset, o = new Error(`Nudging 'currentTime' from ${r} to ${a}`);
      S.warn(o.message), i.currentTime = a, t.trigger(p.ERROR, {
        type: V.MEDIA_ERROR,
        details: I.BUFFER_NUDGE_ON_STALL,
        error: o,
        fatal: !1
      });
    } else {
      const a = new Error(`Playhead still not moving while enough data buffered @${r} after ${e.nudgeMaxRetry} nudges`);
      S.error(a.message), t.trigger(p.ERROR, {
        type: V.MEDIA_ERROR,
        details: I.BUFFER_STALLED_ERROR,
        error: a,
        fatal: !0
      });
    }
  }
}
const Td = 100;
class Ed extends $s {
  constructor(e, t, i) {
    super(e, t, i, "[stream-controller]", G.MAIN), this.audioCodecSwap = !1, this.gapController = null, this.level = -1, this._forceStartLoad = !1, this.altAudio = !1, this.audioOnly = !1, this.fragPlaying = null, this.onvplaying = null, this.onvseeked = null, this.fragLastKbps = 0, this.couldBacktrack = !1, this.backtrackFragment = null, this.audioCodecSwitch = !1, this.videoBuffer = null, this._registerListeners();
  }
  _registerListeners() {
    const {
      hls: e
    } = this;
    e.on(p.MEDIA_ATTACHED, this.onMediaAttached, this), e.on(p.MEDIA_DETACHING, this.onMediaDetaching, this), e.on(p.MANIFEST_LOADING, this.onManifestLoading, this), e.on(p.MANIFEST_PARSED, this.onManifestParsed, this), e.on(p.LEVEL_LOADING, this.onLevelLoading, this), e.on(p.LEVEL_LOADED, this.onLevelLoaded, this), e.on(p.FRAG_LOAD_EMERGENCY_ABORTED, this.onFragLoadEmergencyAborted, this), e.on(p.ERROR, this.onError, this), e.on(p.AUDIO_TRACK_SWITCHING, this.onAudioTrackSwitching, this), e.on(p.AUDIO_TRACK_SWITCHED, this.onAudioTrackSwitched, this), e.on(p.BUFFER_CREATED, this.onBufferCreated, this), e.on(p.BUFFER_FLUSHED, this.onBufferFlushed, this), e.on(p.LEVELS_UPDATED, this.onLevelsUpdated, this), e.on(p.FRAG_BUFFERED, this.onFragBuffered, this);
  }
  _unregisterListeners() {
    const {
      hls: e
    } = this;
    e.off(p.MEDIA_ATTACHED, this.onMediaAttached, this), e.off(p.MEDIA_DETACHING, this.onMediaDetaching, this), e.off(p.MANIFEST_LOADING, this.onManifestLoading, this), e.off(p.MANIFEST_PARSED, this.onManifestParsed, this), e.off(p.LEVEL_LOADED, this.onLevelLoaded, this), e.off(p.FRAG_LOAD_EMERGENCY_ABORTED, this.onFragLoadEmergencyAborted, this), e.off(p.ERROR, this.onError, this), e.off(p.AUDIO_TRACK_SWITCHING, this.onAudioTrackSwitching, this), e.off(p.AUDIO_TRACK_SWITCHED, this.onAudioTrackSwitched, this), e.off(p.BUFFER_CREATED, this.onBufferCreated, this), e.off(p.BUFFER_FLUSHED, this.onBufferFlushed, this), e.off(p.LEVELS_UPDATED, this.onLevelsUpdated, this), e.off(p.FRAG_BUFFERED, this.onFragBuffered, this);
  }
  onHandlerDestroying() {
    this._unregisterListeners(), super.onHandlerDestroying();
  }
  startLoad(e) {
    if (this.levels) {
      const {
        lastCurrentTime: t,
        hls: i
      } = this;
      if (this.stopLoad(), this.setInterval(Td), this.level = -1, !this.startFragRequested) {
        let n = i.startLevel;
        n === -1 && (i.config.testBandwidth && this.levels.length > 1 ? (n = 0, this.bitrateTest = !0) : n = i.firstAutoLevel), i.nextLoadLevel = n, this.level = i.loadLevel, this.loadedmetadata = !1;
      }
      t > 0 && e === -1 && (this.log(`Override startPosition with lastCurrentTime @${t.toFixed(3)}`), e = t), this.state = D.IDLE, this.nextLoadPosition = this.startPosition = this.lastCurrentTime = e, this.tick();
    } else
      this._forceStartLoad = !0, this.state = D.STOPPED;
  }
  stopLoad() {
    this._forceStartLoad = !1, super.stopLoad();
  }
  doTick() {
    switch (this.state) {
      case D.WAITING_LEVEL: {
        const {
          levels: t,
          level: i
        } = this, n = t == null ? void 0 : t[i], r = n == null ? void 0 : n.details;
        if (r && (!r.live || this.levelLastLoaded === n)) {
          if (this.waitForCdnTuneIn(r))
            break;
          this.state = D.IDLE;
          break;
        } else if (this.hls.nextLoadLevel !== this.level) {
          this.state = D.IDLE;
          break;
        }
        break;
      }
      case D.FRAG_LOADING_WAITING_RETRY:
        {
          var e;
          const t = self.performance.now(), i = this.retryDate;
          if (!i || t >= i || (e = this.media) != null && e.seeking) {
            const {
              levels: n,
              level: r
            } = this, a = n == null ? void 0 : n[r];
            this.resetStartWhenNotLoaded(a || null), this.state = D.IDLE;
          }
        }
        break;
    }
    this.state === D.IDLE && this.doTickIdle(), this.onTickEnd();
  }
  onTickEnd() {
    super.onTickEnd(), this.checkBuffer(), this.checkFragmentChanged();
  }
  doTickIdle() {
    const {
      hls: e,
      levelLastLoaded: t,
      levels: i,
      media: n
    } = this;
    if (t === null || !n && (this.startFragRequested || !e.config.startFragPrefetch) || this.altAudio && this.audioOnly)
      return;
    const r = this.buffering ? e.nextLoadLevel : e.loadLevel;
    if (!(i != null && i[r]))
      return;
    const a = i[r], o = this.getMainFwdBufferInfo();
    if (o === null)
      return;
    const l = this.getLevelDetails();
    if (l && this._streamEnded(o, l)) {
      const m = {};
      this.altAudio && (m.type = "video"), this.hls.trigger(p.BUFFER_EOS, m), this.state = D.ENDED;
      return;
    }
    if (!this.buffering)
      return;
    e.loadLevel !== r && e.manualLevel === -1 && this.log(`Adapting to level ${r} from level ${this.level}`), this.level = e.nextLoadLevel = r;
    const c = a.details;
    if (!c || this.state === D.WAITING_LEVEL || c.live && this.levelLastLoaded !== a) {
      this.level = r, this.state = D.WAITING_LEVEL;
      return;
    }
    const h = o.len, u = this.getMaxBufferLength(a.maxBitrate);
    if (h >= u)
      return;
    this.backtrackFragment && this.backtrackFragment.start > o.end && (this.backtrackFragment = null);
    const d = this.backtrackFragment ? this.backtrackFragment.start : o.end;
    let g = this.getNextFragment(d, c);
    if (this.couldBacktrack && !this.fragPrevious && g && g.sn !== "initSegment" && this.fragmentTracker.getState(g) !== ve.OK) {
      var f;
      const y = ((f = this.backtrackFragment) != null ? f : g).sn - c.startSN, T = c.fragments[y - 1];
      T && g.cc === T.cc && (g = T, this.fragmentTracker.removeFragment(T));
    } else this.backtrackFragment && o.len && (this.backtrackFragment = null);
    if (g && this.isLoopLoading(g, d)) {
      if (!g.gap) {
        const y = this.audioOnly && !this.altAudio ? re.AUDIO : re.VIDEO, T = (y === re.VIDEO ? this.videoBuffer : this.mediaBuffer) || this.media;
        T && this.afterBufferFlushed(T, y, G.MAIN);
      }
      g = this.getNextFragmentLoopLoading(g, c, o, G.MAIN, u);
    }
    g && (g.initSegment && !g.initSegment.data && !this.bitrateTest && (g = g.initSegment), this.loadFragment(g, a, d));
  }
  loadFragment(e, t, i) {
    const n = this.fragmentTracker.getState(e);
    this.fragCurrent = e, n === ve.NOT_LOADED || n === ve.PARTIAL ? e.sn === "initSegment" ? this._loadInitSegment(e, t) : this.bitrateTest ? (this.log(`Fragment ${e.sn} of level ${e.level} is being downloaded to test bitrate and will not be buffered`), this._loadBitrateTestFrag(e, t)) : (this.startFragRequested = !0, super.loadFragment(e, t, i)) : this.clearTrackerIfNeeded(e);
  }
  getBufferedFrag(e) {
    return this.fragmentTracker.getBufferedFrag(e, G.MAIN);
  }
  followingBufferedFrag(e) {
    return e ? this.getBufferedFrag(e.end + 0.5) : null;
  }
  /*
    on immediate level switch :
     - pause playback if playing
     - cancel any pending load request
     - and trigger a buffer flush
  */
  immediateLevelSwitch() {
    this.abortCurrentFrag(), this.flushMainBuffer(0, Number.POSITIVE_INFINITY);
  }
  /**
   * try to switch ASAP without breaking video playback:
   * in order to ensure smooth but quick level switching,
   * we need to find the next flushable buffer range
   * we should take into account new segment fetch time
   */
  nextLevelSwitch() {
    const {
      levels: e,
      media: t
    } = this;
    if (t != null && t.readyState) {
      let i;
      const n = this.getAppendedFrag(t.currentTime);
      n && n.start > 1 && this.flushMainBuffer(0, n.start - 1);
      const r = this.getLevelDetails();
      if (r != null && r.live) {
        const o = this.getMainFwdBufferInfo();
        if (!o || o.len < r.targetduration * 2)
          return;
      }
      if (!t.paused && e) {
        const o = this.hls.nextLoadLevel, l = e[o], c = this.fragLastKbps;
        c && this.fragCurrent ? i = this.fragCurrent.duration * l.maxBitrate / (1e3 * c) + 1 : i = 0;
      } else
        i = 0;
      const a = this.getBufferedFrag(t.currentTime + i);
      if (a) {
        const o = this.followingBufferedFrag(a);
        if (o) {
          this.abortCurrentFrag();
          const l = o.maxStartPTS ? o.maxStartPTS : o.start, c = o.duration, h = Math.max(a.end, l + Math.min(Math.max(c - this.config.maxFragLookUpTolerance, c * (this.couldBacktrack ? 0.5 : 0.125)), c * (this.couldBacktrack ? 0.75 : 0.25)));
          this.flushMainBuffer(h, Number.POSITIVE_INFINITY);
        }
      }
    }
  }
  abortCurrentFrag() {
    const e = this.fragCurrent;
    switch (this.fragCurrent = null, this.backtrackFragment = null, e && (e.abortRequests(), this.fragmentTracker.removeFragment(e)), this.state) {
      case D.KEY_LOADING:
      case D.FRAG_LOADING:
      case D.FRAG_LOADING_WAITING_RETRY:
      case D.PARSING:
      case D.PARSED:
        this.state = D.IDLE;
        break;
    }
    this.nextLoadPosition = this.getLoadPosition();
  }
  flushMainBuffer(e, t) {
    super.flushMainBuffer(e, t, this.altAudio ? "video" : null);
  }
  onMediaAttached(e, t) {
    super.onMediaAttached(e, t);
    const i = t.media;
    this.onvplaying = this.onMediaPlaying.bind(this), this.onvseeked = this.onMediaSeeked.bind(this), i.addEventListener("playing", this.onvplaying), i.addEventListener("seeked", this.onvseeked), this.gapController = new yd(this.config, i, this.fragmentTracker, this.hls);
  }
  onMediaDetaching() {
    const {
      media: e
    } = this;
    e && this.onvplaying && this.onvseeked && (e.removeEventListener("playing", this.onvplaying), e.removeEventListener("seeked", this.onvseeked), this.onvplaying = this.onvseeked = null, this.videoBuffer = null), this.fragPlaying = null, this.gapController && (this.gapController.destroy(), this.gapController = null), super.onMediaDetaching();
  }
  onMediaPlaying() {
    this.tick();
  }
  onMediaSeeked() {
    const e = this.media, t = e ? e.currentTime : null;
    U(t) && this.log(`Media seeked to ${t.toFixed(3)}`);
    const i = this.getMainFwdBufferInfo();
    if (i === null || i.len === 0) {
      this.warn(`Main forward buffer length on "seeked" event ${i ? i.len : "empty"})`);
      return;
    }
    this.tick();
  }
  onManifestLoading() {
    this.log("Trigger BUFFER_RESET"), this.hls.trigger(p.BUFFER_RESET, void 0), this.fragmentTracker.removeAllFragments(), this.couldBacktrack = !1, this.startPosition = this.lastCurrentTime = this.fragLastKbps = 0, this.levels = this.fragPlaying = this.backtrackFragment = this.levelLastLoaded = null, this.altAudio = this.audioOnly = this.startFragRequested = !1;
  }
  onManifestParsed(e, t) {
    let i = !1, n = !1;
    t.levels.forEach((r) => {
      const a = r.audioCodec;
      a && (i = i || a.indexOf("mp4a.40.2") !== -1, n = n || a.indexOf("mp4a.40.5") !== -1);
    }), this.audioCodecSwitch = i && n && !fd(), this.audioCodecSwitch && this.log("Both AAC/HE-AAC audio found in levels; declaring level codec as HE-AAC"), this.levels = t.levels, this.startFragRequested = !1;
  }
  onLevelLoading(e, t) {
    const {
      levels: i
    } = this;
    if (!i || this.state !== D.IDLE)
      return;
    const n = i[t.level];
    (!n.details || n.details.live && this.levelLastLoaded !== n || this.waitForCdnTuneIn(n.details)) && (this.state = D.WAITING_LEVEL);
  }
  onLevelLoaded(e, t) {
    var i;
    const {
      levels: n
    } = this, r = t.level, a = t.details, o = a.totalduration;
    if (!n) {
      this.warn(`Levels were reset while loading level ${r}`);
      return;
    }
    this.log(`Level ${r} loaded [${a.startSN},${a.endSN}]${a.lastPartSn ? `[part-${a.lastPartSn}-${a.lastPartIndex}]` : ""}, cc [${a.startCC}, ${a.endCC}] duration:${o}`);
    const l = n[r], c = this.fragCurrent;
    c && (this.state === D.FRAG_LOADING || this.state === D.FRAG_LOADING_WAITING_RETRY) && c.level !== t.level && c.loader && this.abortCurrentFrag();
    let h = 0;
    if (a.live || (i = l.details) != null && i.live) {
      var u;
      if (this.checkLiveUpdate(a), a.deltaUpdateFailed)
        return;
      h = this.alignPlaylists(a, l.details, (u = this.levelLastLoaded) == null ? void 0 : u.details);
    }
    if (l.details = a, this.levelLastLoaded = l, this.hls.trigger(p.LEVEL_UPDATED, {
      details: a,
      level: r
    }), this.state === D.WAITING_LEVEL) {
      if (this.waitForCdnTuneIn(a))
        return;
      this.state = D.IDLE;
    }
    this.startFragRequested ? a.live && this.synchronizeToLiveEdge(a) : this.setStartPosition(a, h), this.tick();
  }
  _handleFragmentLoadProgress(e) {
    var t;
    const {
      frag: i,
      part: n,
      payload: r
    } = e, {
      levels: a
    } = this;
    if (!a) {
      this.warn(`Levels were reset while fragment load was in progress. Fragment ${i.sn} of level ${i.level} will not be buffered`);
      return;
    }
    const o = a[i.level], l = o.details;
    if (!l) {
      this.warn(`Dropping fragment ${i.sn} of level ${i.level} after level details were reset`), this.fragmentTracker.removeFragment(i);
      return;
    }
    const c = o.videoCodec, h = l.PTSKnown || !l.live, u = (t = i.initSegment) == null ? void 0 : t.data, d = this._getAudioCodec(o), g = this.transmuxer = this.transmuxer || new Sa(this.hls, G.MAIN, this._handleTransmuxComplete.bind(this), this._handleTransmuxerFlush.bind(this)), f = n ? n.index : -1, m = f !== -1, y = new Us(i.level, i.sn, i.stats.chunkCount, r.byteLength, f, m), T = this.initPTS[i.cc];
    g.push(r, u, d, c, i, n, l.totalduration, h, y, T);
  }
  onAudioTrackSwitching(e, t) {
    const i = this.altAudio;
    if (!!!t.url) {
      if (this.mediaBuffer !== this.media) {
        this.log("Switching on main audio, use media.buffered to schedule main fragment loading"), this.mediaBuffer = this.media;
        const a = this.fragCurrent;
        a && (this.log("Switching to main audio track, cancel main fragment load"), a.abortRequests(), this.fragmentTracker.removeFragment(a)), this.resetTransmuxer(), this.resetLoadingState();
      } else this.audioOnly && this.resetTransmuxer();
      const r = this.hls;
      i && (r.trigger(p.BUFFER_FLUSHING, {
        startOffset: 0,
        endOffset: Number.POSITIVE_INFINITY,
        type: null
      }), this.fragmentTracker.removeAllFragments()), r.trigger(p.AUDIO_TRACK_SWITCHED, t);
    }
  }
  onAudioTrackSwitched(e, t) {
    const i = t.id, n = !!this.hls.audioTracks[i].url;
    if (n) {
      const r = this.videoBuffer;
      r && this.mediaBuffer !== r && (this.log("Switching on alternate audio, use video.buffered to schedule main fragment loading"), this.mediaBuffer = r);
    }
    this.altAudio = n, this.tick();
  }
  onBufferCreated(e, t) {
    const i = t.tracks;
    let n, r, a = !1;
    for (const o in i) {
      const l = i[o];
      if (l.id === "main") {
        if (r = o, n = l, o === "video") {
          const c = i[o];
          c && (this.videoBuffer = c.buffer);
        }
      } else
        a = !0;
    }
    a && n ? (this.log(`Alternate track found, use ${r}.buffered to schedule main fragment loading`), this.mediaBuffer = n.buffer) : this.mediaBuffer = this.media;
  }
  onFragBuffered(e, t) {
    const {
      frag: i,
      part: n
    } = t;
    if (i && i.type !== G.MAIN)
      return;
    if (this.fragContextChanged(i)) {
      this.warn(`Fragment ${i.sn}${n ? " p: " + n.index : ""} of level ${i.level} finished buffering, but was aborted. state: ${this.state}`), this.state === D.PARSED && (this.state = D.IDLE);
      return;
    }
    const r = n ? n.stats : i.stats;
    this.fragLastKbps = Math.round(8 * r.total / (r.buffering.end - r.loading.first)), i.sn !== "initSegment" && (this.fragPrevious = i), this.fragBufferedComplete(i, n);
  }
  onError(e, t) {
    var i;
    if (t.fatal) {
      this.state = D.ERROR;
      return;
    }
    switch (t.details) {
      case I.FRAG_GAP:
      case I.FRAG_PARSING_ERROR:
      case I.FRAG_DECRYPT_ERROR:
      case I.FRAG_LOAD_ERROR:
      case I.FRAG_LOAD_TIMEOUT:
      case I.KEY_LOAD_ERROR:
      case I.KEY_LOAD_TIMEOUT:
        this.onFragmentOrKeyLoadError(G.MAIN, t);
        break;
      case I.LEVEL_LOAD_ERROR:
      case I.LEVEL_LOAD_TIMEOUT:
      case I.LEVEL_PARSING_ERROR:
        !t.levelRetry && this.state === D.WAITING_LEVEL && ((i = t.context) == null ? void 0 : i.type) === Q.LEVEL && (this.state = D.IDLE);
        break;
      case I.BUFFER_APPEND_ERROR:
      case I.BUFFER_FULL_ERROR:
        if (!t.parent || t.parent !== "main")
          return;
        if (t.details === I.BUFFER_APPEND_ERROR) {
          this.resetLoadingState();
          return;
        }
        this.reduceLengthAndFlushBuffer(t) && this.flushMainBuffer(0, Number.POSITIVE_INFINITY);
        break;
      case I.INTERNAL_EXCEPTION:
        this.recoverWorkerError(t);
        break;
    }
  }
  // Checks the health of the buffer and attempts to resolve playback stalls.
  checkBuffer() {
    const {
      media: e,
      gapController: t
    } = this;
    if (!(!e || !t || !e.readyState)) {
      if (this.loadedmetadata || !le.getBuffered(e).length) {
        const i = this.state !== D.IDLE ? this.fragCurrent : null;
        t.poll(this.lastCurrentTime, i);
      }
      this.lastCurrentTime = e.currentTime;
    }
  }
  onFragLoadEmergencyAborted() {
    this.state = D.IDLE, this.loadedmetadata || (this.startFragRequested = !1, this.nextLoadPosition = this.startPosition), this.tickImmediate();
  }
  onBufferFlushed(e, {
    type: t
  }) {
    if (t !== re.AUDIO || this.audioOnly && !this.altAudio) {
      const i = (t === re.VIDEO ? this.videoBuffer : this.mediaBuffer) || this.media;
      this.afterBufferFlushed(i, t, G.MAIN), this.tick();
    }
  }
  onLevelsUpdated(e, t) {
    this.level > -1 && this.fragCurrent && (this.level = this.fragCurrent.level), this.levels = t.levels;
  }
  swapAudioCodec() {
    this.audioCodecSwap = !this.audioCodecSwap;
  }
  /**
   * Seeks to the set startPosition if not equal to the mediaElement's current time.
   */
  seekToStartPos() {
    const {
      media: e
    } = this;
    if (!e)
      return;
    const t = e.currentTime;
    let i = this.startPosition;
    if (i >= 0 && t < i) {
      if (e.seeking) {
        this.log(`could not seek to ${i}, already seeking at ${t}`);
        return;
      }
      const n = le.getBuffered(e), a = (n.length ? n.start(0) : 0) - i;
      a > 0 && (a < this.config.maxBufferHole || a < this.config.maxFragLookUpTolerance) && (this.log(`adjusting start position by ${a} to match buffer start`), i += a, this.startPosition = i), this.log(`seek to target start position ${i} from current time ${t}`), e.currentTime = i;
    }
  }
  _getAudioCodec(e) {
    let t = this.config.defaultAudioCodec || e.audioCodec;
    return this.audioCodecSwap && t && (this.log("Swapping audio codec"), t.indexOf("mp4a.40.5") !== -1 ? t = "mp4a.40.2" : t = "mp4a.40.5"), t;
  }
  _loadBitrateTestFrag(e, t) {
    e.bitrateTest = !0, this._doFragLoad(e, t).then((i) => {
      const {
        hls: n
      } = this;
      if (!i || this.fragContextChanged(e))
        return;
      t.fragmentError = 0, this.state = D.IDLE, this.startFragRequested = !1, this.bitrateTest = !1;
      const r = e.stats;
      r.parsing.start = r.parsing.end = r.buffering.start = r.buffering.end = self.performance.now(), n.trigger(p.FRAG_LOADED, i), e.bitrateTest = !1;
    });
  }
  _handleTransmuxComplete(e) {
    var t;
    const i = "main", {
      hls: n
    } = this, {
      remuxResult: r,
      chunkMeta: a
    } = e, o = this.getCurrentContext(a);
    if (!o) {
      this.resetWhenMissingContext(a);
      return;
    }
    const {
      frag: l,
      part: c,
      level: h
    } = o, {
      video: u,
      text: d,
      id3: g,
      initSegment: f
    } = r, {
      details: m
    } = h, y = this.altAudio ? void 0 : r.audio;
    if (this.fragContextChanged(l)) {
      this.fragmentTracker.removeFragment(l);
      return;
    }
    if (this.state = D.PARSING, f) {
      if (f != null && f.tracks) {
        const v = l.initSegment || l;
        this._bufferInitSegment(h, f.tracks, v, a), n.trigger(p.FRAG_PARSING_INIT_SEGMENT, {
          frag: v,
          id: i,
          tracks: f.tracks
        });
      }
      const T = f.initPTS, b = f.timescale;
      U(T) && (this.initPTS[l.cc] = {
        baseTime: T,
        timescale: b
      }, n.trigger(p.INIT_PTS_FOUND, {
        frag: l,
        id: i,
        initPTS: T,
        timescale: b
      }));
    }
    if (u && m && l.sn !== "initSegment") {
      const T = m.fragments[l.sn - 1 - m.startSN], b = l.sn === m.startSN, v = !T || l.cc > T.cc;
      if (r.independent !== !1) {
        const {
          startPTS: A,
          endPTS: x,
          startDTS: w,
          endDTS: R
        } = u;
        if (c)
          c.elementaryStreams[u.type] = {
            startPTS: A,
            endPTS: x,
            startDTS: w,
            endDTS: R
          };
        else if (u.firstKeyFrame && u.independent && a.id === 1 && !v && (this.couldBacktrack = !0), u.dropped && u.independent) {
          const k = this.getMainFwdBufferInfo(), _ = (k ? k.end : this.getLoadPosition()) + this.config.maxBufferHole, C = u.firstKeyFramePTS ? u.firstKeyFramePTS : A;
          if (!b && _ < C - this.config.maxBufferHole && !v) {
            this.backtrack(l);
            return;
          } else v && (l.gap = !0);
          l.setElementaryStreamInfo(u.type, l.start, x, l.start, R, !0);
        } else b && A > ci && (l.gap = !0);
        l.setElementaryStreamInfo(u.type, A, x, w, R), this.backtrackFragment && (this.backtrackFragment = l), this.bufferFragmentData(u, l, c, a, b || v);
      } else if (b || v)
        l.gap = !0;
      else {
        this.backtrack(l);
        return;
      }
    }
    if (y) {
      const {
        startPTS: T,
        endPTS: b,
        startDTS: v,
        endDTS: A
      } = y;
      c && (c.elementaryStreams[re.AUDIO] = {
        startPTS: T,
        endPTS: b,
        startDTS: v,
        endDTS: A
      }), l.setElementaryStreamInfo(re.AUDIO, T, b, v, A), this.bufferFragmentData(y, l, c, a);
    }
    if (m && g != null && (t = g.samples) != null && t.length) {
      const T = {
        id: i,
        frag: l,
        details: m,
        samples: g.samples
      };
      n.trigger(p.FRAG_PARSING_METADATA, T);
    }
    if (m && d) {
      const T = {
        id: i,
        frag: l,
        details: m,
        samples: d.samples
      };
      n.trigger(p.FRAG_PARSING_USERDATA, T);
    }
  }
  _bufferInitSegment(e, t, i, n) {
    if (this.state !== D.PARSING)
      return;
    this.audioOnly = !!t.audio && !t.video, this.altAudio && !this.audioOnly && delete t.audio;
    const {
      audio: r,
      video: a,
      audiovideo: o
    } = t;
    if (r) {
      let l = e.audioCodec;
      const c = navigator.userAgent.toLowerCase();
      if (this.audioCodecSwitch) {
        l && (l.indexOf("mp4a.40.5") !== -1 ? l = "mp4a.40.2" : l = "mp4a.40.5");
        const h = r.metadata;
        h && "channelCount" in h && (h.channelCount || 1) !== 1 && c.indexOf("firefox") === -1 && (l = "mp4a.40.5");
      }
      l && l.indexOf("mp4a.40.5") !== -1 && c.indexOf("android") !== -1 && r.container !== "audio/mpeg" && (l = "mp4a.40.2", this.log(`Android: force audio codec to ${l}`)), e.audioCodec && e.audioCodec !== l && this.log(`Swapping manifest audio codec "${e.audioCodec}" for "${l}"`), r.levelCodec = l, r.id = "main", this.log(`Init audio buffer, container:${r.container}, codecs[selected/level/parsed]=[${l || ""}/${e.audioCodec || ""}/${r.codec}]`);
    }
    a && (a.levelCodec = e.videoCodec, a.id = "main", this.log(`Init video buffer, container:${a.container}, codecs[level/parsed]=[${e.videoCodec || ""}/${a.codec}]`)), o && this.log(`Init audiovideo buffer, container:${o.container}, codecs[level/parsed]=[${e.codecs}/${o.codec}]`), this.hls.trigger(p.BUFFER_CODECS, t), Object.keys(t).forEach((l) => {
      const h = t[l].initSegment;
      h != null && h.byteLength && this.hls.trigger(p.BUFFER_APPENDING, {
        type: l,
        data: h,
        frag: i,
        part: null,
        chunkMeta: n,
        parent: i.type
      });
    }), this.tickImmediate();
  }
  getMainFwdBufferInfo() {
    return this.getFwdBufferInfo(this.mediaBuffer ? this.mediaBuffer : this.media, G.MAIN);
  }
  backtrack(e) {
    this.couldBacktrack = !0, this.backtrackFragment = e, this.resetTransmuxer(), this.flushBufferGap(e), this.fragmentTracker.removeFragment(e), this.fragPrevious = null, this.nextLoadPosition = e.start, this.state = D.IDLE;
  }
  checkFragmentChanged() {
    const e = this.media;
    let t = null;
    if (e && e.readyState > 1 && e.seeking === !1) {
      const i = e.currentTime;
      if (le.isBuffered(e, i) ? t = this.getAppendedFrag(i) : le.isBuffered(e, i + 0.1) && (t = this.getAppendedFrag(i + 0.1)), t) {
        this.backtrackFragment = null;
        const n = this.fragPlaying, r = t.level;
        (!n || t.sn !== n.sn || n.level !== r) && (this.fragPlaying = t, this.hls.trigger(p.FRAG_CHANGED, {
          frag: t
        }), (!n || n.level !== r) && this.hls.trigger(p.LEVEL_SWITCHED, {
          level: r
        }));
      }
    }
  }
  get nextLevel() {
    const e = this.nextBufferedFrag;
    return e ? e.level : -1;
  }
  get currentFrag() {
    const e = this.media;
    return e ? this.fragPlaying || this.getAppendedFrag(e.currentTime) : null;
  }
  get currentProgramDateTime() {
    const e = this.media;
    if (e) {
      const t = e.currentTime, i = this.currentFrag;
      if (i && U(t) && U(i.programDateTime)) {
        const n = i.programDateTime + (t - i.start) * 1e3;
        return new Date(n);
      }
    }
    return null;
  }
  get currentLevel() {
    const e = this.currentFrag;
    return e ? e.level : -1;
  }
  get nextBufferedFrag() {
    const e = this.currentFrag;
    return e ? this.followingBufferedFrag(e) : null;
  }
  get forceStartLoad() {
    return this._forceStartLoad;
  }
}
class pt {
  /**
   * Get the video-dev/hls.js package version.
   */
  static get version() {
    return "1.5.20";
  }
  /**
   * Check if the required MediaSource Extensions are available.
   */
  static isMSESupported() {
    return Ka();
  }
  /**
   * Check if MediaSource Extensions are available and isTypeSupported checks pass for any baseline codecs.
   */
  static isSupported() {
    return dd();
  }
  /**
   * Get the MediaSource global used for MSE playback (ManagedMediaSource, MediaSource, or WebKitMediaSource).
   */
  static getMediaSource() {
    return ht();
  }
  static get Events() {
    return p;
  }
  static get ErrorTypes() {
    return V;
  }
  static get ErrorDetails() {
    return I;
  }
  /**
   * Get the default configuration applied to new instances.
   */
  static get DefaultConfig() {
    return pt.defaultConfig ? pt.defaultConfig : Ga;
  }
  /**
   * Replace the default configuration applied to new instances.
   */
  static set DefaultConfig(e) {
    pt.defaultConfig = e;
  }
  /**
   * Creates an instance of an HLS client that can attach to exactly one `HTMLMediaElement`.
   * @param userConfig - Configuration options applied over `Hls.DefaultConfig`
   */
  constructor(e = {}) {
    this.config = void 0, this.userConfig = void 0, this.coreComponents = void 0, this.networkControllers = void 0, this.started = !1, this._emitter = new Ws(), this._autoLevelCapping = -1, this._maxHdcpLevel = null, this.abrController = void 0, this.bufferController = void 0, this.capLevelController = void 0, this.latencyController = void 0, this.levelController = void 0, this.streamController = void 0, this.audioTrackController = void 0, this.subtitleTrackController = void 0, this.emeController = void 0, this.cmcdController = void 0, this._media = null, this.url = null, this.triggeringException = void 0, ol(e.debug || !1, "Hls instance");
    const t = this.config = ld(pt.DefaultConfig, e);
    this.userConfig = e, t.progressive && cd(t);
    const {
      abrController: i,
      bufferController: n,
      capLevelController: r,
      errorController: a,
      fpsController: o
    } = t, l = new a(this), c = this.abrController = new i(this), h = this.bufferController = new n(this), u = this.capLevelController = new r(this), d = new o(this), g = new tc(this), f = new ac(this), m = t.contentSteeringController, y = m ? new m(this) : null, T = this.levelController = new hd(this, y), b = new Fc(this), v = new ud(this.config), A = this.streamController = new Ed(this, b, v);
    u.setStreamController(A), d.setStreamController(A);
    const x = [g, T, A];
    y && x.splice(1, 0, y), this.networkControllers = x;
    const w = [c, h, u, d, f, b];
    this.audioTrackController = this.createController(t.audioTrackController, x);
    const R = t.audioStreamController;
    R && x.push(new R(this, b, v)), this.subtitleTrackController = this.createController(t.subtitleTrackController, x);
    const k = t.subtitleStreamController;
    k && x.push(new k(this, b, v)), this.createController(t.timelineController, w), v.emeController = this.emeController = this.createController(t.emeController, w), this.cmcdController = this.createController(t.cmcdController, w), this.latencyController = this.createController(oc, w), this.coreComponents = w, x.push(l);
    const _ = l.onErrorOut;
    typeof _ == "function" && this.on(p.ERROR, _, l);
  }
  createController(e, t) {
    if (e) {
      const i = new e(this);
      return t && t.push(i), i;
    }
    return null;
  }
  // Delegate the EventEmitter through the public API of Hls.js
  on(e, t, i = this) {
    this._emitter.on(e, t, i);
  }
  once(e, t, i = this) {
    this._emitter.once(e, t, i);
  }
  removeAllListeners(e) {
    this._emitter.removeAllListeners(e);
  }
  off(e, t, i = this, n) {
    this._emitter.off(e, t, i, n);
  }
  listeners(e) {
    return this._emitter.listeners(e);
  }
  emit(e, t, i) {
    return this._emitter.emit(e, t, i);
  }
  trigger(e, t) {
    if (this.config.debug)
      return this.emit(e, e, t);
    try {
      return this.emit(e, e, t);
    } catch (i) {
      if (S.error("An internal error happened while handling event " + e + '. Error message: "' + i.message + '". Here is a stacktrace:', i), !this.triggeringException) {
        this.triggeringException = !0;
        const n = e === p.ERROR;
        this.trigger(p.ERROR, {
          type: V.OTHER_ERROR,
          details: I.INTERNAL_EXCEPTION,
          fatal: n,
          event: e,
          error: i
        }), this.triggeringException = !1;
      }
    }
    return !1;
  }
  listenerCount(e) {
    return this._emitter.listenerCount(e);
  }
  /**
   * Dispose of the instance
   */
  destroy() {
    S.log("destroy"), this.trigger(p.DESTROYING, void 0), this.detachMedia(), this.removeAllListeners(), this._autoLevelCapping = -1, this.url = null, this.networkControllers.forEach((t) => t.destroy()), this.networkControllers.length = 0, this.coreComponents.forEach((t) => t.destroy()), this.coreComponents.length = 0;
    const e = this.config;
    e.xhrSetup = e.fetchSetup = void 0, this.userConfig = null;
  }
  /**
   * Attaches Hls.js to a media element
   */
  attachMedia(e) {
    S.log("attachMedia"), this._media = e, this.trigger(p.MEDIA_ATTACHING, {
      media: e
    });
  }
  /**
   * Detach Hls.js from the media
   */
  detachMedia() {
    S.log("detachMedia"), this.trigger(p.MEDIA_DETACHING, void 0), this._media = null;
  }
  /**
   * Set the source URL. Can be relative or absolute.
   */
  loadSource(e) {
    this.stopLoad();
    const t = this.media, i = this.url, n = this.url = Ps.buildAbsoluteURL(self.location.href, e, {
      alwaysNormalize: !0
    });
    this._autoLevelCapping = -1, this._maxHdcpLevel = null, S.log(`loadSource:${n}`), t && i && (i !== n || this.bufferController.hasSourceTypes()) && (this.detachMedia(), this.attachMedia(t)), this.trigger(p.MANIFEST_LOADING, {
      url: e
    });
  }
  /**
   * Start loading data from the stream source.
   * Depending on default config, client starts loading automatically when a source is set.
   *
   * @param startPosition - Set the start position to stream from.
   * Defaults to -1 (None: starts from earliest point)
   */
  startLoad(e = -1) {
    S.log(`startLoad(${e})`), this.started = !0, this.resumeBuffering();
    for (let t = 0; t < this.networkControllers.length && (this.networkControllers[t].startLoad(e), !(!this.started || !this.networkControllers)); t++)
      ;
  }
  /**
   * Stop loading of any stream data.
   */
  stopLoad() {
    S.log("stopLoad"), this.started = !1;
    for (let e = 0; e < this.networkControllers.length && (this.networkControllers[e].stopLoad(), !(this.started || !this.networkControllers)); e++)
      ;
  }
  /**
   * Resumes stream controller segment loading after `pauseBuffering` has been called.
   */
  resumeBuffering() {
    S.log("resume buffering"), this.networkControllers.forEach((e) => {
      e.resumeBuffering && e.resumeBuffering();
    });
  }
  /**
   * Prevents stream controller from loading new segments until `resumeBuffering` is called.
   * This allows for media buffering to be paused without interupting playlist loading.
   */
  pauseBuffering() {
    S.log("pause buffering"), this.networkControllers.forEach((e) => {
      e.pauseBuffering && e.pauseBuffering();
    });
  }
  /**
   * Swap through possible audio codecs in the stream (for example to switch from stereo to 5.1)
   */
  swapAudioCodec() {
    S.log("swapAudioCodec"), this.streamController.swapAudioCodec();
  }
  /**
   * When the media-element fails, this allows to detach and then re-attach it
   * as one call (convenience method).
   *
   * Automatic recovery of media-errors by this process is configurable.
   */
  recoverMediaError() {
    S.log("recoverMediaError");
    const e = this._media;
    this.detachMedia(), e && this.attachMedia(e);
  }
  removeLevel(e) {
    this.levelController.removeLevel(e);
  }
  /**
   * @returns an array of levels (variants) sorted by HDCP-LEVEL, RESOLUTION (height), FRAME-RATE, CODECS, VIDEO-RANGE, and BANDWIDTH
   */
  get levels() {
    const e = this.levelController.levels;
    return e || [];
  }
  /**
   * Index of quality level (variant) currently played
   */
  get currentLevel() {
    return this.streamController.currentLevel;
  }
  /**
   * Set quality level index immediately. This will flush the current buffer to replace the quality asap. That means playback will interrupt at least shortly to re-buffer and re-sync eventually. Set to -1 for automatic level selection.
   */
  set currentLevel(e) {
    S.log(`set currentLevel:${e}`), this.levelController.manualLevel = e, this.streamController.immediateLevelSwitch();
  }
  /**
   * Index of next quality level loaded as scheduled by stream controller.
   */
  get nextLevel() {
    return this.streamController.nextLevel;
  }
  /**
   * Set quality level index for next loaded data.
   * This will switch the video quality asap, without interrupting playback.
   * May abort current loading of data, and flush parts of buffer (outside currently played fragment region).
   * @param newLevel - Pass -1 for automatic level selection
   */
  set nextLevel(e) {
    S.log(`set nextLevel:${e}`), this.levelController.manualLevel = e, this.streamController.nextLevelSwitch();
  }
  /**
   * Return the quality level of the currently or last (of none is loaded currently) segment
   */
  get loadLevel() {
    return this.levelController.level;
  }
  /**
   * Set quality level index for next loaded data in a conservative way.
   * This will switch the quality without flushing, but interrupt current loading.
   * Thus the moment when the quality switch will appear in effect will only be after the already existing buffer.
   * @param newLevel - Pass -1 for automatic level selection
   */
  set loadLevel(e) {
    S.log(`set loadLevel:${e}`), this.levelController.manualLevel = e;
  }
  /**
   * get next quality level loaded
   */
  get nextLoadLevel() {
    return this.levelController.nextLoadLevel;
  }
  /**
   * Set quality level of next loaded segment in a fully "non-destructive" way.
   * Same as `loadLevel` but will wait for next switch (until current loading is done).
   */
  set nextLoadLevel(e) {
    this.levelController.nextLoadLevel = e;
  }
  /**
   * Return "first level": like a default level, if not set,
   * falls back to index of first level referenced in manifest
   */
  get firstLevel() {
    return Math.max(this.levelController.firstLevel, this.minAutoLevel);
  }
  /**
   * Sets "first-level", see getter.
   */
  set firstLevel(e) {
    S.log(`set firstLevel:${e}`), this.levelController.firstLevel = e;
  }
  /**
   * Return the desired start level for the first fragment that will be loaded.
   * The default value of -1 indicates automatic start level selection.
   * Setting hls.nextAutoLevel without setting a startLevel will result in
   * the nextAutoLevel value being used for one fragment load.
   */
  get startLevel() {
    const e = this.levelController.startLevel;
    return e === -1 && this.abrController.forcedAutoLevel > -1 ? this.abrController.forcedAutoLevel : e;
  }
  /**
   * set  start level (level of first fragment that will be played back)
   * if not overrided by user, first level appearing in manifest will be used as start level
   * if -1 : automatic start level selection, playback will start from level matching download bandwidth
   * (determined from download of first segment)
   */
  set startLevel(e) {
    S.log(`set startLevel:${e}`), e !== -1 && (e = Math.max(e, this.minAutoLevel)), this.levelController.startLevel = e;
  }
  /**
   * Whether level capping is enabled.
   * Default value is set via `config.capLevelToPlayerSize`.
   */
  get capLevelToPlayerSize() {
    return this.config.capLevelToPlayerSize;
  }
  /**
   * Enables or disables level capping. If disabled after previously enabled, `nextLevelSwitch` will be immediately called.
   */
  set capLevelToPlayerSize(e) {
    const t = !!e;
    t !== this.config.capLevelToPlayerSize && (t ? this.capLevelController.startCapping() : (this.capLevelController.stopCapping(), this.autoLevelCapping = -1, this.streamController.nextLevelSwitch()), this.config.capLevelToPlayerSize = t);
  }
  /**
   * Capping/max level value that should be used by automatic level selection algorithm (`ABRController`)
   */
  get autoLevelCapping() {
    return this._autoLevelCapping;
  }
  /**
   * Returns the current bandwidth estimate in bits per second, when available. Otherwise, `NaN` is returned.
   */
  get bandwidthEstimate() {
    const {
      bwEstimator: e
    } = this.abrController;
    return e ? e.getEstimate() : NaN;
  }
  set bandwidthEstimate(e) {
    this.abrController.resetEstimator(e);
  }
  /**
   * get time to first byte estimate
   * @type {number}
   */
  get ttfbEstimate() {
    const {
      bwEstimator: e
    } = this.abrController;
    return e ? e.getEstimateTTFB() : NaN;
  }
  /**
   * Capping/max level value that should be used by automatic level selection algorithm (`ABRController`)
   */
  set autoLevelCapping(e) {
    this._autoLevelCapping !== e && (S.log(`set autoLevelCapping:${e}`), this._autoLevelCapping = e, this.levelController.checkMaxAutoUpdated());
  }
  get maxHdcpLevel() {
    return this._maxHdcpLevel;
  }
  set maxHdcpLevel(e) {
    lc(e) && this._maxHdcpLevel !== e && (this._maxHdcpLevel = e, this.levelController.checkMaxAutoUpdated());
  }
  /**
   * True when automatic level selection enabled
   */
  get autoLevelEnabled() {
    return this.levelController.manualLevel === -1;
  }
  /**
   * Level set manually (if any)
   */
  get manualLevel() {
    return this.levelController.manualLevel;
  }
  /**
   * min level selectable in auto mode according to config.minAutoBitrate
   */
  get minAutoLevel() {
    const {
      levels: e,
      config: {
        minAutoBitrate: t
      }
    } = this;
    if (!e) return 0;
    const i = e.length;
    for (let n = 0; n < i; n++)
      if (e[n].maxBitrate >= t)
        return n;
    return 0;
  }
  /**
   * max level selectable in auto mode according to autoLevelCapping
   */
  get maxAutoLevel() {
    const {
      levels: e,
      autoLevelCapping: t,
      maxHdcpLevel: i
    } = this;
    let n;
    if (t === -1 && e != null && e.length ? n = e.length - 1 : n = t, i)
      for (let r = n; r--; ) {
        const a = e[r].attrs["HDCP-LEVEL"];
        if (a && a <= i)
          return r;
      }
    return n;
  }
  get firstAutoLevel() {
    return this.abrController.firstAutoLevel;
  }
  /**
   * next automatically selected quality level
   */
  get nextAutoLevel() {
    return this.abrController.nextAutoLevel;
  }
  /**
   * this setter is used to force next auto level.
   * this is useful to force a switch down in auto mode:
   * in case of load error on level N, hls.js can set nextAutoLevel to N-1 for example)
   * forced value is valid for one fragment. upon successful frag loading at forced level,
   * this value will be resetted to -1 by ABR controller.
   */
  set nextAutoLevel(e) {
    this.abrController.nextAutoLevel = e;
  }
  /**
   * get the datetime value relative to media.currentTime for the active level Program Date Time if present
   */
  get playingDate() {
    return this.streamController.currentProgramDateTime;
  }
  get mainForwardBufferInfo() {
    return this.streamController.getMainFwdBufferInfo();
  }
  /**
   * Find and select the best matching audio track, making a level switch when a Group change is necessary.
   * Updates `hls.config.audioPreference`. Returns the selected track, or null when no matching track is found.
   */
  setAudioOption(e) {
    var t;
    return (t = this.audioTrackController) == null ? void 0 : t.setAudioOption(e);
  }
  /**
   * Find and select the best matching subtitle track, making a level switch when a Group change is necessary.
   * Updates `hls.config.subtitlePreference`. Returns the selected track, or null when no matching track is found.
   */
  setSubtitleOption(e) {
    var t;
    return (t = this.subtitleTrackController) == null || t.setSubtitleOption(e), null;
  }
  /**
   * Get the complete list of audio tracks across all media groups
   */
  get allAudioTracks() {
    const e = this.audioTrackController;
    return e ? e.allAudioTracks : [];
  }
  /**
   * Get the list of selectable audio tracks
   */
  get audioTracks() {
    const e = this.audioTrackController;
    return e ? e.audioTracks : [];
  }
  /**
   * index of the selected audio track (index in audio track lists)
   */
  get audioTrack() {
    const e = this.audioTrackController;
    return e ? e.audioTrack : -1;
  }
  /**
   * selects an audio track, based on its index in audio track lists
   */
  set audioTrack(e) {
    const t = this.audioTrackController;
    t && (t.audioTrack = e);
  }
  /**
   * get the complete list of subtitle tracks across all media groups
   */
  get allSubtitleTracks() {
    const e = this.subtitleTrackController;
    return e ? e.allSubtitleTracks : [];
  }
  /**
   * get alternate subtitle tracks list from playlist
   */
  get subtitleTracks() {
    const e = this.subtitleTrackController;
    return e ? e.subtitleTracks : [];
  }
  /**
   * index of the selected subtitle track (index in subtitle track lists)
   */
  get subtitleTrack() {
    const e = this.subtitleTrackController;
    return e ? e.subtitleTrack : -1;
  }
  get media() {
    return this._media;
  }
  /**
   * select an subtitle track, based on its index in subtitle track lists
   */
  set subtitleTrack(e) {
    const t = this.subtitleTrackController;
    t && (t.subtitleTrack = e);
  }
  /**
   * Whether subtitle display is enabled or not
   */
  get subtitleDisplay() {
    const e = this.subtitleTrackController;
    return e ? e.subtitleDisplay : !1;
  }
  /**
   * Enable/disable subtitle display rendering
   */
  set subtitleDisplay(e) {
    const t = this.subtitleTrackController;
    t && (t.subtitleDisplay = e);
  }
  /**
   * get mode for Low-Latency HLS loading
   */
  get lowLatencyMode() {
    return this.config.lowLatencyMode;
  }
  /**
   * Enable/disable Low-Latency HLS part playlist and segment loading, and start live streams at playlist PART-HOLD-BACK rather than HOLD-BACK.
   */
  set lowLatencyMode(e) {
    this.config.lowLatencyMode = e;
  }
  /**
   * Position (in seconds) of live sync point (ie edge of live position minus safety delay defined by ```hls.config.liveSyncDuration```)
   * @returns null prior to loading live Playlist
   */
  get liveSyncPosition() {
    return this.latencyController.liveSyncPosition;
  }
  /**
   * Estimated position (in seconds) of live edge (ie edge of live playlist plus time sync playlist advanced)
   * @returns 0 before first playlist is loaded
   */
  get latency() {
    return this.latencyController.latency;
  }
  /**
   * maximum distance from the edge before the player seeks forward to ```hls.liveSyncPosition```
   * configured using ```liveMaxLatencyDurationCount``` (multiple of target duration) or ```liveMaxLatencyDuration```
   * @returns 0 before first playlist is loaded
   */
  get maxLatency() {
    return this.latencyController.maxLatency;
  }
  /**
   * target distance from the edge as calculated by the latency controller
   */
  get targetLatency() {
    return this.latencyController.targetLatency;
  }
  /**
   * the rate at which the edge of the current live playlist is advancing or 1 if there is none
   */
  get drift() {
    return this.latencyController.drift;
  }
  /**
   * set to true when startLoad is called before MANIFEST_PARSED event
   */
  get forceStartLoad() {
    return this.streamController.forceStartLoad;
  }
}
pt.defaultConfig = void 0;
export {
  p as E,
  pt as H,
  fi as P
};
